/* eslint-disable */
import type { RawDate } from '@/types/globals';
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: RawDate; output: RawDate };
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: RawDate; output: RawDate };
  /** Represents untyped JSON */
  JSON: { input: any; output: any };
};

export type AcceptProjectInvitationCompany = {
  city: Scalars['String']['input'];
  companyNumber: Scalars['String']['input'];
  companyType: CompanyTypeEnum;
  country: Scalars['String']['input'];
  name: Scalars['String']['input'];
  primaryEmail: Scalars['String']['input'];
  primaryPhone: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  tradingName?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type AcceptProjectInvitationUser = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
};

export type AccessAuditEvent = {
  __typename?: 'AccessAuditEvent';
  actorEmployment?: Maybe<Employment>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  event: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  payload: Scalars['JSON']['output'];
  subjectId: Scalars['ID']['output'];
  subjectType: Scalars['String']['output'];
};

export type AccessGrantPair = {
  __typename?: 'AccessGrantPair';
  action: PermissionActionEnum;
  entity: PermissionEntityEnum;
};

export type AccessGrantPairInput = {
  action: Scalars['String']['input'];
  entity: Scalars['String']['input'];
};

export type AccessRegistryAction = {
  __typename?: 'AccessRegistryAction';
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AccessRegistryEntity = {
  __typename?: 'AccessRegistryEntity';
  actions: Array<AccessRegistryAction>;
  icon?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  ownable: Scalars['Boolean']['output'];
  projectScoped: Scalars['Boolean']['output'];
};

export type AccessRequest = {
  __typename?: 'AccessRequest';
  createdAt: Scalars['ISO8601DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  status: AccessRequestStatusEnum;
};

/** Access Request Status enum */
export enum AccessRequestStatusEnum {
  /** Approved */
  Approved = 'approved',
  /** Pending */
  Pending = 'pending',
  /** Rejected */
  Rejected = 'rejected',
}

export type AccessRequestUpdate = {
  id: Scalars['ID']['input'];
  status?: InputMaybe<AccessRequestStatusEnum>;
};

export type ActivityInput = {
  colorCode?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  supervisorId?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
};

export type Address = {
  __typename?: 'Address';
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  locationType: AddressLocationTypeEnum;
  state: Scalars['String']['output'];
  street: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  zip: Scalars['String']['output'];
};

export type AddressCreate = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  locationType?: InputMaybe<AddressLocationTypeEnum>;
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type AddressInput = {
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  locationType: AddressLocationTypeEnum;
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  zip: Scalars['String']['input'];
};

/** For address location type enums */
export enum AddressLocationTypeEnum {
  /** Main */
  Main = 'main',
  /** Sub */
  Sub = 'sub',
}

export type AddressUpdate = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  locationType?: InputMaybe<AddressLocationTypeEnum>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/** Document link association type (soft vs hard) */
export enum AssociationTypeEnum {
  /** Hard association */
  Hard = 'hard',
  /** Soft association */
  Soft = 'soft',
}

export type Attachment = {
  __typename?: 'Attachment';
  associationType?: Maybe<AssociationTypeEnum>;
  byteSize: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  filename: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  previewUrl: Scalars['String']['output'];
  /** Signed blob ID for use in mutations (e.g. destroy, tag) */
  signedBlobId?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<CompanyTag>>;
};

export type BillableItem = {
  __typename?: 'BillableItem';
  attachments: Array<Attachment>;
  documentUrls?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  imageUrls?: Maybe<Array<Scalars['String']['output']>>;
  itemCategory: Scalars['String']['output'];
  rate: Scalars['Int']['output'];
  resourceId: Scalars['ID']['output'];
  resourceName: Scalars['String']['output'];
  resourceType?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  subEventBillableItems: Array<SubEventBillableItem>;
  unit?: Maybe<Scalars['String']['output']>;
};

export type BillableItemOption = {
  __typename?: 'BillableItemOption';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  uniqueKey: Scalars['String']['output'];
  unit?: Maybe<Scalars['String']['output']>;
};

export type CeqSubEvent = {
  __typename?: 'CeqSubEvent';
  billableItems?: Maybe<Array<BillableItem>>;
  cost?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  programmeImpact?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CeqSubEventBillableItemInput = {
  multiplier: Scalars['String']['input'];
  quantity: Scalars['String']['input'];
  rate: Scalars['String']['input'];
  resourceId: Scalars['ID']['input'];
  resourceType: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type Client = {
  __typename?: 'Client';
  /** The current user's resolved permissions on this record */
  abilities: ClientsAbilities;
  activeProjectsCount: Scalars['Int']['output'];
  address?: Maybe<Address>;
  cancelledProjectsCount: Scalars['Int']['output'];
  companyNumber: Scalars['String']['output'];
  companyResources: Array<CompanyResource>;
  companyType?: Maybe<CompanyTypeEnum>;
  completedProjectsCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  inFunnelCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  primaryEmail?: Maybe<Scalars['String']['output']>;
  primaryPhone?: Maybe<Scalars['String']['output']>;
  tradingName?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
};

export type ClientCreate = {
  address?: InputMaybe<AddressCreate>;
  companyName: Scalars['String']['input'];
  companyNumber: Scalars['String']['input'];
  companyType?: InputMaybe<CompanyTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  tradingName?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClientFilters = {
  __typename?: 'ClientFilters';
  companyNames?: Maybe<Array<Scalars['String']['output']>>;
  projectStatuses?: Maybe<Array<Scalars['String']['output']>>;
};

export type ClientInstructionCreate = {
  compensationEventNoticeId: Scalars['ID']['input'];
  instructions: Scalars['String']['input'];
  responseDate: Scalars['String']['input'];
  signedIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type ClientInstructions = {
  __typename?: 'ClientInstructions';
  attachments: Array<Attachment>;
  documentUrls?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  imageUrls?: Maybe<Array<Scalars['String']['output']>>;
  instructions: Scalars['String']['output'];
  responseDate: Scalars['String']['output'];
};

export type ClientRepInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
};

export type ClientUpdate = {
  address?: InputMaybe<AddressUpdate>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNumber: Scalars['String']['input'];
  companyType?: InputMaybe<CompanyTypeEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  tradingName?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Resolved permissions of the current user against this clients record */
export type ClientsAbilities = {
  __typename?: 'ClientsAbilities';
  create: Scalars['Boolean']['output'];
  edit: Scalars['Boolean']['output'];
  export: Scalars['Boolean']['output'];
  manage: Scalars['Boolean']['output'];
  view: Scalars['Boolean']['output'];
};

export type CommentReaction = {
  __typename?: 'CommentReaction';
  emoji: Scalars['String']['output'];
  employments: Array<Employment>;
};

export type CompaniesHouseAddress = {
  __typename?: 'CompaniesHouseAddress';
  city: Scalars['String']['output'];
  state?: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};

export type CompaniesHouseData = {
  __typename?: 'CompaniesHouseData';
  address?: Maybe<CompaniesHouseAddress>;
  companyType?: Maybe<CompanyTypeEnum>;
  name: Scalars['String']['output'];
  number: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
};

export type CompaniesHouseInfo = {
  __typename?: 'CompaniesHouseInfo';
  data?: Maybe<CompaniesHouseData>;
  success: Scalars['Boolean']['output'];
};

export type Company = {
  __typename?: 'Company';
  active?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<Address>;
  basicOnboardingCompleted?: Maybe<Scalars['Boolean']['output']>;
  companyNumber: Scalars['String']['output'];
  companyType: CompanyTypeEnum;
  hasClients?: Maybe<Scalars['Boolean']['output']>;
  hasHumanResources?: Maybe<Scalars['Boolean']['output']>;
  hasProjects?: Maybe<Scalars['Boolean']['output']>;
  humanResourcesCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  isParent: Scalars['Boolean']['output'];
  mainAddress?: Maybe<Address>;
  name: Scalars['String']['output'];
  onboardingSteps: OnboardingSteps;
  owner?: Maybe<User>;
  primaryEmail: Scalars['String']['output'];
  primaryPhone?: Maybe<Scalars['String']['output']>;
  projectsCount: Scalars['Int']['output'];
  reportsCount: Scalars['Int']['output'];
  tags?: Maybe<Array<CompanyTag>>;
  tradingName?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  welcomeChecklistCompleted?: Maybe<Scalars['Boolean']['output']>;
};

export type CompanyContract = {
  __typename?: 'CompanyContract';
  companyId: Scalars['ID']['output'];
  contractTypeId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CompanyContractTypeInput = {
  contractTypeId: Scalars['ID']['input'];
};

export type CompanyDocumentsHierarchy = {
  __typename?: 'CompanyDocumentsHierarchy';
  /** Direct attachments for this node */
  attachments?: Maybe<Array<Attachment>>;
  /** Number of children (for lazy loading) */
  childrenCount?: Maybe<Scalars['Int']['output']>;
  /** A modified ID of the node */
  id: Scalars['String']['output'];
  /** Display name of the node */
  label: Scalars['String']['output'];
  /** Type of the node (company, project, event, report, issue, early_warning_notice, compensation_event_notice) */
  type: DocumentHierarchyNodeTypeEnum;
};

export type CompanyDocumentsHierarchyFiltersInput = {
  associationTypeFilter?: InputMaybe<AssociationTypeEnum>;
  fileExtension?: InputMaybe<Scalars['ID']['input']>;
  filenameSearch?: InputMaybe<Scalars['ID']['input']>;
  projectFilter?: InputMaybe<Scalars['ID']['input']>;
  uploadDateFrom?: InputMaybe<Scalars['String']['input']>;
  uploadDateTo?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyDocumentsHierarchyInput = {
  cenId?: InputMaybe<Scalars['ID']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  eventId?: InputMaybe<Scalars['ID']['input']>;
  ewnId?: InputMaybe<Scalars['ID']['input']>;
  filters?: InputMaybe<CompanyDocumentsHierarchyFiltersInput>;
  issueId?: InputMaybe<Scalars['ID']['input']>;
  kickOffId?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  reportId?: InputMaybe<Scalars['ID']['input']>;
};

export type CompanyEquipment = {
  __typename?: 'CompanyEquipment';
  category: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  equipmentType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  quantity?: Maybe<Scalars['String']['output']>;
  resourceCategory?: Maybe<ResourceCategory>;
  shortCode: Scalars['String']['output'];
  tags?: Maybe<Array<CompanyTag>>;
  unit: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type CompanyEventColumn = {
  __typename?: 'CompanyEventColumn';
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  status: EventStatusEnum;
};

export type CompanyResource = {
  __typename?: 'CompanyResource';
  canInviteSubContractor?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  resourceMeta?: Maybe<ResourceMeta>;
  resourceType: CompanyResourceResourceTypeEnum;
  source: CompanyResourceSourceEnum;
  subContractor?: Maybe<SubContractor>;
  subContractorId?: Maybe<Scalars['ID']['output']>;
  uniqueReference: Scalars['String']['output'];
  user?: Maybe<User>;
};

/** The connection type for CompanyResource. */
export type CompanyResourceConnection = {
  __typename?: 'CompanyResourceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CompanyResourceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CompanyResource>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CompanyResourceCreate = {
  inviteSubContractor?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  resourceMeta: ResourceMetaCreate;
  resourceType: CompanyResourceResourceTypeEnum;
  source?: InputMaybe<CompanyResourceSourceEnum>;
  uniqueReference?: InputMaybe<Scalars['String']['input']>;
};

/** An edge in a connection. */
export type CompanyResourceEdge = {
  __typename?: 'CompanyResourceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CompanyResource>;
};

/** Enums for CompanyResource resource_type */
export enum CompanyResourceResourceTypeEnum {
  /** equipment */
  Equipment = 'equipment',
  /** human */
  Human = 'human',
  /** material */
  Material = 'material',
  /** sub_contractor */
  SubContractor = 'sub_contractor',
}

/** Enums for CompanyResource source */
export enum CompanyResourceSourceEnum {
  /** external */
  External = 'external',
  /** internal */
  Internal = 'internal',
}

export type CompanyResourceUpdate = {
  id: Scalars['ID']['input'];
  inviteSubContractor?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  resourceMeta: ResourceMetaCreate;
  resourceType: CompanyResourceResourceTypeEnum;
  source?: InputMaybe<CompanyResourceSourceEnum>;
  uniqueReference?: InputMaybe<Scalars['String']['input']>;
};

export type CompanySetting = {
  __typename?: 'CompanySetting';
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type CompanySubContractor = {
  __typename?: 'CompanySubContractor';
  company: Company;
  principalContact: User;
  subContractor: SubContractor;
};

/** The connection type for CompanySubContractor. */
export type CompanySubContractorConnection = {
  __typename?: 'CompanySubContractorConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CompanySubContractorEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CompanySubContractor>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type CompanySubContractorEdge = {
  __typename?: 'CompanySubContractorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CompanySubContractor>;
};

export type CompanyTag = {
  __typename?: 'CompanyTag';
  createdAt: Scalars['String']['output'];
  equipments?: Maybe<Array<CompanyEquipment>>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  users?: Maybe<Array<User>>;
};

export type CompanyTagCreate = {
  title: Array<Scalars['String']['input']>;
};

/** UK Company Type enum */
export enum CompanyTypeEnum {
  /** Cic */
  Cic = 'cic',
  /** Cio */
  Cio = 'cio',
  /** General Partnership */
  GeneralPartnership = 'general_partnership',
  /** Llp */
  Llp = 'llp',
  /** Lp */
  Lp = 'lp',
  /** Ltd */
  Ltd = 'ltd',
  /** Plc */
  Plc = 'plc',
  /** Sole Trader */
  SoleTrader = 'sole_trader',
}

export type CompensationEventNotice = {
  __typename?: 'CompensationEventNotice';
  attachments: Array<Attachment>;
  clientInstruction?: Maybe<ClientInstructions>;
  description: Scalars['String']['output'];
  documentUrls?: Maybe<Array<Scalars['String']['output']>>;
  editable: Scalars['Boolean']['output'];
  event: Event;
  id: Scalars['ID']['output'];
  imageUrls?: Maybe<Array<Scalars['String']['output']>>;
  state: CompensationEventNoticeStateEnum;
  uuid: Scalars['String']['output'];
};

export type CompensationEventNoticeCreate = {
  description: Scalars['String']['input'];
  eventId: Scalars['ID']['input'];
  signedIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Compensation Event Notice state enum */
export enum CompensationEventNoticeStateEnum {
  /** Approved */
  Approved = 'approved',
  /** Disputed */
  Disputed = 'disputed',
  /** Issued */
  Issued = 'issued',
  /** Rejected */
  Rejected = 'rejected',
  /** Unissued */
  Unissued = 'unissued',
}

export type CompensationEventNoticeUpdate = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  signedIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  state?: InputMaybe<CompensationEventNoticeStateEnum>;
};

export type CompensationEventQuotation = {
  __typename?: 'CompensationEventQuotation';
  associatedCen?: Maybe<CompensationEventNotice>;
  attachments: Array<Attachment>;
  description?: Maybe<Scalars['String']['output']>;
  documentUrls?: Maybe<Array<Scalars['String']['output']>>;
  editable: Scalars['Boolean']['output'];
  eventId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  imageUrls?: Maybe<Array<Scalars['String']['output']>>;
  programmeImpact: Scalars['Int']['output'];
  totalCost?: Maybe<Scalars['Float']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
};

export type CompensationEventQuotationCreate = {
  ceqSubEventsAttributes?: InputMaybe<Array<CompensationEventQuotationSubEventInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
  programmeImpact: Scalars['String']['input'];
  signedIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CompensationEventQuotationSubEventInput = {
  billableItemsAttributes?: InputMaybe<Array<CeqSubEventBillableItemInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ConflictedResources = {
  __typename?: 'ConflictedResources';
  address?: Maybe<ConflictedScheduleAddress>;
  conflictingSchedules?: Maybe<Array<ConflictedResources>>;
  date: Scalars['String']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  project: ConflictedScheduleProject;
  quantity?: Maybe<Scalars['Int']['output']>;
  resourceId: Scalars['ID']['output'];
  resourceName: Scalars['String']['output'];
  resourceType: Scalars['String']['output'];
  source?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ConflictedScheduleAddress = {
  __typename?: 'ConflictedScheduleAddress';
  formatted?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ConflictedScheduleProject = {
  __typename?: 'ConflictedScheduleProject';
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type Contract = {
  __typename?: 'Contract';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CreateEquipment = {
  equipmentType: EquipmentTypeEnum;
  isScheduleable?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  resourceCategoryId: Scalars['ID']['input'];
  shortCode: Scalars['String']['input'];
  unit: Scalars['String']['input'];
};

export type CreateMeetingInput = {
  mode?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  scheduledAt?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateResourceScheduleV2Input = {
  addressId: Scalars['ID']['input'];
  approverEmploymentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  collectable?: InputMaybe<Scalars['Boolean']['input']>;
  customEndTime?: InputMaybe<Scalars['String']['input']>;
  customShift?: InputMaybe<Scalars['Boolean']['input']>;
  customStartTime?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['String']['input'];
  delivererName?: InputMaybe<Scalars['String']['input']>;
  descriptionOfService?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['String']['input'];
  onHire?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  receiverName?: InputMaybe<Scalars['String']['input']>;
  resourceId?: InputMaybe<Scalars['ID']['input']>;
  resourceName?: InputMaybe<Scalars['String']['input']>;
  resourceType: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['String']['input'];
  supplier?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateResourceScheduleV2. */
export type CreateResourceScheduleV2Payload = {
  __typename?: 'CreateResourceScheduleV2Payload';
  hasConflicts: Scalars['Boolean']['output'];
  schedules: Array<SchedulerSchedule>;
};

/** Autogenerated return type of CreateSingleResourceSchedule. */
export type CreateSingleResourceSchedulePayload = {
  __typename?: 'CreateSingleResourceSchedulePayload';
  hasConflicts: Scalars['Boolean']['output'];
  scheduleId: Scalars['ID']['output'];
};

export type CustomShiftNotificationDetails = {
  __typename?: 'CustomShiftNotificationDetails';
  canApprove: Scalars['Boolean']['output'];
  date?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['String']['output'];
  existingShifts: Array<ProjectShift>;
  projectId: Scalars['ID']['output'];
  projectName: Scalars['String']['output'];
  scheduleId: Scalars['ID']['output'];
  startTime: Scalars['String']['output'];
};

export type DeliveryAndCollectionItem = {
  companyResourceId: Scalars['ID']['input'];
  delivererName: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['String']['input'];
  receiverName: Scalars['String']['input'];
  supplier: Scalars['String']['input'];
};

export type DeliveryAndCollectionItemState = {
  __typename?: 'DeliveryAndCollectionItemState';
  actor: User;
  currentState: DeliveryAndCollectionItemStateEnum;
  currentStateSetAt: Scalars['String']['output'];
  delivererName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  item: DeliveryAndCollectionRegisterItem;
  notes?: Maybe<Scalars['String']['output']>;
  receiverName: Scalars['String']['output'];
  reportId: Scalars['ID']['output'];
  supplier: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

/** Delivery and Collection Item to_state enum */
export enum DeliveryAndCollectionItemStateEnum {
  /** Arrived */
  Arrived = 'arrived',
  /** Collected */
  Collected = 'collected',
  /** Deployed */
  Deployed = 'deployed',
  /** Ready For Collection */
  ReadyForCollection = 'ready_for_collection',
}

export type DeliveryAndCollectionRegister = {
  __typename?: 'DeliveryAndCollectionRegister';
  createdAt: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  items: Array<DeliveryAndCollectionRegisterItem>;
  projectId: Scalars['ID']['output'];
  requestor: User;
  uuid: Scalars['String']['output'];
};

export type DeliveryAndCollectionRegisterCreate = {
  items: Array<DeliveryAndCollectionItem>;
  reportId: Scalars['ID']['input'];
};

export type DeliveryAndCollectionRegisterItem = {
  __typename?: 'DeliveryAndCollectionRegisterItem';
  companyResource: CompanyResource;
  id: Scalars['ID']['output'];
  itemStates: Array<DeliveryAndCollectionItemState>;
  latestItemState?: Maybe<DeliveryAndCollectionItemState>;
  quantity: Scalars['String']['output'];
};

export type DeliveryItemsView = {
  __typename?: 'DeliveryItemsView';
  actor: User;
  currentState: DeliveryAndCollectionItemStateEnum;
  delivererName: Scalars['String']['output'];
  documentUrls?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  imageUrls?: Maybe<Array<Scalars['String']['output']>>;
  item: DeliveryAndCollectionRegisterItem;
  notes?: Maybe<Scalars['String']['output']>;
  receiverName: Scalars['String']['output'];
  supplier: Scalars['String']['output'];
};

export type DirectUpload = {
  __typename?: 'DirectUpload';
  /** Blob record ID */
  blobId: Scalars['ID']['output'];
  /** JSON-encoded HTTP request headers */
  headers: Scalars['JSON']['output'];
  /** Document record ID */
  id: Scalars['ID']['output'];
  /** Signed blob ID for use in attach/destroy mutations */
  signedBlobId: Scalars['String']['output'];
  /** Upload URL */
  url: Scalars['String']['output'];
};

export type DirectUploadCreate = {
  /** File size in bytes */
  byteSize: Scalars['String']['input'];
  /** MD5 checksum as base64 */
  checksum: Scalars['String']['input'];
  /** File content type */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** Original file name */
  filename: Scalars['String']['input'];
  /** Directory path filename inclusive */
  key?: InputMaybe<Scalars['String']['input']>;
};

/** Document Hierarchy Node type enum */
export enum DocumentHierarchyNodeTypeEnum {
  /** Attachment */
  Attachment = 'attachment',
  /** Company */
  Company = 'company',
  /** CompensationEventNotice */
  CompensationEventNotice = 'compensation_event_notice',
  /** EarlyWarningNotice */
  EarlyWarningNotice = 'early_warning_notice',
  /** Event */
  Event = 'event',
  /** Issue */
  Issue = 'issue',
  /** KickOff */
  KickOff = 'kick_off',
  /** Project */
  Project = 'project',
  /** Report */
  Report = 'report',
}

/** Autogenerated return type of DropResourceScheduleV2. */
export type DropResourceScheduleV2Payload = {
  __typename?: 'DropResourceScheduleV2Payload';
  droppedIds: Array<Scalars['ID']['output']>;
};

export type EarlyWarningNotice = {
  __typename?: 'EarlyWarningNotice';
  cost?: Maybe<Scalars['Boolean']['output']>;
  description: Scalars['String']['output'];
  documentUrls?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  imageUrls?: Maybe<Array<Scalars['String']['output']>>;
  keyDates?: Maybe<Scalars['Boolean']['output']>;
  others?: Maybe<Scalars['String']['output']>;
  programmeImpact?: Maybe<Scalars['Boolean']['output']>;
  time?: Maybe<Scalars['Boolean']['output']>;
};

export type EarlyWarningNoticeCreate = {
  cost?: InputMaybe<Scalars['Boolean']['input']>;
  description: Scalars['String']['input'];
  eventId: Scalars['ID']['input'];
  keyDates?: InputMaybe<Scalars['Boolean']['input']>;
  notifiableResourceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  others?: InputMaybe<Scalars['String']['input']>;
  programmeImpact?: InputMaybe<Scalars['Boolean']['input']>;
  signedIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  time?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmployeeUpdate = {
  bio?: InputMaybe<Scalars['String']['input']>;
  companyEmploymentStatus?: InputMaybe<EmploymentStatusEnum>;
  confirmPassword?: InputMaybe<Scalars['String']['input']>;
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  ignoreSchedules?: InputMaybe<Scalars['Boolean']['input']>;
  imageSignedId?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  loginEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  newPassword?: InputMaybe<Scalars['String']['input']>;
  primaryPhone?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatusEnum>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedScheduleId?: InputMaybe<Scalars['ID']['input']>;
};

export type Employment = {
  __typename?: 'Employment';
  companyId?: Maybe<Scalars['ID']['output']>;
  createdBy?: Maybe<User>;
  defaultEmployment?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employee?: Maybe<User>;
  employmentType?: Maybe<Scalars['String']['output']>;
  endedAt?: Maybe<Scalars['String']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  loginEnabled?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EmploymentStatusEnum>;
  subscription?: Maybe<Subscription>;
  user?: Maybe<User>;
};

export type EmploymentAccess = {
  __typename?: 'EmploymentAccess';
  directGrants: Array<EmploymentGrant>;
  effective: Array<MyAccessGrant>;
  employment: Employment;
  roles: Array<Role>;
};

export type EmploymentGrant = {
  __typename?: 'EmploymentGrant';
  action: PermissionActionEnum;
  createdAt: Scalars['ISO8601DateTime']['output'];
  entity: PermissionEntityEnum;
  expired: Scalars['Boolean']['output'];
  grantedBy?: Maybe<Employment>;
  id: Scalars['ID']['output'];
  project?: Maybe<Project>;
  projectId?: Maybe<Scalars['ID']['output']>;
  validTill?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type EmploymentGrantInput = {
  action: Scalars['String']['input'];
  entity: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
  validTill?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

/** Employment Status enum */
export enum EmploymentStatusEnum {
  /** Active */
  Active = 'active',
  /** Inactive */
  Inactive = 'inactive',
  /** Pending */
  Pending = 'pending',
  /** Rejected */
  Rejected = 'rejected',
}

/** Company Equipment Type enum */
export enum EquipmentTypeEnum {
  /** External */
  External = 'external',
  /** Internal */
  Internal = 'internal',
}

export type Event = {
  __typename?: 'Event';
  /** The current user's resolved permissions on this record */
  abilities: EventsAbilities;
  approvableId?: Maybe<Scalars['ID']['output']>;
  approvableType?: Maybe<Scalars['String']['output']>;
  approved: Scalars['Boolean']['output'];
  assignee?: Maybe<Employment>;
  category?: Maybe<EventCategoryEnum>;
  cenCount: Scalars['Int']['output'];
  compensationEventNotices?: Maybe<Array<CompensationEventNotice>>;
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  earlyWarningNotices?: Maybe<Array<EarlyWarningNotice>>;
  eventComments?: Maybe<Array<EventComment>>;
  eventLabels: Array<EventLabel>;
  eventSources?: Maybe<Array<EventSource>>;
  eventType: EventTypeEnum;
  ewnCount: Scalars['Int']['output'];
  flag: Scalars['Boolean']['output'];
  hasActiveCeq: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  occurredAt?: Maybe<Scalars['String']['output']>;
  orderIndex: Scalars['Int']['output'];
  project: Project;
  projectCurrency?: Maybe<Scalars['String']['output']>;
  projectId: Scalars['Int']['output'];
  status: EventStatusEnum;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

/** Event category enum */
export enum EventCategoryEnum {
  /** External */
  External = 'external',
  /** Internal */
  Internal = 'internal',
}

export type EventComment = {
  __typename?: 'EventComment';
  createdAt?: Maybe<Scalars['String']['output']>;
  event: Event;
  id: Scalars['ID']['output'];
  status: EventCommentStatusEnum;
  text: Scalars['String']['output'];
  user: User;
};

/** Event Comment type enum */
export enum EventCommentStatusEnum {
  /** Approved */
  Approved = 'approved',
  /** Discontinued */
  Discontinued = 'discontinued',
  /** Hold */
  Hold = 'hold',
  /** In Progress */
  InProgress = 'in_progress',
  /** Open */
  Open = 'open',
  /** Rejected */
  Rejected = 'rejected',
  /** Resolved */
  Resolved = 'resolved',
  /** Response Received */
  ResponseReceived = 'response_received',
  /** Response Sent */
  ResponseSent = 'response_sent',
  /** Waiting */
  Waiting = 'waiting',
}

export type EventCreate = {
  category?: InputMaybe<EventCategoryEnum>;
  description: Scalars['String']['input'];
  eventSourcesAttributes?: InputMaybe<Array<EventSourceCreate>>;
  eventType: EventTypeEnum;
  flag?: InputMaybe<Scalars['Boolean']['input']>;
  occurredAt?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EventLabel = {
  __typename?: 'EventLabel';
  company: Company;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type EventSource = {
  __typename?: 'EventSource';
  event: Event;
  id: Scalars['ID']['output'];
  source: Source;
};

export type EventSourceCreate = {
  eventId?: InputMaybe<Scalars['ID']['input']>;
  sourceId: Scalars['ID']['input'];
  sourceType: Scalars['String']['input'];
};

/** Event status enum */
export enum EventStatusEnum {
  /** Approved */
  Approved = 'approved',
  /** Discontinued */
  Discontinued = 'discontinued',
  /** Hold */
  Hold = 'hold',
  /** In Progress */
  InProgress = 'in_progress',
  /** Open */
  Open = 'open',
  /** Rejected */
  Rejected = 'rejected',
  /** Resolved */
  Resolved = 'resolved',
  /** Response Received */
  ResponseReceived = 'response_received',
  /** Response Sent */
  ResponseSent = 'response_sent',
  /** Waiting */
  Waiting = 'waiting',
}

/** Event type enum */
export enum EventTypeEnum {
  /** Future */
  Future = 'future',
  /** Past */
  Past = 'past',
  /** Present */
  Present = 'present',
}

export type EventUpdate = {
  assigneeUserId?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<EventCategoryEnum>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<EventTypeEnum>;
  flag?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  occurredAt?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EventStatusEnum>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Resolved permissions of the current user against this events record */
export type EventsAbilities = {
  __typename?: 'EventsAbilities';
  approve: Scalars['Boolean']['output'];
  create: Scalars['Boolean']['output'];
  edit: Scalars['Boolean']['output'];
  export: Scalars['Boolean']['output'];
  issue: Scalars['Boolean']['output'];
  manage: Scalars['Boolean']['output'];
  publish: Scalars['Boolean']['output'];
  review: Scalars['Boolean']['output'];
  sendEmail: Scalars['Boolean']['output'];
  view: Scalars['Boolean']['output'];
};

export type Feedback = {
  __typename?: 'Feedback';
  createdAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  feedbackType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrls?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  resolved: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
};

export type FeedbackCreate = {
  companyId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  feedbackType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  signedIds?: InputMaybe<Array<Scalars['String']['input']>>;
  text: Scalars['String']['input'];
};

export type FeedbackUpdate = {
  id: Scalars['ID']['input'];
  resolved: Scalars['Boolean']['input'];
};

/** Resource Meta Fuel Type Enum */
export enum FuelTypeEnum {
  /** Diesel */
  Diesel = 'diesel',
  /** Electric */
  Electric = 'electric',
  /** Petrol */
  Petrol = 'petrol',
}

export type GrantRequest = {
  __typename?: 'GrantRequest';
  action: PermissionActionEnum;
  actorEmployment?: Maybe<Employment>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  entity: PermissionEntityEnum;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  project?: Maybe<Project>;
  requestFor: Scalars['String']['output'];
  requestorEmployment: Employment;
  resolvedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: Scalars['String']['output'];
};

export type GuestUserScheduleCreate = {
  addressId?: InputMaybe<Scalars['ID']['input']>;
  collectable?: InputMaybe<Scalars['Boolean']['input']>;
  date: Scalars['String']['input'];
  descriptionOfService?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['String']['input'];
  name: Scalars['String']['input'];
  onHire?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['ID']['input'];
  resourceType: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Issue = {
  __typename?: 'Issue';
  categories: Array<IssueCategory>;
  createdAt?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<Employment>;
  description: Scalars['String']['output'];
  documentUrls?: Maybe<Array<Scalars['String']['output']>>;
  endTime: Scalars['String']['output'];
  flagged?: Maybe<Scalars['Boolean']['output']>;
  headline: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageUrls?: Maybe<Array<Scalars['String']['output']>>;
  issueType: IssueTypeEnum;
  startTime: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type IssueCategory = {
  __typename?: 'IssueCategory';
  colorCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type IssueCreate = {
  categoryNames?: InputMaybe<Array<Scalars['String']['input']>>;
  description: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  issueType: IssueTypeEnum;
  reportId: Scalars['ID']['input'];
  signedIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startTime: Scalars['String']['input'];
};

/** Issue type enum */
export enum IssueTypeEnum {
  /** External Issue */
  ExternalIssue = 'external_issue',
  /** Internal Issue */
  InternalIssue = 'internal_issue',
}

export type IssueUpdate = {
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  flagged?: InputMaybe<Scalars['Boolean']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  issueType?: InputMaybe<IssueTypeEnum>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type ItemOrder = {
  __typename?: 'ItemOrder';
  h: Scalars['Int']['output'];
  i: Scalars['String']['output'];
  isBounded?: Maybe<Scalars['Boolean']['output']>;
  isDraggable?: Maybe<Scalars['Boolean']['output']>;
  isResizable?: Maybe<Scalars['Boolean']['output']>;
  maxH?: Maybe<Scalars['Int']['output']>;
  maxW?: Maybe<Scalars['Int']['output']>;
  minH?: Maybe<Scalars['Int']['output']>;
  minW?: Maybe<Scalars['Int']['output']>;
  moved?: Maybe<Scalars['Boolean']['output']>;
  static?: Maybe<Scalars['Boolean']['output']>;
  w: Scalars['Int']['output'];
  x: Scalars['Int']['output'];
  y: Scalars['Int']['output'];
};

export type KanbanColumn = {
  __typename?: 'KanbanColumn';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  value: Array<KanbanColumnItem>;
};

export type KanbanColumnItem = {
  __typename?: 'KanbanColumnItem';
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type KickOffCreate = {
  data: Scalars['JSON']['input'];
  templateId?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
};

export type KickOffData = {
  __typename?: 'KickOffData';
  addresses?: Maybe<Array<Scalars['JSON']['output']>>;
  clientCompanyNumber?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['ID']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  clientReps?: Maybe<Array<Scalars['JSON']['output']>>;
  newTemplate?: Maybe<Scalars['Boolean']['output']>;
  newTemplateTitle?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<Scalars['JSON']['output']>>;
  projectCode?: Maybe<Scalars['String']['output']>;
  projectDetails?: Maybe<KickOffProjectDetails>;
  projectId?: Maybe<Scalars['ID']['output']>;
  projectTitle?: Maybe<Scalars['String']['output']>;
};

export type KickOffProjectDetails = {
  __typename?: 'KickOffProjectDetails';
  activities?: Maybe<Array<Scalars['JSON']['output']>>;
  contractTypeIds?: Maybe<Array<Scalars['String']['output']>>;
  managers?: Maybe<Array<Scalars['JSON']['output']>>;
  projectSettings?: Maybe<Array<Scalars['JSON']['output']>>;
  projectTagIds?: Maybe<Array<Scalars['String']['output']>>;
};

/** Kick Off Status Enum */
export enum KickOffStatusEnum {
  /** Draft */
  Draft = 'draft',
  /** Finished */
  Finished = 'finished',
}

export type KickOffTemplate = {
  __typename?: 'KickOffTemplate';
  company?: Maybe<Company>;
  createdAt?: Maybe<Scalars['String']['output']>;
  data?: Maybe<KickOffData>;
  id: Scalars['ID']['output'];
  kickOffs?: Maybe<Array<ProjectKickOffs>>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type ManagerCreate = {
  companyResourceId?: InputMaybe<Scalars['ID']['input']>;
  employmentId?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type ManagerUpdate = {
  companyResourceId?: InputMaybe<Scalars['ID']['input']>;
  employmentId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MeetingNote = {
  __typename?: 'MeetingNote';
  actionable: Scalars['Boolean']['output'];
  body: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Summary: Handles the full client onboarding flow when a client accepts an invitation — creates their user account, company resource, employment, and sets their password.
   *
   * Auth: None required - the potential user lands on this page via an email invite, and their sign up flow is handled in here
   *
   * Arguments:
   *   - token (required) - The invitation token identifying the ClientInvitation record.
   *   - first_name (optional) - Required in practice for new users; combined with last_name to form the full name displayed on the account.
   *   - last_name (optional) - Required in practice for new users; combined with first_name to form the full name.
   *   - email (optional) - The client user's email address. Used to find an existing user or create a new one.
   *   - password (optional) - Sets the client owner's password, whether the account is new or already existed.
   *
   * Returns: String - The onboarded user's email address, used by the caller to confirm which account was created or updated.
   *
   */
  acceptClientInvitation: Scalars['String']['output'];
  /**
   * Summary:
   *   Handles the full sub-contractor onboarding flow when a contractor accepts a project invitation via a token link.
   *   The user's details are received from the client and used to create the user account.
   *
   *   Only used for new users. Existing users get sent a notification email in another flow.
   *
   * Auth: None required - the potential user lands on this page via an email invite, and their sign up flow is handled in here
   *
   * Arguments:
   *   - token (required) - Base64-encoded token identifying the CompanyResource (company_resource_id is the last segment).
   *   - company (required) - The company details including name, email, phone, and address.
   *   - user (required) - The user details including first name, last name, and password (optional) - For new users.
   *
   * Returns: Boolean - True if flow completes successfully, False if it fails at some point
   *
   */
  acceptProjectInvitation: Scalars['Boolean']['output'];
  /**
   * Summary: Approves a custom shift request for a schedule, adds the new named shift
   * to project_settings under 'project-shifts', marks custom_shift on schedule(s) as false,
   * and marks the notification as read.
   *
   * Auth: Requires approve custom_shifts permission on the project.
   *
   */
  approveCustomShift: Scalars['Boolean']['output'];
  /**
   * Summary: Transitions an event to the approved state and notifies all project members.
   *
   * Auth: Requires approve_events permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - id (required) - The event to approve.
   *
   * Side effects: Transitions the event to approved and creates in-app notifications for project members.
   *
   * Returns: Boolean - True if successful, rolls back changes and raises an Error in case of failure.
   *
   */
  approveEvent: Scalars['Boolean']['output'];
  /**
   * Summary: Assigns a role to an employment (live reference — role edits
   * propagate to the member immediately).
   *
   * Auth: Requires manage permission_management.
   *
   * Returns: Boolean.
   *
   */
  assignRole: Scalars['Boolean']['output'];
  /**
   * Summary: Attaches one or more Active Storage blobs to an existing kick-off record.
   *
   * Auth: Requires user to be logged in.
   *
   * Arguments:
   *   - id (required) - The kick-off to attach documents to.
   *   - signed_ids (required) - Array of blob signed IDs to attach.
   *
   * Returns: Boolean. True if successful; otherwise either sets 'KickOff#errors' and returns false, or raises an appropriate Error based on 'attach' logic.
   *
   */
  attachKickOffDocuments: Scalars['Boolean']['output'];
  /**
   * Summary: Triggers a bulk import of company equipment records from an uploaded file.
   *
   * Auth: Requires user to be logged in (should have an appropriate permission).
   *
   * Arguments:
   *   - signed_id (required) - The Active Storage signed ID of the uploaded file to process.
   *
   * Returns: Boolean. True if 'CreateBulkRecord' returns the CSV row array; raises GraphQL::ExecutionError in case of failure.
   *
   */
  bulkImportCompanyEquipments: Scalars['Boolean']['output'];
  /**
   * Summary: Bulk import of company resources/clients (e.g. human resources) from an uploaded spreadsheet.
   *
   * Auth: Requires user to be logged in (should have a proper authorization check in the future).
   *
   * Arguments:
   *   - import_type (required) - String identifying which importer to run (e.g. "humans", "equipments").
   *   - signed_id (required) - Signed ID of the previously uploaded spreadsheet blob (.xls or .xlsx).
   *
   * Side effects: Enqueues a background job that parses the spreadsheet, creates CompanyResource/ResourceMeta/Clients records for valid rows, and sends an in-app notification (plus an email for header/row errors) to the current user's default employment.
   *
   * Returns: Boolean. True once the import job has been successfully enqueued (not once the import itself has completed).
   *
   */
  bulkImportResources: Scalars['Boolean']['output'];
  /**
   * Summary: Triggers a bulk import of users from an uploaded CSV.
   *
   * Auth: Requires user to be logged in (should have an appropriate permission).
   *
   * Arguments:
   *   - file_signed_id (required) - The Active Storage signed ID of the uploaded CSV.
   *
   * Returns: Boolean. True if the importer returns ActiveRecord::Import; raises GraphQL::ExecutionError in case of failure.
   *
   */
  bulkImportUsers: Scalars['Boolean']['output'];
  /**
   * Summary: Transitions a project to a new status, enforcing preconditions and triggering cascading effects on cancellation.
   *
   * Auth: Requires edit_projects permission (since the resolver updates Project#status) for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - projectId (required) - The project to update.
   *   - status (required) - The new status value. Requires a client and main address for statuses other than not_started.
   *
   * Side effects: Transitions project status. On cancellation, bulk-drops future schedules and marks related events/activities as discontinued or cancelled. Sends cancellation emails to project managers.
   *
   * Returns: Boolean. True if project data is persisted; raises GraphQL::ExecutionError if flow breaks at any point prior.
   *
   */
  changeProjectStatus: Project;
  /**
   * Summary: Fully finalises a kick-off end-to-end: resolves or creates the client company, upserts the project with all associations, replaces team and activity records, and dispatches completion emails.
   *
   * Auth: Requires the create_project_kick_off permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - kick_off_id (required) - The kick-off to complete.
   *   - emails (optional) - Optional additional email addresses to notify beyond the assigned managers and initiator.
   *   - file_url (optional) - Optional — attaches a file at this URL to the project.
   *
   * Side effects: Creates/updates client and project records with associated users, activities, settings, and addresses. Finalizes the kick-off by transitioning status to finished. Sends completion email notifications.
   *
   * Returns: Boolean. True if kick off data is persisted; rolls back changes and raises GraphQL::ExecutionError in case of an error.
   *
   */
  completeKickOff: Scalars['Boolean']['output'];
  /**
   * Summary: Request site access for the provided email address.
   *
   * Auth: None - it is a publicly accessible mutation via the marketing page.
   *
   * Arguments:
   *   - email (required) - The email address to request access for.
   *
   * Returns: Boolean. True if successful, raises GraphQL::ExecutionError in case of an error.
   *
   */
  createAccessRequest: Scalars['Boolean']['output'];
  /**
   * Summary: Link a Stripe Customer Portal session for managing an existing
   * paid subscription (update card, change plan, cancel).
   *
   * Auth: Requires user to be logged in, their default employment to be an owner,
   * and an existing Stripe customer on file.
   *
   * Arguments:
   *   - None
   *
   * Returns: String. The Stripe-hosted billing portal URL to redirect the user to.
   *
   */
  createBillingPortalSession: Scalars['String']['output'];
  /**
   * Summary: Bulk-creates Schedule entries for a list of company resources across a date range, with first-time sub-contractor invitation notifications.
   *
   * Auth: Requires logged in user (should have a proper permission).
   *
   * Arguments:
   *   - schedules (required) - ScheduleCreateType array containing the schedules to create.
   *
   * Side effects: Creates in-app notifications.
   *
   * Returns: Boolean. True if the schedules are created successfully; raises GraphQL::ExecutionError if validation or execution fails.
   *
   */
  createBulkSchedules: Scalars['Boolean']['output'];
  /**
   * Summary: Creates multiple new employee users under the current company and sends them invitation emails.
   *
   * Auth: Requires create_employee_management permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - users (required) - Array of UserCreateType including first_name, last_name, email, primary_phone, bio, and optional company_resource_id.
   *
   * Side effects: Sends email notifications.
   *
   * Returns: Boolean. True if all users are created successfully; rolls back changes and raises GraphQL::ExecutionError if any execution fails.
   *
   */
  createBulkUsers?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Summary: Idempotently creates a new editable Compensation Event Quotation for a given event — skips creation if an editable CEQ already exists.
   *
   * Auth: Requires create_events permission (as Compensation Event Quotations are related to Events) for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - event_id (required) - The event to create a CEQ for.
   *   - cen_id (optional) - The Compensation Event Notice to associate the CEQ with (can be null).
   *
   * Returns: Boolean. True if the CEQ is created successfully (or already exists); raises GraphQL::ExecutionError if the CEQ is not created.
   *
   */
  createCeq: Scalars['Boolean']['output'];
  /**
   * Summary: Adds a new billable item to a CEQ and backfills a SubEventBillableItem row for every existing sub-event on that CEQ.
   *
   * Auth: Requires create_events permission (as Compensation Event Quotations are related to Events) for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - ceq_id (required) - The CEQ to add the billable item to.
   *   - resource_type (required) - The type of resource (User, CompanyEquipment, Materials, etc.). SubContractor is normalised to Company internally.
   *   - resource_id (required) - The specific resource being billed.
   *   - unit (optional) - The unit of the item (can be null).
   *   - role (optional) - The role the item is assuming (can be null).
   *
   * Returns: Boolean. True if the billable item and sub-event billable items are created successfully; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  createCeqBillableItem: Scalars['Boolean']['output'];
  /**
   * Summary: Creates a new sub-event on a CEQ and scaffolds SubEventBillableItem rows for every existing billable item on that CEQ.
   *
   * Auth: Requires create_events permission (as Compensation Event Quotations are related to Events) for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - ceq_id (required) - The CEQ to add a sub-event to.
   *
   *
   * Returns: Types::CeqSubEventType - The created sub-event to let callers update cache; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  createCeqSubEvent: CeqSubEvent;
  /**
   * Summary: Creates a Stripe Checkout Session for the current user's owner employment
   * to subscribe to a monthly or yearly plan.
   *
   * Auth: Requires user to be logged in and their default employment to be an owner.
   *
   * Arguments:
   *   - interval: "monthly" or "yearly"
   *   - return_path: where to redirect after success/cancel (defaults to app root)
   *
   * Returns: String. The Stripe-hosted checkout URL to redirect the user to.
   *
   */
  createCheckoutSession: Scalars['String']['output'];
  /**
   * Summary: Creates a new client company with its primary address and links it to the current user's company.
   *
   * Auth:
   *   - Bypassed when the request originates from the contracts funnel (context[:origin] == :contracts_funnel);
   *   - Otherwise requires create_clients permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - client (required) - ClientCreateType containing the client fields.
   *
   * Side effects: Creates a company client record and a primary address for the client.
   *
   * Returns: Types::ClientType - The created client to let callers update cache; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  createClient?: Maybe<Client>;
  /**
   * Summary: Creates a Client Instruction record for an event with optional document attachments.
   *
   * Auth: Requires create_events permission (as Client Instructions belong to CENs) for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - client_instruction (required) - ClientInstructionCreateType containing the client instruction fields.
   *
   * Side effects: Creates document attachments if provided.
   *
   * Returns: Boolean. True if the client instruction is created successfully; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  createClientInstructions: Scalars['Boolean']['output'];
  /**
   * Summary: Creates or finds an existing client invitation for a company-client and project pair, and sends an invitation email to the client.
   *
   * Auth: Requires user to be logged in (should have a proper permission).
   *
   * Arguments:
   *   - client_id (required) - The client company being invited.
   *   - project_id (required) - The project the invitation is for.
   *
   * Side effects: Sends email notifications.
   *
   * Returns: Boolean. True if the client invitation is created successfully; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  createClientInvitation: Scalars['Boolean']['output'];
  /**
   * Summary: Creates a new company with its address, seeds default resource categories, and registers the current user as the owner.
   *
   * Auth: Requires user to be logged in to create the company.
   *
   * Arguments:
   *   - owner_id (optional) - Should be removed in the future; it is not used anymore.
   *   - name (required)
   *   - primary_phone (required)
   *   - primary_email (required)
   *   - is_parent (required)
   *   - street (required)
   *   - city (required)
   *   - state (required)
   *   - country (required)
   *   - zip (required)
   *   - company_number (required)
   *   - trading_name (optional)
   *   - vat_number (optional)
   *   - company_type (optional)
   *   - logo_signed_id (optional)
   *
   * Side effects: Creates the company address, its resource categories, and registers the current user as the owner.
   *
   * Returns: String - The new company's ID to let callers fetch the company manually; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  createCompany: Scalars['String']['output'];
  /**
   * Summary: Links an existing contract type to the current user's company by creating a CompanyContractType join record.
   *
   * Auth: None (however should have an authorization check in the future)
   *
   * Arguments:
   *   - contract_type (required) - CompanyContractTypeInput containing contract_type_id.
   *
   *
   * Returns: Types::CompanyContractType - The created join record to let callers update cache; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  createCompanyContractType: CompanyContract;
  /**
   * Summary: Creates a new equipment record scoped to the current user's company.
   *
   * Auth: Requires create_equipment_management permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - company_equipment (required) - CreateEquipmentType containing the equipment fields. Has quantity as optional.
   *
   * Returns: Types::CompanyEquipmentType - The created equipment to let callers update cache; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  createCompanyEquipment: CompanyEquipment;
  /**
   * Summary: Creates a new company resource and its associated metadata record, with optional sub-contractor invitation.
   *
   * Auth: Requires user to be logged in (should have a proper permission).
   *
   * Arguments:
   *   - company_resource (required) - CompanyResourceCreateType containing resource_type, name, resource_meta (with optional signed_ids for file attachments), and invite_sub_contractor flag.
   *
   * Side effects: Creates a sub-contractor invitation and sends invitation emails if invite_sub_contractor is enabled.
   *
   * Returns: Boolean. True if the company resource is created successfully; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  createCompanyResource: Scalars['Boolean']['output'];
  /**
   * Summary: Provisions a schedulable human CompanyResource on-demand for an existing User.
   * Auth: Requires create:employee_management permission or company owner.
   * Arguments:
   *   - user_id (required) - The user to provision a resource for.
   *   - company_id (optional) - Scoped company, defaults to current_user.default_company_id.
   * Returns: Types::CompanyResourceType.
   *
   */
  createCompanyResourceForUser?: Maybe<CompanyResource>;
  /**
   * Summary: Creates or updates a key-value setting for the current user's default company using upsert behaviour.
   *
   * Auth: Requires user to be logged in (should have a proper permission).
   *
   * Arguments:
   *   - name (required) - The setting key. Used together with company_id to find-or-initialize the record.
   *   - value (required) - The setting value to store.
   *
   * Returns: Boolean. True if the company setting is created successfully; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  createCompanySetting: CompanySetting;
  /**
   * Summary: Batch-creates one or more tags for the current user's company.
   *
   * Auth: Requires user to be logged in (should have a proper permission).
   *
   * Arguments:
   *   - company_tags (required) - CompanyTagCreateType containing title — an array of tag name strings to create.
   *
   * Returns: [Types::CompanyTagType] - The created tags to let callers update cache; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  createCompanyTags: Array<CompanyTag>;
  /**
   * Summary: Creates a Compensation Event Notice for an event with optional document attachments.
   *
   * Auth: Requires create_events permission (as Compensation Event Notices belong to Events) for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - cen (required) - CompensationEventNoticeCreateType containing the compensation event notice fields. Has signed_ids as optional.
   *
   * Side effects: Creates document attachments if provided.
   *
   * Returns: Boolean. True if the Compensation Event Notice is created successfully; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  createCompensationEventNotice: Scalars['Boolean']['output'];
  /**
   * Summary: Creates a Compensation Event Quotation with optional image attachments.
   *
   * Auth: Requires create_events permission (as Compensation Event Quotations belong to Events) for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - quotation (required) - CompensationEventQuotationCreateType containing the compensation event quotation fields. Has signed_ids as optional.
   *
   * Side effects: Creates image attachments if provided.
   *
   * Returns: Boolean. True if the Compensation Event Quotation is created successfully; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  createCompensationEventQuotation: Scalars['Boolean']['output'];
  /**
   * Summary: Creates or finds the project-level delivery and collection register and adds new items with their initial state records, all tied to a specific report.
   *
   * Auth: Requires create_scheduling permission (as Delivery and Collection Registers belong to Scheduling) for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - delivery_and_collection_register (required) - DeliveryAndCollectionRegisterCreateType containing the delivery and collection register fields. Has report_id as required and items[] as optional.
   *
   * Returns: [Types::DeliveryAndCollectionItemStateType] - The created state records created to let callers update cache; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  createDeliveryAndCollectionRegister: Array<DeliveryAndCollectionItemState>;
  /**
   * Summary: Provisions an Active Storage blob for a client-side direct upload and creates a Document record, returning the credentials needed for the client to PUT the file directly to storage.
   *
   * Auth: Requires user to be logged in (as users should not be able to upload files without being logged in).
   *
   * Arguments:
   *   - input (required) - DirectUploadCreateType containing the direct upload fields. Has key, filename, byte_size, checksum, and content_type as required.
   *
   * Returns: Types::DirectUploadType - The direct upload credentials to let callers complete the upload; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  createDirectUpload: DirectUpload;
  /**
   * Summary: Creates an Early Warning Notice for an event, with optional notifications and document attachments.
   *
   * Auth: Requires create_events permission (as Early Warning Notices belong to Events) for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - ewn (required) - EarlyWarningNoticeCreateType containing the early warning notice fields. Has event_id as required, notice as required, notifiable_ids as optional, and signed_ids as optional.
   *
   * Side effects: Sends email notifications and creates in-app notifications.
   *
   * Returns: Boolean. True if the Early Warning Notice is created successfully; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  createEarlyWarningNotice: Scalars['Boolean']['output'];
  /**
   * Summary: Creates a new event for a project and notifies all assigned project members.
   *
   * Auth: Requires create_events permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - event (required) - EventCreateType input containing event fields.
   *
   * Side effects: Creates in-app notifications.
   *
   * Returns: Types::EventType. The created event to let callers update cache; raises GraphQL::ExecutionError if execution fails.
   *
   */
  createEvent: Event;
  /**
   * Summary: Adds a comment to an event, stamped with the current user's employment and the event's current status at the time of commenting.
   *
   * Auth: Requires create_events permission (as Event Comments belong to Events) for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - event_id (required) - The event to comment on.
   *   - text (required) - The comment body.
   *
   *
   * Returns: Boolean. True if the mutation completes successfully. False if the event comment is not created.
   *
   */
  createEventComment: Scalars['Boolean']['output'];
  /**
   * Summary: Creates a new feedback record with optional file attachments.
   *
   * Auth: None; current locations that call this mutation all require user authentication, but given that it is a 'feedback' mutation, it is not clear if this is a public endpoint or not.
   *
   * Arguments:
   *   - feedback (required) - FeedbackCreateType input including feedback content fields and optional signed_ids for file attachments.
   *
   * Side effects: Creates file attachments if provided.
   *
   * Returns: Boolean. True if the feedback is created successfully; raises GraphQL::ExecutionError if validation or execution fails.
   *
   */
  createFeedback: Scalars['Boolean']['output'];
  /**
   * Summary: Files a request for a permission grant (optionally scoped to a
   * project) and notifies the company's permission admins in-app and by email.
   *
   * Auth: Requires user to be logged in.
   *
   * Returns: Types::GrantRequestType.
   *
   */
  createGrantRequest: GrantRequest;
  /**
   * Summary: Creates a guest company resource and schedule for a project in one transaction.
   *
   * Auth: Requires user to be logged in (as guest user schedules are created by logged in users).
   *
   * Arguments:
   *   - resource_schedule (required) - GuestUserScheduleCreateType input with project_id, name, resource_type, and schedule fields.
   *
   * Returns: Boolean. True if the schedule is created successfully; rolls back changes and raises CreateGuestUserScheduleError when buffer validation fails.
   *
   */
  createGuestSchedule: Scalars['Boolean']['output'];
  /**
   * Summary: Creates a new company resource with the resource type set to HUMAN. For use with ManagerAutocomplete.
   *
   * Auth: Requires user to be logged in (should have a proper permission).
   *
   * Arguments:
   *   - name (required) - The name of the human resource.
   *
   * Side effects: -
   *
   * Returns: Types::CompanyResourceType. The created event to let callers update cache; raises GraphQL::ExecutionError if execution fails.
   *
   */
  createHumanResource: CompanyResource;
  /**
   * Summary: Creates a standalone issue record with optional file attachments.
   *
   * Auth: Requires user to be logged in.
   *
   * Arguments:
   *   - issue (required) - IssueCreateType containing the issue fields. Has start_time, end_time as required, and signed_ids as optional.
   *
   * Side effects: Creates file attachments if provided.
   *
   * Returns: Boolean. True if the issue is created successfully; rolls back changes and raises GraphQL::ExecutionError if validation or execution fails.
   *
   */
  createIssue: Scalars['Boolean']['output'];
  /**
   * Summary: Appends a new column to a Kanban board's JSON column array, preventing duplicate column IDs.
   *
   * Auth: Requires user to be logged in (as Kanban Columns are company-specific). Should have an explicit permission check in the future.
   *
   * Arguments:
   *   - name (required) - The board name (used with company_id to find the KanbanColumn record).
   *   - title (required) - The display title for the new column.
   *   - column_id (required) - A unique string identifier for the column within the board. Raises ExecutionError if a column with this ID already exists.
   *
   * Returns: Types::KanbanColumnType. The updated Kanban Column data to let callers update cache; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  createKanbanColumns?: Maybe<KanbanColumn>;
  /**
   * Summary: Creates a new kick-off record for the current user's company, or reuses an existing draft if one already exists for the same project.
   *
   * Auth: Requires create_project_kick_off permission (as Kick-Offs belong to Projects) for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - kick_off (required) - KickOffCreateType containing project_id and other kick-off fields. When a project_id is present, reuses the existing draft for that project; otherwise reuses the last project-less company draft.
   *
   * Returns: String. The kick-off ID to let callers manually refetch the kick-off record; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  createKickOff: Scalars['String']['output'];
  /**
   * Summary: Creates a new meeting record, optionally associated with a project.
   *
   * Auth: Requires view_projects permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - meeting_data (optional) - CreateMeetingInputType containing optional project_id, title, scheduled_at, mode, and meeting_note_sections (stripped before save — not persisted on create).
   *     - meeting_data.project_id
   *     - meeting_data.title (optional | default: "Internal Meeting")
   *     - meeting_data.scheduled_at (optional | default: Time.zone.now)
   *     - meeting_data.mode (optional | default: "online")
   *     - meeting_data.meeting_note_sections
   *
   *
   * Returns: Types::ProjectMeetingType. Mutation result.
   *
   */
  createMeeting: ProjectMeeting;
  /**
   * Summary: Creates structured meeting notes from section content and automatically creates tasks from any @mention patterns found in the notes.
   *
   * Auth: Requires view_projects permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - meeting_id (required) - The meeting the minutes belong to.
   *   - note_sections (required) - Array of JSON objects representing note sections; each non-blank HTML chunk becomes a MeetingNote record.
   *
   *
   * Returns: Boolean. True if the mutation completes successfully.
   *
   */
  createMeetingMinutes: Scalars['Boolean']['output'];
  /**
   * Summary: Creates a new note with optional tags, file attachments, and a reminder notification.
   *
   * Auth: Requires user to be logged in.
   *
   * Arguments:
   *   - note_data (required) - NotesCreateType containing the note fields. Has description, notes_type, target_type, target_id , reminder as optional, tag_ids (optional) and signed_ids (optional).
   *
   * Side effects: Creates file attachments if provided and schedules a reminder if a reminder is set.
   *
   * Returns: Types::NoteType. The created note to let callers update cache; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  createNotes?: Maybe<Note>;
  /**
   * Summary: Creates or upserts a project along with all its associated records in a single transaction.
   *
   * Auth: Bypassed when the request originates from the contracts funnel; otherwise requires create_projects permission.
   *
   * Arguments:
   *   - project (required) - ProjectCreateType — a rich input containing the project fields. Has id, title, code, description, dates, client_id, company_id, visible, client_reps, project_users, tag_ids, contract_type_ids, addresses, activities, source_id/source_type, and settings as required. The id field allows upsert behaviour — if the project already exists it is updated.
   *
   * Side effects: Creates file attachments if provided, project addresses, project activities, project contract types, project settings, project users, project tags, and project sources.
   *
   * Returns: String. The project's ID to let callers manually refetch the project record; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  createProject: Scalars['String']['output'];
  /**
   * Summary: Creates a new activity log entry for a project, stamped with the current user as creator.
   *
   * Auth: Requires create_projects permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - project_activity (required) - ProjectActivityCreateType containing the project activity fields.
   *
   *
   * Returns: Boolean. True if the project activity is created successfully; raises GraphQL::ExecutionError if execution fails.
   *
   */
  createProjectActivity: Scalars['Boolean']['output'];
  /**
   * Summary: Creates a new project template for the current user's company.
   *
   * Auth: Requires user to be logged in with a default company; template is created for current_user.default_company_id.
   *
   * Arguments:
   *   - project_template (required) - ProjectTemplateCreateType containing the project template fields. Has title, description, activities, tag_ids, and manager_ids as required.
   *
   * Side effects: Creates file attachments if provided.
   *
   * Returns: Types::ProjectTemplateType. The created template to let callers update cache; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  createProjectTemplate: ProjectTemplate;
  /**
   * Summary: Creates an issue in the context of a report, sets the creator, and optionally attaches files and associates named categories.
   *
   * Auth: Requires create_reports permission (possibly should be a different permission) for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - report_issue (required) - IssueCreateType containing the issue fields. Has start_time, end_time as required, signed_ids as optional, and category_names as optional.
   *
   * Side effects: Creates file attachments if provided and associates named categories if provided.
   *
   * Returns: Types::IssueType. The created issue to let callers update cache; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  createReportIssue: Issue;
  /**
   * Summary: Creates a new representative (client-facing portal user) with an auto-generated password.
   *
   * Auth: None required — open create; relies on resolver-level validation only.
   *
   * Arguments:
   *   - representative (required) - RepresentativeCreateType containing the representative fields. Has name, email, phone, password as required.
   *
   * Returns: Boolean. True if the representative is created successfully; raises GraphQL::ExecutionError if validation or execution fails.
   *
   */
  createRepresentative: Scalars['Boolean']['output'];
  /**
   * Summary: Creates a new resource category for the company.
   *
   * Auth: None (however should have an authorization check in the future)
   *
   * Arguments:
   *   - resource_category (required) - ResourceCategoryCreateType containing the resource category fields. Has company_id and name as required.
   *
   * Returns: Boolean. True if the resource category is created successfully; raises GraphQL::ExecutionError if validation or execution fails.
   *
   */
  createResourceCategory: Scalars['Boolean']['output'];
  /**
   * Summary: Bulk-creates Schedule entries for a resource (or placeholder) across a date range in one import, replacing the older single-record create mutation.
   *
   * Auth: Requires create_scheduling permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - input (required) - CreateResourceScheduleV2InputType containing resource_id, resource_type, project_id, address_id, date, end_date, start_time, end_time, source, title, description_of_service, collectable, on_hire, quantity, and resource_name for placeholder entries.
   *
   * Side effects: Creates schedules and toggles ignored conflicting schedules.
   *
   * Returns: Object. The created schedules and the presence of conflicts to let callers update cache; raises GraphQL::ExecutionError if execution fails.
   *
   */
  createResourceScheduleV2: CreateResourceScheduleV2Payload;
  /**
   * Summary: Creates a company role bundling (action, entity) grants; assignment
   * to employments is live — later edits to the role apply to all members.
   *
   * Auth: Requires manage permission_management.
   *
   * Returns: Types::RoleType.
   *
   */
  createRole: Role;
  /**
   * Summary: Creates a single resource schedule and optionally registers delivery/collection item states when collectable.
   *
   * Auth: Requires create_scheduling permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - resource_schedule (required) - ResourceScheduleCreateType containing the resource schedule fields. Has resource_id, resource_type, project_id, address_id, start_time, end_time, source, title, description_of_service, collectable, on_hire, quantity, and resource_name as required.
   *
   * Side effects: Creates delivery/collection register items and states when collectable; creates notifications for user resources.
   *
   * Returns: Object. The created schedule and the presence of conflicts to let callers update cache; raises GraphQL::ExecutionError if execution fails.
   *
   */
  createSingleSchedule: CreateSingleResourceSchedulePayload;
  /**
   * Summary: Creates a sub-contractor relationship between the current company and another company, handling both new and existing companies and their principal contacts.
   *
   * Auth: None (however should have an authorization check in the future)
   *
   * Arguments:
   *   - sub_contractor (required) - SubContractorCreateType containing the sub-contractor fields. Has name, principal_contact (containing name, email, primary_phone) as required.
   *
   * Side effects: Creates an employment for the principal contact if they are not already associated with the sub-contractor.
   *
   * Returns: Boolean. True if the sub-contractor is created successfully; raises GraphQL::ExecutionError if validation or execution fails.
   *
   */
  createSubContractor: Scalars['Boolean']['output'];
  /**
   * Summary: Creates or finds an existing sub-contractor invitation for a company resource and sends an invitation email.
   *
   * Auth: Requires user to be logged in.
   *
   * Arguments:
   *   - company_resource_id (required) - The company resource to invite.
   *   - project_id (optional) - The project to invite the company resource to.
   *
   * Side effects: Creates a sub-contractor invitation and sends an invitation email.
   *
   * Returns: Boolean. True if the sub-contractor invitation is created successfully; raises GraphQL::ExecutionError if execution fails.
   *
   */
  createSubContractorInvitation: Scalars['Boolean']['output'];
  /**
   * Summary: Creates sub-contractor schedule entries for one or more sub-contractors across a date range, and sends first-time project invitations to newly assigned subs.
   *
   * Auth: Requires create_scheduling permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - sub_contractor_schedule (required) - SubContractorScheduleCreateType containing project_id, sub_contractor_ids[], date, end_date, start_time, end_time, description_of_service, address_id.
   *
   * Side effects: Creates sub-contractor schedules and sends project invitations to newly assigned subs.
   *
   * Returns: Boolean. True if the sub-contractor schedules are created successfully; raises GraphQL::ExecutionError if validation or execution fails.
   *
   */
  createSubContractorSchedules: Scalars['Boolean']['output'];
  /**
   * Summary: Creates a new task and notifies the assignee based on their task notification preferences.
   *
   * Auth: Requires user to be logged in (should have an authorization check in the future).
   *
   * Arguments:
   *   - task (required) - TaskCreateType containing the task fields. Has title, description, assignee_id, and signed_ids as required.
   *
   * Side effects: Creates file attachments if provided and dispatches notifications to the assignee based on their task notification preferences.
   *
   * Returns: Boolean. True if the task is created successfully; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  createTask: Scalars['Boolean']['output'];
  /**
   * Summary: Creates a comment on a task and dispatches notifications to mentioned users, the assignee, and the creator.
   *
   * Auth: Requires user to be logged in.
   *
   * Arguments:
   *   - comment (required) - TaskCommentInputType containing the comment fields. Has task_id, content, and parent_comment as required.
   *
   * Side effects: Dispatches notifications to mentioned users, the assignee, and the creator (if they are different from the current user).
   *
   * Returns: Boolean. True if the comment is created successfully; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  createTaskComment: Scalars['Boolean']['output'];
  /**
   * Summary: Creates a new employee user under the current company and sends them an invitation email.
   *
   * Auth: Requires create_employee_management permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - user (required) - UserCreateType including first_name, last_name, email, primary_phone, bio, and optional company_resource_id to link to an existing resource.
   *
   * Side effects: Sends email notifications.
   *
   * Returns: Boolean. True if the user is created successfully; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  createUser?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Summary: Creates or finds an existing user merge request for a source user and target user pair.
   *
   * Auth: Requires user to be logged in (should have a proper permission).
   *
   * Arguments:
   *   - source_email (required) - The email of the user to merge.
   *
   * Side effects: Sends email notifications.
   *
   * Returns: Boolean. True if the user merge request is created successfully; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  createUserMergeRequest: Scalars['Boolean']['output'];
  /**
   * Summary: Initiates the password reset flow by sending reset instructions to the provided email address.
   *
   * Auth: None required as the potential user lands on this page via an email invite, and their password reset flow is handled in here
   *
   * Arguments:
   *   - email (required) - The user's email. If no account is found for this email, the mutation still returns true to prevent email enumeration.
   *   - origin (required) - The calling application/domain, used to build the correct reset link URL.
   *
   * Returns: Boolean. True in all cases to avoid spilling information about the existence of the email address.
   *
   */
  createUserPasswordReset: Scalars['Boolean']['output'];
  /**
   * Summary: Deletes a role and its assignments. Members lose the role's
   * grants immediately; their direct grants are untouched.
   *
   * Auth: Requires manage permission_management.
   *
   * Returns: Boolean.
   *
   */
  deleteRole: Scalars['Boolean']['output'];
  /**
   * Summary: Fully removes a document — its metadata records, the Document row, and the underlying Active Storage blob from storage.
   *
   * Auth: Requires user to be logged in (should have an authorization check in the future).
   *
   * Arguments:
   *   - id (required) - The Document record ID to destroy.
   *
   * Returns: Boolean. True if the attachment is destroyed successfully; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  destroyAttachment: Scalars['Boolean']['output'];
  /**
   * Summary: Removes the link between a contract type and the current user's company.
   *
   * Auth: None (should have an authorization check in the future).
   *
   * Arguments:
   *   - id (required) - The contract type ID to destroy.
   *
   * Returns: Boolean. True if the company contract type is destroyed successfully; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  destroyCompanyContractType: Scalars['Boolean']['output'];
  /**
   * Summary: Deletes a delivery and collection item. If it is the last item in the register, the entire register is deleted instead.
   *
   * Auth: Requires manage_scheduling permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - id (required) - The delivery and collection item ID to destroy.
   *
   * Returns: Boolean. True if the delivery and collection item is destroyed successfully; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  destroyDeliveryAndCollectionItem: Scalars['Boolean']['output'];
  /**
   * Summary: Permanently destroys a kick-off template and its dependent associations.
   *
   * Auth: Requires user to be logged in.
   *
   * Arguments:
   *   - id (required) - The kick-off template ID to destroy.
   *
   *
   * Returns: Boolean. True if the kick-off template is destroyed successfully; False in case of failure.
   *
   */
  destroyKickOffTemplate: Scalars['Boolean']['output'];
  /**
   * Summary: Permanently destroys a note and its cascading dependents (tags, attachments).
   *
   * Auth: Requires user to be logged in.
   *
   * Arguments:
   *   - id (required) - The note ID to destroy.
   *
   * Returns: Boolean. True if the Note is destroyed successfully; False in case of failure.
   *
   */
  destroyNotes: Scalars['Boolean']['output'];
  /**
   * Summary:
   *   Soft-marks a project for deletion by setting a metadata flag — does not immediately destroy records. The idea is that a background job at a later point
   *   should be able to query 'auto_delete' projects through 'metadata' and purge them.
   *
   * Auth: Requires manage_projects permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - id (required) - The project ID to soft-delete
   *
   * Returns: Boolean. True if the Project is soft-deleted successfully; raises GraphQL::ExecutionError if execution fails.
   *
   */
  destroyProject: Scalars['Boolean']['output'];
  /**
   * Summary: Permanently deletes a project activity record by ID.
   *
   * Auth: Requires manage_projects permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - id (required) - The project activity ID to destroy.
   *
   * Returns: Boolean. True if the ProjectActivity is destroyed successfully; False in case of failure.
   *
   */
  destroyProjectActivity: Scalars['Boolean']['output'];
  /**
   * Summary: Permanently deletes an issue by ID.
   *
   * Auth: Requires manage_reports permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - id (required) - The issue ID to destroy.
   *
   *
   * Returns: Boolean. True if the issue is destroyed successfully; False in case of failure.
   *
   */
  destroyReportIssue: Scalars['Boolean']['output'];
  /**
   * Summary: Removes a sub-contractor association from the current company, with options to handle their existing future schedules.
   *
   * Auth: Requires manage_subcontractor_management permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - id (required) - The sub-contractor company ID to remove.
   *   - ignore_schedules (optional) - When true, all future schedules for this sub-contractor are deleted.
   *   - updated_sub_contractor_id (optional) - When provided, future schedules are reassigned to this replacement sub-contractor instead of being deleted.
   *
   * Returns: Boolean. True if the sub-contractor is destroyed successfully; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  destroySubContractor: Scalars['Boolean']['output'];
  /**
   * Summary: Permanently destroys a task and its cascading dependents.
   *
   * Auth: Requires user to be logged in (should have an authorization check in the future).
   *
   * Arguments:
   *   - id (required) - The task ID to destroy.
   *
   *
   * Returns: Boolean. True if the task is destroyed successfully; False in case of failure.
   *
   */
  destroyTask: Scalars['Boolean']['output'];
  /**
   * Summary: Attaches uploaded documents to a project and marks it as visible — used in the contracts funnel onboarding flow.
   *
   * Auth: None (however should have some form of authorization even if it is meant to be used via embedding the funnel)
   *
   * Arguments:
   *   - project_id (required) - The project ID to attach documents to.
   *   - document_ids (required) - Array of Document record IDs whose blobs are attached.
   *
   * Returns: Boolean. True if the attachments are dispatched successfully; False in case of failure.
   *
   */
  dispatchAttachments: Scalars['Boolean']['output'];
  /**
   * Summary: Marks a Compensation Event Notice as disputed and notifies the entire project team by email.
   *
   * Auth: Requires create_events permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - id (required) - The Compensation Event Notice ID to dispute.
   *
   * Side effects: Locks the notice for editing by transitioning its state to disputed and sends dispute emails to project users.
   *
   * Returns: Boolean. True if the Compensation Event Notice is disputed successfully; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  disputeCompensationEventNotice: Scalars['Boolean']['output'];
  /**
   * Summary: Soft-deletes one or more Schedule records by setting their status to dropped in a single bulk update.
   *
   * Auth: Requires create_scheduling permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - ids (required) - The schedule IDs to drop. Uses update_all — no model callbacks are fired.
   *
   *
   * Side effects: Bulk-updates related records (e.g. schedules, events, or activities).
   *
   * Returns: Object. { dropped_ids: [ID] } — the IDs that were actually updated.
   *
   */
  dropResourceScheduleV2: DropResourceScheduleV2Payload;
  /**
   * Summary: Silently renews the current user's session using the refresh token cookie, keeping the session alive without requiring re-login.
   *
   * Auth: None required — exchanges the refresh token cookie for a renewed session.
   *
   * Arguments: None
   *
   * Side Effects: Rotates the refresh token. Replaying a token that was already rotated (outside a short grace window) is treated as theft and revokes the session.
   *
   * Returns: Boolean. True if the mutation completes successfully; raises GraphQL::ExecutionError with status EXPIRED and clears cookies if the token is missing, expired, revoked, or replayed.
   *
   */
  exchangeRefreshTokenForJwt: Scalars['Boolean']['output'];
  /**
   * Summary: Exports the current user's default company data to an .xlsx workbook and emails the download to the requesting user.
   *
   * Auth: Requires user to be logged in and to have an `owner`-type employment at their default company.
   *
   * Arguments: None.
   *
   * Side effects: Builds an .xlsx export of the company's data (companies, roles, company_clients,
   *   company_resources, projects, schedules, reports, employments, and tasks), uploads it via
   *   ActiveStorage, and emails a copy to the requesting user.
   *
   * Returns: Boolean. True once the export has run and the email has been sent; raises
   *   GraphQL::ExecutionError if the user is not authorized.
   *
   */
  exportUserData: Scalars['Boolean']['output'];
  /**
   * Summary: Finalises and issues a Compensation Event Notice, locking it from further edits and emailing the project client.
   *
   * Auth: Requires create_events permission (as Compensation Event Notices belong to Events) for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - id (required) - The Compensation Event Notice ID to issue.
   *
   * Side effects: Sends issue emails to the client.
   *
   * Returns: Boolean. True if the Compensation Event Notice is issued successfully; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  issueCompensationEventNotice: Scalars['Boolean']['output'];
  /**
   * Summary: Issues a Compensation Event Quotation by locking it, generating a PDF, and emailing it to the project client.
   *
   * Auth: Requires create_events permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - id (required) - The CEQ to issue.
   *
   *
   * Side Effects: Locks the quotation for editing, generates a PDF, and emails it to the client.
   *
   * Returns: Boolean. True if the mutation completes successfully; raises GraphQL::ExecutionError if validation or execution fails.
   *
   */
  issueCompensationEventQuotation: Scalars['Boolean']['output'];
  /**
   * Summary: Upserts all addresses for a project — creates new ones, updates existing ones, removes omitted ones, and ensures at least one address is marked as main.
   *
   * Auth: Requires user to be logged in (should have a proper permission check in the future).
   *
   * Arguments:
   *   - addresses (required) - Array of AddressUpdateType objects representing the full desired state of the project's addresses.
   *   - project_id (required) - The project to manage locations for.
   *
   * Returns: Boolean. True if the project locations are managed successfully; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  manageProjectLocations: Scalars['Boolean']['output'];
  /**
   * Summary: Advances a delivery and collection item to the collected terminal state, optionally overriding delivery details and attaching collection documents.
   *
   * Auth: Requires edit_scheduling permission (as DACs are technically schedules) for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - id (required) - The current DeliveryAndCollectionItemState ID.
   *   - deliverer_name (optional) - Optional override for collection details.
   *   - receiver_name (optional) - Optional override for collection details.
   *   - notes (optional) - Optional override for collection details.
   *   - signed_ids (optional) - Optional Active Storage blob IDs to attach to the register (e.g. signed collection documents).
   *
   * Side Effects: Optionally attaches collection documents to the register.
   *
   * Returns: Types::DeliveryAndCollectionItemStateType. The new terminal state record; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  markAsCollected: DeliveryAndCollectionItemState;
  /**
   * Summary: Advances a delivery and collection item to the deployed state and creates a corresponding Schedule entry for the deployed resource.
   *
   * Auth: Requires edit_scheduling permission (as DACs are technically schedules) for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - id (required) - The current DeliveryAndCollectionItemState ID to deploy.
   *   - report_date (optional) - Optional schedule timing field for the created Schedule.
   *   - start_time (optional) - Optional schedule timing field for the created Schedule.
   *   - end_time (optional) - Optional schedule timing field for the created Schedule.
   *
   * Side Effects: Creates a corresponding Schedule entry for the deployed resource.
   *
   * Returns: Boolean. True if the delivery and collection item is deployed successfully; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  markAsDeployed: Scalars['Boolean']['output'];
  /**
   * Summary: Advances a deployed delivery and collection item to the ready_for_collection state and marks the linked schedule as no longer collectable.
   *
   * Auth: Requires edit_scheduling permission (as DACs are technically schedules) for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - company_resource_id (required) - Used to locate the current state record.
   *   - project_id (required) - Used to locate the current state record.
   *   - report_id (required) - Used to locate the current state record.
   *   - schedule_id (required) - The linked Schedule record to update.
   *
   * Side Effects: Marks the linked schedule as no longer collectable.
   *
   * Returns: Types::DeliveryAndCollectionItemStateType. The new state record; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  markAsReadyForCollection: DeliveryAndCollectionItemState;
  /**
   * Summary: Notification find by ID if provided otherwise mark all unread notifications for the current user as read in a single bulk update.
   *
   * Auth: Requires user to be logged in.
   *
   * Arguments:
   *   - None
   *
   * Returns: Boolean. True if the notifications are marked as read successfully; False in case of failure.
   *
   */
  markNotificationsAsRead: Scalars['Boolean']['output'];
  /**
   * Summary: Toggles an emoji reaction on a task comment for the current user's default_employment — looks up an existing Reaction by comment_id, emoji, and employment_id; destroys it if found, otherwise creates one.
   *
   * Auth: Requires user to be logged in.
   *
   * Arguments:
   *   - reaction (required) - TaskCommentReactionInput with comment_id and emoji. employment_id is merged from current_user in resolve and cannot be overridden by the caller.
   *
   * Side effects: Creates or destroys a Reaction record for the given comment and emoji.
   *
   * Returns: Boolean. True when the reaction is removed or created; False if destroy fails. Raises an Error if Reaction.create! fails.
   *
   */
  reactOnTaskComment: Scalars['Boolean']['output'];
  /**
   * Summary: Rejects a custom shift request by assigning selected shift start and end times to the schedule,
   * updating the schedule start and end times, setting custom_shift to false,
   * and marking the notification as read.
   *
   * Auth: Requires approve custom_shifts permission on the project.
   *
   */
  rejectCustomShift: Scalars['Boolean']['output'];
  /**
   * Summary: Rejects a guest user schedule by destroying the schedule, guest employment, and guest user in one transaction.
   *
   * Auth: None (however should have an authorization check in the future)
   *
   * Arguments:
   *   - user_schedule (required) - RejectGuestUserScheduleType input with schedule_id.
   *
   * Side effects: Destroys the guest user, their employment, and the user schedule record.
   *
   * Returns: Boolean. True if the guest user schedule is rejected successfully; False in case of failure.
   *
   */
  rejectGuestSchedule: Scalars['Boolean']['output'];
  /**
   * Summary: Detaches and removes the profile picture for the specified user.
   *
   * Auth: Requires the current user to match the target user id (self-service only).
   *
   * Arguments:
   *   - id (required) - The user's ID. The current user can only remove their own profile picture.
   *
   * Returns: Boolean. True if the profile picture is removed successfully; False in case of failure.
   *
   */
  removeProfilePicture?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Summary: Removes one or more project members/managers by destroying their ProjectUser join records.
   *
   * Auth: None (however should have an authorization check in the future)
   *
   * Arguments:
   *   - user_ids (required) - Array of ProjectUser record IDs to destroy — these are the join record IDs, not User IDs.
   *
   * Returns: Boolean. True if the mutation completes successfully, False otherwise.
   *
   */
  removeUsersFromProject: Scalars['Boolean']['output'];
  /**
   * Summary: Completes the password reset by validating the reset token, setting the new password, and signing the user in.
   *
   * Auth: None required — completes password reset using the token from email.
   *
   * Arguments:
   *   - token (required) - The reset token from the password reset email link.
   *   - password (required) - The new password to set. Must be at least 12 characters and include an uppercase letter, a lowercase letter, and a number.
   *
   * Side Effects: Revokes all existing sessions for the user, unlocks the account if it was locked, and opens a new session by setting auth and refresh token cookies.
   *
   * Returns: Boolean. True once the password is reset and the user is signed in. Raises GraphQL::ExecutionError if the token is invalid or expired, or the password fails policy.
   *
   */
  resetUserPassword: Scalars['Boolean']['output'];
  /**
   * Summary: Resizes a multi-day schedule span across working days.
   * Extends or shrinks the dates covered by the schedule.
   * Automatically skips weekends (if weekends are disabled for the project) and holidays that conflict with the schedule's shift.
   * Drops truncated day schedules and creates new day schedules with identical metadata.
   *
   * Auth: Requires create_scheduling permission on the schedule's project.
   *
   * Arguments:
   *   - input (required): { ids: [ID!]!, start_date: String!, end_date: String!, start_time: String, end_time: String }
   *
   * Returns: Object containing updated/created schedules, dropped schedule IDs, and conflict status.
   *
   */
  resizeResourceScheduleV2: ResizeResourceScheduleV2Payload;
  /**
   * Summary: Approves or rejects a pending grant request. Approval creates the
   * direct grant (optionally project-narrowed and/or time-bound) and notifies
   * the requestor in-app and by email.
   *
   * Auth: Requires manage permission_management.
   *
   * Returns: Types::GrantRequestType.
   *
   */
  resolveGrantRequest: GrantRequest;
  /**
   * Summary: Reverts a previously approved or rejected report back to an unapproved state, clearing all approval metadata.
   *
   * Auth: Requires manage_events permission (possibly should be manage_reports instead) for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - report_id (required) - The report to revert.
   *
   * Returns: Boolean. True if the report approval is reverted successfully; raises GraphQL::ExecutionError if execution fails.
   *
   */
  revertReportApproval: Scalars['Boolean']['output'];
  /**
   * Summary: Selects the free plan for the current user's owner employment and
   * marks onboarding complete.
   *
   * Auth: Requires user to be logged in and their default employment to be an owner.
   *
   * Arguments:
   *   - None
   *
   * Returns: SubscriptionType.
   *
   */
  selectFreePlan: Subscription;
  /**
   * Summary: Updates the association_type on the DocumentMetadatum record linking a document to a specific polymorphic resource.
   *
   * Auth: Requires user to be logged in (should have an authorization check in the future).
   *
   * Arguments:
   *   - id (required) - The document ID.
   *   - attachable_type (required) - Identifies the specific DocumentMetadatum row to update.
   *   - attachable_id (required) - Identifies the specific DocumentMetadatum row to update.
   *   - association_type (required) - The new association type value (e.g. hard or soft link).
   *
   * Returns: Boolean. True if the document association type is set successfully; raises GraphQL::ExecutionError if execution fails.
   *
   */
  setDocumentAssociationType: Scalars['Boolean']['output'];
  /**
   * Summary: Replaces an employment's direct grants with the given set
   * (project-scoped and time-bound grants included). Grants coming from
   * roles are not touched — manage those via role assignment.
   *
   * Auth: Requires manage permission_management.
   *
   * Returns: [Types::EmploymentGrantType]. The employment's direct grants after the update.
   *
   */
  setEmploymentGrants: Array<EmploymentGrant>;
  /**
   * Summary: Generates a PDF of a kick-off template and emails it to the provided addresses synchronously.
   *
   * Auth: Requires user to be logged in (maybe should have an authorization check in the future).
   *
   * Arguments:
   *   - id (required) - The kick-off template to share.
   *   - emails (required) - The recipient email addresses.
   *
   * Side effects: Sends email notifications.
   *
   * Returns: Boolean. True if the kick-off template is shared successfully; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  shareKickOffTemplate: Scalars['Boolean']['output'];
  /**
   * Summary: Generates guest access tokens for a list of email addresses and emails each recipient a link to the project's reports dashboard. Uses possibly deprecated logic.
   *
   * Auth: Requires send_email_events permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - project_id (required) - The project whose reports are being shared.
   *   - emails (required) - The recipient email addresses — one GuestAccessToken is created per address.
   *
   * Side effects: Sends email notifications.
   *
   * Returns: Boolean. True if the mutation completes successfully.
   *
   */
  shareProjectReports: Scalars['Boolean']['output'];
  /**
   * Summary: Authenticates a user via email and password against the local credential store and issues session cookies.
   *
   * Auth: None required — unauthenticated login; sets auth and refresh token cookies on success.
   *
   * Arguments:
   *   - email (required) - The user's email
   *   - password (required) - The user's password
   *   - remember_me (required) - Controls how long the session's refresh token remains valid.
   *
   *
   * Returns: Boolean. True if the mutation completes successfully; raises GraphQL::ExecutionError if validation or execution fails. Users migrated from the previous identity provider have no local password and receive a PASSWORD_RESET_REQUIRED error until they complete a reset.
   *
   */
  signIn: Scalars['Boolean']['output'];
  /**
   * Summary: Signs the user out by revoking their session and clearing local auth cookies.
   *
   * Auth: None required — unauthenticated sign-out.
   *
   * Arguments:
   *   - None
   *
   * Side Effects: Revokes the session identified by the refresh token cookie and clears auth_token, refresh_token, and remember_me cookies.
   *
   * Returns: Boolean. True if the mutation completes successfully. Revocation errors are logged without raising; cookies are cleared either way.
   *
   */
  signOut: Scalars['Boolean']['output'];
  /**
   * Summary: Registers a new user account and immediately signs them in.
   *
   * Auth: None required — public registration flow.
   *
   * Arguments:
   *   - first_name (required) - The user's first name for the new account profile.
   *   - last_name (required) - The user's last name for the new account profile.
   *   - email (required) - The email address used to register the account and sign in.
   *   - password (required) - The password for the new account. Must be at least 12 characters and include an uppercase letter, a lowercase letter, and a number.
   *   - confirm_password (required) - Must exactly match password to confirm account creation.
   *
   * Side Effects: Creates a new user and opens a session, setting auth and refresh token cookies.
   *
   * Returns: Boolean. True if the user is signed up and signed in successfully; raises GraphQL::ExecutionError if execution fails.
   *
   */
  signUp: Scalars['Boolean']['output'];
  /**
   * Summary: Creates or updates draft sub-projects as part of a project split operation, optionally finalising the split.
   *
   * Auth: Bypassed when the request originates from the contracts funnel; otherwise requires create_project permission.
   *
   * Arguments:
   *   - root_id (required) - The project being split.
   *   - splits (required) - Array of ProjectSplitType objects describing each sub-project.
   *   - finalize (optional) - When true, finalises the split; when false (default), saves as draft for review.
   *   - sub_contractor_project_mappings (optional) - Optional — maps sub-contractor schedules to the resulting sub-projects.
   *
   * Returns: [ID] - Array of IDs of the resulting split projects.
   *
   */
  splitProject: Array<Scalars['ID']['output']>;
  /**
   * Summary: Marks a report as submitted, recording the reporter, submission stage, and date.
   *
   * Auth: Requires manage_reports if report_date is before today, otherwise create_reports, for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - report_id (required) - The report to submit.
   *
   *
   * Returns: Boolean. True if the report is submitted successfully; False in case of failure.
   *
   */
  submitReport: Scalars['Boolean']['output'];
  /**
   * Summary: Replaces all tags on a document with a new set — full replace, not additive.
   *
   * Auth: Requires user to be logged in.
   *
   * Arguments:
   *   - id (required) - The Document record ID.
   *   - company_tag_ids (required) - The complete new set of tag IDs. All existing tags are removed first.
   *
   * Returns: Boolean. True if the document tags are updated successfully; False in case of failure.
   *
   */
  tagAttachment: Scalars['Boolean']['output'];
  /**
   * Summary: Removes a role from an employment; the role's grants stop
   * applying immediately.
   *
   * Auth: Requires manage permission_management.
   *
   * Returns: Boolean.
   *
   */
  unassignRole: Scalars['Boolean']['output'];
  /**
   * Summary: Update an access request's status
   *
   * Auth: Requires super admin access.
   *
   * Arguments:
   *   - access_request (required) - Requires the 'id' of the AccessRequest to update and relevant 'status'
   *     - id
   *     - status
   *
   * Returns: Types::AccessRequestType in case of success to allow callers to update cache; raises GraphQL::ExecutionError in case of an error.
   *
   */
  updateAccessRequest?: Maybe<AccessRequest>;
  /**
   * Summary: Updates a billable item's resource, rate, or role.
   *
   * Auth: Requires edit_events (as Compensation Event Quotations are related to Events) permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - id (required) - The billable item to update.
   *   - resource_id (optional) - New resource identifier for the billable item.
   *   - rate (optional) - New billable rate value for the item.
   *   - role (optional) - New role label for the billable item.
   *
   *
   * Returns: Boolean. True if the billable item is updated successfully; raises an Error in case of failure.
   *
   */
  updateCeqBillableItem: Scalars['Boolean']['output'];
  /**
   * Summary: Updates a CEQ sub-event's fields (currently programme_impact).
   *
   * Auth: Requires edit_events (as Compensation Event Quotations are related to Events) permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - id (required) - The sub-event to update.
   *   - programme_impact (optional) - Optional string describing the programme impact.
   *
   *
   * Returns: Boolean. True if the CEQ sub-event is updated successfully; raises an Error in case of failure.
   *
   */
  updateCeqSubEvent: Scalars['Boolean']['output'];
  /**
   * Summary: Updates an existing client company's core fields and primary address.
   *
   * Auth: Requires update_clients permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - id (required) - The client company id to update.
   *   - company_name (optional) - Updated client company name.
   *   - phone (optional) - Updated client primary phone.
   *   - email (optional) - Updated client primary email.
   *   - company_number (required) - Client company registration number.
   *   - trading_name (optional) - Updated client trading name.
   *   - vat_number (optional) - Updated client VAT/tax number.
   *   - company_type (optional) - Updated client company type enum value.
   *   - street (optional) - Updated street for the client main address.
   *   - city (optional) - Updated city for the client main address.
   *   - state (optional) - Updated state/region for the client main address.
   *   - country (optional) - Updated country for the client main address.
   *   - zip (optional) - Updated postal/ZIP code for the client main address.
   *
   *
   * Returns: Boolean. True if the client is updated successfully; raises an Error in case of failure.
   *
   */
  updateClient: Scalars['Boolean']['output'];
  /**
   * Summary: Updates an existing company's core details and address, and optionally replaces its logo.
   *
   * Auth: Requires user to be logged in and the company id must match current_user.default_company_id.
   *
   * Arguments:
   *   - id (required) - The company id to update (must be current_user default company).
   *   - name (required) - The company legal name.
   *   - primary_phone (required) - The company primary contact phone number.
   *   - primary_email (required) - The company primary contact email address.
   *   - street (required) - Street line for the company address.
   *   - city (required) - City for the company address.
   *   - state (required) - State/region for the company address.
   *   - country (required) - Country for the company address.
   *   - zip (required) - Postal/ZIP code for the company address.
   *   - company_number (required) - Company registration number.
   *   - trading_name (optional) - Trading name used publicly by the company.
   *   - vat_number (optional) - VAT/tax registration number.
   *   - company_type (optional) - Company type classification enum value.
   *   - logo_signed_id (optional) - Signed blob id for replacing the company logo.
   *
   *
   * Returns: Boolean. True if the company is updated successfully; raises an Error in case of failure.
   *
   */
  updateCompany: Scalars['Boolean']['output'];
  /**
   * Summary: Renames the label of a Kanban event column.
   *
   * Auth: Requires edit_events permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - id (required) - The CompanyEventColumn to update.
   *   - label (required) - The new display label for the column.
   *
   *
   * Returns: Boolean. True if the company event column is updated successfully; raises an Error in case of failure.
   *
   */
  updateCompanyEventColumn: Scalars['Boolean']['output'];
  /**
   * Summary: Updates an existing company resource and its metadata, optionally appending new file attachments.
   *
   * Auth: Requires user to be logged in (should perhaps have a proper permission in the future).
   *
   * Arguments:
   *   - company_resource (required) - CompanyResourceUpdateType containing id, resource_type, name, and resource_meta (with optional signed_ids).
   *
   * Returns: Boolean. True if the company resource is updated successfully; raises an Error in case of failure.
   *
   */
  updateCompanyResource: Scalars['Boolean']['output'];
  /**
   * Summary: Updates an existing Compensation Event Notice and optionally attaches new documents.
   *
   * Auth: Requires edit_events (as Compensation Event Notices belong to Events) permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - cen (required) - CompensationEventNoticeUpdateType containing id, updatable fields, and optional signed_ids.
   *
   * Returns: Boolean. True if the Compensation Event Notice is updated successfully; raises an Error in case of failure.
   *
   */
  updateCompensationEventNotice: Scalars['Boolean']['output'];
  /**
   * Summary: Resolves conflicting schedules by applying field-level updates to a batch of schedule records, intentionally bypassing validations.
   *
   * Auth: Requires edit_scheduling permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - resource_schedules (required) - Array of ResourceScheduleUpdateType objects each containing id plus optional company_resource_id, start_time, end_time, quantity, status.
   *
   * Returns: Boolean. True if the conflicted schedules are updated successfully; raises an Error in case of failure.
   *
   */
  updateConflictedSchedules: Scalars['Boolean']['output'];
  /**
   * Summary: Changes a user's active default company by marking the corresponding employment as default.
   *
   * Auth: Only need to verify that current user exists
   *
   * Arguments:
   *   - user_id (required) - The user whose default company is being changed.
   *   - company_id (required) - The company to set as default.
   *
   *
   * Returns: Boolean. True if the default company is updated successfully; raises an Error in case of failure.
   *
   */
  updateDefaultCompany: Scalars['Boolean']['output'];
  /**
   * Summary: Updates a delivery and collection item's quantity and its associated state record's descriptive fields in one operation.
   *
   * Auth: Requires edit_scheduling permission (as DACs are technically schedules) for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - id (required) - The item to update.
   *   - state_id (required) - The specific state record to update alongside the item.
   *   - quantity (optional) - Optional update field.
   *   - supplier (optional) - Optional update field.
   *   - receiver_name (optional) - Optional update field.
   *   - deliverer_name (optional) - Optional update field.
   *   - notes (optional) - Optional update field.
   *
   *
   * Returns: Types::DeliveryAndCollectionItemStateType. The updated state record; rolls back and raises an Error in case of failure.
   *
   */
  updateDeliveryAndCollectionItem: DeliveryAndCollectionItemState;
  /**
   * Summary: Admin-level update of an employee's profile with additional capabilities for employment status, tags, login access, and schedule reassignment.
   *
   * Auth: Requires edit_employee_management permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - user (required) - UserUpdateType input for employee profile, access, tags, and scheduling controls.
   *
   * Returns: Boolean. True if the employee is updated successfully; returns False if the user is not found or the user data is invalid. Raises an Error in case of failure.
   *
   */
  updateEmployee?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Summary: Updates an existing event's attributes by id.
   *
   * Auth: Requires edit_events permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - event (required) - EventUpdateType containing the event fields. Has id, title, category, event_type, description, status, assignee_id, flag, occurred_at as required.
   *
   * Returns: Types::EventType. The updated event; raises GraphQL::ExecutionError if execution fails.
   *
   */
  updateEvent: Event;
  /**
   * Summary: Updates an event's position within its Kanban status column.
   *
   * Auth: Requires edit_events permission for 'non-owner' users (since we quite literally update an Event to change its position). Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - event_id (required) - The event to reposition.
   *   - status (required) - The target status column (EventStatusEnum).
   *   - prev_id (optional) - Optional ID of the event this should appear after.
   *   - next_id (optional) - Optional ID of the event this should appear before.
   *
   * Returns: Boolean. True if the event is repositioned successfully; raises an Error in case of failure.
   *
   */
  updateEventPosition: Scalars['Boolean']['output'];
  /**
   * Summary: Toggles the resolved status of a feedback item.
   *
   * Auth: Requires create_feedback permission for 'non-owner' users (as feedback is a user-generated item). Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - feedback (required) - FeedbackUpdateType containing the feedback fields. Has :id and :resolved as required.
   *
   * Returns: Boolean. True if the feedback is updated successfully; raises an Error in case of failure.
   *
   */
  updateFeedback: Scalars['Boolean']['output'];
  /**
   * Summary: Bulk-updates multiple Schedule records in place — used for drag and resize interactions in the Gantt view.
   *
   * Auth: Requires user to be logged in (should have a proper permission in the future).
   *
   * Arguments:
   *   - schedule_ids (required) - The IDs of schedules to update.
   *   - user_id (optional) - Existing assignee id (for caller context/filtering).
   *   - updated_resource_id (optional) - New company_resource_id to assign to the schedules.
   *   - title (optional) - New title applied to all targeted schedules.
   *   - source (optional) - New source value applied to all targeted schedules.
   *   - start_time (optional) - New start time (recomputed against each schedule date).
   *   - end_time (optional) - New end time (recomputed against each schedule date).
   *   - quantity (optional) - New quantity value for the schedules.
   *   - description_of_service (optional) - New description of service text for the schedules.
   *
   *
   * Returns: Boolean. True if the Gantt schedules are updated successfully; raises an Error in case of failure.
   *
   */
  updateGanttSchedule: Scalars['Boolean']['output'];
  /**
   * Summary: Renames an existing column in a Kanban board's JSON array, identified by column_id.
   *
   * Auth: Requires user to be logged in (should have a proper permission in the future).
   *
   * Arguments:
   *   - name (required) - The board name used to find the KanbanColumn record.
   *   - title (required) - The new display title. Raises ExecutionError if a different column already has this title.
   *   - column_id (required) - Identifies which column within the board's JSON array to rename.
   *
   *
   * Returns: Types::KanbanColumnType. The updated board record; raises an Error in case of failure.
   *
   */
  updateKanbanColumns?: Maybe<KanbanColumn>;
  /**
   * Summary: Updates the action items (notes) section within a kick-off's data JSON column.
   *
   * Auth: Requires user to be logged in (should have a proper permission in the future).
   *
   * Arguments:
   *   - kick_off_id (required) - The kick-off to update.
   *   - kick_off_actions (required) - Array of action item JSON objects to write to data["notes"].
   *
   * Returns: Boolean. True if the kick-off actions are updated successfully; raises an Error in case of failure.
   *
   */
  updateKickOffActions: Scalars['Boolean']['output'];
  /**
   * Summary: Updates a kick-off's title and shallowly merges new fields into its data JSON column.
   *
   * Auth: Requires user to be logged in (should have a proper permission in the future).
   *
   * Arguments:
   *   - id (required) - The kick-off to update.
   *   - title (required) - The new title.
   *   - data (required) - JSON object whose keys are merged into the existing data (shallow merge, not deep).
   *
   *
   * Returns: Boolean. True if the kick-off basics are updated successfully; raises an Error in case of failure.
   *
   */
  updateKickOffBasics: Scalars['Boolean']['output'];
  /**
   * Summary: Writes the project details sub-section of a kick-off's data JSON column, covering managers, activities, settings, contract types, and tags.
   *
   * Auth: Requires user to be logged in (should have a proper permission in the future).
   *
   * Arguments:
   *   - kick_off_id (required) - The kick-off to update.
   *   - managers (optional) - Manager entries saved under projectDetails.managers.
   *   - activities (optional) - Activity entries saved under projectDetails.activities.
   *   - contract_type_ids (optional) - Contract type IDs saved under projectDetails.contractTypeIds.
   *   - project_tag_ids (optional) - Project tag IDs saved under projectDetails.projectTagIds.
   *   - project_settings (optional) - Project setting entries saved under projectDetails.projectSettings.
   *
   *
   * Returns: Boolean. True if the kick-off project details are updated successfully; raises an Error in case of failure.
   *
   */
  updateKickOffProjectDetails: Scalars['Boolean']['output'];
  /**
   * Summary: Replaces the data JSON payload of an existing kick-off template.
   *
   * Auth: Requires user to be logged in (should have a proper permission in the future).
   *
   * Arguments:
   *   - id (required) - The template to update.
   *   - title (required) - The new title for the template.
   *   - data (required) - The new JSON object to store as the template's content.
   *
   * Returns: Boolean. True if the kick-off template is updated successfully; false in case of failure.
   *
   */
  updateKickOffTemplate: Scalars['Boolean']['output'];
  /**
   * Summary: Updates an existing note, optionally replacing its tag set and appending new file attachments.
   *
   * Auth: Requires user to be logged in (should have a proper permission in the future).
   *
   * Arguments:
   *   - note_data (required) - NotesUpdateType containing id plus updatable fields including tag_ids and signed_ids.
   *
   * Side effects: Updates the note's tag set and attaches new file attachments if provided.
   *
   * Returns: Types::NoteType. The updated note to let callers update cache; raises an Error in case of failure.
   *
   */
  updateNotes?: Maybe<Note>;
  /**
   * Summary: Update the user's onboarding step for the default company.
   *
   * Auth: Requires user to be logged in.
   *
   * Arguments:
   *   - step (required) - The onboarding step to be set to 'true'
   *
   * Side effects: None
   *
   * Returns: Types::OnboardingStepsType. The updated onboarding steps for the default company.
   *
   */
  updateOnboardingStep?: Maybe<OnboardingSteps>;
  /**
   * Summary: Updates an existing project's attributes, team assignments, main address, and settings in a single operation.
   *
   * Auth: Bypassed when the request originates from the contracts funnel; otherwise requires edit_projects permission. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - project (required) - ProjectUpdateType payload for project updates.
   *
   * Returns: Boolean. True if the mutation completes successfully; raises GraphQL::ExecutionError if validation or execution fails.
   *
   */
  updateProject: Scalars['Boolean']['output'];
  /**
   * Summary: Updates an existing project activity record by ID.
   *
   * Auth: Requires manage_projects permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - project_activity (required) - ProjectActivityUpdateType containing id and updatable fields. Uses find_by (returns null silently if not found rather than raising).
   *
   * Returns: Boolean. True if the project activity is updated successfully; returns False if the project activity is not found.
   *
   */
  updateProjectActivity: Scalars['Boolean']['output'];
  /**
   * Summary: Assigns or removes a reviewer on a project — upserts a reviewer ProjectUser when a resource is provided, or destroys the existing reviewer record when it is absent.
   *
   * Auth: Requires edit_projects permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - id (required) - The project to update.
   *   - company_resource_id (optional) - When provided, assigns/updates this resource as reviewer. When absent, the existing reviewer ProjectUser for this title is destroyed.
   *   - title (required) - The reviewer role title used to scope the ProjectUser lookup.
   *
   * Returns: Boolean. True if the mutation completes successfully; raises GraphQL::ExecutionError if validation or execution fails.
   *
   */
  updateProjectReviewer: Scalars['Boolean']['output'];
  /**
   * Summary: Approves or rejects a daily report, recording the approver and timestamp, and notifying the reporter.
   *
   * Auth: Requires edit_reports permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - report_id (required) - The report to approve or reject.
   *   - approved (required) - Boolean indicating approval (true) or rejection (false).
   *
   *
   * Side effects: Sends report-status emails, and creates in-app notifications.
   *
   * Returns: Boolean. True if the mutation completes successfully; raises GraphQL::ExecutionError if validation or execution fails.
   *
   */
  updateReport: Report;
  /**
   * Summary: Updates an existing report issue's fields.
   *
   * Auth: Requires edit_reports permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - report_issue (required) - IssueUpdateType containing id and any updatable fields.
   *
   * Returns: Types::IssueType. The updated issue to let callers update cache; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  updateReportIssue: Issue;
  /**
   * Summary: Updates one or more Schedule records. When the resource has changed, soft-drops the originals and bulk-creates replacements; otherwise updates in place.
   *
   * Auth: Requires create_scheduling permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - input (required) - UpdateResourceScheduleV2InputType containing ids ([ID]), resource_id, resource_type, address_id, start_time, end_time, source, title, description_of_service, on_hire, resource_name, original_placeholder.
   *
   * Side effects: Toggles ignored conflicting schedules.
   *
   * Returns: Object. The updated schedules and the presence of conflicts to let callers update cache; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  updateResourceScheduleV2: UpdateResourceScheduleV2Payload;
  /**
   * Summary: Updates a role's name/description and declaratively replaces its
   * grant bundle when grants is passed. Changes apply live to all members.
   *
   * Auth: Requires manage permission_management.
   *
   * Returns: Types::RoleType.
   *
   */
  updateRole: Role;
  /**
   * Summary: Updates a schedule entry. When the resource changes, the original is soft-dropped and a new schedule is created for the replacement resource instead of mutating in place.
   *
   * Auth: Requires edit_scheduling permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - schedule (required) - ScheduleUpdateType containing id and optional update fields including company_resource_id (triggers the soft-drop + create flow) and update_future_schedules (when true, bulk-reassigns user_id on future schedules with the same title).
   *
   * Side effects: Bulk-updates future schedules with the same title.
   *
   * Returns: Types::ScheduleType. The updated schedule record to let callers update cache; rolls back changes and raises GraphQL::ExecutionError if execution fails.
   *
   */
  updateSchedule?: Maybe<Schedule>;
  /**
   * Summary: Updates select fields on an existing sub-contractor schedule entry.
   *
   * Auth: Requires edit_scheduling permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - sub_contractor_schedule (required) - SubContractorScheduleUpdateType containing id and optional start_time, end_time, description_of_service, status.
   *
   * Returns: Boolean. True if the mutation completes successfully; raises GraphQL::ExecutionError if validation or execution fails.
   *
   */
  updateSubContractorSchedule: Scalars['Boolean']['output'];
  /**
   * Summary: Updates the multiplier and/or quantity on a SubEventBillableItem — the per-sub-event usage line for a billable item.
   *
   * Auth: Requires edit_scheduling permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - id (required) - The SubEventBillableItem to update.
   *   - multiplier (optional) - New multiplier applied to this sub-event billable item.
   *   - quantity (optional) - New quantity applied to this sub-event billable item.
   *
   *
   * Returns: Boolean. True if the mutation completes successfully; raises GraphQL::ExecutionError if validation or execution fails.
   *
   */
  updateSubEventBillableItem: Scalars['Boolean']['output'];
  /**
   * Summary: Updates a task and optionally attaches new files.
   *
   * Auth: Requires edit_tasks permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - task (required) - TaskUpdateType containing id and updatable fields including optional signed_ids.
   *
   * Side effects: Attaches new files if provided.
   *
   * Returns: Boolean. True if the task is updated successfully. False in case of failure.
   *
   */
  updateTask?: Maybe<Task>;
  /**
   * Summary: Updates the content and edited flag of a task comment.
   *
   * Auth: Requires user to be logged in.
   *
   * Arguments:
   *   - id (required) - The comment to update.
   *   - content (required) - The new comment body.
   *   - is_edited (required) - Boolean flag indicating the comment has been edited (persisted for UI display).
   *
   * Returns: Boolean. True if the mutation completes successfully; raises GraphQL::ExecutionError if validation or execution fails.
   *
   */
  updateTaskComment: Scalars['Boolean']['output'];
  /**
   * Summary: Allows a user to update their own profile information, including profile picture, tags, and password.
   *
   * Auth: Requires the current user to match the target user id (self-service only).
   *
   * Arguments:
   *   - user (required) - UserUpdateType payload for the current user profile update.
   *
   * Side effects: Attaches new profile picture if provided. Sets tags if provided. Changes password if provided.
   *
   * Returns: Boolean. True if the user profile is updated successfully; raises an error in case of failure.
   *
   */
  updateUserProfile?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Summary: Creates or updates a single key-value user setting scoped to the current user's default employment.
   *
   * Auth: Requires user to be logged in.
   *
   * Arguments:
   *   - name (required) - The setting key.
   *   - value (required) - The setting value.
   *
   * Side effects: Creates or updates the user setting.
   *
   * Returns: Boolean. True if the user setting is updated successfully; raises an error in case of failure.
   *
   */
  updateUserSetting?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Summary: Attaches signed blob ids to a billable item.
   *
   * Auth: Requires create_events or manage_events permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - item_id (required) - BillableItem id.
   *   - signed_ids (optional) - ActiveStorage signed blob ids to attach.
   *
   * Returns: Boolean. True if the item remains persisted after attachment; raises an error in case of failure.
   *
   */
  uploadBillableItemFiles: Scalars['Boolean']['output'];
  /**
   * Summary: Attaches signed blob ids to a compensation event quotation.
   *
   * Auth: Requires create_events or manage_events permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - id (required) - CompensationEventQuotation id.
   *   - signed_ids (optional) - ActiveStorage signed blob ids to attach.
   *
   * Side effects: Attaches the signed blob ids to the CEQ if provided.
   *
   * Returns: Boolean. True if the CEQ is persisted after attachment; raises an error or returns false otherwise.
   *
   */
  uploadCeqFiles: Scalars['Boolean']['output'];
  /**
   * Summary: Syncs funnel-uploaded documents onto a project via signed blob ids.
   *
   * Auth: Requires user to be logged in.
   *
   * Arguments:
   *   - id (required) - Project id.
   *   - signed_ids (optional) - ActiveStorage signed blob ids to sync as attachments.
   *
   * Returns: Boolean. True if the project remains persisted after syncing attachments; raises an error or returns false otherwise.
   *
   */
  uploadFunnelProjectFiles: Scalars['Boolean']['output'];
  /**
   * Summary: Verifies a completed Stripe Checkout Session and syncs the local
   * Subscription record, marking onboarding complete for the associated owner.
   *
   * Auth: Requires user to be logged in.
   *
   * Arguments:
   *   - session_id: the Stripe Checkout Session ID returned in the success redirect
   *
   * Returns: SubscriptionType. Raises GraphQL::ExecutionError if the session is
   * invalid, unpaid, or the associated employment cannot be found.
   *
   */
  verifyCheckoutSession: Subscription;
};

export type MutationAcceptClientInvitationArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type MutationAcceptProjectInvitationArgs = {
  admin?: InputMaybe<AcceptProjectInvitationUser>;
  company: AcceptProjectInvitationCompany;
  token: Scalars['String']['input'];
  user: AcceptProjectInvitationUser;
};

export type MutationApproveCustomShiftArgs = {
  notificationId?: InputMaybe<Scalars['ID']['input']>;
  scheduleId: Scalars['ID']['input'];
  shiftName: Scalars['String']['input'];
};

export type MutationApproveEventArgs = {
  id: Scalars['ID']['input'];
};

export type MutationAssignRoleArgs = {
  employmentId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
};

export type MutationAttachKickOffDocumentsArgs = {
  id: Scalars['ID']['input'];
  signedIds: Array<Scalars['ID']['input']>;
};

export type MutationBulkImportCompanyEquipmentsArgs = {
  signedId: Scalars['String']['input'];
};

export type MutationBulkImportResourcesArgs = {
  importType: Scalars['String']['input'];
  signedId: Scalars['String']['input'];
};

export type MutationBulkImportUsersArgs = {
  fileSignedId: Scalars['String']['input'];
};

export type MutationChangeProjectStatusArgs = {
  projectId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
};

export type MutationCompleteKickOffArgs = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  fileUrl: Scalars['String']['input'];
  kickOffId: Scalars['ID']['input'];
  signedId: Scalars['String']['input'];
};

export type MutationCreateAccessRequestArgs = {
  email: Scalars['String']['input'];
};

export type MutationCreateBulkSchedulesArgs = {
  schedules: ScheduleCreate;
};

export type MutationCreateBulkUsersArgs = {
  users: Array<UserCreate>;
};

export type MutationCreateCeqArgs = {
  cenId?: InputMaybe<Scalars['ID']['input']>;
  eventId: Scalars['ID']['input'];
};

export type MutationCreateCeqBillableItemArgs = {
  ceqId: Scalars['ID']['input'];
  resourceId: Scalars['String']['input'];
  resourceType: Scalars['String']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateCeqSubEventArgs = {
  ceqId: Scalars['ID']['input'];
};

export type MutationCreateCheckoutSessionArgs = {
  interval: Scalars['String']['input'];
  returnPath?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateClientArgs = {
  client: ClientCreate;
};

export type MutationCreateClientInstructionsArgs = {
  clientInstruction: ClientInstructionCreate;
};

export type MutationCreateClientInvitationArgs = {
  clientId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};

export type MutationCreateCompanyArgs = {
  city: Scalars['String']['input'];
  companyNumber: Scalars['String']['input'];
  companyType?: InputMaybe<CompanyTypeEnum>;
  country: Scalars['String']['input'];
  isParent: Scalars['Boolean']['input'];
  logoSignedId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  primaryEmail: Scalars['String']['input'];
  primaryPhone: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  tradingName?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type MutationCreateCompanyContractTypeArgs = {
  contractType: CompanyContractTypeInput;
};

export type MutationCreateCompanyEquipmentArgs = {
  companyEquipment: CreateEquipment;
};

export type MutationCreateCompanyResourceArgs = {
  companyResource: CompanyResourceCreate;
};

export type MutationCreateCompanyResourceForUserArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export type MutationCreateCompanySettingArgs = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type MutationCreateCompanyTagsArgs = {
  companyTags: CompanyTagCreate;
};

export type MutationCreateCompensationEventNoticeArgs = {
  cen: CompensationEventNoticeCreate;
};

export type MutationCreateCompensationEventQuotationArgs = {
  quotation: CompensationEventQuotationCreate;
};

export type MutationCreateDeliveryAndCollectionRegisterArgs = {
  deliveryAndCollectionRegister: DeliveryAndCollectionRegisterCreate;
};

export type MutationCreateDirectUploadArgs = {
  input: DirectUploadCreate;
};

export type MutationCreateEarlyWarningNoticeArgs = {
  ewn: EarlyWarningNoticeCreate;
};

export type MutationCreateEventArgs = {
  event: EventCreate;
};

export type MutationCreateEventCommentArgs = {
  eventId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

export type MutationCreateFeedbackArgs = {
  feedback: FeedbackCreate;
};

export type MutationCreateGrantRequestArgs = {
  action: Scalars['String']['input'];
  entity: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationCreateGuestScheduleArgs = {
  resourceSchedule: GuestUserScheduleCreate;
};

export type MutationCreateHumanResourceArgs = {
  name: Scalars['String']['input'];
};

export type MutationCreateIssueArgs = {
  issue: IssueCreate;
};

export type MutationCreateKanbanColumnsArgs = {
  columnId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type MutationCreateKickOffArgs = {
  kickOff: KickOffCreate;
};

export type MutationCreateMeetingArgs = {
  meetingData?: InputMaybe<CreateMeetingInput>;
};

export type MutationCreateMeetingMinutesArgs = {
  meetingId: Scalars['ID']['input'];
  noteSections: Array<Scalars['JSON']['input']>;
};

export type MutationCreateNotesArgs = {
  noteData: NotesCreate;
};

export type MutationCreateProjectArgs = {
  project: ProjectCreate;
};

export type MutationCreateProjectActivityArgs = {
  projectActivity: ProjectActivityCreate;
};

export type MutationCreateProjectTemplateArgs = {
  projectTemplate: ProjectTemplateCreate;
};

export type MutationCreateReportIssueArgs = {
  reportIssue: IssueCreate;
};

export type MutationCreateRepresentativeArgs = {
  representative: RepresentativeCreate;
};

export type MutationCreateResourceCategoryArgs = {
  resourceCategory: ResourceCategoryCreate;
};

export type MutationCreateResourceScheduleV2Args = {
  input: CreateResourceScheduleV2Input;
};

export type MutationCreateRoleArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  grants: Array<AccessGrantPairInput>;
  name: Scalars['String']['input'];
};

export type MutationCreateSingleScheduleArgs = {
  resourceSchedule: ResourceScheduleCreate;
};

export type MutationCreateSubContractorArgs = {
  subContractor: SubContractorCreate;
};

export type MutationCreateSubContractorInvitationArgs = {
  companyResourceId: Scalars['ID']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationCreateSubContractorSchedulesArgs = {
  subContractorSchedule: SubContractorScheduleCreate;
};

export type MutationCreateTaskArgs = {
  task: TaskCreate;
};

export type MutationCreateTaskCommentArgs = {
  comment: TaskCommentInput;
};

export type MutationCreateUserArgs = {
  user: UserCreate;
};

export type MutationCreateUserMergeRequestArgs = {
  sourceEmail: Scalars['String']['input'];
};

export type MutationCreateUserPasswordResetArgs = {
  email: Scalars['String']['input'];
  origin: Scalars['String']['input'];
};

export type MutationDeleteRoleArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDestroyAttachmentArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDestroyCompanyContractTypeArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDestroyDeliveryAndCollectionItemArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDestroyKickOffTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDestroyNotesArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDestroyProjectArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDestroyProjectActivityArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDestroyReportIssueArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDestroySubContractorArgs = {
  id: Scalars['ID']['input'];
  ignoreSchedules?: InputMaybe<Scalars['Boolean']['input']>;
  updatedSubContractorId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationDestroyTaskArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDispatchAttachmentsArgs = {
  documentIds: Array<Scalars['ID']['input']>;
  projectId: Scalars['ID']['input'];
};

export type MutationDisputeCompensationEventNoticeArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDropResourceScheduleV2Args = {
  ids: Array<Scalars['ID']['input']>;
};

export type MutationIssueCompensationEventNoticeArgs = {
  id: Scalars['ID']['input'];
};

export type MutationIssueCompensationEventQuotationArgs = {
  id: Scalars['ID']['input'];
};

export type MutationManageProjectLocationsArgs = {
  addresses: Array<AddressUpdate>;
  projectId: Scalars['ID']['input'];
};

export type MutationMarkAsCollectedArgs = {
  delivererName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  receiverName?: InputMaybe<Scalars['String']['input']>;
  signedIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MutationMarkAsDeployedArgs = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  reportDate?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
};

export type MutationMarkAsReadyForCollectionArgs = {
  companyResourceId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
  scheduleId: Scalars['ID']['input'];
};

export type MutationMarkNotificationsAsReadArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationReactOnTaskCommentArgs = {
  reaction: TaskCommentReactionInput;
};

export type MutationRejectCustomShiftArgs = {
  endTime: Scalars['String']['input'];
  notificationId?: InputMaybe<Scalars['ID']['input']>;
  scheduleId: Scalars['ID']['input'];
  startTime: Scalars['String']['input'];
};

export type MutationRejectGuestScheduleArgs = {
  userSchedule: RejectGuestUserSchedule;
};

export type MutationRemoveProfilePictureArgs = {
  id: Scalars['ID']['input'];
};

export type MutationRemoveUsersFromProjectArgs = {
  userIds: Array<Scalars['ID']['input']>;
};

export type MutationResetUserPasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type MutationResizeResourceScheduleV2Args = {
  input: ResizeResourceScheduleV2Input;
};

export type MutationResolveGrantRequestArgs = {
  additionalActions?: InputMaybe<Array<Scalars['String']['input']>>;
  approve: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
  validTill?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
};

export type MutationRevertReportApprovalArgs = {
  reportId: Scalars['ID']['input'];
};

export type MutationSetDocumentAssociationTypeArgs = {
  associationType: AssociationTypeEnum;
  attachableId: Scalars['ID']['input'];
  attachableType: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type MutationSetEmploymentGrantsArgs = {
  employmentId: Scalars['ID']['input'];
  grants: Array<EmploymentGrantInput>;
};

export type MutationShareKickOffTemplateArgs = {
  emails: Array<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationShareProjectReportsArgs = {
  emails: Array<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
};

export type MutationSignInArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  rememberMe: Scalars['Boolean']['input'];
};

export type MutationSignUpArgs = {
  confirmPassword: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type MutationSplitProjectArgs = {
  finalize?: InputMaybe<Scalars['Boolean']['input']>;
  rootId: Scalars['ID']['input'];
  splits: Array<ProjectSplit>;
  subContractorProjectMappings?: InputMaybe<Array<SubContractorProjectMappingInput>>;
};

export type MutationSubmitReportArgs = {
  reportId: Scalars['ID']['input'];
};

export type MutationTagAttachmentArgs = {
  companyTagIds: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type MutationUnassignRoleArgs = {
  employmentId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
};

export type MutationUpdateAccessRequestArgs = {
  accessRequest: AccessRequestUpdate;
};

export type MutationUpdateCeqBillableItemArgs = {
  id: Scalars['ID']['input'];
  rate?: InputMaybe<Scalars['String']['input']>;
  resourceId?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateCeqSubEventArgs = {
  id: Scalars['ID']['input'];
  programmeImpact?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateClientArgs = {
  city?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<ClientUpdate>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  companyNumber: Scalars['String']['input'];
  companyType?: InputMaybe<CompanyTypeEnum>;
  country?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  tradingName?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateCompanyArgs = {
  city: Scalars['String']['input'];
  companyNumber: Scalars['String']['input'];
  companyType?: InputMaybe<CompanyTypeEnum>;
  country: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  logoSignedId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  primaryEmail: Scalars['String']['input'];
  primaryPhone: Scalars['String']['input'];
  state: Scalars['String']['input'];
  street: Scalars['String']['input'];
  tradingName?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type MutationUpdateCompanyEventColumnArgs = {
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
};

export type MutationUpdateCompanyResourceArgs = {
  companyResource: CompanyResourceUpdate;
};

export type MutationUpdateCompensationEventNoticeArgs = {
  cen: CompensationEventNoticeUpdate;
};

export type MutationUpdateConflictedSchedulesArgs = {
  resourceSchedules: Array<ResourceScheduleUpdate>;
};

export type MutationUpdateDefaultCompanyArgs = {
  companyId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type MutationUpdateDeliveryAndCollectionItemArgs = {
  delivererName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  receiverName?: InputMaybe<Scalars['String']['input']>;
  stateId: Scalars['ID']['input'];
  supplier?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateEmployeeArgs = {
  user: EmployeeUpdate;
};

export type MutationUpdateEventArgs = {
  event: EventUpdate;
};

export type MutationUpdateEventPositionArgs = {
  eventId: Scalars['ID']['input'];
  nextId?: InputMaybe<Scalars['ID']['input']>;
  prevId?: InputMaybe<Scalars['ID']['input']>;
  status: EventStatusEnum;
};

export type MutationUpdateFeedbackArgs = {
  feedback: FeedbackUpdate;
};

export type MutationUpdateGanttScheduleArgs = {
  descriptionOfService?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  scheduleIds: Array<Scalars['ID']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedResourceId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationUpdateKanbanColumnsArgs = {
  columnId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type MutationUpdateKickOffActionsArgs = {
  kickOffActions: Array<Scalars['JSON']['input']>;
  kickOffId: Scalars['ID']['input'];
};

export type MutationUpdateKickOffBasicsArgs = {
  data: Scalars['JSON']['input'];
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type MutationUpdateKickOffProjectDetailsArgs = {
  activities?: InputMaybe<Array<Scalars['JSON']['input']>>;
  contractTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  kickOffId: Scalars['ID']['input'];
  managers?: InputMaybe<Array<Scalars['JSON']['input']>>;
  projectSettings?: InputMaybe<Array<Scalars['JSON']['input']>>;
  projectTagIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MutationUpdateKickOffTemplateArgs = {
  data: Scalars['JSON']['input'];
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
};

export type MutationUpdateNotesArgs = {
  noteData: NotesUpdate;
};

export type MutationUpdateOnboardingStepArgs = {
  step: OnboardingStepsEnum;
};

export type MutationUpdateProjectArgs = {
  project: ProjectUpdate;
};

export type MutationUpdateProjectActivityArgs = {
  projectActivity: ProjectActivityUpdate;
};

export type MutationUpdateProjectReviewerArgs = {
  companyResourceId?: InputMaybe<Scalars['ID']['input']>;
  employmentId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutationUpdateReportArgs = {
  approved: Scalars['Boolean']['input'];
  reportId: Scalars['ID']['input'];
};

export type MutationUpdateReportIssueArgs = {
  reportIssue: IssueUpdate;
};

export type MutationUpdateResourceScheduleV2Args = {
  input: UpdateResourceScheduleV2Input;
};

export type MutationUpdateRoleArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  grants?: InputMaybe<Array<AccessGrantPairInput>>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateScheduleArgs = {
  schedule: ScheduleUpdate;
};

export type MutationUpdateSubContractorScheduleArgs = {
  subContractorSchedule: SubContractorScheduleUpdate;
};

export type MutationUpdateSubEventBillableItemArgs = {
  id: Scalars['ID']['input'];
  multiplier?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateTaskArgs = {
  task: TaskUpdate;
};

export type MutationUpdateTaskCommentArgs = {
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  isEdited: Scalars['Boolean']['input'];
};

export type MutationUpdateUserProfileArgs = {
  user: UserUpdate;
};

export type MutationUpdateUserSettingArgs = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type MutationUploadBillableItemFilesArgs = {
  itemId: Scalars['ID']['input'];
  signedIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MutationUploadCeqFilesArgs = {
  id: Scalars['ID']['input'];
  signedIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MutationUploadFunnelProjectFilesArgs = {
  id: Scalars['ID']['input'];
  signedIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type MutationVerifyCheckoutSessionArgs = {
  sessionId: Scalars['String']['input'];
};

/** One effective grant of the current user. projectIds null means company-wide. */
export type MyAccessGrant = {
  __typename?: 'MyAccessGrant';
  action: PermissionActionEnum;
  entity: PermissionEntityEnum;
  projectIds?: Maybe<Array<Scalars['ID']['output']>>;
};

export type Note = {
  __typename?: 'Note';
  attachments: Array<Attachment>;
  description: Scalars['String']['output'];
  documentUrls?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  imageUrls?: Maybe<Array<Scalars['String']['output']>>;
  notesType: NotesTypeEnum;
  reminder?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<CompanyTag>>;
  targetId?: Maybe<Scalars['ID']['output']>;
  targetType?: Maybe<Scalars['String']['output']>;
};

export type NoteFilters = {
  __typename?: 'NoteFilters';
  noteTypes?: Maybe<Array<Scalars['String']['output']>>;
  sources?: Maybe<Array<Scalars['String']['output']>>;
};

export type NotesCreate = {
  description: Scalars['String']['input'];
  notesType: NotesTypeEnum;
  reminder?: InputMaybe<Scalars['String']['input']>;
  signedIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  targetId?: InputMaybe<Scalars['ID']['input']>;
  targetType?: InputMaybe<Scalars['String']['input']>;
};

/** Note type enum */
export enum NotesTypeEnum {
  /** Personal */
  Personal = 'personal',
  /** Project */
  Project = 'project',
  /** Report */
  Report = 'report',
}

export type NotesUpdate = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  notesType?: InputMaybe<NotesTypeEnum>;
  reminder?: InputMaybe<Scalars['String']['input']>;
  signedIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  targetId?: InputMaybe<Scalars['ID']['input']>;
  targetType?: InputMaybe<Scalars['String']['input']>;
};

export type Notification = {
  __typename?: 'Notification';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  customShiftDetails?: Maybe<CustomShiftNotificationDetails>;
  id: Scalars['ID']['output'];
  isMentioned: Scalars['Boolean']['output'];
  priority: NotificationPriorityEnum;
  read: Scalars['Boolean']['output'];
  targetId?: Maybe<Scalars['ID']['output']>;
  targetType?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

/** Notification Priority Enum */
export enum NotificationPriorityEnum {
  /** High */
  High = 'high',
  /** Low */
  Low = 'low',
  /** Medium */
  Medium = 'medium',
  /** Normal */
  Normal = 'normal',
}

/** Completion status for company onboarding steps */
export type OnboardingSteps = {
  __typename?: 'OnboardingSteps';
  clientCreated: Scalars['Boolean']['output'];
  companyInformation: Scalars['Boolean']['output'];
  equipmentResourceCreated: Scalars['Boolean']['output'];
  humanResourceCreated: Scalars['Boolean']['output'];
  planSelection: Scalars['Boolean']['output'];
  projectCreated: Scalars['Boolean']['output'];
  taskCreated: Scalars['Boolean']['output'];
};

/** Onboarding Steps Enum */
export enum OnboardingStepsEnum {
  /** client_created */
  ClientCreated = 'client_created',
  /** company_information */
  CompanyInformation = 'company_information',
  /** equipment_resource_created */
  EquipmentResourceCreated = 'equipment_resource_created',
  /** human_resource_created */
  HumanResourceCreated = 'human_resource_created',
  /** plan_selection */
  PlanSelection = 'plan_selection',
  /** project_created */
  ProjectCreated = 'project_created',
  /** task_created */
  TaskCreated = 'task_created',
}

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** All possible permission action types */
export enum PermissionActionEnum {
  /** Approve */
  Approve = 'approve',
  /** Create */
  Create = 'create',
  /** Edit */
  Edit = 'edit',
  /** Export */
  Export = 'export',
  /** Issue */
  Issue = 'issue',
  /** Manage */
  Manage = 'manage',
  /** Publish */
  Publish = 'publish',
  /** Review */
  Review = 'review',
  /** Send Email */
  SendEmail = 'send_email',
  /** View */
  View = 'view',
}

/** All possible permission entity types */
export enum PermissionEntityEnum {
  /** Clients */
  Clients = 'clients',
  /** Company Settings */
  CompanySettings = 'company_settings',
  /** Custom Shifts */
  CustomShifts = 'custom_shifts',
  /** Employee Management */
  EmployeeManagement = 'employee_management',
  /** Equipment Management */
  EquipmentManagement = 'equipment_management',
  /** Events */
  Events = 'events',
  /** Feedback */
  Feedback = 'feedback',
  /** Permission Management */
  PermissionManagement = 'permission_management',
  /** Project Kick Off */
  ProjectKickOff = 'project_kick_off',
  /** Projects */
  Projects = 'projects',
  /** Reports */
  Reports = 'reports',
  /** Scheduling */
  Scheduling = 'scheduling',
  /** Subcontractor Management */
  SubcontractorManagement = 'subcontractor_management',
  /** Tag Management */
  TagManagement = 'tag_management',
  /** Tasks */
  Tasks = 'tasks',
  /** Workflows */
  Workflows = 'workflows',
}

export type PrincipalContactCreate = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  primaryPhone?: InputMaybe<Scalars['String']['input']>;
};

export type Project = {
  __typename?: 'Project';
  /** The current user's resolved permissions on this record */
  abilities: ProjectsAbilities;
  addresses?: Maybe<Array<Address>>;
  archived: Scalars['Boolean']['output'];
  attachments: Array<Attachment>;
  canInviteClient: Scalars['Boolean']['output'];
  client?: Maybe<Client>;
  code: Scalars['String']['output'];
  companyId: Scalars['ID']['output'];
  contractTypeIds?: Maybe<Array<Scalars['ID']['output']>>;
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  documentUrls?: Maybe<Array<Scalars['String']['output']>>;
  endDate?: Maybe<Scalars['String']['output']>;
  hasReports: Scalars['Boolean']['output'];
  hasSubLocations?: Maybe<Scalars['Boolean']['output']>;
  holidays?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrls?: Maybe<Array<Scalars['String']['output']>>;
  issues?: Maybe<Array<Issue>>;
  issuesCount: Scalars['Int']['output'];
  kickOffs?: Maybe<Array<ProjectKickOffs>>;
  mainAddress?: Maybe<Address>;
  managers?: Maybe<Array<ProjectUser>>;
  parentProject?: Maybe<Project>;
  pastReports: Array<Report>;
  pointOfContacts?: Maybe<Array<ProjectUser>>;
  projectActivities: Array<ProjectActivity>;
  projectAutomations?: Maybe<Array<ProjectAutomation>>;
  projectSettings: Array<ProjectSetting>;
  reviewers?: Maybe<Array<ProjectUser>>;
  rootProjectId?: Maybe<Scalars['ID']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  status: ProjectStatusEnum;
  subLocations?: Maybe<Array<Address>>;
  tagIds?: Maybe<Array<Scalars['ID']['output']>>;
  tags?: Maybe<Array<CompanyTag>>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  visible: Scalars['Boolean']['output'];
};

export type ProjectActivity = {
  __typename?: 'ProjectActivity';
  colorCode: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  createdBy: Employment;
  description?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  project: Project;
  startTime: Scalars['String']['output'];
  status: ProjectActivityStatusEnum;
  supervisor?: Maybe<Employment>;
  timeBasedStatus: ProjectActivityTimeBasedStatusEnum;
  title: Scalars['String']['output'];
};

export type ProjectActivityCreate = {
  colorCode?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  startTime: Scalars['String']['input'];
  supervisorId?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
};

/** For project activity statuses */
export enum ProjectActivityStatusEnum {
  /** Cancelled */
  Cancelled = 'cancelled',
  /** Completed */
  Completed = 'completed',
  /** In Progress */
  InProgress = 'in_progress',
  /** On Hold */
  OnHold = 'on_hold',
  /** Planned */
  Planned = 'planned',
}

/** For project activity time-based statuses */
export enum ProjectActivityTimeBasedStatusEnum {
  /** Completed Before Time */
  CompletedBeforeTime = 'completed_before_time',
  /** Completed On Time */
  CompletedOnTime = 'completed_on_time',
  /** Completed Spilled */
  CompletedSpilled = 'completed_spilled',
  /** Indeterminate */
  Indeterminate = 'indeterminate',
}

export type ProjectActivityUpdate = {
  colorCode?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  startTime?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ProjectActivityStatusEnum>;
  supervisorId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectAutomation = {
  __typename?: 'ProjectAutomation';
  actions: Array<Scalars['JSON']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  lastProcessedAt?: Maybe<Scalars['String']['output']>;
  project?: Maybe<Project>;
};

/** The connection type for Project. */
export type ProjectConnection = {
  __typename?: 'ProjectConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProjectEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Project>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ProjectCreate = {
  activities?: InputMaybe<Array<ActivityInput>>;
  addresses?: InputMaybe<Array<AddressInput>>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  clientReps?: InputMaybe<Array<ClientRepInput>>;
  code: Scalars['String']['input'];
  companyId: Scalars['ID']['input'];
  contractTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  eventIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  projectUsers?: InputMaybe<Array<ManagerCreate>>;
  settings?: InputMaybe<Array<ProjectSettingsCreate>>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title: Scalars['String']['input'];
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An edge in a connection. */
export type ProjectEdge = {
  __typename?: 'ProjectEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Project>;
};

export type ProjectFilters = {
  __typename?: 'ProjectFilters';
  clients?: Maybe<Array<Client>>;
  people?: Maybe<Array<Employment>>;
  statuses?: Maybe<Array<Scalars['String']['output']>>;
};

export type ProjectInvitationPrefill = {
  __typename?: 'ProjectInvitationPrefill';
  companyName?: Maybe<Scalars['String']['output']>;
  companyPhone?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

/** Resolved permissions of the current user against this project kick off record */
export type ProjectKickOffAbilities = {
  __typename?: 'ProjectKickOffAbilities';
  create: Scalars['Boolean']['output'];
  edit: Scalars['Boolean']['output'];
  export: Scalars['Boolean']['output'];
  manage: Scalars['Boolean']['output'];
  sendEmail: Scalars['Boolean']['output'];
  view: Scalars['Boolean']['output'];
};

export type ProjectKickOffs = {
  __typename?: 'ProjectKickOffs';
  /** The current user's resolved permissions on this record */
  abilities: ProjectKickOffAbilities;
  attachments: Array<Attachment>;
  createdAt: Scalars['String']['output'];
  data?: Maybe<KickOffData>;
  documentUrls?: Maybe<Array<Scalars['String']['output']>>;
  emails?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  imageUrls?: Maybe<Array<Scalars['String']['output']>>;
  initiator: User;
  lastEditedAt: Scalars['String']['output'];
  lastEditedBy: User;
  project?: Maybe<Project>;
  projectId?: Maybe<Scalars['ID']['output']>;
  status: KickOffStatusEnum;
  templateId?: Maybe<Scalars['ID']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

/** The connection type for ProjectKickOffs. */
export type ProjectKickOffsConnection = {
  __typename?: 'ProjectKickOffsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProjectKickOffsEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProjectKickOffs>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type ProjectKickOffsEdge = {
  __typename?: 'ProjectKickOffsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProjectKickOffs>;
};

export type ProjectMeeting = {
  __typename?: 'ProjectMeeting';
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  meetingNotes?: Maybe<Array<MeetingNote>>;
  mode: Scalars['String']['output'];
  projectId?: Maybe<Scalars['ID']['output']>;
  scheduledAt: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type ProjectSetting = {
  __typename?: 'ProjectSetting';
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type ProjectSettingsCreate = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ProjectSettingsUpdate = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ProjectShift = {
  __typename?: 'ProjectShift';
  endTime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
};

export type ProjectSplit = {
  activityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  addresses?: InputMaybe<Array<AddressInput>>;
  attachmentSignedIds?: InputMaybe<Array<Scalars['String']['input']>>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  code: Scalars['String']['input'];
  companyId: Scalars['ID']['input'];
  contractTypeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  deliveryRegisterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  eventIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  managers?: InputMaybe<Array<ManagerCreate>>;
  pointOfContacts?: InputMaybe<Array<ClientRepInput>>;
  scheduleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  settings?: InputMaybe<Array<ProjectSettingsCreate>>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title: Scalars['String']['input'];
};

/** For project statuses */
export enum ProjectStatusEnum {
  /** Cancelled */
  Cancelled = 'cancelled',
  /** Completed */
  Completed = 'completed',
  /** In Progress */
  InProgress = 'in_progress',
  /** Not Started */
  NotStarted = 'not_started',
  /** On Hold */
  OnHold = 'on_hold',
}

export type ProjectTemplate = {
  __typename?: 'ProjectTemplate';
  activities?: Maybe<Scalars['JSON']['output']>;
  companyResources?: Maybe<Array<CompanyResource>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  managers?: Maybe<Array<Employment>>;
  tags?: Maybe<Array<CompanyTag>>;
  title: Scalars['String']['output'];
};

export type ProjectTemplateCreate = {
  activities?: InputMaybe<Array<TemplateActivityInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  managerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title: Scalars['String']['input'];
};

export type ProjectUpdate = {
  addressId?: InputMaybe<Scalars['ID']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  projectSettings?: InputMaybe<Array<ProjectSettingsUpdate>>;
  projectUsers?: InputMaybe<Array<ManagerUpdate>>;
  representativeId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProjectUser = {
  __typename?: 'ProjectUser';
  companyResource?: Maybe<CompanyResource>;
  employment?: Maybe<Employment>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  user?: Maybe<User>;
  userType: ProjectUserTypeEnum;
};

/** For user type of project user */
export enum ProjectUserTypeEnum {
  /** Point Of Contact */
  PointOfContact = 'point_of_contact',
  /** Reviewer */
  Reviewer = 'reviewer',
  /** User */
  User = 'user',
}

export type ProjectWorkingHours = {
  __typename?: 'ProjectWorkingHours';
  hours?: Maybe<Scalars['JSON']['output']>;
};

/** Resolved permissions of the current user against this projects record */
export type ProjectsAbilities = {
  __typename?: 'ProjectsAbilities';
  create: Scalars['Boolean']['output'];
  edit: Scalars['Boolean']['output'];
  export: Scalars['Boolean']['output'];
  manage: Scalars['Boolean']['output'];
  view: Scalars['Boolean']['output'];
};

export type Query = {
  __typename?: 'Query';
  /**
   * Summary: The permission registry — every grantable entity with its
   * actions and UI metadata. Replaces the legacy permission matrix and
   * permissionDefinitions queries; there is no dashboard dimension.
   *
   * Auth: Requires user to be logged in.
   *
   * Returns: [Types::AccessRegistryEntityType].
   *
   */
  accessRegistry: Array<AccessRegistryEntity>;
  /**
   * Summary: Checks whether rescheduling a resource would cause time conflicts with existing schedules, applying a 29-minute overlap buffer.
   *
   * Auth: Requires user to be logged in.
   *
   * Arguments:
   *   - schedule_ids (required) - Required array of schedule IDs being checked.
   *   - start_time (optional) - Optional override for the start of the time window.
   *   - end_time (optional) - Optional override for the end of the time window.
   *   - updated_resource_id (optional) - Optional. The resource being swapped in.
   *
   * Returns: JSON object { has_conflicts: Boolean, schedules: Array of conflict details }.
   *
   */
  checkScheduleConflicts: Scalars['JSON']['output'];
  /**
   * Summary: Returns all active employment records for the current user's default company. Use this instead of fetching users directly when the employment record itself (e.g. for permission lookups) is needed alongside the user.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - None
   *
   * Returns: [Types::EmploymentType]. Matching records for the query filters.
   *
   */
  companyEmployments?: Maybe<Array<Employment>>;
  /**
   * Summary: Returns the active representative from context — used in client and contractor portal sessions where the caller is a Representative, not a User.
   *
   * Auth: Requires an active representative session (context[:current_representative]).
   *
   * Arguments:
   *   - None
   *
   * Returns: Types::RepresentativeType. The matching record, or null when not found.
   *
   */
  fetchCurrentRepresentative: Representative;
  /**
   * Summary: Returns the currently authenticated user's own profile data.
   *
   * Auth: Requires user to be logged in.
   *
   * Arguments:
   *   - None
   *
   * Returns: Types::UserType. The matching record, or null when not found.
   *
   */
  fetchMyData?: Maybe<User>;
  /**
   * Summary: The company's access-control audit trail (grant/role/request
   * changes), newest first, paged via limit/offset.
   *
   * Auth: Requires view permission_management.
   *
   * Returns: [Types::AccessAuditEventType].
   *
   */
  getAccessAuditEvents: Array<AccessAuditEvent>;
  /**
   * Summary: Get all access requests
   *
   * Auth: Requires super admin access.
   *
   * Arguments:
   *   - None
   *
   * Returns: [Types::AccessRequestType]
   *
   */
  getAccessRequests?: Maybe<Array<AccessRequest>>;
  /**
   * Summary: Returns project activities across multiple projects for a company with optional status and order filtering.
   *
   * Auth: Requires view_activities permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - company_id (required) - Required. Scopes via project join to this company's activities.
   *   - project_ids (required) - Required. Array of project IDs for bulk loading activities.
   *   - status (optional) - Filters by activity status.
   *   - order (optional) - SQL order clause applied to the result set.
   *
   * Returns: [Types::ProjectActivityType]. Matching records for the query filters, or an empty array when none match.
   *
   */
  getActivitiesForProjects: Array<ProjectActivity>;
  /**
   * Summary: Returns attachment metadata for a document looked up by its document_id (not the metadata record's own primary key).
   *
   * Auth: None (to discuss whether we need to add a permission check)
   *
   * Arguments:
   *   - id (required) - The document_id stored on DocumentMetadatum, not the PK of the metadata record itself. Returns null if no metadata row exists for the given document.
   *
   * Returns: Types::AttachmentType. Attachment metadata for the document_id, or null when not found.
   *
   */
  getAttachment?: Maybe<Attachment>;
  /**
   * Summary: Returns billable items for a given CEQ filtered by resource type.
   *
   * Auth: None (however should discuss whether we need to have a permission check)
   *
   * Arguments:
   *   - ceq_id (required) - Identifies the CEQ whose billable items to fetch.
   *   - resource_type (required) - Both args together scope the result to a meaningful subset.
   *
   * Returns: [Types::BillableItemType]. Matching records for the query filters.
   *
   */
  getCeqBillableItems: Array<BillableItem>;
  /**
   * Summary: Returns all sub-events associated with a given Compensation Event Quotation.
   *
   * Auth: None (however should discuss whether we need to have a permission check)
   *
   * Arguments:
   *   - ceq_id (required) - Identifies the CEQ whose sub-events to fetch.
   *
   * Returns: [Types::CeqSubEventType]. Matching records for the query filters.
   *
   */
  getCeqSubEvents: Array<CeqSubEvent>;
  /**
   * Summary: Returns a single client (Company record) by ID.
   *
   * Auth: Requires view_clients permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - client_id (required) - The client company's ID.
   *
   * Returns: Types::ClientType. The matching record, or null when not found.
   *
   */
  getClient?: Maybe<Client>;
  /**
   * Summary: Returns a filtered, alphabetically ordered list of clients belonging to the current user's default company.
   *
   * Auth: Requires view_clients permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - project_status (optional) - Optional array of statuses — when provided, joins to projects and filters clients to those with at least one project in the given statuses.
   *   - company_name (optional) - Optional name filter applied as a case-insensitive match.
   *   - visible (optional) - When true, applies the .visible scope to exclude hidden clients.
   *
   * Returns: [Types::ClientType]. Matching records for the query filters.
   *
   */
  getClients?: Maybe<Array<Client>>;
  /**
   * Summary: Returns distinct filter option values (project statuses and client names) for the clients listing filter UI, scoped to the current user's company.
   *
   * Auth: Requires user to be logged in (should probably use view_clients permission).
   *
   * Arguments:
   *   - None
   *
   * Returns: Types::ClientFiltersType. The matching record, or null when not found.
   *
   */
  getClientsFilters: ClientFilters;
  /**
   * Summary: Returns all companies in the system.
   *
   * Auth: Requires a super admin user.
   *
   * Arguments:
   *   - None
   *
   * Returns: [Types::CompanyType]. The matching records, or null when not found.
   *
   */
  getCompanies?: Maybe<Array<Company>>;
  getCompaniesHouseInfo: CompaniesHouseInfo;
  /**
   * Summary: Returns a single Company by ID.
   *
   * Auth: Requires a super admin user.
   *
   * Arguments:
   *   - id (required) - The company's ID.
   *
   * Returns: Types::CompanyType. The matching record, or null when not found.
   *
   */
  getCompany?: Maybe<Company>;
  /**
   * Summary: Returns all project addresses across every project belonging to a given company.
   *
   * Auth: None (however should discuss whether we need to have a permission check)
   *
   * Arguments:
   *   - company_id (required) - The company whose project addresses are fetched. Not defaulted to current user's company so that admins can query on behalf of any company.
   *
   * Returns: [Types::AddressType]. Matching records for the query filters.
   *
   */
  getCompanyAddresses: Array<Address>;
  /**
   * Summary: Returns contract types linked specifically to the current user's default company.
   *
   * Auth: None (however should discuss whether we need to have a permission check)
   *
   * Arguments:
   *   - None
   *
   * Returns: [Types::CompanyContractType]. Matching records for the query filters, or an empty array when none match.
   *
   */
  getCompanyContractTypes: Array<CompanyContract>;
  /**
   * Summary: Returns the hierarchical structure of documents and attachments for the current user's company, supporting lazy loading and search. Used for the Documents Drawer in the Manager Dashboard.
   *
   * Auth: Requires view_projects permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - query (optional) - Optional CompanyDocumentsHierarchyInputType input that controls filtering and lazy-load depth. Defaults to an empty hash when omitted. Passed as a plain hash to the CoordinatorService rather than an ActiveRecord scope.
   *
   * Returns: [Types::CompanyDocumentsHierarchyType]. Matching records for the query filters.
   *
   */
  getCompanyDocumentsHierarchy?: Maybe<Array<CompanyDocumentsHierarchy>>;
  /**
   * Summary: Returns the Kanban-style column definitions for the current company's event board.
   *
   * Auth: Requires view_events permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - None
   *
   * Returns: [Types::CompanyEventColumnType]. Matching records for the query filters, or an empty array when none match. Used for the Event Board in the Manager Dashboard.
   *
   */
  getCompanyEventColumns: Array<CompanyEventColumn>;
  /**
   * Summary: Returns all events for a company's projects with optional filtering, including timezone-aware date filtering.
   *
   * Auth: Requires view_events permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - company_id (required) - Required. Scopes events to this company's projects.
   *   - project_id (optional) - Narrows results to a specific project.
   *   - category (optional) - Filters by event category enum.
   *   - event_type (optional) - Narrows results to events of this type.
   *   - status (optional) - Filters by one or more EventStatusEnum values.
   *   - order (optional) - SQL order clause applied to the result set.
   *   - date (optional) - Single date to filter events by occurred_at.
   *   - time_zone (optional) - Used to build the day range for date filtering; falls back to server time if the zone string is invalid.
   *
   * Returns: [Types::EventType]. Matching records for the query filters, or an empty array when none match.
   *
   */
  getCompanyEvents: Array<Event>;
  /**
   * Summary: Returns all non-private, non-notes issues authored by employees of the current user's company.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - category (optional) - Optional. Narrows results to issues in this category.
   *   - issue_type (optional) - Optional. Narrows results to issues of this type.
   *
   * Returns: [Types::IssueType]. Matching records for the query filters.
   *
   */
  getCompanyIssues: Array<Issue>;
  /**
   * Summary: Returns all kick-off templates for the current user's default company.
   *
   * Auth: None (however should discuss whether we need to have a permission check)
   *
   * Arguments:
   *   - company_id (required) - No auth guard; any caller who knows the company ID can fetch its templates.
   *
   * Returns: [Types::KickOffTemplateType]. Matching records for the query filters.
   *
   */
  getCompanyKickOffTemplates?: Maybe<Array<KickOffTemplate>>;
  /**
   * Summary: Returns all kick-offs for the current user's company, optionally filtered by project or initiator.
   *
   * Auth: Requires view_project_kick_off permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - project_id (optional) - Narrows results to kick-offs for this project.
   *   - initiator_id (optional) - Narrows results to kick-offs started by this user.
   *
   * Returns: [Types::ProjectKickOffsType]. Matching records for the query filters.
   *
   */
  getCompanyKickOffs: Array<ProjectKickOffs>;
  /**
   * Summary: Returns a paginated, filterable list of reports for the current user's default company.
   *
   * Auth: Requires view_reports permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - status (optional) - Filters by approval status ('Approved' or 'Pending').
   *   - project_id (optional) - Narrows results to a specific project.
   *   - issue_type (optional) - Narrows results to reports containing issues of this type.
   *   - category_ids (optional) - Narrows results to reports containing issues in these categories.
   *   - stage (optional) - Filters by report stage; defaults to ['submitted'] when absent.
   *   - start_date (optional) - Lower bound for report_date filtering.
   *   - end_date (optional) - Upper bound for report_date filtering.
   *   - issue_description (optional) - Full-text search via Issue.search_description.
   *   - sort_field (optional) - Column to sort by.
   *   - sort_direction (optional) - Direction of the sort ('asc' or 'desc').
   *
   * Returns: Relay connection type for cursor-based pagination.
   *
   */
  getCompanyReports: ReportConnection;
  /**
   * Summary: Returns company resources with multi-dimensional filtering, using LEFT OUTER JOIN on resource_meta to support JSONB-based category filtering.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - search_by (optional) - text search.
   *   - resource_category_id (optional) - Extracted from JSONB resource_meta.
   *   - name (optional) - name filter.
   *   - resource_type (optional) - CompanyResourceResourceTypeEnum filter.
   *   - user_exists (optional) - Boolean; when true filters to resources linked to a User record.
   *
   * Returns: [Types::CompanyResourceType]. Matching records for the query filters.
   *
   */
  getCompanyResources?: Maybe<Array<CompanyResource>>;
  getCompanyResourcesPaginated?: Maybe<CompanyResourceConnection>;
  /**
   * Summary: Returns all settings records for the current user's default company.
   *
   * Auth: Requires view_company_settings permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - None
   *
   * Returns: [Types::CompanySettingType]. Matching records for the query filters, or an empty array when none match.
   *
   */
  getCompanySettings: Array<CompanySetting>;
  /**
   * Summary: Returns all tags for the current user's default company.
   *
   * Auth: Requires user to be logged in.
   *
   * Arguments:
   *   - None
   *
   * Returns: [Types::CompanyTagType]. Matching records for the query filters, or an empty array when none match.
   *
   */
  getCompanyTags: Array<CompanyTag>;
  /**
   * Summary: Returns all Compensation Event Notices associated with a given event.
   *
   * Auth: None (however should probably have view_events permission)
   *
   * Arguments:
   *   - event_id (required) - Required. Identifies the event whose compensation event notices to fetch.
   *
   * Returns: [Types::CompensationEventNoticeType]. Matching records for the query filters.
   *
   */
  getCompensationEventNotices: Array<CompensationEventNotice>;
  /**
   * Summary: Returns the full history of all Compensation Event Quotations for a given event, regardless of editable state.
   *
   * Auth: None (however should probably have view_events permission)
   *
   * Arguments:
   *   - event_id (required) - Required. Identifies the event whose quotations to fetch.
   *
   * Returns: [Types::CompensationEventQuotationType]. Matching records for the query filters.
   *
   */
  getCompensationEventQuotations: Array<CompensationEventQuotation>;
  /**
   * Summary: Detects scheduling conflicts for resources or projects within an optional date range, delegating all logic to ConflictDetectionService.
   *
   * Auth: Requires edit_scheduling or manage_scheduling permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - date_range_start (optional) - Both must be present for date-range scoping to apply; providing only one has no effect.
   *   - date_range_end (optional) - Both must be present for date-range scoping to apply; providing only one has no effect.
   *   - resource_ids (optional) - Scope conflict detection to specific resources.
   *   - project_ids (optional) - Scope conflict detection to specific projects.
   *
   * Returns: [Types::ConflictedResourcesType]. Matching records for the query filters.
   *
   */
  getConflictingSchedules?: Maybe<Array<ConflictedResources>>;
  /**
   * Summary: Returns all globally available contract types with no company scoping.
   *
   * Auth: None (however should discuss whether we need to have a permission check)
   *
   * Arguments:
   *   - None
   *
   * Returns: [Types::ContractType]. Matching records for the query filters, or an empty array when none match.
   *
   */
  getContractTypes: Array<Contract>;
  /**
   * Summary: Returns project users who have permission to approve custom shifts for the specified project.
   * Excludes the current user so they do not request approval from themselves.
   * Falls back to company administrators/owners if no other project users hold approval permission.
   *
   */
  getCustomShiftApprovers: Array<Employment>;
  /**
   * Summary: Returns all resource schedules for a company on a specific date, grouped by project ID. Deprecated — use get_scheduled_resources instead.
   *
   * Auth: None (however should probably be view_scheduling permission)
   *
   * Arguments:
   *   - company_id (required) - Required. Scopes schedules to this company's projects.
   *   - date (required) - Required. Single date to filter schedules against.
   *
   * Returns: JSON. Hash keyed by project_id (not a typed GraphQL object).
   *
   * @deprecated replaced by GetScheduledResources
   */
  getDatedSchedules: Scalars['JSON']['output'];
  /**
   * Summary: Returns the most recent state record for each delivery and collection item associated with a given report.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - report_id (required) - Required. Scopes results to items belonging to this report.
   *
   * Returns: One state record per item, selected via DISTINCT ON (delivery_and_collection_item_id) ORDER BY id DESC. A PostgreSQL-specific pattern.
   *
   */
  getDeliveryItemStates: Array<DeliveryAndCollectionItemState>;
  /**
   * Summary: Returns all delivery and collection register entries for a given project.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - project_id (required) - Required. Scopes results to this project.
   *
   * Returns: [Types::DeliveryAndCollectionRegisterType]. Matching records for the query filters.
   *
   */
  getDeliveryRegisters: Array<DeliveryAndCollectionRegister>;
  /**
   * Summary: Returns delivery and collection registers for a project, optionally filtered by item state.
   *
   * Auth: Requires view_scheduling permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - project_id (required) - The project to get the delivery registers for.
   *   - states (optional) - Array of state strings; defaults to all AASM states when omitted so the caller doesn't need to enumerate them.
   *
   * Returns: [Types::DeliveryAndCollectionRegisterType]. Matching records for the query filters, or an empty array when none match.
   *
   */
  getDeliveryRegistersForProject: Array<DeliveryAndCollectionRegister>;
  /**
   * Summary: Returns sub-projects that are part of an incomplete split operation for a root project.
   *
   * Auth: None (however should probably be view_projects permission).
   *
   * Arguments:
   *   - root_project_id (required) - The root project to check for an incomplete split. Reads the project's metadata.split_history JSON — returns an empty array immediately if the status is not "incomplete".
   *
   * Returns: [Types::ProjectType]. Sub-projects from split_history when status is incomplete; otherwise an empty array.
   *
   */
  getDraftSplitProjects?: Maybe<Array<Project>>;
  /**
   * Summary: Returns all Early Warning Notices associated with a given event.
   *
   * Auth: None (however should probably have view_events permission)
   *
   * Arguments:
   *   - event_id (required) - Identifies the event whose early warning notices to fetch.
   *
   * Returns: [Types::EarlyWarningNoticeType]. Matching records for the query filters.
   *
   */
  getEarlyWarningNotices: Array<EarlyWarningNotice>;
  /**
   * Summary: Returns a single user by ID in an employee context.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - id (required) - The user's ID. Uses find (raises RecordNotFound rather than returning null) if the user does not exist.
   *
   * Returns: Types::UserType. The user record for the given id.
   *
   */
  getEmployee?: Maybe<User>;
  /**
   * Summary: Returns a paginated, searchable list of employees for the current user's company, including both active and inactive employments.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - search (optional) - Optional name/email search via pg_search. Note: mixing pg_search ordering with additional ORDER BY clauses breaks ranking — avoid appending custom sorts.
   *
   * Returns: Relay connection type supporting cursor-based pagination.
   *
   */
  getEmployees?: Maybe<UserConnection>;
  /**
   * Summary: One employment's access setup — assigned roles, direct grants
   * (including expired, for history) and the resolved effective union.
   *
   * Auth: Requires view permission_management. Employment must belong to the caller's company.
   *
   * Returns: Types::EmploymentAccessType.
   *
   */
  getEmploymentAccess?: Maybe<EmploymentAccess>;
  /**
   * Summary: Returns a single event by ID.
   *
   * Auth: Requires view_events permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - id (required) - Uses find, raises ActiveRecord::RecordNotFound if not found.
   *
   * Returns: Types::EventType. The matching record.
   *
   */
  getEvent: Event;
  /**
   * Summary: Returns events for a specific project with optional filtering.
   *
   * Auth: Requires user to be logged in (possibly needs the proper permission in the future).
   *
   * Arguments:
   *   - project_id (required) - Scopes events to this project.
   *   - category (optional) - Narrows results to events in this category.
   *   - event_type (optional) - Narrows results to events of this type.
   *   - status (optional) - Filters by event status.
   *   - order (optional) - SQL order clause applied to the result set.
   *
   * Returns: [Types::EventType]. Matching records for the query filters, or an empty array when none match.
   *
   */
  getEventsByProject: Array<Event>;
  /**
   * Summary: Returns external-only events for a project, intended for the client-facing view. Internal events are never exposed regardless of filters.
   *
   * Auth: None (however should probably have view_events permission).
   *
   * Arguments:
   *   - project_id (required) - Scoped to visible projects; category is hardcoded to 'external'.
   *   - event_type (optional) - Narrows results to events of this type.
   *   - order (optional) - SQL order clause applied to the result set.
   *
   * Returns: [Types::EventType]. Matching records for the query filters, or an empty array when none match.
   *
   */
  getEventsForClient: Array<Event>;
  /**
   * Summary: Returns events across multiple projects for a company with optional filtering.
   *
   * Auth: Requires view_events permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - company_id (required) - Scopes the query to this company's events.
   *   - project_ids (required) - Array of project IDs for bulk loading events.
   *   - category (optional) - Narrows results to events in this category.
   *   - event_type (optional) - Narrows results to events of this type.
   *   - status (optional) - Filters by event status.
   *   - order (optional) - SQL order clause applied to the result set.
   *
   * Returns: [Types::EventType]. Matching records for the query filters, or an empty array when none match.
   *
   */
  getEventsForProjects: Array<Event>;
  /**
   * Summary:
   *   Returns email addresses of existing platform users matching a given name who are not yet employed at (or rejected from) the current company — used to pre-fill invite flows.
   *   Users already employed (any status except rejected) at the company are excluded from results.
   *
   * Auth: Requires user to be logged in with a default company; excludes users already employed at that company.
   *
   * Arguments:
   *   - first_name (required) - Matched case-insensitively against existing users.
   *   - last_name (required) - Matched case-insensitively against existing users.
   *
   * Returns: [String]. Emails of users matching the name who are not yet employed at the current company.
   *
   */
  getExistingUsersEmails: Array<Scalars['String']['output']>;
  /**
   * Summary: Returns feedback records for the current user's default company, ordered newest first.
   *
   * Auth: Requires view_feedback permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - resolved (optional) - When provided filters by resolved status; omitting it returns all.
   *
   * Returns: [Types::FeedbackType]. Matching records for the query filters.
   *
   */
  getFeedbacks?: Maybe<Array<Feedback>>;
  /**
   * Summary: Returns projects in the contracts funnel — those with status not_started or on_hold that have associated documents — for rendering funnel card views.
   *
   * Auth: Requires user to be logged in (requires a proper permission in the future).
   *
   * Arguments:
   *   - None
   *
   * Returns: [Types::ProjectType]. Matching records for the query filters.
   *
   */
  getFunnelCards: Array<Project>;
  /**
   * Summary: Returns upcoming scheduled entries (today and forward) for a root project, ordered by date and start_time.
   *
   * Auth: Requires view_schedules permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - root_project_id (required) - The root project to scope results to.
   *   - company_id (required) - Explicit safety check rather than defaulting to current_user's company.
   *
   * Returns: [Types::ScheduleType]. Matching records for the query filters, or an empty array when none match.
   *
   */
  getFutureSchedules: Array<Schedule>;
  /**
   * Summary: The company's grant requests, optionally filtered by status
   * (pending/approved/rejected).
   *
   * Auth: Requires view permission_management.
   *
   * Returns: [Types::GrantRequestType].
   *
   */
  getGrantRequests: Array<GrantRequest>;
  /**
   * Summary: Returns issue categories — all of them or only those actively used by the current company's issues.
   *
   * Auth: Requires user to be logged in.
   *
   * Arguments:
   *   - dynamic (required): When false returns Category.all; when true filters to categories with at least one company issue.
   *
   * Returns: [Types::IssueCategoryType]. Matching records for the query filters, or an empty array when none match.
   *
   */
  getIssueCategories: Array<IssueCategory>;
  /**
   * Summary: Returns the distinct issue categories that have at least one issue within the current user's company, for populating filter dropdowns.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - None
   *
   * Returns: [Types::IssueCategoryType]. Matching records for the query filters.
   *
   */
  getIssueFilter: Array<IssueCategory>;
  /**
   * Summary: Returns a single Kanban column for the current user's company looked up by name — returns one record, not a collection.
   *
   * Auth: Requires user to be logged in (requires a proper permission in the future).
   *
   * Arguments:
   *   - name (optional) - Used with company_id to find the specific column; if omitted may match the first column with a null name.
   *
   * Returns: Types::KanbanColumnType. The matching record, or null when not found.
   *
   */
  getKanbanColumns: KanbanColumn;
  getKickOff: ProjectKickOffs;
  /** For fetching Kick Off templates by ID */
  getKickOffTemplate?: Maybe<KickOffTemplate>;
  /**
   * Summary: Returns the most recent editable Compensation Event Quotation for a given event — only quotations still open for editing, not finalized ones.
   *
   * Auth: None (however should probably have view_events permission)
   *
   * Arguments:
   *   - event_id (required) - Returns null if no editable CEQ exists.
   *
   * Returns: Types::CompensationEventQuotationType. The matching record, or null when not found.
   *
   */
  getLastCompensationEventQuotation?: Maybe<CompensationEventQuotation>;
  /**
   * Summary: Returns a distinct list of human-type company resources. Specifically designed for use with the ManagerAutocomplete component.
   *
   * Auth: None (however should probably have view_users permission)
   *
   * Arguments:
   *   - None
   *
   * Returns: [Types::CompanyResourceType]. Matching records for the query filters.
   *
   */
  getManagerAutocompleteOptions?: Maybe<Array<Employment>>;
  /**
   * Summary: Returns a deduplicated list of human-type company resources (managers) using DISTINCT ON (name). Deprecated — use GetUsersByRole instead. This is a temporary solution.
   *
   * Auth: None (however should probably have view_users permission)
   *
   * Arguments:
   *   - None
   *
   * Returns: [Types::CompanyResourceType]. Matching records for the query filters.
   *
   * @deprecated replaced by GetUsersByRole
   */
  getManagers?: Maybe<Array<CompanyResource>>;
  /**
   * Summary: The current user's own grant requests (for the request-access UI),
   * optionally filtered by status.
   *
   * Auth: Requires user to be logged in.
   *
   * Returns: [Types::GrantRequestType].
   *
   */
  getMyGrantRequests: Array<GrantRequest>;
  /**
   * Summary: Returns notes shared with the current user, with optional filtering by type, source entity, and search text.
   *
   * Auth: Requires user to be logged in.
   *
   * Arguments:
   *   - search (optional) - Uses ILIKE with sanitize_sql_like to safely escape wildcard characters.
   *   - note_type (optional) - Optional IssueTypeEnum filter applied to issue_type.
   *   - source (optional) - Maps to attachable_type, the polymorphic entity the note is attached to.
   *
   * Returns: [Types::IssueType]. Matching records for the query filters.
   *
   */
  getMyNotes: Array<Issue>;
  /**
   * Summary: Returns in-progress, visible projects for a specific user. Non-owners are scoped to their own project assignments.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - user_id (required) - The user to fetch projects for (noted in code as a TODO to deprecate in favour of current_user).
   *   - company_id (required) - The company to scope results to.
   *
   * Returns: [Types::ProjectType]. In-progress visible projects for the company, scoped by user_id/company_id arguments.
   *
   */
  getMyProjects?: Maybe<Array<Project>>;
  /**
   * Summary: Returns all tasks where the current user is either the creator or the assignee, ordered newest first.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - None
   *
   * Returns: [Types::TaskType]. Matching records for the query filters, or an empty array when none match.
   *
   */
  getMyTasks: Array<Task>;
  /**
   * Summary: Returns users with pending employment status at the current user's default company — users awaiting approval to join — ordered oldest first.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - None
   *
   * Returns: [Types::UserType]. Matching records for the query filters.
   *
   */
  getNewUsersRequests?: Maybe<Array<User>>;
  /**
   * Summary: Returns entity picker options for associating a note with a specific entity type, scoped to the current user's company.
   *
   * Auth: Requires user to be logged in.
   *
   * Arguments:
   *   - entity_type (required) - Determines which model to query: reports, projects, clients, feedbacks; each type builds display labels differently.
   *
   * Returns: Raw JSON array, not a typed GraphQL object.
   *
   */
  getNoteEntityOptions: Scalars['JSON']['output'];
  /**
   * Summary: Returns distinct filter option values (categories, note types, and source types) derived from the current user's shared notes, for populating the notes filter UI.
   *
   * Auth: Requires user to be logged in.
   *
   * Arguments:
   *   - None
   *
   * Returns: Types::NoteFiltersType. The matching record, or null when not found.
   *
   */
  getNoteFilters?: Maybe<NoteFilters>;
  /**
   * Summary: Returns selectable resource options for a given billable item type scoped to the current company, used to populate item-picker dropdowns when building a CEQ.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - item_type (required) - One of User, InternalEquipment, ExternalEquipment, Materials, SubContractor; determines which model/scope is queried; raises ArgumentError on unknown values.
   *
   * Returns: [Types::BillableItemOptionType]. Matching records for the query filters.
   *
   */
  getOptionsForBillableItems: Array<BillableItemOption>;
  /**
   * Summary: Returns the current user's own personal notes based on the default employment with optional filtering. Distinct from get_my_notes which returns notes shared with the user.
   *
   * Auth: Requires user to be logged in.
   *
   * Arguments:
   *   - search (optional) - Optional keyword filter.
   *   - tag_ids (optional) - Optional array of tag IDs; filters via tags join.
   *   - note_type (optional) - Optional NotesTypeEnum filter.
   *
   * Returns: [Types::NoteType]. Matching records for the query filters.
   *
   */
  getPersonalNotes: Array<Note>;
  /**
   * Summary: Returns synthetic placeholder resources derived from distinct meta_data descriptions on unassigned schedules — for schedules not linked to a real CompanyResource.
   *
   * Auth: Requires user to be logged in.
   *
   * Arguments:
   *   - search_by (optional) - Filters on the meta_data description.
   *
   * Returns: [Types::SchedulerResourceType]. Matching records for the query filters, or an empty array when none match.
   *
   */
  getPlaceholdersForScheduler: Array<SchedulerResource>;
  /**
   * Summary: Returns a single visible project by ID.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - project_id (required) - The project's ID. Uses Project.unscoped.visible to explicitly bypass default scopes before re-applying the visibility filter.
   *
   * Returns: Types::ProjectType. The visible project, or null when not found.
   *
   */
  getProject?: Maybe<Project>;
  /**
   * Summary: Returns all activity log entries for a project, ordered newest first.
   *
   * Auth: Requires view_projects permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - project_id (required) - The project whose activities are fetched.
   *
   * Returns: [Types::ProjectActivityType]. Matching records for the query filters.
   *
   */
  getProjectActivities?: Maybe<Array<ProjectActivity>>;
  /**
   * Summary: Returns all addresses associated with a given project.
   *
   * Auth: None (however should probably have view_projects permission).
   *
   * Arguments:
   *   - project_id (required) - The project whose addresses are fetched.
   *
   * Returns: [Types::AddressType]. Matching records for the query filters.
   *
   */
  getProjectAddresses: Array<Address>;
  /**
   * Summary: Generates a recommended project code from a title and appends a zero-padded sequence number to ensure uniqueness within the company.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - title (required) - Used to derive the code abbreviation — 1 word gives first 3 chars, 2 words gives first+last chars of each, 3+ words gives first char of first three words.
   *   - parent_code (optional) - When provided, counts sub-projects under the matched parent project to determine the sequence number instead of counting all company projects.
   *
   * Returns: A string like "GIB-003". The suggested code for display only; uniqueness is not enforced.
   *
   */
  getProjectCodeSuggestion?: Maybe<Scalars['String']['output']>;
  /**
   * Summary: Returns the draft kick-off for a project, or the most recent company-level draft if no project is specified.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - project_id (optional) - When nil or "0" returns the last project-less draft for the current user's company; otherwise finds the draft for the given project.
   *
   * Returns: Types::ProjectKickOffsType. The matching record, or null when not found.
   *
   */
  getProjectDraftKickOff?: Maybe<ProjectKickOffs>;
  /**
   * Summary: Returns available filter option values (people, statuses, and clients) for the projects listing filter UI. Non-owners are scoped to their own projects before computing options.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - None
   *
   * Returns: Types::ProjectFiltersType. The matching record, or null when not found.
   *
   */
  getProjectFilters: ProjectFilters;
  /**
   * Summary: Decodes a sub-contractor invitation token and returns pre-fill data (name and email) for the onboarding form.
   *
   * Auth: None
   *
   * Arguments:
   *   - token (required) - Base64-encoded string containing the company_resource_id in the last segment; the token itself acts as the access control.
   *
   * Returns: Types::ProjectInvitationPrefillType. The matching record, or null when not found.
   *
   */
  getProjectInvitationPrefillData: ProjectInvitationPrefill;
  /**
   * Summary: Returns all issues for a specific visible project, ordered newest first.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - project_id (required) - Required. Scoped to Project.visible, so hidden projects return nothing.
   *
   * Returns: [Types::IssueType]. Matching records for the query filters.
   *
   */
  getProjectIssues: Array<Issue>;
  /**
   * Summary: Returns all kick-offs for a given project, optionally filtered by status.
   *
   * Auth: Requires view_project_kick_off permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - project_id (required) - Scopes kick-offs to this project.
   *   - status (optional) - Filters by kick-off status.
   *
   * Returns: Relay connection type for cursor-based pagination.
   *
   */
  getProjectKickOffs: ProjectKickOffsConnection;
  /**
   * Summary: Returns all notes belonging to a given meeting.
   *
   * Auth: Requires view_projects permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - meeting_id (required) - The meeting whose notes are fetched.
   *
   * Returns: [Types::MeetingNoteType]. Matching records for the query filters.
   *
   */
  getProjectMeetingNotes?: Maybe<Array<MeetingNote>>;
  /**
   * Summary: Returns all meetings for a given project.
   *
   * Auth: Requires view_projects permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - project_id (required) - The project whose meetings are fetched.
   *
   * Returns: [Types::ProjectMeetingType]. Matching records for the query filters.
   *
   */
  getProjectMeetings?: Maybe<Array<ProjectMeeting>>;
  /**
   * Summary: Returns all notes associated with a specific project via the polymorphic target association.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - id (required) - The project's ID; no company scoping applied.
   *
   * Returns: [Types::NoteType]. Matching records for the query filters.
   *
   */
  getProjectNotes: Array<Note>;
  /**
   * Summary: Returns all settings for a specific project.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - project_id (required) - No company scoping applied; any authenticated user can fetch settings for any project by ID.
   *
   * Returns: [Types::ProjectSettingType]. Matching records for the query filters, or an empty array when none match.
   *
   */
  getProjectSettings: Array<ProjectSetting>;
  /**
   * Summary: Returns all project templates for the current user's default company.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - None
   *
   * Returns: [Types::ProjectTemplateType]. Matching records for the query filters, or an empty array when none match.
   *
   */
  getProjectTemplates: Array<ProjectTemplate>;
  /**
   * Summary: Returns the active working hours automation record for a project — specifically the set_default_hours automation type.
   *
   * Auth: None (however should probably have view_projects permission).
   *
   * Arguments:
   *   - project_id (required) - The project to look up. Returns null if no active working hours automation exists.
   *
   * Returns: Types::ProjectWorkingHoursType. The matching record, or null when not found.
   *
   */
  getProjectWorkingHours?: Maybe<ProjectWorkingHours>;
  /**
   * Summary: Returns a paginated, richly filterable list of projects for a given company. Non-owners are automatically scoped to projects they are assigned to.
   *
   * Auth: Requires view_projects permission for 'non-owner' users. Automatically authorized if user is 'owner'. Non-owners are further scoped in the resolver to assigned projects only.
   *
   * Arguments:
   *   - company_id (required) - The company to fetch projects for.
   *   - status (optional) - Optional array of project status strings to filter by.
   *   - client_id (optional) - Optional — filters to projects belonging to this client.
   *   - people_ids (optional) - Optional — filters to projects where all given people are assigned (uses GROUP BY / HAVING for exact set matching).
   *   - visible (optional) - Optional — when provided, applies the visibility scope.
   *   - has_kick_offs (optional) - Optional boolean flag that adds a scoping join.
   *   - has_sub_locations (optional) - Optional boolean flag that adds a scoping join.
   *   - has_sub_projects (optional) - Optional boolean flag that adds a scoping join.
   *   - has_reports_shared (optional) - Optional boolean flag that adds a scoping join.
   *   - has_issues (optional) - Optional boolean flag that adds a scoping join.
   *   - has_open_events (optional) - Optional boolean flag that adds a scoping join.
   *   - searchText (optional) - Optional full-text search across KickOff headings and field values.
   *
   * Returns: Relay connection. Paginated projects with conditional preloads driven by the GraphQL selection set (lookahead).
   *
   */
  getProjects?: Maybe<ProjectConnection>;
  /**
   * Summary: Returns projects available for the scheduler resource panel, with rich filtering support.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - status (optional) - Optional array of ProjectStatusEnum values. Constrained to [not_started, in_progress, on_hold]. Defaults to all 3 when omitted.
   *   - single_out_project_id (optional) - When provided, ensures this specific project is always included in results regardless of other filters.
   *   - project_ids (optional) - Optional explicit list of project IDs to include.
   *   - tag_ids (optional) - Optional — filters via join on company_tag_resources.
   *   - search_by (optional) - Optional name/code search.
   *   - client_ids (optional) - Optional client filter.
   *   - city (optional) - Optional city filter via main_address join.
   *   - zip (optional) - Optional zip filter via main_address join.
   *   - issue_ids (optional) - Optional — filters to projects with specific issues.
   *   - issue_search (optional) - Optional full-text search on issue descriptions.
   *   - event_search (optional) - Optional full-text search on event descriptions.
   *
   * Returns: [Types::SchedulerProjectType]. Matching records for the query filters, or an empty array when none match.
   *
   */
  getProjectsForScheduling?: Maybe<Array<SchedulerProject>>;
  /**
   * Summary: Returns all visible projects that have at least one kick-off record, used to populate kick-off related dropdowns and listings.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - company_id (required) - The company to scope results to.
   *
   * Returns: [Types::ProjectType]. Matching records for the query filters.
   *
   */
  getProjectsWithKickoffs?: Maybe<Array<Project>>;
  /**
   * Summary: Returns a single report either by its ID or by project and date (submitted stage only when querying by project/date).
   *
   * Auth: Requires view_reports permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - report_id (optional) - When provided, fetches by ID ignoring project_id/report_date.
   *   - project_id (optional) - Used together with report_date when report_id is absent to find a submitted report.
   *   - report_date (optional) - Used together with project_id when report_id is absent to find a submitted report.
   *
   * Returns: Types::ReportType. The matching record, or null when not found.
   *
   */
  getReport?: Maybe<Report>;
  /**
   * Summary: Returns a report for the given project and date for the submission flow, creating it if one does not yet exist.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - project_id (required) - Identifies the project the report belongs to.
   *   - report_date (required) - The date of the report to find or create.
   *
   * Returns: Types::ReportType. The matching record, or null when not found.
   *
   */
  getReportForSubmission?: Maybe<Report>;
  /**
   * Summary: Returns a single issue by ID with no company or report scoping.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - id (required) - The ID of the issue to fetch.
   *
   * Returns: Types::IssueType. The matching record, or null when not found.
   *
   */
  getReportIssue: Issue;
  /**
   * Summary: Returns a count of issues on a given report, grouped by category.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - report_id (required) - Identifies the report whose issues to count.
   *
   * Returns: ReportIssueCountType. A structured object mapping category names to counts rather than a plain integer.
   *
   */
  getReportIssueCount: ReportIssueCount;
  /**
   * Summary: Returns all issues attached to a specific report, ordered oldest first.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - report_id (required) - Identifies the report whose issues to fetch.
   *   - category (optional) - Narrows results to issues in this category.
   *
   * Returns: [Types::IssueType]. Matching records for the query filters.
   *
   */
  getReportIssues: Array<Issue>;
  /**
   * Summary: Returns all reports for a given project including historical ones, with optional filtering.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - project_id (required) - Required. Identifies the project whose reports to fetch.
   *   - approved (optional) - Filters by approval status when provided.
   *   - issue_type (optional) - Narrows results to reports containing issues of this type.
   *   - category (optional) - Narrows results to reports containing issues in this category.
   *   - order (optional) - SQL order clause applied to the result set.
   *
   * Returns: [Types::ReportType]. Reports for the project, optionally filtered and ordered per Arguments.
   *
   */
  getReportsByProject?: Maybe<Array<Report>>;
  /**
   * Summary: Returns all human-type company resources (representatives/contacts) belonging to a given client company.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - client_id (required) - The client company whose resources are fetched.
   *
   * Returns: [Types::CompanyResourceType]. Matching records for the query filters.
   *
   */
  getRepresentativesByClient?: Maybe<Array<CompanyResource>>;
  /**
   * Summary: Returns all resource categories for a given company.
   *
   * Auth: Currently checks if the company is found, but should probably have a proper permission in the future.
   *
   * Arguments:
   *   - company_id (optional) - The authorized? method performs the company lookup and doubles as a guard; the query is denied if the company is not found.
   *
   * Returns: [Types::ResourceCategoryType]. Matching records for the query filters.
   *
   */
  getResourceCategories: Array<ResourceCategory>;
  /**
   * Summary: Returns company resources to populate the scheduler resource panel, with equipment-specific availability filtering.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - resource_type (required) - Determines which resources to load; for EQUIPMENT_TYPE also filters by available/in_use statuses from JSONB resource_meta with a NULL fallback.
   *   - search_by (optional) - Optional text search.
   *
   * Returns: Relay connection type for cursor-based pagination.
   *
   */
  getResourcesForScheduler: SchedulerResourceConnection;
  /**
   * Summary: All roles of the current company with their grant bundles and members.
   *
   * Auth: Requires view permission_management.
   *
   * Returns: [Types::RoleType].
   *
   */
  getRoles: Array<Role>;
  /**
   * Summary: Returns company equipment items eligible for scheduling (quantity >= 1), ordered by name length ascending for dropdown UX.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - company_id (required) - Scopes equipment to this company.
   *   - search_by (optional) - Optional name filter applied via search_by_name scope.
   *
   * Returns: [Types::CompanyEquipmentType]. Matching records for the query filters.
   *
   */
  getSchedulableCompanyEquipments: Array<CompanyEquipment>;
  /**
   * Summary: Returns users who are eligible for scheduling — those with active or pending employment at the given company.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - company_id (required) - The company to scope the query to.
   *   - search_by (optional) - Optional name filter via the search_by_name scope.
   *
   * Returns: [Types::UserType]. Matching records for the query filters.
   *
   */
  getSchedulableEmployees?: Maybe<Array<User>>;
  /**
   * Summary: Returns all user schedules for a company within a date range, grouped by date as a raw JSON hash.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - company_id (required) - The company to scope schedules to.
   *   - start_date (required) - Range start (inclusive).
   *   - end_date (required) - Range end (exclusive — uses Ruby's exclusive range operator).
   *
   * Returns: JSON. Hash keyed by date string (not a typed GraphQL object).
   *
   */
  getSchedule?: Maybe<Scalars['JSON']['output']>;
  /**
   * Summary: Returns a single schedule record by ID for the V2 edit modal, scoped to the current user's company via a projects join.
   *
   * Auth: Requires user to be logged in (possibly needs a proper permission in the future).
   *
   * Arguments:
   *   - id (required) - The schedule's ID. Uses find_by (returns null) rather than find (raises) for safe handling.
   *
   * Returns: Types::ScheduleForEditType. The matching record, or null when not found.
   *
   */
  getScheduleForEdit?: Maybe<ScheduleForEdit>;
  /**
   * Summary: Returns sub-contractor schedules filtered by project/company scope and date or date range.
   *
   * Auth: None but needs a proper permission in the future.
   *
   * Arguments:
   *   - project_id (optional) - Project scope filter (used by report dashboard flows).
   *   - company_id (optional) - Company scope filter (used by scheduler flows to include all projects).
   *   - date (optional) - Single schedule date filter.
   *   - date_range (optional) - Two-element [start_date, end_date] range filter.
   *
   * Returns: [Types::SubContractorScheduleType]. Matching records for the query filters.
   *
   */
  getScheduledSubContractors?: Maybe<Array<SubContractorSchedule>>;
  /**
   * Summary: Returns all available filter option values for the scheduler filter bar — distinct clients, cities, zip codes, and issues — aggregated across the current user's company projects.
   *
   * Auth: None but needs a proper permission in the future.
   *
   * Arguments:
   *   - None
   *
   * Returns: Types::SchedulerFilterOptionsType. The matching record.
   *
   */
  getSchedulerFilterOptions: SchedulerFilterOptions;
  /**
   * Summary: Returns schedule entries supporting both single-project and company-wide views with date range filtering.
   *
   * Auth: None but needs a proper permission in the future.
   *
   * Arguments:
   *   - project_id (optional) - Scopes to a single project for the report dashboard.
   *   - company_id (optional) - Scopes to all company projects for the scheduler.
   *   - date (optional) - Optional single date filter.
   *   - date_range (optional)  - Optional 2-element [String] array; takes precedence over date when both are provided.
   *   - resource_type (optional) - Triggers an additional join on company_resource.
   *
   * Returns: [Types::ScheduleType]. Matching records for the query filters.
   *
   */
  getSchedules?: Maybe<Array<Schedule>>;
  /**
   * Summary: Returns all scheduled entries within a date range for the scheduler view, scoped to the current user's company. Only returns entries with status SCHEDULED.
   *
   * Auth: None but needs a proper permission in the future.
   *
   * Arguments:
   *   - start_date (required) - Start of the date range (inclusive).
   *   - end_date (required) - End of the date range (inclusive).
   *   - project_id (optional) - Optional — when provided, narrows results to a single project.
   *
   * Returns: [Types::SchedulerScheduleType]. Matching records for the query filters, or an empty array when none match.
   *
   */
  getSchedulesForScheduler: Array<SchedulerSchedule>;
  /**
   * Summary: Lists all document library drives within a specific SharePoint site.
   *
   * Auth: Requires user to be logged in with an active SharePoint OAuth connection (token refresh may run in the resolver).
   *
   * Arguments:
   *   - site_id (required) - The SharePoint site ID whose drives (document libraries) should be listed.
   *
   * Returns: [Types::SharepointDriveType]. Matching records for the query filters, or an empty array when none match.
   *
   */
  getSharepointDrives: Array<SharepointDrive>;
  /**
   * Summary: Returns metadata for a single file within a SharePoint drive.
   *
   * Auth: Requires user to be logged in with an active SharePoint OAuth connection (token refresh may run in the resolver).
   *
   * Arguments:
   *   - drive_id (required) - The drive containing the file.
   *   - item_id (required) - The specific file's SharePoint item ID.
   *
   * Returns: Types::SharepointFileType. The matching record, or null when not found.
   *
   */
  getSharepointFileMetadata?: Maybe<SharepointFile>;
  /**
   * Summary: Lists files and folders within a SharePoint drive, supporting recursive folder navigation.
   *
   * Auth: Requires user to be logged in with an active SharePoint OAuth connection (token refresh may run in the resolver).
   *
   * Arguments:
   *   - drive_id (required) - The drive to list items from.
   *   - item_id (optional) - Optional folder ID to list items within a sub-folder. When omitted, lists the root of the drive.
   *
   * Returns: [Types::SharepointFileType]. Matching records for the query filters, or an empty array when none match.
   *
   */
  getSharepointFiles: Array<SharepointFile>;
  /**
   * Summary: Lists available SharePoint sites accessible to the current user via the Microsoft Graph API, with optional search filtering.
   *
   * Auth: Requires user to be logged in with an active SharePoint OAuth connection (token refresh may run in the resolver).
   *
   * Arguments:
   *   - search_query (optional) - Optional keyword passed directly to the Graph API sites search endpoint.
   *
   * Returns: [Types::SharepointSiteType]. Matching records for the query filters, or an empty array when none match.
   *
   */
  getSharepointSites: Array<SharepointSite>;
  /**
   * Summary: Returns a paginated list of sub-contractors for the current user's default company, with optional search.
   *
   * Auth: None but needs a proper permission in the future.
   *
   * Arguments:
   *   - search_by (optional) - Delegates to a .search scope when provided.
   *
   * Returns: Relay connection type for cursor-based pagination.
   *
   */
  getSubContractors: CompanySubContractorConnection;
  /**
   * Summary: Returns a single task by ID, restricted to tasks the current user created or is assigned to. Raises a GraphQL::ExecutionError with a user-friendly message instead of propagating ActiveRecord::RecordNotFound when not found.
   *
   * Auth: Requires view_tasks permission for 'non-owner' users. Automatically authorized if user is 'owner'.
   *
   * Arguments:
   *   - id (required) - The task ID.
   *
   * Returns: Types::TaskType. The matching record, or null when not found.
   *
   */
  getTask?: Maybe<Task>;
  /**
   * Summary: Returns top-level comments for a given task only — replies (nested comments with a parent_comment_id) are not included at this level.
   *
   * Auth: Requires user to be logged in.
   *
   * Arguments:
   *   - task_id (required) - The task to fetch comments for.
   *
   * Returns: [Types::TaskCommentType]. Matching records for the query filters, or an empty array when none match.
   *
   */
  getTaskComments: Array<TaskComment>;
  /**
   * Summary: Returns a filterable list of tasks. Users with view_tasks permission see all company tasks; others see only their own created/assigned tasks.
   *
   * Auth: None but needs a proper permission in the future. Resolver returns all company tasks when view_tasks applies; otherwise only tasks created by or assigned to the current user.
   *
   * Arguments:
   *   - created_by_id (optional) - Optional filter by task creator.
   *   - assignee_id (optional) - Optional filter by assignee.
   *   - status (optional) - Optional status filter.
   *   - priority (optional) - Optional priority filter.
   *   - search_text (optional) - Optional text search on task description.
   *   - entity (optional) - Optional polymorphic entity filter (TaskEntityType).
   *   - due_date_from (optional) - Optional start of date range; records with null due dates are excluded when applied.
   *   - due_date_to (optional) - Optional end of date range; records with null due dates are excluded when applied.
   *
   * Returns: [Types::TaskType]. Filtered task list ordered newest first.
   *
   */
  getTasks: Array<Task>;
  /**
   * Summary: Returns a single user by ID.
   *
   * Auth: None but needs a proper permission in the future based on the use case.
   *
   * Arguments:
   *   - id (required) - The user's ID. No company scoping — any authenticated user can fetch any user by ID.
   *
   * Returns: Types::UserType. The matching record, or null when not found.
   *
   */
  getUser?: Maybe<User>;
  /**
   * Summary: Returns all notifications for the current user's default employment, ordered newest first.
   *
   * Auth: Requires user to be logged in.
   *
   * Arguments:
   *   - None
   *
   * Returns: [Types::NotificationType]. Matching records for the query filters, or an empty array when none match.
   *
   */
  getUserNotifications?: Maybe<Array<Notification>>;
  isLoggedIn: Scalars['Boolean']['output'];
  /**
   * Summary: The current user's effective grants (role grants unioned with
   * valid direct grants) in the single dashboard-less permission namespace.
   *
   * Auth: Requires user to be logged in.
   *
   * Returns: [Types::MyAccessGrantType]. projectIds null = company-wide,
   * otherwise the grant only covers the listed projects.
   *
   */
  myAccess: Array<MyAccessGrant>;
  /**
   * Summary: Returns settings for the current user's active company, resolved from their default employment record.
   *
   * Auth: Requires user to be logged in.
   *
   * Arguments:
   *   - None
   *
   * Returns: Types::UserSettingType. The matching record, or null when not found.
   *
   */
  userSettings?: Maybe<UserSetting>;
  /**
   * Summary: Validates a guest access token and returns whether it is valid along with the associated project ID.
   *
   * Auth: None required — validates a guest access token without a user session.
   *
   * Arguments:
   *   - token (required) - Required. Checked against GuestAccessToken.non_expired.
   *
   * Returns: JSON object { valid: Boolean, project_id: ID | nil }. Returns { valid: false, project_id: nil } for expired or unknown tokens without raising an error.
   *
   */
  validateGuestAccessToken: Scalars['JSON']['output'];
  /**
   * Summary: Checks whether an email is already registered on the platform — either as a User account or as a human CompanyResource via JSONB resource_meta.
   *
   * Auth: None required — public email availability check used during registration and invites.
   *
   * Arguments:
   *   - email (required) - Required. Downcased before querying; checks both users.email and resource_meta.data->>'email'.
   *
   * Returns: JSON object { exists: Boolean }.
   *
   */
  verifyEmailExists: Scalars['JSON']['output'];
};

export type QueryCheckScheduleConflictsArgs = {
  endTime?: InputMaybe<Scalars['String']['input']>;
  scheduleIds: Array<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  updatedResourceId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryCompanyEmploymentsArgs = {
  includeOwner?: InputMaybe<Scalars['Boolean']['input']>;
  includeSelf?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetAccessAuditEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QueryGetActivitiesForProjectsArgs = {
  companyId: Scalars['ID']['input'];
  order?: InputMaybe<Scalars['String']['input']>;
  projectIds: Array<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetAttachmentArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetCeqBillableItemsArgs = {
  ceqId: Scalars['ID']['input'];
  resourceType: Scalars['String']['input'];
};

export type QueryGetCeqSubEventsArgs = {
  ceqId: Scalars['ID']['input'];
};

export type QueryGetClientArgs = {
  clientId: Scalars['ID']['input'];
};

export type QueryGetClientsArgs = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  projectStatus?: InputMaybe<Array<ProjectStatusEnum>>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetCompaniesHouseInfoArgs = {
  companyNumber: Scalars['String']['input'];
};

export type QueryGetCompanyArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetCompanyAddressesArgs = {
  companyId: Scalars['ID']['input'];
};

export type QueryGetCompanyDocumentsHierarchyArgs = {
  query?: InputMaybe<CompanyDocumentsHierarchyInput>;
};

export type QueryGetCompanyEventsArgs = {
  category?: InputMaybe<EventCategoryEnum>;
  companyId: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Array<EventStatusEnum>>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetCompanyIssuesArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  issueType?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetCompanyKickOffsArgs = {
  initiatorId?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<KickOffStatusEnum>;
};

export type QueryGetCompanyReportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  issueDescription?: InputMaybe<Scalars['String']['input']>;
  issueType?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<SortDirectionEnum>;
  sortField?: InputMaybe<ReportsSortFieldsEnum>;
  stage?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetCompanyResourcesArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  resourceCategoryId?: InputMaybe<Scalars['ID']['input']>;
  resourceType?: InputMaybe<CompanyResourceResourceTypeEnum>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  userExists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetCompanyResourcesPaginatedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  resourceCategoryId?: InputMaybe<Scalars['ID']['input']>;
  resourceType?: InputMaybe<CompanyResourceResourceTypeEnum>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  userExists?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetCompensationEventNoticesArgs = {
  eventId: Scalars['ID']['input'];
};

export type QueryGetCompensationEventQuotationsArgs = {
  eventId: Scalars['ID']['input'];
};

export type QueryGetConflictingSchedulesArgs = {
  dateRangeEnd?: InputMaybe<Scalars['String']['input']>;
  dateRangeStart?: InputMaybe<Scalars['String']['input']>;
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  resourceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryGetCustomShiftApproversArgs = {
  projectId: Scalars['ID']['input'];
};

export type QueryGetDatedSchedulesArgs = {
  companyId: Scalars['ID']['input'];
  date: Scalars['String']['input'];
};

export type QueryGetDeliveryItemStatesArgs = {
  reportId: Scalars['ID']['input'];
};

export type QueryGetDeliveryRegistersArgs = {
  projectId: Scalars['ID']['input'];
};

export type QueryGetDeliveryRegistersForProjectArgs = {
  projectId: Scalars['ID']['input'];
  states?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QueryGetDraftSplitProjectsArgs = {
  rootProjectId: Scalars['ID']['input'];
};

export type QueryGetEarlyWarningNoticesArgs = {
  eventId: Scalars['ID']['input'];
};

export type QueryGetEmployeeArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetEmployeesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetEmploymentAccessArgs = {
  employmentId: Scalars['ID']['input'];
};

export type QueryGetEventArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetEventsByProjectArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetEventsForClientArgs = {
  eventType?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
};

export type QueryGetEventsForProjectsArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['ID']['input'];
  eventType?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  projectIds: Array<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetExistingUsersEmailsArgs = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type QueryGetFeedbacksArgs = {
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetFutureSchedulesArgs = {
  companyId: Scalars['ID']['input'];
  rootProjectId: Scalars['ID']['input'];
};

export type QueryGetGrantRequestsArgs = {
  status?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetIssueCategoriesArgs = {
  dynamic: Scalars['Boolean']['input'];
};

export type QueryGetKanbanColumnsArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetKickOffArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetKickOffTemplateArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetLastCompensationEventQuotationArgs = {
  eventId: Scalars['ID']['input'];
};

export type QueryGetMyGrantRequestsArgs = {
  status?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetMyNotesArgs = {
  noteType?: InputMaybe<IssueTypeEnum>;
  search?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetMyProjectsArgs = {
  companyId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type QueryGetNoteEntityOptionsArgs = {
  entityType: Scalars['String']['input'];
};

export type QueryGetOptionsForBillableItemsArgs = {
  itemType: Scalars['String']['input'];
};

export type QueryGetPersonalNotesArgs = {
  noteType?: InputMaybe<NotesTypeEnum>;
  search?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type QueryGetPlaceholdersForSchedulerArgs = {
  searchBy?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetProjectArgs = {
  projectId: Scalars['ID']['input'];
  withDrafts?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetProjectActivitiesArgs = {
  projectId: Scalars['ID']['input'];
};

export type QueryGetProjectAddressesArgs = {
  projectId: Scalars['ID']['input'];
};

export type QueryGetProjectCodeSuggestionArgs = {
  parentCode?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type QueryGetProjectDraftKickOffArgs = {
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetProjectInvitationPrefillDataArgs = {
  token: Scalars['String']['input'];
};

export type QueryGetProjectIssuesArgs = {
  projectId: Scalars['ID']['input'];
};

export type QueryGetProjectKickOffsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  projectId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetProjectMeetingNotesArgs = {
  meetingId: Scalars['ID']['input'];
};

export type QueryGetProjectMeetingsArgs = {
  projectId: Scalars['ID']['input'];
};

export type QueryGetProjectNotesArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetProjectSettingsArgs = {
  projectId: Scalars['ID']['input'];
};

export type QueryGetProjectWorkingHoursArgs = {
  projectId: Scalars['ID']['input'];
};

export type QueryGetProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  companyId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  hasIssues?: InputMaybe<Scalars['Boolean']['input']>;
  hasKickOffs?: InputMaybe<Scalars['Boolean']['input']>;
  hasOpenEvents?: InputMaybe<Scalars['Boolean']['input']>;
  hasReportsShared?: InputMaybe<Scalars['Boolean']['input']>;
  hasSubLocations?: InputMaybe<Scalars['Boolean']['input']>;
  hasSubProjects?: InputMaybe<Scalars['Boolean']['input']>;
  isProjectTab?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  peopleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryGetProjectsForSchedulingArgs = {
  city?: InputMaybe<Scalars['String']['input']>;
  clientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  eventSearch?: InputMaybe<Scalars['String']['input']>;
  issueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  issueSearch?: InputMaybe<Scalars['String']['input']>;
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  singleOutProjectId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Array<ProjectStatusEnum>>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetProjectsWithKickoffsArgs = {
  companyId: Scalars['ID']['input'];
};

export type QueryGetReportArgs = {
  projectId?: InputMaybe<Scalars['ID']['input']>;
  reportDate?: InputMaybe<Scalars['String']['input']>;
  reportId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetReportForSubmissionArgs = {
  projectId: Scalars['ID']['input'];
  reportDate: Scalars['String']['input'];
};

export type QueryGetReportIssueArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetReportIssueCountArgs = {
  reportId: Scalars['ID']['input'];
};

export type QueryGetReportIssuesArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['ID']['input'];
};

export type QueryGetReportsByProjectArgs = {
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  issueType?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
};

export type QueryGetRepresentativesByClientArgs = {
  clientId: Scalars['ID']['input'];
};

export type QueryGetResourceCategoriesArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetResourcesForSchedulerArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  resourceType: Scalars['String']['input'];
  searchBy?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetSchedulableCompanyEquipmentsArgs = {
  companyId: Scalars['ID']['input'];
  searchBy?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetSchedulableEmployeesArgs = {
  companyId: Scalars['ID']['input'];
  searchBy?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetScheduleArgs = {
  companyId: Scalars['ID']['input'];
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type QueryGetScheduleForEditArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetScheduledSubContractorsArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<Array<Scalars['String']['input']>>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryGetSchedulesArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<Array<Scalars['String']['input']>>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  resourceType?: InputMaybe<CompanyResourceResourceTypeEnum>;
};

export type QueryGetSchedulesForSchedulerArgs = {
  endDate: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['String']['input'];
};

export type QueryGetSharepointDrivesArgs = {
  siteId: Scalars['String']['input'];
};

export type QueryGetSharepointFileMetadataArgs = {
  driveId: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
};

export type QueryGetSharepointFilesArgs = {
  driveId: Scalars['String']['input'];
  itemId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetSharepointSitesArgs = {
  searchQuery?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetSubContractorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetTaskArgs = {
  id: Scalars['ID']['input'];
};

export type QueryGetTaskCommentsArgs = {
  taskId: Scalars['ID']['input'];
};

export type QueryGetTasksArgs = {
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  createdById?: InputMaybe<Scalars['ID']['input']>;
  dueDateFrom?: InputMaybe<Scalars['String']['input']>;
  dueDateTo?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<TaskEntity>;
  priority?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetUserArgs = {
  id: Scalars['ID']['input'];
};

export type QueryValidateGuestAccessTokenArgs = {
  token: Scalars['String']['input'];
};

export type QueryVerifyEmailExistsArgs = {
  email: Scalars['String']['input'];
};

export type RejectGuestUserSchedule = {
  scheduleId: Scalars['ID']['input'];
};

export type Report = {
  __typename?: 'Report';
  /** The current user's resolved permissions on this record */
  abilities: ReportsAbilities;
  approvalDate?: Maybe<Scalars['ISO8601Date']['output']>;
  approved: Scalars['Boolean']['output'];
  approvedBy?: Maybe<Employment>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  deliveryAndCollection?: Maybe<Array<DeliveryItemsView>>;
  equipmentRegisters: Array<Schedule>;
  hasDeliveryRegisters?: Maybe<Scalars['Boolean']['output']>;
  hasEquipmentRegisters?: Maybe<Scalars['Boolean']['output']>;
  hasIssues?: Maybe<Scalars['Boolean']['output']>;
  hasPeopleRegisters?: Maybe<Scalars['Boolean']['output']>;
  hasSubContractorRegisters?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  issues?: Maybe<Array<Issue>>;
  peopleRegisters: Array<Schedule>;
  project: Project;
  projectId: Scalars['ID']['output'];
  reportDate: Scalars['String']['output'];
  reporter: Employment;
  reporterId: Scalars['Int']['output'];
  stage: Scalars['String']['output'];
  subContractorRegisters: Array<Schedule>;
  submittedOn?: Maybe<Scalars['ISO8601Date']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  weather?: Maybe<Scalars['String']['output']>;
};

/** The connection type for Report. */
export type ReportConnection = {
  __typename?: 'ReportConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ReportEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Report>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type ReportEdge = {
  __typename?: 'ReportEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Report>;
};

export type ReportIssueCount = {
  __typename?: 'ReportIssueCount';
  environmental?: Maybe<Scalars['Int']['output']>;
  healthAndSafety?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Scalars['Int']['output']>;
  performance?: Maybe<Scalars['Int']['output']>;
  quality?: Maybe<Scalars['Int']['output']>;
  workDone?: Maybe<Scalars['Int']['output']>;
};

/** Resolved permissions of the current user against this reports record */
export type ReportsAbilities = {
  __typename?: 'ReportsAbilities';
  create: Scalars['Boolean']['output'];
  edit: Scalars['Boolean']['output'];
  export: Scalars['Boolean']['output'];
  manage: Scalars['Boolean']['output'];
  view: Scalars['Boolean']['output'];
};

export enum ReportsSortFieldsEnum {
  /** approval_date */
  ApprovalDate = 'approval_date',
  /** approved */
  Approved = 'approved',
  /** approved_by */
  ApprovedBy = 'approved_by',
  /** created_at */
  CreatedAt = 'created_at',
  /** id */
  Id = 'id',
  /** project_id */
  ProjectId = 'project_id',
  /** report_date */
  ReportDate = 'report_date',
  /** reporter_id */
  ReporterId = 'reporter_id',
  /** stage */
  Stage = 'stage',
  /** submitted_on */
  SubmittedOn = 'submitted_on',
  /** updated_at */
  UpdatedAt = 'updated_at',
  /** weather */
  Weather = 'weather',
}

export type Representative = {
  __typename?: 'Representative';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  primaryPhone?: Maybe<Scalars['String']['output']>;
  projects?: Maybe<Array<Project>>;
};

export type RepresentativeCreate = {
  clientId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  primaryPhone?: InputMaybe<Scalars['String']['input']>;
};

export type ResizeResourceScheduleV2Input = {
  endDate: Scalars['String']['input'];
  endTime?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
  startDate: Scalars['String']['input'];
  startTime?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ResizeResourceScheduleV2. */
export type ResizeResourceScheduleV2Payload = {
  __typename?: 'ResizeResourceScheduleV2Payload';
  droppedScheduleIds: Array<Scalars['ID']['output']>;
  hasConflicts: Scalars['Boolean']['output'];
  schedules: Array<SchedulerSchedule>;
};

export type ResourceCategory = {
  __typename?: 'ResourceCategory';
  companyId?: Maybe<Scalars['ID']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type ResourceCategoryCreate = {
  companyId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type ResourceMeta = {
  __typename?: 'ResourceMeta';
  attachments: Array<Attachment>;
  batchNumber?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  capacity?: Maybe<Scalars['String']['output']>;
  currentLocation?: Maybe<Scalars['String']['output']>;
  documentUrls?: Maybe<Array<Scalars['String']['output']>>;
  email?: Maybe<Scalars['String']['output']>;
  equipmentType?: Maybe<Scalars['String']['output']>;
  expiryDate?: Maybe<Scalars['String']['output']>;
  fuelType?: Maybe<FuelTypeEnum>;
  id: Scalars['ID']['output'];
  imageUrls?: Maybe<Array<Scalars['String']['output']>>;
  insuranceExpiryDate?: Maybe<Scalars['String']['output']>;
  isScheduleable?: Maybe<Scalars['Boolean']['output']>;
  makeModel?: Maybe<Scalars['String']['output']>;
  maxReach?: Maybe<Scalars['String']['output']>;
  nextServiceDate?: Maybe<Scalars['String']['output']>;
  operatorRequirements?: Maybe<Scalars['String']['output']>;
  permitExpiryDate?: Maybe<Scalars['String']['output']>;
  pointOfContact?: Maybe<Scalars['String']['output']>;
  primaryPhone?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
  resourceCategory?: Maybe<ResourceCategory>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  shortCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ResourceMetaStatusTypeEnum>;
  unit?: Maybe<Scalars['String']['output']>;
  weightDimensions?: Maybe<Scalars['String']['output']>;
};

export type ResourceMetaCreate = {
  batchNumber?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  capacity?: InputMaybe<Scalars['String']['input']>;
  currentLocation?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  equipmentType?: InputMaybe<Scalars['String']['input']>;
  expiryDate?: InputMaybe<Scalars['String']['input']>;
  fuelType?: InputMaybe<FuelTypeEnum>;
  insuranceExpiryDate?: InputMaybe<Scalars['String']['input']>;
  isScheduleable?: InputMaybe<Scalars['Boolean']['input']>;
  makeModel?: InputMaybe<Scalars['String']['input']>;
  maxReach?: InputMaybe<Scalars['String']['input']>;
  nextServiceDate?: InputMaybe<Scalars['String']['input']>;
  operatorRequirements?: InputMaybe<Scalars['String']['input']>;
  permitExpiryDate?: InputMaybe<Scalars['String']['input']>;
  pointOfContact?: InputMaybe<Scalars['String']['input']>;
  primaryPhone?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  resourceCategoryId?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  shortCode?: InputMaybe<Scalars['String']['input']>;
  signedIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<ResourceMetaStatusTypeEnum>;
  unit?: InputMaybe<Scalars['String']['input']>;
  weightDimensions?: InputMaybe<Scalars['String']['input']>;
};

/** Resource Meta Status Type Enum */
export enum ResourceMetaStatusTypeEnum {
  /** Available */
  Available = 'available',
  /** Decommissioned */
  Decommissioned = 'decommissioned',
  /** In Use */
  InUse = 'in_use',
  /** Lost */
  Lost = 'lost',
  /** Maintenance */
  Maintenance = 'maintenance',
}

export type ResourceScheduleCreate = {
  addressId?: InputMaybe<Scalars['ID']['input']>;
  approverEmploymentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  collectable?: InputMaybe<Scalars['Boolean']['input']>;
  companyResourceId: Scalars['ID']['input'];
  customEndTime?: InputMaybe<Scalars['String']['input']>;
  customShift?: InputMaybe<Scalars['Boolean']['input']>;
  customStartTime?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['String']['input'];
  delivererName?: InputMaybe<Scalars['String']['input']>;
  descriptionOfService?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['String']['input'];
  onHire?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  receiverName?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['ID']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['String']['input'];
  supplier?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Resource schedule status enum */
export enum ResourceScheduleStatusEnum {
  /** Completed */
  Completed = 'completed',
  /** Dropped */
  Dropped = 'dropped',
  /** Missed */
  Missed = 'missed',
  /** On Hold */
  OnHold = 'on_hold',
  /** Scheduled */
  Scheduled = 'scheduled',
}

export type ResourceScheduleUpdate = {
  addressId?: InputMaybe<Scalars['ID']['input']>;
  companyResourceId?: InputMaybe<Scalars['ID']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ResourceScheduleStatusEnum>;
  updateFutureSchedules?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Role = {
  __typename?: 'Role';
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  grants: Array<AccessGrantPair>;
  id: Scalars['ID']['output'];
  members: Array<Employment>;
  membersCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Schedule = {
  __typename?: 'Schedule';
  /** The current user's resolved permissions on this record */
  abilities: SchedulingAbilities;
  address?: Maybe<Address>;
  collectable?: Maybe<Scalars['Boolean']['output']>;
  companyResource?: Maybe<CompanyResource>;
  customShift?: Maybe<Scalars['Boolean']['output']>;
  date: Scalars['String']['output'];
  descriptionOfService?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['String']['output'];
  hasConflicts: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  ignored?: Maybe<Scalars['Boolean']['output']>;
  onHire?: Maybe<Scalars['Boolean']['output']>;
  previousResourceId?: Maybe<Scalars['ID']['output']>;
  project: Project;
  quantity?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['String']['output'];
  status: ResourceScheduleStatusEnum;
  title?: Maybe<Scalars['String']['output']>;
};

export type ScheduleCreate = {
  addressId: Scalars['ID']['input'];
  companyResourceIds: Array<Scalars['ID']['input']>;
  date: Scalars['String']['input'];
  descriptionOfService?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['String']['input'];
  onHire?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['ID']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduleForEdit = {
  __typename?: 'ScheduleForEdit';
  addressId?: Maybe<Scalars['ID']['output']>;
  customShift?: Maybe<Scalars['Boolean']['output']>;
  date: Scalars['String']['output'];
  descriptionOfService?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  onHire?: Maybe<Scalars['Boolean']['output']>;
  resourceId?: Maybe<Scalars['ID']['output']>;
  resourceName?: Maybe<Scalars['String']['output']>;
  resourceType: Scalars['String']['output'];
  source?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ScheduleUpdate = {
  addressId?: InputMaybe<Scalars['ID']['input']>;
  collectable?: InputMaybe<Scalars['Boolean']['input']>;
  companyResourceId?: InputMaybe<Scalars['ID']['input']>;
  descriptionOfService?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  ignored?: InputMaybe<Scalars['Boolean']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ResourceScheduleStatusEnum>;
  title?: InputMaybe<Scalars['String']['input']>;
  updateFutureSchedules?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SchedulerFilterClient = {
  __typename?: 'SchedulerFilterClient';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type SchedulerFilterIssue = {
  __typename?: 'SchedulerFilterIssue';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type SchedulerFilterOptions = {
  __typename?: 'SchedulerFilterOptions';
  cities: Array<Scalars['String']['output']>;
  clients: Array<SchedulerFilterClient>;
  issues: Array<SchedulerFilterIssue>;
  zips: Array<Scalars['String']['output']>;
};

export type SchedulerProject = {
  __typename?: 'SchedulerProject';
  code: Scalars['String']['output'];
  enableWeekends: Scalars['Boolean']['output'];
  holidays?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mainAddress?: Maybe<Address>;
  name: Scalars['String']['output'];
  shifts?: Maybe<Scalars['String']['output']>;
  status: ProjectStatusEnum;
  subLocations: Array<Address>;
};

export type SchedulerResource = {
  __typename?: 'SchedulerResource';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  resourceType: Scalars['String']['output'];
};

/** The connection type for SchedulerResource. */
export type SchedulerResourceConnection = {
  __typename?: 'SchedulerResourceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SchedulerResourceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SchedulerResource>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type SchedulerResourceEdge = {
  __typename?: 'SchedulerResourceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SchedulerResource>;
};

export type SchedulerSchedule = {
  __typename?: 'SchedulerSchedule';
  descriptionOfService?: Maybe<Scalars['String']['output']>;
  endDate: Scalars['String']['output'];
  endTime?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  onHire?: Maybe<Scalars['Boolean']['output']>;
  projectId: Scalars['ID']['output'];
  resourceId: Scalars['ID']['output'];
  resourceType: Scalars['String']['output'];
  source?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['String']['output'];
  startTime?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Resolved permissions of the current user against this scheduling record */
export type SchedulingAbilities = {
  __typename?: 'SchedulingAbilities';
  create: Scalars['Boolean']['output'];
  edit: Scalars['Boolean']['output'];
  export: Scalars['Boolean']['output'];
  manage: Scalars['Boolean']['output'];
  view: Scalars['Boolean']['output'];
};

export type SharepointDrive = {
  __typename?: 'SharepointDrive';
  /** Drive type (e.g., 'documentLibrary') */
  driveType?: Maybe<Scalars['String']['output']>;
  /** Drive (document library) ID */
  id: Scalars['String']['output'];
  /** Drive name */
  name?: Maybe<Scalars['String']['output']>;
  /** Drive web URL */
  webUrl?: Maybe<Scalars['String']['output']>;
};

export type SharepointFile = {
  __typename?: 'SharepointFile';
  /** Temporary download URL (null for folders) */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** File or folder item ID */
  id: Scalars['String']['output'];
  /** Whether this item is a folder */
  isFolder: Scalars['Boolean']['output'];
  /** Last modified date/time (ISO 8601) */
  lastModified?: Maybe<Scalars['String']['output']>;
  /** MIME type (null for folders) */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** File or folder name */
  name: Scalars['String']['output'];
  /** File size in bytes (null for folders) */
  size?: Maybe<Scalars['Int']['output']>;
  /** Node type (sharepoint_file or sharepoint_folder) */
  type: SharepointNodeTypeEnum;
  /** Web URL to view the file/folder */
  webUrl?: Maybe<Scalars['String']['output']>;
};

/** SharePoint node type enum */
export enum SharepointNodeTypeEnum {
  /** SharePoint Drive */
  Drive = 'drive',
  /** SharePoint File */
  File = 'file',
  /** SharePoint Folder */
  Folder = 'folder',
  /** SharePoint Root */
  Root = 'root',
  /** SharePoint Site */
  Site = 'site',
}

export type SharepointSite = {
  __typename?: 'SharepointSite';
  /** Site display name */
  displayName?: Maybe<Scalars['String']['output']>;
  /** SharePoint site ID */
  id: Scalars['String']['output'];
  /** Site name */
  name?: Maybe<Scalars['String']['output']>;
  /** Site web URL */
  webUrl?: Maybe<Scalars['String']['output']>;
};

export enum SortDirectionEnum {
  /** Ascending order */
  Asc = 'ASC',
  /** Descending order */
  Desc = 'DESC',
}

export type Source = Issue;

export type SubContractor = {
  __typename?: 'SubContractor';
  active?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<Address>;
  basicOnboardingCompleted?: Maybe<Scalars['Boolean']['output']>;
  companyNumber: Scalars['String']['output'];
  companyType: CompanyTypeEnum;
  hasClients?: Maybe<Scalars['Boolean']['output']>;
  hasFutureSchedules?: Maybe<Scalars['Boolean']['output']>;
  hasHumanResources?: Maybe<Scalars['Boolean']['output']>;
  hasProjects?: Maybe<Scalars['Boolean']['output']>;
  humanResourcesCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  isParent: Scalars['Boolean']['output'];
  mainAddress?: Maybe<Address>;
  name: Scalars['String']['output'];
  onboardingSteps: OnboardingSteps;
  owner?: Maybe<User>;
  primaryEmail: Scalars['String']['output'];
  primaryPhone?: Maybe<Scalars['String']['output']>;
  principalContact?: Maybe<User>;
  projectsCount: Scalars['Int']['output'];
  reportsCount: Scalars['Int']['output'];
  tags?: Maybe<Array<CompanyTag>>;
  tradingName?: Maybe<Scalars['String']['output']>;
  vatNumber?: Maybe<Scalars['String']['output']>;
  welcomeChecklistCompleted?: Maybe<Scalars['Boolean']['output']>;
};

export type SubContractorCreate = {
  name: Scalars['String']['input'];
  principalContact: PrincipalContactCreate;
};

export type SubContractorProjectMappingInput = {
  splitIndex: Scalars['Int']['input'];
  subContractorId: Scalars['ID']['input'];
};

export type SubContractorSchedule = {
  __typename?: 'SubContractorSchedule';
  address: Address;
  date: Scalars['String']['output'];
  descriptionOfService: Scalars['String']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  principalContact: User;
  project: Project;
  startTime: Scalars['String']['output'];
  status: Scalars['String']['output'];
  subContractor: SubContractor;
};

export type SubContractorScheduleCreate = {
  addressId: Scalars['ID']['input'];
  date: Scalars['String']['input'];
  descriptionOfService: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  startTime: Scalars['String']['input'];
  subContractorIds: Array<Scalars['ID']['input']>;
};

export type SubContractorScheduleUpdate = {
  descriptionOfService?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  startTime?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ResourceScheduleStatusEnum>;
};

/** A billable item attached to a specific sub-event, with custom multiplier/quantity/cost. */
export type SubEventBillableItem = {
  __typename?: 'SubEventBillableItem';
  billableItem: BillableItem;
  billableItemId: Scalars['ID']['output'];
  ceqSubEvent: CeqSubEvent;
  ceqSubEventId: Scalars['ID']['output'];
  cost?: Maybe<Scalars['Float']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  multiplier: Scalars['Float']['output'];
  quantity: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  currentPeriodEnd?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  interval: SubscriptionIntervalEnum;
  planType: SubscriptionPlanTypeEnum;
  status: SubscriptionStatusEnum;
};

/** Subscription Interval Enum */
export enum SubscriptionIntervalEnum {
  /** Monthly */
  Monthly = 'monthly',
  /** Unset */
  Unset = 'unset',
  /** Yearly */
  Yearly = 'yearly',
}

/** Subscription Plan Type Enum */
export enum SubscriptionPlanTypeEnum {
  /** Free */
  Free = 'free',
  /** Paid */
  Paid = 'paid',
}

/** Subscription Status Enum */
export enum SubscriptionStatusEnum {
  /** Active */
  Active = 'active',
  /** Canceled */
  Canceled = 'canceled',
  /** Incomplete */
  Incomplete = 'incomplete',
  /** Past Due */
  PastDue = 'past_due',
}

export type Task = {
  __typename?: 'Task';
  /** The current user's resolved permissions on this record */
  abilities: TasksAbilities;
  assignee: Employment;
  attachments: Array<Attachment>;
  createdAt: Scalars['String']['output'];
  creator: Employment;
  description?: Maybe<Scalars['String']['output']>;
  documentUrls?: Maybe<Array<Scalars['String']['output']>>;
  dueDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  entityId?: Maybe<Scalars['ID']['output']>;
  entityName: Scalars['String']['output'];
  entityType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrls?: Maybe<Array<Scalars['String']['output']>>;
  priority: TaskPriorityEnum;
  status: TaskStatusEnum;
  title: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type TaskComment = {
  __typename?: 'TaskComment';
  content: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  employment: Employment;
  id: Scalars['ID']['output'];
  isEdited: Scalars['Boolean']['output'];
  reactions?: Maybe<Array<CommentReaction>>;
  replies: Array<TaskComment>;
  updatedAt: Scalars['String']['output'];
};

export type TaskCommentInput = {
  content: Scalars['String']['input'];
  isEdited?: InputMaybe<Scalars['Boolean']['input']>;
  parentCommentId?: InputMaybe<Scalars['ID']['input']>;
  taskId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

export type TaskCommentReactionInput = {
  commentId: Scalars['ID']['input'];
  emoji: Scalars['String']['input'];
};

export type TaskCreate = {
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  priority: TaskPriorityEnum;
  signedIds?: InputMaybe<Array<Scalars['String']['input']>>;
  status: TaskStatusEnum;
  title: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type TaskEntity = {
  id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Task Priority enum */
export enum TaskPriorityEnum {
  /** Important */
  Important = 'important',
  /** Important And Urgent */
  ImportantAndUrgent = 'important_and_urgent',
  /** Normal */
  Normal = 'normal',
  /** Urgent */
  Urgent = 'urgent',
}

/** Task Status enum */
export enum TaskStatusEnum {
  /** Assigned */
  Assigned = 'assigned',
  /** Blocked */
  Blocked = 'blocked',
  /** Completed */
  Completed = 'completed',
  /** Dropped */
  Dropped = 'dropped',
  /** Started */
  Started = 'started',
}

export type TaskUpdate = {
  description?: InputMaybe<Scalars['String']['input']>;
  dueDate?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  priority?: InputMaybe<TaskPriorityEnum>;
  signedIds?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<TaskStatusEnum>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Resolved permissions of the current user against this tasks record */
export type TasksAbilities = {
  __typename?: 'TasksAbilities';
  create: Scalars['Boolean']['output'];
  edit: Scalars['Boolean']['output'];
  export: Scalars['Boolean']['output'];
  manage: Scalars['Boolean']['output'];
  view: Scalars['Boolean']['output'];
};

export type TemplateActivityInput = {
  colorCode?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type UpdateResourceScheduleV2Input = {
  addressId?: InputMaybe<Scalars['ID']['input']>;
  descriptionOfService?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['String']['input'];
  ids: Array<Scalars['ID']['input']>;
  onHire?: InputMaybe<Scalars['Boolean']['input']>;
  originalPlaceholder?: InputMaybe<Scalars['String']['input']>;
  resourceId?: InputMaybe<Scalars['ID']['input']>;
  resourceName?: InputMaybe<Scalars['String']['input']>;
  resourceType: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateResourceScheduleV2. */
export type UpdateResourceScheduleV2Payload = {
  __typename?: 'UpdateResourceScheduleV2Payload';
  droppedScheduleIds: Array<Scalars['ID']['output']>;
  hasConflicts: Scalars['Boolean']['output'];
  schedules: Array<SchedulerSchedule>;
};

export type User = {
  __typename?: 'User';
  basicOnboardingCompleted?: Maybe<Scalars['Boolean']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  companies?: Maybe<Array<Company>>;
  companyEmployment?: Maybe<Employment>;
  createdAt: Scalars['String']['output'];
  currentSignInAt?: Maybe<Scalars['String']['output']>;
  currentSignInIp?: Maybe<Scalars['String']['output']>;
  dashboardLayout: Scalars['String']['output'];
  defaultCompany?: Maybe<Company>;
  defaultCompanyId?: Maybe<Scalars['ID']['output']>;
  defaultEmployment?: Maybe<Employment>;
  defaultEmploymentStatus?: Maybe<EmploymentStatusEnum>;
  email: Scalars['String']['output'];
  employers?: Maybe<Array<Company>>;
  employmentId: Scalars['String']['output'];
  favoriteTabs: Array<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  hasCompanies?: Maybe<Scalars['Boolean']['output']>;
  hasFutureSchedules: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated Replaced by the role system, no longer to be used */
  isOwner?: Maybe<Scalars['Boolean']['output']>;
  isSuperAdmin?: Maybe<Scalars['Boolean']['output']>;
  lastName: Scalars['String']['output'];
  lastSignInAt?: Maybe<Scalars['String']['output']>;
  lastSignInIp?: Maybe<Scalars['String']['output']>;
  loginEnabled?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  primaryPhone?: Maybe<Scalars['String']['output']>;
  /** Whether the user has an active SharePoint connection that is not expired */
  sharepointConnectionActive: Scalars['Boolean']['output'];
  signInCount?: Maybe<Scalars['Int']['output']>;
  status: UserStatusEnum;
  welcomeChecklistCompleted?: Maybe<Scalars['Boolean']['output']>;
};

/** The connection type for User. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type UserCreate = {
  bio?: InputMaybe<Scalars['String']['input']>;
  companyResourceId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  primaryPhone?: InputMaybe<Scalars['String']['input']>;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

export type UserSetting = {
  __typename?: 'UserSetting';
  dateTimePreference: Scalars['String']['output'];
  projectOrder: Array<ItemOrder>;
  taskPreferences: Scalars['String']['output'];
  widgetLayout: Array<ItemOrder>;
};

/** For user statuses */
export enum UserStatusEnum {
  /** Active */
  Active = 'active',
  /** Inactive */
  Inactive = 'inactive',
}

export type UserUpdate = {
  bio?: InputMaybe<Scalars['String']['input']>;
  companyEmploymentStatus?: InputMaybe<EmploymentStatusEnum>;
  confirmPassword?: InputMaybe<Scalars['String']['input']>;
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  ignoreSchedules?: InputMaybe<Scalars['Boolean']['input']>;
  imageSignedId?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  loginEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  newPassword?: InputMaybe<Scalars['String']['input']>;
  primaryPhone?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserStatusEnum>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  updatedScheduleId?: InputMaybe<Scalars['ID']['input']>;
};

export type AddressFragmentFragment = {
  __typename?: 'Address';
  id: string;
  city: string;
  country: string;
  state: string;
  street: string;
  zip: string;
};

export type AttachedFileFragment = {
  __typename?: 'Attachment';
  id: string;
  signedBlobId?: string | null;
  previewUrl: string;
  filename: string;
  byteSize: number;
  createdAt?: RawDate | null;
  associationType?: AssociationTypeEnum | null;
  tags?: Array<{ __typename?: 'CompanyTag'; title: string }> | null;
};

export type CompleteClientFragmentFragment = {
  __typename?: 'Client';
  id: string;
  name: string;
  primaryEmail?: string | null;
  primaryPhone?: string | null;
  companyNumber: string;
  companyType?: CompanyTypeEnum | null;
  address?: {
    __typename?: 'Address';
    id: string;
    city: string;
    country: string;
    state: string;
    street: string;
    zip: string;
  } | null;
  companyResources: Array<{
    __typename?: 'CompanyResource';
    id: string;
    name: string;
    resourceType: CompanyResourceResourceTypeEnum;
    resourceMeta?: {
      __typename?: 'ResourceMeta';
      id: string;
      email?: string | null;
      primaryPhone?: string | null;
    } | null;
    user?: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      primaryPhone?: string | null;
    } | null;
  }>;
};

export type CompleteEventFragmentFragment = {
  __typename?: 'Event';
  id: string;
  title: string;
  uuid: string;
  category?: EventCategoryEnum | null;
  eventType: EventTypeEnum;
  status: EventStatusEnum;
  description?: string | null;
  approved: boolean;
  flag: boolean;
  ewnCount: number;
  cenCount: number;
  hasActiveCeq: boolean;
  projectCurrency?: string | null;
  orderIndex: number;
  occurredAt?: string | null;
  assignee?: {
    __typename?: 'Employment';
    id: string;
    employee?: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      imageUrl?: string | null;
    } | null;
  } | null;
  project: {
    __typename?: 'Project';
    id: string;
    title: string;
    code: string;
    pointOfContacts?: Array<{
      __typename?: 'ProjectUser';
      id: string;
      title: string;
      companyResource?: {
        __typename?: 'CompanyResource';
        id: string;
        name: string;
        resourceType: CompanyResourceResourceTypeEnum;
        resourceMeta?: {
          __typename?: 'ResourceMeta';
          id: string;
          email?: string | null;
          primaryPhone?: string | null;
          bio?: string | null;
          quantity?: string | null;
          unit?: string | null;
          expiryDate?: string | null;
          batchNumber?: string | null;
          currentLocation?: string | null;
          nextServiceDate?: string | null;
          insuranceExpiryDate?: string | null;
          permitExpiryDate?: string | null;
          operatorRequirements?: string | null;
          capacity?: string | null;
          maxReach?: string | null;
          weightDimensions?: string | null;
          fuelType?: FuelTypeEnum | null;
          status?: ResourceMetaStatusTypeEnum | null;
          pointOfContact?: string | null;
          equipmentType?: string | null;
          shortCode?: string | null;
          serialNumber?: string | null;
          makeModel?: string | null;
          isScheduleable?: boolean | null;
          resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
        } | null;
        user?: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          primaryPhone?: string | null;
          defaultEmploymentStatus?: EmploymentStatusEnum | null;
        } | null;
      } | null;
    }> | null;
    managers?: Array<{
      __typename?: 'ProjectUser';
      id: string;
      title: string;
      user?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName: string;
        lastName: string;
        email: string;
        imageUrl?: string | null;
      } | null;
      companyResource?: {
        __typename?: 'CompanyResource';
        id: string;
        name: string;
        resourceType: CompanyResourceResourceTypeEnum;
        resourceMeta?: {
          __typename?: 'ResourceMeta';
          id: string;
          email?: string | null;
          primaryPhone?: string | null;
          bio?: string | null;
          quantity?: string | null;
          unit?: string | null;
          expiryDate?: string | null;
          batchNumber?: string | null;
          currentLocation?: string | null;
          nextServiceDate?: string | null;
          insuranceExpiryDate?: string | null;
          permitExpiryDate?: string | null;
          operatorRequirements?: string | null;
          capacity?: string | null;
          maxReach?: string | null;
          weightDimensions?: string | null;
          fuelType?: FuelTypeEnum | null;
          status?: ResourceMetaStatusTypeEnum | null;
          pointOfContact?: string | null;
          equipmentType?: string | null;
          shortCode?: string | null;
          serialNumber?: string | null;
          makeModel?: string | null;
          isScheduleable?: boolean | null;
          resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
        } | null;
        user?: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          primaryPhone?: string | null;
          defaultEmploymentStatus?: EmploymentStatusEnum | null;
        } | null;
      } | null;
    }> | null;
    client?: { __typename?: 'Client'; id: string; name: string } | null;
    mainAddress?: {
      __typename?: 'Address';
      id: string;
      street: string;
      city: string;
      state: string;
      zip: string;
      country: string;
      locationType: AddressLocationTypeEnum;
    } | null;
  };
  eventSources?: Array<{
    __typename?: 'EventSource';
    source: {
      __typename: 'Issue';
      id: string;
      description: string;
      issueType: IssueTypeEnum;
      categories: Array<{ __typename?: 'IssueCategory'; id: string; name: string }>;
    };
  }> | null;
  eventComments?: Array<{
    __typename?: 'EventComment';
    id: string;
    text: string;
    status: EventCommentStatusEnum;
    createdAt?: string | null;
  }> | null;
};

export type CompleteScheduleFragmentFragment = {
  __typename?: 'Schedule';
  id: string;
  endTime: string;
  startTime: string;
  status: ResourceScheduleStatusEnum;
  date: string;
  title?: string | null;
  source?: string | null;
  collectable?: boolean | null;
  quantity?: number | null;
  descriptionOfService?: string | null;
  onHire?: boolean | null;
  customShift?: boolean | null;
  hasConflicts: boolean;
  project: {
    __typename?: 'Project';
    id: string;
    title: string;
    code: string;
    mainAddress?: {
      __typename?: 'Address';
      id: string;
      street: string;
      city: string;
      state: string;
      zip: string;
      country: string;
      locationType: AddressLocationTypeEnum;
    } | null;
    subLocations?: Array<{
      __typename?: 'Address';
      id: string;
      title?: string | null;
      street: string;
      city: string;
      state: string;
      zip: string;
      country: string;
    }> | null;
  };
  companyResource?: {
    __typename?: 'CompanyResource';
    id: string;
    name: string;
    resourceType: CompanyResourceResourceTypeEnum;
    resourceMeta?: {
      __typename?: 'ResourceMeta';
      id: string;
      email?: string | null;
      primaryPhone?: string | null;
      bio?: string | null;
      quantity?: string | null;
      unit?: string | null;
      expiryDate?: string | null;
      batchNumber?: string | null;
      currentLocation?: string | null;
      nextServiceDate?: string | null;
      insuranceExpiryDate?: string | null;
      permitExpiryDate?: string | null;
      operatorRequirements?: string | null;
      capacity?: string | null;
      maxReach?: string | null;
      weightDimensions?: string | null;
      fuelType?: FuelTypeEnum | null;
      status?: ResourceMetaStatusTypeEnum | null;
      pointOfContact?: string | null;
      equipmentType?: string | null;
      shortCode?: string | null;
      serialNumber?: string | null;
      makeModel?: string | null;
      isScheduleable?: boolean | null;
      resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
    } | null;
    subContractor?: {
      __typename?: 'SubContractor';
      hasFutureSchedules?: boolean | null;
      id: string;
      imageUrl: string;
      isParent: boolean;
      name: string;
      principalContact?: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        email: string;
        primaryPhone?: string | null;
      } | null;
    } | null;
    user?: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      primaryPhone?: string | null;
      defaultEmploymentStatus?: EmploymentStatusEnum | null;
    } | null;
  } | null;
  address?: {
    __typename?: 'Address';
    id: string;
    street: string;
    city: string;
    state: string;
    zip: string;
    country: string;
    title?: string | null;
    locationType: AddressLocationTypeEnum;
  } | null;
};

export type RegisterDataFragment = {
  __typename?: 'DeliveryAndCollectionRegister';
  id: string;
  projectId: string;
  uuid: string;
  createdAt: string;
  requestor: { __typename?: 'User'; id: string; firstName: string; lastName: string; email: string };
  items: Array<{
    __typename?: 'DeliveryAndCollectionRegisterItem';
    id: string;
    quantity: string;
    companyResource: {
      __typename?: 'CompanyResource';
      id: string;
      name: string;
      resourceType: CompanyResourceResourceTypeEnum;
      resourceMeta?: {
        __typename?: 'ResourceMeta';
        id: string;
        email?: string | null;
        primaryPhone?: string | null;
        bio?: string | null;
        quantity?: string | null;
        unit?: string | null;
        expiryDate?: string | null;
        batchNumber?: string | null;
        currentLocation?: string | null;
        nextServiceDate?: string | null;
        insuranceExpiryDate?: string | null;
        permitExpiryDate?: string | null;
        operatorRequirements?: string | null;
        capacity?: string | null;
        maxReach?: string | null;
        weightDimensions?: string | null;
        fuelType?: FuelTypeEnum | null;
        status?: ResourceMetaStatusTypeEnum | null;
        pointOfContact?: string | null;
        equipmentType?: string | null;
        shortCode?: string | null;
        serialNumber?: string | null;
        makeModel?: string | null;
        isScheduleable?: boolean | null;
        resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
      } | null;
    };
    itemStates: Array<{
      __typename?: 'DeliveryAndCollectionItemState';
      id: string;
      supplier: string;
      notes?: string | null;
      reportId: string;
      currentState: DeliveryAndCollectionItemStateEnum;
      delivererName: string;
      receiverName: string;
      currentStateSetAt: string;
      actor: { __typename?: 'User'; id: string; firstName: string; lastName: string; email: string };
    }>;
  }>;
};

export type RegisterItemStateFragmentFragment = {
  __typename?: 'DeliveryAndCollectionItemState';
  id: string;
  supplier: string;
  notes?: string | null;
  reportId: string;
  currentState: DeliveryAndCollectionItemStateEnum;
  delivererName: string;
  receiverName: string;
  currentStateSetAt: string;
  uuid: string;
  actor: { __typename?: 'User'; id: string; firstName: string; lastName: string; email: string };
  item: {
    __typename?: 'DeliveryAndCollectionRegisterItem';
    id: string;
    quantity: string;
    companyResource: {
      __typename?: 'CompanyResource';
      id: string;
      name: string;
      resourceType: CompanyResourceResourceTypeEnum;
      resourceMeta?: {
        __typename?: 'ResourceMeta';
        id: string;
        email?: string | null;
        primaryPhone?: string | null;
        bio?: string | null;
        quantity?: string | null;
        unit?: string | null;
        expiryDate?: string | null;
        batchNumber?: string | null;
        currentLocation?: string | null;
        nextServiceDate?: string | null;
        insuranceExpiryDate?: string | null;
        permitExpiryDate?: string | null;
        operatorRequirements?: string | null;
        capacity?: string | null;
        maxReach?: string | null;
        weightDimensions?: string | null;
        fuelType?: FuelTypeEnum | null;
        status?: ResourceMetaStatusTypeEnum | null;
        pointOfContact?: string | null;
        equipmentType?: string | null;
        shortCode?: string | null;
        serialNumber?: string | null;
        makeModel?: string | null;
        isScheduleable?: boolean | null;
        resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
      } | null;
    };
  };
};

export type KickOffDataFragmentFragment = {
  __typename?: 'KickOffData';
  projectId?: string | null;
  projectCode?: string | null;
  projectTitle?: string | null;
  clientId?: string | null;
  clientName?: string | null;
  clientCompanyNumber?: string | null;
  clientReps?: Array<any> | null;
  addresses?: Array<any> | null;
  notes?: Array<any> | null;
  newTemplate?: boolean | null;
  projectDetails?: {
    __typename?: 'KickOffProjectDetails';
    managers?: Array<any> | null;
    activities?: Array<any> | null;
    projectTagIds?: Array<string> | null;
    contractTypeIds?: Array<string> | null;
    projectSettings?: Array<any> | null;
  } | null;
};

export type ManagerFieldsFragment = {
  __typename?: 'ProjectUser';
  id: string;
  title: string;
  userType: ProjectUserTypeEnum;
  employment?: {
    __typename?: 'Employment';
    id: string;
    name?: string | null;
    status?: EmploymentStatusEnum | null;
    employee?: {
      __typename?: 'User';
      id: string;
      name?: string | null;
      firstName: string;
      lastName: string;
      email: string;
      primaryPhone?: string | null;
      imageUrl?: string | null;
    } | null;
  } | null;
  user?: {
    __typename?: 'User';
    id: string;
    name?: string | null;
    firstName: string;
    lastName: string;
    email: string;
    primaryPhone?: string | null;
    defaultEmploymentStatus?: EmploymentStatusEnum | null;
    imageUrl?: string | null;
  } | null;
  companyResource?: {
    __typename?: 'CompanyResource';
    id: string;
    name: string;
    resourceType: CompanyResourceResourceTypeEnum;
    resourceMeta?: {
      __typename?: 'ResourceMeta';
      id: string;
      email?: string | null;
      primaryPhone?: string | null;
      bio?: string | null;
      quantity?: string | null;
      unit?: string | null;
      expiryDate?: string | null;
      batchNumber?: string | null;
      currentLocation?: string | null;
      nextServiceDate?: string | null;
      insuranceExpiryDate?: string | null;
      permitExpiryDate?: string | null;
      operatorRequirements?: string | null;
      capacity?: string | null;
      maxReach?: string | null;
      weightDimensions?: string | null;
      fuelType?: FuelTypeEnum | null;
      status?: ResourceMetaStatusTypeEnum | null;
      pointOfContact?: string | null;
      equipmentType?: string | null;
      shortCode?: string | null;
      serialNumber?: string | null;
      makeModel?: string | null;
      isScheduleable?: boolean | null;
      resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
    } | null;
    user?: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      primaryPhone?: string | null;
      defaultEmploymentStatus?: EmploymentStatusEnum | null;
      imageUrl?: string | null;
    } | null;
  } | null;
};

export type PocFieldsFragment = {
  __typename?: 'ProjectUser';
  id: string;
  title: string;
  userType: ProjectUserTypeEnum;
  companyResource?: {
    __typename?: 'CompanyResource';
    id: string;
    name: string;
    resourceType: CompanyResourceResourceTypeEnum;
    resourceMeta?: {
      __typename?: 'ResourceMeta';
      id: string;
      email?: string | null;
      primaryPhone?: string | null;
      bio?: string | null;
      quantity?: string | null;
      unit?: string | null;
      expiryDate?: string | null;
      batchNumber?: string | null;
      currentLocation?: string | null;
      nextServiceDate?: string | null;
      insuranceExpiryDate?: string | null;
      permitExpiryDate?: string | null;
      operatorRequirements?: string | null;
      capacity?: string | null;
      maxReach?: string | null;
      weightDimensions?: string | null;
      fuelType?: FuelTypeEnum | null;
      status?: ResourceMetaStatusTypeEnum | null;
      pointOfContact?: string | null;
      equipmentType?: string | null;
      shortCode?: string | null;
      serialNumber?: string | null;
      makeModel?: string | null;
      isScheduleable?: boolean | null;
      resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
    } | null;
    user?: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      primaryPhone?: string | null;
      defaultEmploymentStatus?: EmploymentStatusEnum | null;
    } | null;
  } | null;
};

export type AcceptClientInvitationMutationVariables = Exact<{
  token: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
}>;

export type AcceptClientInvitationMutation = { __typename?: 'Mutation'; acceptClientInvitation: string };

export type AcceptProjectInvitationMutationVariables = Exact<{
  token: Scalars['String']['input'];
  company: AcceptProjectInvitationCompany;
  user: AcceptProjectInvitationUser;
  admin?: InputMaybe<AcceptProjectInvitationUser>;
}>;

export type AcceptProjectInvitationMutation = { __typename?: 'Mutation'; acceptProjectInvitation: boolean };

export type CreateRoleMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  grants: Array<AccessGrantPairInput> | AccessGrantPairInput;
}>;

export type CreateRoleMutation = {
  __typename?: 'Mutation';
  createRole: { __typename?: 'Role'; id: string; name: string };
};

export type UpdateRoleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  grants?: InputMaybe<Array<AccessGrantPairInput> | AccessGrantPairInput>;
}>;

export type UpdateRoleMutation = {
  __typename?: 'Mutation';
  updateRole: {
    __typename?: 'Role';
    id: string;
    name: string;
    grants: Array<{ __typename?: 'AccessGrantPair'; action: PermissionActionEnum; entity: PermissionEntityEnum }>;
  };
};

export type DeleteRoleMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DeleteRoleMutation = { __typename?: 'Mutation'; deleteRole: boolean };

export type AssignRoleMutationVariables = Exact<{
  employmentId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
}>;

export type AssignRoleMutation = { __typename?: 'Mutation'; assignRole: boolean };

export type UnassignRoleMutationVariables = Exact<{
  employmentId: Scalars['ID']['input'];
  roleId: Scalars['ID']['input'];
}>;

export type UnassignRoleMutation = { __typename?: 'Mutation'; unassignRole: boolean };

export type SetEmploymentGrantsMutationVariables = Exact<{
  employmentId: Scalars['ID']['input'];
  grants: Array<EmploymentGrantInput> | EmploymentGrantInput;
}>;

export type SetEmploymentGrantsMutation = {
  __typename?: 'Mutation';
  setEmploymentGrants: Array<{
    __typename?: 'EmploymentGrant';
    id: string;
    action: PermissionActionEnum;
    entity: PermissionEntityEnum;
    projectId?: string | null;
    validTill?: RawDate | null;
  }>;
};

export type ResolveGrantRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  approve: Scalars['Boolean']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
  validTill?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  additionalActions?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type ResolveGrantRequestMutation = {
  __typename?: 'Mutation';
  resolveGrantRequest: { __typename?: 'GrantRequest'; id: string; status: string };
};

export type ApproveCustomShiftMutationVariables = Exact<{
  scheduleId: Scalars['ID']['input'];
  shiftName: Scalars['String']['input'];
  notificationId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type ApproveCustomShiftMutation = { __typename?: 'Mutation'; approveCustomShift: boolean };

export type ApproveEventMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type ApproveEventMutation = { __typename?: 'Mutation'; approveEvent: boolean };

export type AttachKickOffDocumentsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  signedIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type AttachKickOffDocumentsMutation = { __typename?: 'Mutation'; attachKickOffDocuments: boolean };

export type BulkImportCompanyEquipmentsMutationVariables = Exact<{
  signedId: Scalars['String']['input'];
}>;

export type BulkImportCompanyEquipmentsMutation = { __typename?: 'Mutation'; bulkImportCompanyEquipments: boolean };

export type BulkImportResourcesMutationVariables = Exact<{
  importType: Scalars['String']['input'];
  signedId: Scalars['String']['input'];
}>;

export type BulkImportResourcesMutation = { __typename?: 'Mutation'; bulkImportResources: boolean };

export type BulkImportUsersMutationVariables = Exact<{
  fileSignedId: Scalars['String']['input'];
}>;

export type BulkImportUsersMutation = { __typename?: 'Mutation'; bulkImportUsers: boolean };

export type ChangeProjectStatusMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
}>;

export type ChangeProjectStatusMutation = {
  __typename?: 'Mutation';
  changeProjectStatus: { __typename?: 'Project'; id: string; status: ProjectStatusEnum };
};

export type CompleteKickOffMutationVariables = Exact<{
  kickOffId: Scalars['ID']['input'];
  emails?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  fileUrl: Scalars['String']['input'];
  signedId: Scalars['String']['input'];
}>;

export type CompleteKickOffMutation = { __typename?: 'Mutation'; completeKickOff: boolean };

export type CreateAccessRequestMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;

export type CreateAccessRequestMutation = { __typename?: 'Mutation'; createAccessRequest: boolean };

export type CreateBillingPortalSessionMutationVariables = Exact<{ [key: string]: never }>;

export type CreateBillingPortalSessionMutation = { __typename?: 'Mutation'; createBillingPortalSession: string };

export type CreateBulkSchedulesMutationVariables = Exact<{
  scheduleData: ScheduleCreate;
}>;

export type CreateBulkSchedulesMutation = { __typename?: 'Mutation'; createBulkSchedules: boolean };

export type CreateBulkUsersMutationVariables = Exact<{
  users: Array<UserCreate> | UserCreate;
}>;

export type CreateBulkUsersMutation = { __typename?: 'Mutation'; createBulkUsers?: boolean | null };

export type CreateCeqMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  cenId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type CreateCeqMutation = { __typename?: 'Mutation'; createCeq: boolean };

export type CreateCeqBillableItemMutationVariables = Exact<{
  ceqId: Scalars['ID']['input'];
  resourceType: Scalars['String']['input'];
  resourceId: Scalars['String']['input'];
  unit?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateCeqBillableItemMutation = { __typename?: 'Mutation'; createCeqBillableItem: boolean };

export type CreateCeqSubEventMutationVariables = Exact<{
  ceqId: Scalars['ID']['input'];
}>;

export type CreateCeqSubEventMutation = {
  __typename?: 'Mutation';
  createCeqSubEvent: {
    __typename?: 'CeqSubEvent';
    id: string;
    title?: string | null;
    cost?: number | null;
    programmeImpact?: number | null;
  };
};

export type CreateCheckoutSessionMutationVariables = Exact<{
  interval: Scalars['String']['input'];
  returnPath?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateCheckoutSessionMutation = { __typename?: 'Mutation'; createCheckoutSession: string };

export type CreateClientMutationVariables = Exact<{
  client: ClientCreate;
}>;

export type CreateClientMutation = {
  __typename?: 'Mutation';
  createClient?: {
    __typename?: 'Client';
    activeProjectsCount: number;
    completedProjectsCount: number;
    cancelledProjectsCount: number;
    inFunnelCount: number;
    id: string;
    name: string;
    primaryEmail?: string | null;
    primaryPhone?: string | null;
    companyNumber: string;
    companyType?: CompanyTypeEnum | null;
    address?: {
      __typename?: 'Address';
      id: string;
      city: string;
      country: string;
      state: string;
      street: string;
      zip: string;
    } | null;
    companyResources: Array<{
      __typename?: 'CompanyResource';
      id: string;
      name: string;
      resourceType: CompanyResourceResourceTypeEnum;
      resourceMeta?: {
        __typename?: 'ResourceMeta';
        id: string;
        email?: string | null;
        primaryPhone?: string | null;
      } | null;
      user?: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        email: string;
        primaryPhone?: string | null;
      } | null;
    }>;
  } | null;
};

export type CreateClientInstructionsMutationVariables = Exact<{
  clientInstruction: ClientInstructionCreate;
}>;

export type CreateClientInstructionsMutation = { __typename?: 'Mutation'; createClientInstructions: boolean };

export type CreateClientInvitationMutationVariables = Exact<{
  clientId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;

export type CreateClientInvitationMutation = { __typename?: 'Mutation'; createClientInvitation: boolean };

export type CreateCompanyMutationVariables = Exact<{
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  primaryPhone: Scalars['String']['input'];
  primaryEmail: Scalars['String']['input'];
  isParent: Scalars['Boolean']['input'];
  street: Scalars['String']['input'];
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  country: Scalars['String']['input'];
  zip: Scalars['String']['input'];
  companyNumber: Scalars['String']['input'];
  tradingName?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  companyType?: InputMaybe<CompanyTypeEnum>;
  logoSignedId?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateCompanyMutation = { __typename?: 'Mutation'; createCompany: string };

export type CreateCompanyContractTypeMutationVariables = Exact<{
  contractType: CompanyContractTypeInput;
}>;

export type CreateCompanyContractTypeMutation = {
  __typename?: 'Mutation';
  createCompanyContractType: {
    __typename?: 'CompanyContract';
    id: string;
    companyId: string;
    contractTypeId?: string | null;
  };
};

export type CreateCompanyEquipmentMutationVariables = Exact<{
  name: Scalars['String']['input'];
  shortCode: Scalars['String']['input'];
  unit: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  resourceCategoryId: Scalars['ID']['input'];
  isScheduleable?: InputMaybe<Scalars['Boolean']['input']>;
  equipmentType: EquipmentTypeEnum;
}>;

export type CreateCompanyEquipmentMutation = {
  __typename?: 'Mutation';
  createCompanyEquipment: { __typename?: 'CompanyEquipment'; id: string; name: string; unit: string };
};

export type CreateCompanyResourceMutationVariables = Exact<{
  companyResource: CompanyResourceCreate;
}>;

export type CreateCompanyResourceMutation = { __typename?: 'Mutation'; createCompanyResource: boolean };

export type CreateCompanySettingMutationVariables = Exact<{
  settingName: Scalars['String']['input'];
  settingValue: Scalars['String']['input'];
}>;

export type CreateCompanySettingMutation = {
  __typename?: 'Mutation';
  createCompanySetting: { __typename?: 'CompanySetting'; id: string; name: string; value: string };
};

export type CreateCompanyTagsMutationVariables = Exact<{
  companyTags: CompanyTagCreate;
}>;

export type CreateCompanyTagsMutation = {
  __typename?: 'Mutation';
  createCompanyTags: Array<{ __typename?: 'CompanyTag'; id: string; title: string; createdAt: string }>;
};

export type CreateCompensationEventNoticeMutationVariables = Exact<{
  cen: CompensationEventNoticeCreate;
}>;

export type CreateCompensationEventNoticeMutation = { __typename?: 'Mutation'; createCompensationEventNotice: boolean };

export type CreateCompensationEventQuotationMutationVariables = Exact<{
  quotation: CompensationEventQuotationCreate;
}>;

export type CreateCompensationEventQuotationMutation = {
  __typename?: 'Mutation';
  createCompensationEventQuotation: boolean;
};

export type CreateDeliveryAndCollectionRegisterMutationVariables = Exact<{
  deliveryAndCollectionRegister: DeliveryAndCollectionRegisterCreate;
}>;

export type CreateDeliveryAndCollectionRegisterMutation = {
  __typename?: 'Mutation';
  createDeliveryAndCollectionRegister: Array<{
    __typename?: 'DeliveryAndCollectionItemState';
    id: string;
    supplier: string;
    notes?: string | null;
    reportId: string;
    currentState: DeliveryAndCollectionItemStateEnum;
    delivererName: string;
    receiverName: string;
    currentStateSetAt: string;
    uuid: string;
    actor: { __typename?: 'User'; id: string; firstName: string; lastName: string; email: string };
    item: {
      __typename?: 'DeliveryAndCollectionRegisterItem';
      id: string;
      quantity: string;
      companyResource: {
        __typename?: 'CompanyResource';
        id: string;
        name: string;
        resourceType: CompanyResourceResourceTypeEnum;
        resourceMeta?: {
          __typename?: 'ResourceMeta';
          id: string;
          email?: string | null;
          primaryPhone?: string | null;
          bio?: string | null;
          quantity?: string | null;
          unit?: string | null;
          expiryDate?: string | null;
          batchNumber?: string | null;
          currentLocation?: string | null;
          nextServiceDate?: string | null;
          insuranceExpiryDate?: string | null;
          permitExpiryDate?: string | null;
          operatorRequirements?: string | null;
          capacity?: string | null;
          maxReach?: string | null;
          weightDimensions?: string | null;
          fuelType?: FuelTypeEnum | null;
          status?: ResourceMetaStatusTypeEnum | null;
          pointOfContact?: string | null;
          equipmentType?: string | null;
          shortCode?: string | null;
          serialNumber?: string | null;
          makeModel?: string | null;
          isScheduleable?: boolean | null;
          resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
        } | null;
      };
    };
  }>;
};

export type CreateDirectUploadMutationVariables = Exact<{
  input: DirectUploadCreate;
}>;

export type CreateDirectUploadMutation = {
  __typename?: 'Mutation';
  createDirectUpload: {
    __typename?: 'DirectUpload';
    url: string;
    headers: any;
    blobId: string;
    signedBlobId: string;
    id: string;
  };
};

export type CreateEarlyWarningNoticeMutationVariables = Exact<{
  ewn: EarlyWarningNoticeCreate;
}>;

export type CreateEarlyWarningNoticeMutation = { __typename?: 'Mutation'; createEarlyWarningNotice: boolean };

export type CreateEventMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<EventCategoryEnum>;
  eventType: EventTypeEnum;
  description: Scalars['String']['input'];
  flag?: InputMaybe<Scalars['Boolean']['input']>;
  eventSourcesAttributes?: InputMaybe<Array<EventSourceCreate> | EventSourceCreate>;
  occurredAt?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateEventMutation = {
  __typename?: 'Mutation';
  createEvent: {
    __typename?: 'Event';
    id: string;
    title: string;
    uuid: string;
    category?: EventCategoryEnum | null;
    eventType: EventTypeEnum;
    status: EventStatusEnum;
    description?: string | null;
    approved: boolean;
    flag: boolean;
    ewnCount: number;
    cenCount: number;
    hasActiveCeq: boolean;
    projectCurrency?: string | null;
    orderIndex: number;
    occurredAt?: string | null;
    assignee?: {
      __typename?: 'Employment';
      id: string;
      employee?: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        email: string;
        imageUrl?: string | null;
      } | null;
    } | null;
    project: {
      __typename?: 'Project';
      id: string;
      title: string;
      code: string;
      pointOfContacts?: Array<{
        __typename?: 'ProjectUser';
        id: string;
        title: string;
        companyResource?: {
          __typename?: 'CompanyResource';
          id: string;
          name: string;
          resourceType: CompanyResourceResourceTypeEnum;
          resourceMeta?: {
            __typename?: 'ResourceMeta';
            id: string;
            email?: string | null;
            primaryPhone?: string | null;
            bio?: string | null;
            quantity?: string | null;
            unit?: string | null;
            expiryDate?: string | null;
            batchNumber?: string | null;
            currentLocation?: string | null;
            nextServiceDate?: string | null;
            insuranceExpiryDate?: string | null;
            permitExpiryDate?: string | null;
            operatorRequirements?: string | null;
            capacity?: string | null;
            maxReach?: string | null;
            weightDimensions?: string | null;
            fuelType?: FuelTypeEnum | null;
            status?: ResourceMetaStatusTypeEnum | null;
            pointOfContact?: string | null;
            equipmentType?: string | null;
            shortCode?: string | null;
            serialNumber?: string | null;
            makeModel?: string | null;
            isScheduleable?: boolean | null;
            resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
          } | null;
          user?: {
            __typename?: 'User';
            id: string;
            firstName: string;
            lastName: string;
            email: string;
            primaryPhone?: string | null;
            defaultEmploymentStatus?: EmploymentStatusEnum | null;
          } | null;
        } | null;
      }> | null;
      managers?: Array<{
        __typename?: 'ProjectUser';
        id: string;
        title: string;
        user?: {
          __typename?: 'User';
          id: string;
          name?: string | null;
          firstName: string;
          lastName: string;
          email: string;
          imageUrl?: string | null;
        } | null;
        companyResource?: {
          __typename?: 'CompanyResource';
          id: string;
          name: string;
          resourceType: CompanyResourceResourceTypeEnum;
          resourceMeta?: {
            __typename?: 'ResourceMeta';
            id: string;
            email?: string | null;
            primaryPhone?: string | null;
            bio?: string | null;
            quantity?: string | null;
            unit?: string | null;
            expiryDate?: string | null;
            batchNumber?: string | null;
            currentLocation?: string | null;
            nextServiceDate?: string | null;
            insuranceExpiryDate?: string | null;
            permitExpiryDate?: string | null;
            operatorRequirements?: string | null;
            capacity?: string | null;
            maxReach?: string | null;
            weightDimensions?: string | null;
            fuelType?: FuelTypeEnum | null;
            status?: ResourceMetaStatusTypeEnum | null;
            pointOfContact?: string | null;
            equipmentType?: string | null;
            shortCode?: string | null;
            serialNumber?: string | null;
            makeModel?: string | null;
            isScheduleable?: boolean | null;
            resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
          } | null;
          user?: {
            __typename?: 'User';
            id: string;
            firstName: string;
            lastName: string;
            email: string;
            primaryPhone?: string | null;
            defaultEmploymentStatus?: EmploymentStatusEnum | null;
          } | null;
        } | null;
      }> | null;
      client?: { __typename?: 'Client'; id: string; name: string } | null;
      mainAddress?: {
        __typename?: 'Address';
        id: string;
        street: string;
        city: string;
        state: string;
        zip: string;
        country: string;
        locationType: AddressLocationTypeEnum;
      } | null;
    };
    eventSources?: Array<{
      __typename?: 'EventSource';
      source: {
        __typename: 'Issue';
        id: string;
        description: string;
        issueType: IssueTypeEnum;
        categories: Array<{ __typename?: 'IssueCategory'; id: string; name: string }>;
      };
    }> | null;
    eventComments?: Array<{
      __typename?: 'EventComment';
      id: string;
      text: string;
      status: EventCommentStatusEnum;
      createdAt?: string | null;
    }> | null;
  };
};

export type CreateEventCommentMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
}>;

export type CreateEventCommentMutation = { __typename?: 'Mutation'; createEventComment: boolean };

export type CreateFeedbackMutationVariables = Exact<{
  feedback: FeedbackCreate;
}>;

export type CreateFeedbackMutation = { __typename?: 'Mutation'; createFeedback: boolean };

export type CreateGrantRequestMutationVariables = Exact<{
  action: Scalars['String']['input'];
  entity: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
}>;

export type CreateGrantRequestMutation = {
  __typename?: 'Mutation';
  createGrantRequest: {
    __typename?: 'GrantRequest';
    id: string;
    action: PermissionActionEnum;
    entity: PermissionEntityEnum;
    status: string;
  };
};

export type CreateHumanResourceMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type CreateHumanResourceMutation = {
  __typename?: 'Mutation';
  createHumanResource: { __typename?: 'CompanyResource'; id: string; name: string };
};

export type CreateIssueMutationVariables = Exact<{
  issue: IssueCreate;
}>;

export type CreateIssueMutation = { __typename?: 'Mutation'; createIssue: boolean };

export type CreateKanbanColumnsMutationVariables = Exact<{
  name: Scalars['String']['input'];
  title: Scalars['String']['input'];
  columnId: Scalars['String']['input'];
}>;

export type CreateKanbanColumnsMutation = {
  __typename?: 'Mutation';
  createKanbanColumns?: {
    __typename?: 'KanbanColumn';
    id: string;
    name: string;
    value: Array<{ __typename?: 'KanbanColumnItem'; id: string; title: string }>;
  } | null;
};

export type CreateKickOffMutationVariables = Exact<{
  data: Scalars['JSON']['input'];
  title: Scalars['String']['input'];
  templateId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type CreateKickOffMutation = { __typename?: 'Mutation'; createKickOff: string };

export type CreateMeetingMutationVariables = Exact<{
  meetingData: CreateMeetingInput;
}>;

export type CreateMeetingMutation = {
  __typename?: 'Mutation';
  createMeeting: { __typename?: 'ProjectMeeting'; id: string };
};

export type CreateMeetingMinutesMutationVariables = Exact<{
  meetingId: Scalars['ID']['input'];
  noteSections: Array<Scalars['JSON']['input']> | Scalars['JSON']['input'];
}>;

export type CreateMeetingMinutesMutation = { __typename?: 'Mutation'; createMeetingMinutes: boolean };

export type CreateNotesMutationVariables = Exact<{
  noteData: NotesCreate;
}>;

export type CreateNotesMutation = {
  __typename?: 'Mutation';
  createNotes?: {
    __typename?: 'Note';
    id: string;
    description: string;
    notesType: NotesTypeEnum;
    reminder?: string | null;
    imageUrls?: Array<string> | null;
    targetId?: string | null;
    targetType?: string | null;
    tags?: Array<{ __typename?: 'CompanyTag'; id: string; title: string }> | null;
    attachments: Array<{
      __typename?: 'Attachment';
      id: string;
      signedBlobId?: string | null;
      previewUrl: string;
      filename: string;
      byteSize: number;
      createdAt?: RawDate | null;
      associationType?: AssociationTypeEnum | null;
      tags?: Array<{ __typename?: 'CompanyTag'; title: string }> | null;
    }>;
  } | null;
};

export type CreateProjectMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  code: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  clientReps?: InputMaybe<Array<ClientRepInput> | ClientRepInput>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  companyId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
  addresses?: InputMaybe<Array<AddressInput> | AddressInput>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  projectUsers?: InputMaybe<Array<ManagerCreate> | ManagerCreate>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  contractTypeIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  activities?: InputMaybe<Array<ActivityInput> | ActivityInput>;
  settings?: InputMaybe<Array<ProjectSettingsCreate> | ProjectSettingsCreate>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type CreateProjectMutation = { __typename?: 'Mutation'; createProject: string };

export type CreateProjectActivityMutationVariables = Exact<{
  projectActivity: ProjectActivityCreate;
}>;

export type CreateProjectActivityMutation = { __typename?: 'Mutation'; createProjectActivity: boolean };

export type CreateProjectTemplateMutationVariables = Exact<{
  projectTemplate: ProjectTemplateCreate;
}>;

export type CreateProjectTemplateMutation = {
  __typename?: 'Mutation';
  createProjectTemplate: { __typename?: 'ProjectTemplate'; id: string; title: string; description?: string | null };
};

export type CreateReportIssueMutationVariables = Exact<{
  reportIssue: IssueCreate;
}>;

export type CreateReportIssueMutation = {
  __typename?: 'Mutation';
  createReportIssue: {
    __typename?: 'Issue';
    id: string;
    issueType: IssueTypeEnum;
    startTime: string;
    endTime: string;
    headline: string;
    description: string;
    createdAt?: string | null;
    updatedAt?: string | null;
    imageUrls?: Array<string> | null;
    categories: Array<{ __typename?: 'IssueCategory'; id: string; name: string }>;
  };
};

export type CreateRepresentativeMutationVariables = Exact<{
  name: Scalars['String']['input'];
  email: Scalars['String']['input'];
  primaryPhone?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['ID']['input'];
}>;

export type CreateRepresentativeMutation = { __typename?: 'Mutation'; createRepresentative: boolean };

export type CreateResourceCategoryMutationVariables = Exact<{
  name: Scalars['String']['input'];
  companyId: Scalars['ID']['input'];
}>;

export type CreateResourceCategoryMutation = { __typename?: 'Mutation'; createResourceCategory: boolean };

export type CreateResourceScheduleV2MutationVariables = Exact<{
  input: CreateResourceScheduleV2Input;
}>;

export type CreateResourceScheduleV2Mutation = {
  __typename?: 'Mutation';
  createResourceScheduleV2: {
    __typename?: 'CreateResourceScheduleV2Payload';
    hasConflicts: boolean;
    schedules: Array<{
      __typename?: 'SchedulerSchedule';
      id: string;
      projectId: string;
      resourceId: string;
      resourceType: string;
      startDate: string;
      endDate: string;
      name?: string | null;
      source?: string | null;
      title?: string | null;
      onHire?: boolean | null;
      descriptionOfService?: string | null;
      startTime?: string | null;
      endTime?: string | null;
    }>;
  };
};

export type ScheduleGuestUserMutationVariables = Exact<{
  scheduleInfo: GuestUserScheduleCreate;
}>;

export type ScheduleGuestUserMutation = { __typename?: 'Mutation'; createGuestSchedule: boolean };

export type CreateSingleScheduleMutationVariables = Exact<{
  scheduleInfo: ResourceScheduleCreate;
}>;

export type CreateSingleScheduleMutation = {
  __typename?: 'Mutation';
  createSingleSchedule: {
    __typename?: 'CreateSingleResourceSchedulePayload';
    scheduleId: string;
    hasConflicts: boolean;
  };
};

export type CreateSubContractorMutationVariables = Exact<{
  subContractor: SubContractorCreate;
}>;

export type CreateSubContractorMutation = { __typename?: 'Mutation'; createSubContractor: boolean };

export type CreateSubContractorInvitationMutationVariables = Exact<{
  companyResourceId: Scalars['ID']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type CreateSubContractorInvitationMutation = { __typename?: 'Mutation'; createSubContractorInvitation: boolean };

export type CreateSubContractorSchedulesMutationVariables = Exact<{
  scheduleData: SubContractorScheduleCreate;
}>;

export type CreateSubContractorSchedulesMutation = { __typename?: 'Mutation'; createSubContractorSchedules: boolean };

export type CreateTaskMutationVariables = Exact<{
  task: TaskCreate;
}>;

export type CreateTaskMutation = { __typename?: 'Mutation'; createTask: boolean };

export type CreateTaskCommentMutationVariables = Exact<{
  comment: TaskCommentInput;
}>;

export type CreateTaskCommentMutation = { __typename?: 'Mutation'; createTaskComment: boolean };

export type CreateUserMutationVariables = Exact<{
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  primaryPhone: Scalars['String']['input'];
  bio?: InputMaybe<Scalars['String']['input']>;
  companyResourceId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type CreateUserMutation = { __typename?: 'Mutation'; createUser?: boolean | null };

export type CreateUserMergeRequestMutationVariables = Exact<{
  sourceEmail: Scalars['String']['input'];
}>;

export type CreateUserMergeRequestMutation = { __typename?: 'Mutation'; createUserMergeRequest: boolean };

export type CreateUserPasswordResetMutationVariables = Exact<{
  email: Scalars['String']['input'];
  origin: Scalars['String']['input'];
}>;

export type CreateUserPasswordResetMutation = { __typename?: 'Mutation'; createUserPasswordReset: boolean };

export type DestroyAttachmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DestroyAttachmentMutation = { __typename?: 'Mutation'; destroyAttachment: boolean };

export type DestroyCompanyContractTypeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DestroyCompanyContractTypeMutation = { __typename?: 'Mutation'; destroyCompanyContractType: boolean };

export type DestroyDeliveryAndCollectionItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DestroyDeliveryAndCollectionItemMutation = {
  __typename?: 'Mutation';
  destroyDeliveryAndCollectionItem: boolean;
};

export type DestroyKickOffTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DestroyKickOffTemplateMutation = { __typename?: 'Mutation'; destroyKickOffTemplate: boolean };

export type DestroyNotesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DestroyNotesMutation = { __typename?: 'Mutation'; destroyNotes: boolean };

export type DestroyProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DestroyProjectMutation = { __typename?: 'Mutation'; destroyProject: boolean };

export type DestroyProjectActivityMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DestroyProjectActivityMutation = { __typename?: 'Mutation'; destroyProjectActivity: boolean };

export type RemoveIssueMutationVariables = Exact<{
  issueId: Scalars['ID']['input'];
}>;

export type RemoveIssueMutation = { __typename?: 'Mutation'; destroyReportIssue: boolean };

export type DestroySubContractorMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  ignoreSchedules?: InputMaybe<Scalars['Boolean']['input']>;
  updatedSubContractorId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type DestroySubContractorMutation = { __typename?: 'Mutation'; destroySubContractor: boolean };

export type DestroyTaskMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DestroyTaskMutation = { __typename?: 'Mutation'; destroyTask: boolean };

export type DispatchAttachmentsMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  documentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type DispatchAttachmentsMutation = { __typename?: 'Mutation'; dispatchAttachments: boolean };

export type DisputeCompensationEventNoticeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DisputeCompensationEventNoticeMutation = {
  __typename?: 'Mutation';
  disputeCompensationEventNotice: boolean;
};

export type DropEventMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type DropEventMutation = { __typename?: 'Mutation'; updateEvent: { __typename?: 'Event'; id: string } };

export type DropResourceScheduleV2MutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type DropResourceScheduleV2Mutation = {
  __typename?: 'Mutation';
  dropResourceScheduleV2: { __typename?: 'DropResourceScheduleV2Payload'; droppedIds: Array<string> };
};

export type ExchangeRefreshTokenForJwtMutationVariables = Exact<{ [key: string]: never }>;

export type ExchangeRefreshTokenForJwtMutation = { __typename?: 'Mutation'; exchangeRefreshTokenForJwt: boolean };

export type ExportUserDataMutationVariables = Exact<{ [key: string]: never }>;

export type ExportUserDataMutation = { __typename?: 'Mutation'; exportUserData: boolean };

export type IssueCompensationEventNoticeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type IssueCompensationEventNoticeMutation = { __typename?: 'Mutation'; issueCompensationEventNotice: boolean };

export type IssueCompensationEventQuotationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type IssueCompensationEventQuotationMutation = {
  __typename?: 'Mutation';
  issueCompensationEventQuotation: boolean;
};

export type SignInMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  rememberMe: Scalars['Boolean']['input'];
}>;

export type SignInMutation = { __typename?: 'Mutation'; signIn: boolean };

export type SignOutMutationVariables = Exact<{ [key: string]: never }>;

export type SignOutMutation = { __typename?: 'Mutation'; signOut: boolean };

export type ManageProjectLocationsMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  addresses: Array<AddressUpdate> | AddressUpdate;
}>;

export type ManageProjectLocationsMutation = { __typename?: 'Mutation'; manageProjectLocations: boolean };

export type MarkAsCollectedMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  delivererName?: InputMaybe<Scalars['String']['input']>;
  receiverName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  signedIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type MarkAsCollectedMutation = {
  __typename?: 'Mutation';
  markAsCollected: {
    __typename?: 'DeliveryAndCollectionItemState';
    id: string;
    supplier: string;
    notes?: string | null;
    reportId: string;
    currentState: DeliveryAndCollectionItemStateEnum;
    delivererName: string;
    receiverName: string;
    currentStateSetAt: string;
    uuid: string;
    actor: { __typename?: 'User'; id: string; firstName: string; lastName: string; email: string };
    item: {
      __typename?: 'DeliveryAndCollectionRegisterItem';
      id: string;
      quantity: string;
      companyResource: {
        __typename?: 'CompanyResource';
        id: string;
        name: string;
        resourceType: CompanyResourceResourceTypeEnum;
        resourceMeta?: {
          __typename?: 'ResourceMeta';
          id: string;
          email?: string | null;
          primaryPhone?: string | null;
          bio?: string | null;
          quantity?: string | null;
          unit?: string | null;
          expiryDate?: string | null;
          batchNumber?: string | null;
          currentLocation?: string | null;
          nextServiceDate?: string | null;
          insuranceExpiryDate?: string | null;
          permitExpiryDate?: string | null;
          operatorRequirements?: string | null;
          capacity?: string | null;
          maxReach?: string | null;
          weightDimensions?: string | null;
          fuelType?: FuelTypeEnum | null;
          status?: ResourceMetaStatusTypeEnum | null;
          pointOfContact?: string | null;
          equipmentType?: string | null;
          shortCode?: string | null;
          serialNumber?: string | null;
          makeModel?: string | null;
          isScheduleable?: boolean | null;
          resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
        } | null;
      };
    };
  };
};

export type MarkAsDeployedMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  reportDate: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
}>;

export type MarkAsDeployedMutation = { __typename?: 'Mutation'; markAsDeployed: boolean };

export type MarkAsReadyForCollectionMutationVariables = Exact<{
  companyResourceId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  reportId: Scalars['ID']['input'];
  scheduleId: Scalars['ID']['input'];
}>;

export type MarkAsReadyForCollectionMutation = {
  __typename?: 'Mutation';
  markAsReadyForCollection: {
    __typename?: 'DeliveryAndCollectionItemState';
    id: string;
    supplier: string;
    notes?: string | null;
    reportId: string;
    currentState: DeliveryAndCollectionItemStateEnum;
    delivererName: string;
    receiverName: string;
    currentStateSetAt: string;
    uuid: string;
    actor: { __typename?: 'User'; id: string; firstName: string; lastName: string; email: string };
    item: {
      __typename?: 'DeliveryAndCollectionRegisterItem';
      id: string;
      quantity: string;
      companyResource: {
        __typename?: 'CompanyResource';
        id: string;
        name: string;
        resourceType: CompanyResourceResourceTypeEnum;
        resourceMeta?: {
          __typename?: 'ResourceMeta';
          id: string;
          email?: string | null;
          primaryPhone?: string | null;
          bio?: string | null;
          quantity?: string | null;
          unit?: string | null;
          expiryDate?: string | null;
          batchNumber?: string | null;
          currentLocation?: string | null;
          nextServiceDate?: string | null;
          insuranceExpiryDate?: string | null;
          permitExpiryDate?: string | null;
          operatorRequirements?: string | null;
          capacity?: string | null;
          maxReach?: string | null;
          weightDimensions?: string | null;
          fuelType?: FuelTypeEnum | null;
          status?: ResourceMetaStatusTypeEnum | null;
          pointOfContact?: string | null;
          equipmentType?: string | null;
          shortCode?: string | null;
          serialNumber?: string | null;
          makeModel?: string | null;
          isScheduleable?: boolean | null;
          resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
        } | null;
      };
    };
  };
};

export type MarkNotificationsAsReadMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;

export type MarkNotificationsAsReadMutation = { __typename?: 'Mutation'; markNotificationsAsRead: boolean };

export type ReactOnTaskCommentMutationVariables = Exact<{
  reaction: TaskCommentReactionInput;
}>;

export type ReactOnTaskCommentMutation = { __typename?: 'Mutation'; reactOnTaskComment: boolean };

export type RejectCustomShiftMutationVariables = Exact<{
  scheduleId: Scalars['ID']['input'];
  startTime: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  notificationId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type RejectCustomShiftMutation = { __typename?: 'Mutation'; rejectCustomShift: boolean };

export type RemoveProfilePictureMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type RemoveProfilePictureMutation = { __typename?: 'Mutation'; removeProfilePicture?: boolean | null };

export type RemoveUsersFromProjectMutationVariables = Exact<{
  userIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type RemoveUsersFromProjectMutation = { __typename?: 'Mutation'; removeUsersFromProject: boolean };

export type ResetUserPasswordMutationVariables = Exact<{
  token: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;

export type ResetUserPasswordMutation = { __typename?: 'Mutation'; resetUserPassword: boolean };

export type ResizeResourceScheduleV2MutationVariables = Exact<{
  input: ResizeResourceScheduleV2Input;
}>;

export type ResizeResourceScheduleV2Mutation = {
  __typename?: 'Mutation';
  resizeResourceScheduleV2: {
    __typename?: 'ResizeResourceScheduleV2Payload';
    hasConflicts: boolean;
    droppedScheduleIds: Array<string>;
    schedules: Array<{
      __typename?: 'SchedulerSchedule';
      id: string;
      projectId: string;
      resourceId: string;
      resourceType: string;
      startDate: string;
      endDate: string;
      name?: string | null;
      source?: string | null;
      title?: string | null;
      onHire?: boolean | null;
      descriptionOfService?: string | null;
      startTime?: string | null;
      endTime?: string | null;
      status?: string | null;
    }>;
  };
};

export type RevertReportApprovalMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;

export type RevertReportApprovalMutation = { __typename?: 'Mutation'; revertReportApproval: boolean };

export type SelectFreePlanMutationVariables = Exact<{ [key: string]: never }>;

export type SelectFreePlanMutation = {
  __typename?: 'Mutation';
  selectFreePlan: {
    __typename?: 'Subscription';
    id: string;
    planType: SubscriptionPlanTypeEnum;
    interval: SubscriptionIntervalEnum;
    status: SubscriptionStatusEnum;
  };
};

export type SetDocumentAssociationTypeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  attachableType: Scalars['String']['input'];
  attachableId: Scalars['ID']['input'];
  associationType: AssociationTypeEnum;
}>;

export type SetDocumentAssociationTypeMutation = { __typename?: 'Mutation'; setDocumentAssociationType: boolean };

export type ShareKickOffTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  emails: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type ShareKickOffTemplateMutation = { __typename?: 'Mutation'; shareKickOffTemplate: boolean };

export type ShareReportsMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  emails: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type ShareReportsMutation = { __typename?: 'Mutation'; shareProjectReports: boolean };

export type SignUpMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  confirmPassword: Scalars['String']['input'];
}>;

export type SignUpMutation = { __typename?: 'Mutation'; signUp: boolean };

export type SplitProjectMutationVariables = Exact<{
  rootId: Scalars['ID']['input'];
  splits: Array<ProjectSplit> | ProjectSplit;
  finalize?: InputMaybe<Scalars['Boolean']['input']>;
  subContractorProjectMappings?: InputMaybe<Array<SubContractorProjectMappingInput> | SubContractorProjectMappingInput>;
}>;

export type SplitProjectMutation = { __typename?: 'Mutation'; splitProject: Array<string> };

export type SubmitReportMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;

export type SubmitReportMutation = { __typename?: 'Mutation'; submitReport: boolean };

export type TagAttachmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  companyTagIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;

export type TagAttachmentMutation = { __typename?: 'Mutation'; tagAttachment: boolean };

export type UpdateAccessRequestMutationVariables = Exact<{
  accessRequest: AccessRequestUpdate;
}>;

export type UpdateAccessRequestMutation = {
  __typename?: 'Mutation';
  updateAccessRequest?: {
    __typename?: 'AccessRequest';
    id: string;
    email: string;
    status: AccessRequestStatusEnum;
    createdAt: RawDate;
  } | null;
};

export type UpdateCeqBillableItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  resourceId?: InputMaybe<Scalars['String']['input']>;
  rate?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateCeqBillableItemMutation = { __typename?: 'Mutation'; updateCeqBillableItem: boolean };

export type UpdateCeqSubEventMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  programmeImpact?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateCeqSubEventMutation = { __typename?: 'Mutation'; updateCeqSubEvent: boolean };

export type UpdateClientMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  companyName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  companyNumber: Scalars['String']['input'];
  tradingName?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  companyType?: InputMaybe<CompanyTypeEnum>;
  street?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<ClientUpdate>;
}>;

export type UpdateClientMutation = { __typename?: 'Mutation'; updateClient: boolean };

export type UpdateCompanyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  primaryPhone: Scalars['String']['input'];
  primaryEmail: Scalars['String']['input'];
  street: Scalars['String']['input'];
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  country: Scalars['String']['input'];
  zip: Scalars['String']['input'];
  companyNumber: Scalars['String']['input'];
  tradingName?: InputMaybe<Scalars['String']['input']>;
  vatNumber?: InputMaybe<Scalars['String']['input']>;
  companyType?: InputMaybe<CompanyTypeEnum>;
  logoSignedId?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateCompanyMutation = { __typename?: 'Mutation'; updateCompany: boolean };

export type UpdateCompanyEventColumnMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  label: Scalars['String']['input'];
}>;

export type UpdateCompanyEventColumnMutation = { __typename?: 'Mutation'; updateCompanyEventColumn: boolean };

export type UpdateCompanyResourceMutationVariables = Exact<{
  companyResource: CompanyResourceUpdate;
}>;

export type UpdateCompanyResourceMutation = { __typename?: 'Mutation'; updateCompanyResource: boolean };

export type UpdateCompensationEventNoticeMutationVariables = Exact<{
  cen: CompensationEventNoticeUpdate;
}>;

export type UpdateCompensationEventNoticeMutation = { __typename?: 'Mutation'; updateCompensationEventNotice: boolean };

export type UpdateConflictedSchedulesMutationVariables = Exact<{
  resourceSchedules: Array<ResourceScheduleUpdate> | ResourceScheduleUpdate;
}>;

export type UpdateConflictedSchedulesMutation = { __typename?: 'Mutation'; updateConflictedSchedules: boolean };

export type UpdateDefaultCompanyMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
}>;

export type UpdateDefaultCompanyMutation = { __typename?: 'Mutation'; updateDefaultCompany: boolean };

export type UpdateDeliveryAndCollectionItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  stateId: Scalars['ID']['input'];
  quantity?: InputMaybe<Scalars['String']['input']>;
  supplier?: InputMaybe<Scalars['String']['input']>;
  delivererName?: InputMaybe<Scalars['String']['input']>;
  receiverName?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateDeliveryAndCollectionItemMutation = {
  __typename?: 'Mutation';
  updateDeliveryAndCollectionItem: {
    __typename?: 'DeliveryAndCollectionItemState';
    id: string;
    supplier: string;
    notes?: string | null;
    reportId: string;
    currentState: DeliveryAndCollectionItemStateEnum;
    delivererName: string;
    receiverName: string;
    currentStateSetAt: string;
    uuid: string;
    actor: { __typename?: 'User'; id: string; firstName: string; lastName: string; email: string };
    item: {
      __typename?: 'DeliveryAndCollectionRegisterItem';
      id: string;
      quantity: string;
      companyResource: {
        __typename?: 'CompanyResource';
        id: string;
        name: string;
        resourceType: CompanyResourceResourceTypeEnum;
        resourceMeta?: {
          __typename?: 'ResourceMeta';
          id: string;
          email?: string | null;
          primaryPhone?: string | null;
          bio?: string | null;
          quantity?: string | null;
          unit?: string | null;
          expiryDate?: string | null;
          batchNumber?: string | null;
          currentLocation?: string | null;
          nextServiceDate?: string | null;
          insuranceExpiryDate?: string | null;
          permitExpiryDate?: string | null;
          operatorRequirements?: string | null;
          capacity?: string | null;
          maxReach?: string | null;
          weightDimensions?: string | null;
          fuelType?: FuelTypeEnum | null;
          status?: ResourceMetaStatusTypeEnum | null;
          pointOfContact?: string | null;
          equipmentType?: string | null;
          shortCode?: string | null;
          serialNumber?: string | null;
          makeModel?: string | null;
          isScheduleable?: boolean | null;
          resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
        } | null;
      };
    };
  };
};

export type UpdateEmployeeMutationVariables = Exact<{
  user: EmployeeUpdate;
}>;

export type UpdateEmployeeMutation = { __typename?: 'Mutation'; updateEmployee?: boolean | null };

export type UpdateEventMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  category?: InputMaybe<EventCategoryEnum>;
  status?: InputMaybe<EventStatusEnum>;
  eventType?: InputMaybe<EventTypeEnum>;
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  flag?: InputMaybe<Scalars['Boolean']['input']>;
  occurredAt?: InputMaybe<Scalars['String']['input']>;
  assigneeUserId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UpdateEventMutation = {
  __typename?: 'Mutation';
  updateEvent: {
    __typename?: 'Event';
    id: string;
    title: string;
    uuid: string;
    category?: EventCategoryEnum | null;
    eventType: EventTypeEnum;
    status: EventStatusEnum;
    description?: string | null;
    approved: boolean;
    flag: boolean;
    ewnCount: number;
    cenCount: number;
    hasActiveCeq: boolean;
    projectCurrency?: string | null;
    orderIndex: number;
    occurredAt?: string | null;
    assignee?: {
      __typename?: 'Employment';
      id: string;
      employee?: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        email: string;
        imageUrl?: string | null;
      } | null;
    } | null;
    project: {
      __typename?: 'Project';
      id: string;
      title: string;
      code: string;
      pointOfContacts?: Array<{
        __typename?: 'ProjectUser';
        id: string;
        title: string;
        companyResource?: {
          __typename?: 'CompanyResource';
          id: string;
          name: string;
          resourceType: CompanyResourceResourceTypeEnum;
          resourceMeta?: {
            __typename?: 'ResourceMeta';
            id: string;
            email?: string | null;
            primaryPhone?: string | null;
            bio?: string | null;
            quantity?: string | null;
            unit?: string | null;
            expiryDate?: string | null;
            batchNumber?: string | null;
            currentLocation?: string | null;
            nextServiceDate?: string | null;
            insuranceExpiryDate?: string | null;
            permitExpiryDate?: string | null;
            operatorRequirements?: string | null;
            capacity?: string | null;
            maxReach?: string | null;
            weightDimensions?: string | null;
            fuelType?: FuelTypeEnum | null;
            status?: ResourceMetaStatusTypeEnum | null;
            pointOfContact?: string | null;
            equipmentType?: string | null;
            shortCode?: string | null;
            serialNumber?: string | null;
            makeModel?: string | null;
            isScheduleable?: boolean | null;
            resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
          } | null;
          user?: {
            __typename?: 'User';
            id: string;
            firstName: string;
            lastName: string;
            email: string;
            primaryPhone?: string | null;
            defaultEmploymentStatus?: EmploymentStatusEnum | null;
          } | null;
        } | null;
      }> | null;
      managers?: Array<{
        __typename?: 'ProjectUser';
        id: string;
        title: string;
        user?: {
          __typename?: 'User';
          id: string;
          name?: string | null;
          firstName: string;
          lastName: string;
          email: string;
          imageUrl?: string | null;
        } | null;
        companyResource?: {
          __typename?: 'CompanyResource';
          id: string;
          name: string;
          resourceType: CompanyResourceResourceTypeEnum;
          resourceMeta?: {
            __typename?: 'ResourceMeta';
            id: string;
            email?: string | null;
            primaryPhone?: string | null;
            bio?: string | null;
            quantity?: string | null;
            unit?: string | null;
            expiryDate?: string | null;
            batchNumber?: string | null;
            currentLocation?: string | null;
            nextServiceDate?: string | null;
            insuranceExpiryDate?: string | null;
            permitExpiryDate?: string | null;
            operatorRequirements?: string | null;
            capacity?: string | null;
            maxReach?: string | null;
            weightDimensions?: string | null;
            fuelType?: FuelTypeEnum | null;
            status?: ResourceMetaStatusTypeEnum | null;
            pointOfContact?: string | null;
            equipmentType?: string | null;
            shortCode?: string | null;
            serialNumber?: string | null;
            makeModel?: string | null;
            isScheduleable?: boolean | null;
            resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
          } | null;
          user?: {
            __typename?: 'User';
            id: string;
            firstName: string;
            lastName: string;
            email: string;
            primaryPhone?: string | null;
            defaultEmploymentStatus?: EmploymentStatusEnum | null;
          } | null;
        } | null;
      }> | null;
      client?: { __typename?: 'Client'; id: string; name: string } | null;
      mainAddress?: {
        __typename?: 'Address';
        id: string;
        street: string;
        city: string;
        state: string;
        zip: string;
        country: string;
        locationType: AddressLocationTypeEnum;
      } | null;
    };
    eventSources?: Array<{
      __typename?: 'EventSource';
      source: {
        __typename: 'Issue';
        id: string;
        description: string;
        issueType: IssueTypeEnum;
        categories: Array<{ __typename?: 'IssueCategory'; id: string; name: string }>;
      };
    }> | null;
    eventComments?: Array<{
      __typename?: 'EventComment';
      id: string;
      text: string;
      status: EventCommentStatusEnum;
      createdAt?: string | null;
    }> | null;
  };
};

export type UpdateEventPositionMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  status: EventStatusEnum;
  prevId?: InputMaybe<Scalars['ID']['input']>;
  nextId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UpdateEventPositionMutation = { __typename?: 'Mutation'; updateEventPosition: boolean };

export type UpdateFeedbackMutationVariables = Exact<{
  feedback: FeedbackUpdate;
}>;

export type UpdateFeedbackMutation = { __typename?: 'Mutation'; updateFeedback: boolean };

export type UpdateGanttScheduleMutationVariables = Exact<{
  scheduleIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
  updatedResourceId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  descriptionOfService?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateGanttScheduleMutation = { __typename?: 'Mutation'; updateGanttSchedule: boolean };

export type UpdateReportIssueMutationVariables = Exact<{
  reportIssue: IssueUpdate;
}>;

export type UpdateReportIssueMutation = {
  __typename?: 'Mutation';
  updateReportIssue: {
    __typename?: 'Issue';
    id: string;
    issueType: IssueTypeEnum;
    startTime: string;
    endTime: string;
    headline: string;
    description: string;
    createdAt?: string | null;
    updatedAt?: string | null;
    imageUrls?: Array<string> | null;
    categories: Array<{ __typename?: 'IssueCategory'; id: string; name: string }>;
  };
};

export type UpdateKanbanColumnsMutationVariables = Exact<{
  name: Scalars['String']['input'];
  title: Scalars['String']['input'];
  columnId: Scalars['String']['input'];
}>;

export type UpdateKanbanColumnsMutation = {
  __typename?: 'Mutation';
  updateKanbanColumns?: {
    __typename?: 'KanbanColumn';
    id: string;
    name: string;
    value: Array<{ __typename?: 'KanbanColumnItem'; id: string; title: string }>;
  } | null;
};

export type UpdateKickOffActionsMutationVariables = Exact<{
  kickOffId: Scalars['ID']['input'];
  kickOffActions: Array<Scalars['JSON']['input']> | Scalars['JSON']['input'];
}>;

export type UpdateKickOffActionsMutation = { __typename?: 'Mutation'; updateKickOffActions: boolean };

export type UpdateKickOffBasicsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  data: Scalars['JSON']['input'];
}>;

export type UpdateKickOffBasicsMutation = { __typename?: 'Mutation'; updateKickOffBasics: boolean };

export type UpdateKickOffProjectDetailsMutationVariables = Exact<{
  kickOffId: Scalars['ID']['input'];
  managers?: InputMaybe<Array<Scalars['JSON']['input']> | Scalars['JSON']['input']>;
  activities?: InputMaybe<Array<Scalars['JSON']['input']> | Scalars['JSON']['input']>;
  projectSettings?: InputMaybe<Array<Scalars['JSON']['input']> | Scalars['JSON']['input']>;
  contractTypeIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  projectTagIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type UpdateKickOffProjectDetailsMutation = { __typename?: 'Mutation'; updateKickOffProjectDetails: boolean };

export type UpdateKickOffTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  data: Scalars['JSON']['input'];
}>;

export type UpdateKickOffTemplateMutation = { __typename?: 'Mutation'; updateKickOffTemplate: boolean };

export type UpdateNotesMutationVariables = Exact<{
  noteData: NotesUpdate;
}>;

export type UpdateNotesMutation = {
  __typename?: 'Mutation';
  updateNotes?: {
    __typename?: 'Note';
    id: string;
    description: string;
    notesType: NotesTypeEnum;
    reminder?: string | null;
    imageUrls?: Array<string> | null;
    targetId?: string | null;
    targetType?: string | null;
    tags?: Array<{ __typename?: 'CompanyTag'; id: string; title: string }> | null;
    attachments: Array<{
      __typename?: 'Attachment';
      id: string;
      signedBlobId?: string | null;
      previewUrl: string;
      filename: string;
      byteSize: number;
      createdAt?: RawDate | null;
      associationType?: AssociationTypeEnum | null;
      tags?: Array<{ __typename?: 'CompanyTag'; title: string }> | null;
    }>;
  } | null;
};

export type UpdateOnboardingStepMutationVariables = Exact<{
  step: OnboardingStepsEnum;
}>;

export type UpdateOnboardingStepMutation = {
  __typename?: 'Mutation';
  updateOnboardingStep?: {
    __typename?: 'OnboardingSteps';
    companyInformation: boolean;
    planSelection: boolean;
    humanResourceCreated: boolean;
    equipmentResourceCreated: boolean;
    clientCreated: boolean;
    projectCreated: boolean;
    taskCreated: boolean;
  } | null;
};

export type UpdateProjectMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  projectUsers?: InputMaybe<Array<ManagerUpdate> | ManagerUpdate>;
  representativeId?: InputMaybe<Scalars['ID']['input']>;
  addressId?: InputMaybe<Scalars['ID']['input']>;
  projectSettings?: InputMaybe<Array<ProjectSettingsUpdate> | ProjectSettingsUpdate>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type UpdateProjectMutation = { __typename?: 'Mutation'; updateProject: boolean };

export type UpdateProjectActivityMutationVariables = Exact<{
  projectActivity: ProjectActivityUpdate;
}>;

export type UpdateProjectActivityMutation = { __typename?: 'Mutation'; updateProjectActivity: boolean };

export type UpdateProjectOrderMutationVariables = Exact<{
  newOrder: Scalars['String']['input'];
}>;

export type UpdateProjectOrderMutation = { __typename?: 'Mutation'; updateUserSetting?: boolean | null };

export type UpdateProjectReviewerMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  companyResourceId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type UpdateProjectReviewerMutation = { __typename?: 'Mutation'; updateProjectReviewer: boolean };

export type UpdateReportMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
  approved: Scalars['Boolean']['input'];
}>;

export type UpdateReportMutation = {
  __typename?: 'Mutation';
  updateReport: {
    __typename?: 'Report';
    id: string;
    approvalDate?: RawDate | null;
    approved: boolean;
    createdAt: RawDate;
    reportDate: string;
    stage: string;
    updatedAt: RawDate;
    weather?: string | null;
    project: { __typename?: 'Project'; id: string; title: string; code: string };
    reporter: {
      __typename?: 'Employment';
      id: string;
      employee?: { __typename?: 'User'; id: string; firstName: string; lastName: string; email: string } | null;
    };
    issues?: Array<{
      __typename?: 'Issue';
      id: string;
      description: string;
      issueType: IssueTypeEnum;
      categories: Array<{ __typename?: 'IssueCategory'; id: string; name: string }>;
    }> | null;
  };
};

export type UpdateResourceScheduleV2MutationVariables = Exact<{
  input: UpdateResourceScheduleV2Input;
}>;

export type UpdateResourceScheduleV2Mutation = {
  __typename?: 'Mutation';
  updateResourceScheduleV2: {
    __typename?: 'UpdateResourceScheduleV2Payload';
    hasConflicts: boolean;
    droppedScheduleIds: Array<string>;
    schedules: Array<{
      __typename?: 'SchedulerSchedule';
      id: string;
      projectId: string;
      resourceId: string;
      resourceType: string;
      startDate: string;
      endDate: string;
      name?: string | null;
      source?: string | null;
      title?: string | null;
      onHire?: boolean | null;
      descriptionOfService?: string | null;
      startTime?: string | null;
      endTime?: string | null;
    }>;
  };
};

export type UpdateScheduleMutationVariables = Exact<{
  schedule: ScheduleUpdate;
}>;

export type UpdateScheduleMutation = {
  __typename?: 'Mutation';
  updateSchedule?: {
    __typename?: 'Schedule';
    id: string;
    endTime: string;
    startTime: string;
    status: ResourceScheduleStatusEnum;
    date: string;
    title?: string | null;
    source?: string | null;
    collectable?: boolean | null;
    quantity?: number | null;
    descriptionOfService?: string | null;
    onHire?: boolean | null;
    customShift?: boolean | null;
    hasConflicts: boolean;
    project: {
      __typename?: 'Project';
      id: string;
      title: string;
      code: string;
      mainAddress?: {
        __typename?: 'Address';
        id: string;
        street: string;
        city: string;
        state: string;
        zip: string;
        country: string;
        locationType: AddressLocationTypeEnum;
      } | null;
      subLocations?: Array<{
        __typename?: 'Address';
        id: string;
        title?: string | null;
        street: string;
        city: string;
        state: string;
        zip: string;
        country: string;
      }> | null;
    };
    companyResource?: {
      __typename?: 'CompanyResource';
      id: string;
      name: string;
      resourceType: CompanyResourceResourceTypeEnum;
      resourceMeta?: {
        __typename?: 'ResourceMeta';
        id: string;
        email?: string | null;
        primaryPhone?: string | null;
        bio?: string | null;
        quantity?: string | null;
        unit?: string | null;
        expiryDate?: string | null;
        batchNumber?: string | null;
        currentLocation?: string | null;
        nextServiceDate?: string | null;
        insuranceExpiryDate?: string | null;
        permitExpiryDate?: string | null;
        operatorRequirements?: string | null;
        capacity?: string | null;
        maxReach?: string | null;
        weightDimensions?: string | null;
        fuelType?: FuelTypeEnum | null;
        status?: ResourceMetaStatusTypeEnum | null;
        pointOfContact?: string | null;
        equipmentType?: string | null;
        shortCode?: string | null;
        serialNumber?: string | null;
        makeModel?: string | null;
        isScheduleable?: boolean | null;
        resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
      } | null;
      subContractor?: {
        __typename?: 'SubContractor';
        hasFutureSchedules?: boolean | null;
        id: string;
        imageUrl: string;
        isParent: boolean;
        name: string;
        principalContact?: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          primaryPhone?: string | null;
        } | null;
      } | null;
      user?: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        email: string;
        primaryPhone?: string | null;
        defaultEmploymentStatus?: EmploymentStatusEnum | null;
      } | null;
    } | null;
    address?: {
      __typename?: 'Address';
      id: string;
      street: string;
      city: string;
      state: string;
      zip: string;
      country: string;
      title?: string | null;
      locationType: AddressLocationTypeEnum;
    } | null;
  } | null;
};

export type UpdateSubContractorScheduleMutationVariables = Exact<{
  subContractorSchedule: SubContractorScheduleUpdate;
}>;

export type UpdateSubContractorScheduleMutation = { __typename?: 'Mutation'; updateSubContractorSchedule: boolean };

export type UpdateSubEventBillableItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  multiplier?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['String']['input']>;
}>;

export type UpdateSubEventBillableItemMutation = { __typename?: 'Mutation'; updateSubEventBillableItem: boolean };

export type UpdateTaskMutationVariables = Exact<{
  task: TaskUpdate;
}>;

export type UpdateTaskMutation = {
  __typename?: 'Mutation';
  updateTask?: {
    __typename?: 'Task';
    id: string;
    title: string;
    entityName: string;
    entityType?: string | null;
    entityId?: string | null;
    description?: string | null;
    status: TaskStatusEnum;
    priority: TaskPriorityEnum;
    dueDate?: RawDate | null;
    createdAt: string;
    updatedAt: string;
    assignee: {
      __typename?: 'Employment';
      id: string;
      employee?: { __typename?: 'User'; id: string; firstName: string; lastName: string; email: string } | null;
    };
    creator: {
      __typename?: 'Employment';
      id: string;
      employee?: { __typename?: 'User'; id: string; firstName: string; lastName: string; email: string } | null;
    };
    attachments: Array<{
      __typename?: 'Attachment';
      id: string;
      signedBlobId?: string | null;
      previewUrl: string;
      filename: string;
      byteSize: number;
      createdAt?: RawDate | null;
      associationType?: AssociationTypeEnum | null;
      tags?: Array<{ __typename?: 'CompanyTag'; title: string }> | null;
    }>;
  } | null;
};

export type UpdateTaskCommentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  content: Scalars['String']['input'];
  isEdited: Scalars['Boolean']['input'];
}>;

export type UpdateTaskCommentMutation = { __typename?: 'Mutation'; updateTaskComment: boolean };

export type UpdateUserProfileMutationVariables = Exact<{
  user: UserUpdate;
}>;

export type UpdateUserProfileMutation = { __typename?: 'Mutation'; updateUserProfile?: boolean | null };

export type UpdateUserSettingMutationVariables = Exact<{
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
}>;

export type UpdateUserSettingMutation = { __typename?: 'Mutation'; updateUserSetting?: boolean | null };

export type UploadBillableItemFilesMutationVariables = Exact<{
  itemId: Scalars['ID']['input'];
  signedIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type UploadBillableItemFilesMutation = { __typename?: 'Mutation'; uploadBillableItemFiles: boolean };

export type UploadCeqFilesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  signedIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type UploadCeqFilesMutation = { __typename?: 'Mutation'; uploadCeqFiles: boolean };

export type UploadFunnelProjectFilesMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  signedIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type UploadFunnelProjectFilesMutation = { __typename?: 'Mutation'; uploadFunnelProjectFiles: boolean };

export type VerifyCheckoutSessionMutationVariables = Exact<{
  sessionId: Scalars['String']['input'];
}>;

export type VerifyCheckoutSessionMutation = {
  __typename?: 'Mutation';
  verifyCheckoutSession: {
    __typename?: 'Subscription';
    id: string;
    planType: SubscriptionPlanTypeEnum;
    interval: SubscriptionIntervalEnum;
    status: SubscriptionStatusEnum;
    currentPeriodEnd?: RawDate | null;
    cancelAtPeriodEnd: boolean;
  };
};

export type AccessProjectsPickerQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;

export type AccessProjectsPickerQuery = {
  __typename?: 'Query';
  getProjects?: {
    __typename?: 'ProjectConnection';
    edges?: Array<{
      __typename?: 'ProjectEdge';
      node?: { __typename?: 'Project'; id: string; title: string; code: string } | null;
    } | null> | null;
  } | null;
};

export type AccessRegistryQueryVariables = Exact<{ [key: string]: never }>;

export type AccessRegistryQuery = {
  __typename?: 'Query';
  accessRegistry: Array<{
    __typename?: 'AccessRegistryEntity';
    key: string;
    name: string;
    icon?: string | null;
    projectScoped: boolean;
    ownable: boolean;
    actions: Array<{
      __typename?: 'AccessRegistryAction';
      key: string;
      name: string;
      icon?: string | null;
      color?: string | null;
      description?: string | null;
    }>;
  }>;
};

export type CheckScheduleConflictsQueryVariables = Exact<{
  scheduleIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  updatedResourceId?: InputMaybe<Scalars['ID']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
}>;

export type CheckScheduleConflictsQuery = { __typename?: 'Query'; checkScheduleConflicts: any };

export type CompanyEmploymentsListQueryVariables = Exact<{
  includeSelf?: InputMaybe<Scalars['Boolean']['input']>;
  includeOwner?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type CompanyEmploymentsListQuery = {
  __typename?: 'Query';
  companyEmployments?: Array<{
    __typename?: 'Employment';
    id: string;
    fullName?: string | null;
    imageUrl?: string | null;
  }> | null;
};

export type GetAccessAuditEventsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetAccessAuditEventsQuery = {
  __typename?: 'Query';
  getAccessAuditEvents: Array<{
    __typename?: 'AccessAuditEvent';
    id: string;
    event: string;
    subjectType: string;
    subjectId: string;
    payload: any;
    createdAt: RawDate;
    actorEmployment?: { __typename?: 'Employment'; id: string; fullName?: string | null } | null;
  }>;
};

export type GetAccessRequestsQueryVariables = Exact<{ [key: string]: never }>;

export type GetAccessRequestsQuery = {
  __typename?: 'Query';
  getAccessRequests?: Array<{
    __typename?: 'AccessRequest';
    id: string;
    email: string;
    status: AccessRequestStatusEnum;
    createdAt: RawDate;
  }> | null;
};

export type GetActivitiesForProjectsQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
  projectIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetActivitiesForProjectsQuery = {
  __typename?: 'Query';
  getActivitiesForProjects: Array<{
    __typename?: 'ProjectActivity';
    id: string;
    title: string;
    description?: string | null;
    status: ProjectActivityStatusEnum;
    startTime: string;
    endTime: string;
    timeBasedStatus: ProjectActivityTimeBasedStatusEnum;
    completedAt?: string | null;
    colorCode: string;
    supervisor?: {
      __typename?: 'Employment';
      id: string;
      employee?: { __typename?: 'User'; id: string; firstName: string; lastName: string } | null;
    } | null;
    createdBy: {
      __typename?: 'Employment';
      id: string;
      employee?: { __typename?: 'User'; id: string; firstName: string; lastName: string } | null;
    };
    project: { __typename?: 'Project'; id: string; title: string; code: string };
  }>;
};

export type GetAllEmployeesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetAllEmployeesQuery = {
  __typename?: 'Query';
  getEmployees?: {
    __typename?: 'UserConnection';
    totalCount?: number | null;
    edges?: Array<{
      __typename?: 'UserEdge';
      cursor: string;
      node?: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        email: string;
        primaryPhone?: string | null;
        imageUrl?: string | null;
        status: UserStatusEnum;
        lastSignInAt?: string | null;
        currentSignInAt?: string | null;
        loginEnabled?: boolean | null;
        hasFutureSchedules: boolean;
        companyEmployment?: {
          __typename?: 'Employment';
          id: string;
          status?: EmploymentStatusEnum | null;
          loginEnabled?: boolean | null;
        } | null;
      } | null;
    } | null> | null;
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  } | null;
};

export type GetAllReportsQueryVariables = Exact<{
  stage?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  issueType?: InputMaybe<Scalars['String']['input']>;
  categoryIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  issueDescription?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetAllReportsQuery = {
  __typename?: 'Query';
  getCompanyReports: {
    __typename?: 'ReportConnection';
    totalCount?: number | null;
    edges?: Array<{
      __typename?: 'ReportEdge';
      cursor: string;
      node?: {
        __typename?: 'Report';
        id: string;
        approvalDate?: RawDate | null;
        approved: boolean;
        createdAt: RawDate;
        reportDate: string;
        stage: string;
        updatedAt: RawDate;
        weather?: string | null;
        project: { __typename?: 'Project'; id: string; title: string; code: string };
        reporter: {
          __typename?: 'Employment';
          id: string;
          employee?: { __typename?: 'User'; id: string; firstName: string; lastName: string; email: string } | null;
        };
        issues?: Array<{
          __typename?: 'Issue';
          id: string;
          description: string;
          issueType: IssueTypeEnum;
          categories: Array<{ __typename?: 'IssueCategory'; id: string; name: string }>;
        }> | null;
      } | null;
    } | null> | null;
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string | null;
    };
  };
};

export type GetAttachmentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetAttachmentQuery = {
  __typename?: 'Query';
  getAttachment?: {
    __typename?: 'Attachment';
    id: string;
    signedBlobId?: string | null;
    previewUrl: string;
    filename: string;
    byteSize: number;
    createdAt?: RawDate | null;
    associationType?: AssociationTypeEnum | null;
    tags?: Array<{ __typename?: 'CompanyTag'; title: string }> | null;
  } | null;
};

export type GetCeqBillableItemsQueryVariables = Exact<{
  ceqId: Scalars['ID']['input'];
  resourceType: Scalars['String']['input'];
}>;

export type GetCeqBillableItemsQuery = {
  __typename?: 'Query';
  getCeqBillableItems: Array<{
    __typename?: 'BillableItem';
    id: string;
    unit?: string | null;
    role?: string | null;
    rate: number;
    resourceId: string;
    resourceName: string;
    itemCategory: string;
    imageUrls?: Array<string> | null;
    attachments: Array<{
      __typename?: 'Attachment';
      id: string;
      signedBlobId?: string | null;
      previewUrl: string;
      filename: string;
      byteSize: number;
      createdAt?: RawDate | null;
      associationType?: AssociationTypeEnum | null;
      tags?: Array<{ __typename?: 'CompanyTag'; title: string }> | null;
    }>;
    subEventBillableItems: Array<{
      __typename?: 'SubEventBillableItem';
      id: string;
      cost?: number | null;
      quantity: number;
      multiplier: number;
      ceqSubEventId: string;
    }>;
  }>;
};

export type GetCeqSubEventsQueryVariables = Exact<{
  ceqId: Scalars['ID']['input'];
}>;

export type GetCeqSubEventsQuery = {
  __typename?: 'Query';
  getCeqSubEvents: Array<{ __typename?: 'CeqSubEvent'; id: string; title?: string | null; cost?: number | null }>;
};

export type GetCeqSubEventsSummaryQueryVariables = Exact<{
  ceqId: Scalars['ID']['input'];
}>;

export type GetCeqSubEventsSummaryQuery = {
  __typename?: 'Query';
  getCeqSubEvents: Array<{
    __typename?: 'CeqSubEvent';
    id: string;
    title?: string | null;
    cost?: number | null;
    programmeImpact?: number | null;
  }>;
};

export type GetClientResourcesQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
}>;

export type GetClientResourcesQuery = {
  __typename?: 'Query';
  getClient?: {
    __typename?: 'Client';
    id: string;
    companyResources: Array<{
      __typename?: 'CompanyResource';
      id: string;
      name: string;
      resourceMeta?: { __typename?: 'ResourceMeta'; email?: string | null; primaryPhone?: string | null } | null;
    }>;
  } | null;
};

export type GetClientsQueryVariables = Exact<{
  projectStatus?: InputMaybe<Array<ProjectStatusEnum> | ProjectStatusEnum>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetClientsQuery = {
  __typename?: 'Query';
  getClients?: Array<{
    __typename?: 'Client';
    id: string;
    name: string;
    primaryEmail?: string | null;
    primaryPhone?: string | null;
    companyNumber: string;
    companyType?: CompanyTypeEnum | null;
    activeProjectsCount: number;
    completedProjectsCount: number;
    cancelledProjectsCount: number;
    inFunnelCount: number;
    address?: {
      __typename?: 'Address';
      id: string;
      city: string;
      country: string;
      state: string;
      street: string;
      zip: string;
    } | null;
  }> | null;
};

export type GetClientsBasicQueryVariables = Exact<{ [key: string]: never }>;

export type GetClientsBasicQuery = {
  __typename?: 'Query';
  getClients?: Array<{ __typename?: 'Client'; id: string; name: string }> | null;
};

export type GetClientsFiltersQueryVariables = Exact<{ [key: string]: never }>;

export type GetClientsFiltersQuery = {
  __typename?: 'Query';
  getClientsFilters: {
    __typename?: 'ClientFilters';
    projectStatuses?: Array<string> | null;
    companyNames?: Array<string> | null;
  };
};

export type GetCompaniesQueryVariables = Exact<{ [key: string]: never }>;

export type GetCompaniesQuery = {
  __typename?: 'Query';
  getCompanies?: Array<{
    __typename?: 'Company';
    id: string;
    name: string;
    companyNumber: string;
    primaryPhone?: string | null;
    primaryEmail: string;
    companyType: CompanyTypeEnum;
    active?: boolean | null;
    owner?: { __typename?: 'User'; firstName: string; lastName: string } | null;
  }> | null;
};

export type GetCompaniesHouseInfoQueryVariables = Exact<{
  companyNumber: Scalars['String']['input'];
}>;

export type GetCompaniesHouseInfoQuery = {
  __typename?: 'Query';
  getCompaniesHouseInfo: {
    __typename?: 'CompaniesHouseInfo';
    success: boolean;
    data?: {
      __typename?: 'CompaniesHouseData';
      name: string;
      number: string;
      status?: string | null;
      companyType?: CompanyTypeEnum | null;
      address?: {
        __typename?: 'CompaniesHouseAddress';
        street: string;
        city: string;
        state?: string | null;
        zip: string;
      } | null;
    } | null;
  };
};

export type GetProjectAddressesQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;

export type GetProjectAddressesQuery = {
  __typename?: 'Query';
  getProjectAddresses: Array<{
    __typename?: 'Address';
    id: string;
    street: string;
    city: string;
    state: string;
    zip: string;
    country: string;
    locationType: AddressLocationTypeEnum;
    title?: string | null;
  }>;
};

export type GetCompanyContractTypesQueryVariables = Exact<{ [key: string]: never }>;

export type GetCompanyContractTypesQuery = {
  __typename?: 'Query';
  getCompanyContractTypes: Array<{
    __typename?: 'CompanyContract';
    id: string;
    companyId: string;
    contractTypeId?: string | null;
    name: string;
  }>;
};

export type GetCompanyDocumentsHierarchyQueryVariables = Exact<{
  query: CompanyDocumentsHierarchyInput;
}>;

export type GetCompanyDocumentsHierarchyQuery = {
  __typename?: 'Query';
  getCompanyDocumentsHierarchy?: Array<{
    __typename?: 'CompanyDocumentsHierarchy';
    id: string;
    type: DocumentHierarchyNodeTypeEnum;
    label: string;
    childrenCount?: number | null;
  }> | null;
};

export type GetCompanyEmployeesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetCompanyEmployeesQuery = {
  __typename?: 'Query';
  getEmployees?: {
    __typename?: 'UserConnection';
    totalCount?: number | null;
    edges?: Array<{
      __typename?: 'UserEdge';
      cursor: string;
      node?: { __typename?: 'User'; id: string; firstName: string; lastName: string; imageUrl?: string | null } | null;
    } | null> | null;
    pageInfo: {
      __typename?: 'PageInfo';
      startCursor?: string | null;
      endCursor?: string | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
    };
  } | null;
};

export type GetCompanyEventColumnsQueryVariables = Exact<{ [key: string]: never }>;

export type GetCompanyEventColumnsQuery = {
  __typename?: 'Query';
  getCompanyEventColumns: Array<{
    __typename?: 'CompanyEventColumn';
    id: string;
    label: string;
    status: EventStatusEnum;
  }>;
};

export type GetCompanyNotesQueryVariables = Exact<{ [key: string]: never }>;

export type GetCompanyNotesQuery = {
  __typename?: 'Query';
  getCompanyIssues: Array<{ __typename?: 'Issue'; id: string }>;
};

export type GetCompanyKickOffTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type GetCompanyKickOffTemplatesQuery = {
  __typename?: 'Query';
  getCompanyKickOffTemplates?: Array<{
    __typename?: 'KickOffTemplate';
    id: string;
    title: string;
    createdAt?: string | null;
    data?: {
      __typename?: 'KickOffData';
      clientId?: string | null;
      clientReps?: Array<any> | null;
      addresses?: Array<any> | null;
      notes?: Array<any> | null;
      projectDetails?: {
        __typename?: 'KickOffProjectDetails';
        managers?: Array<any> | null;
        activities?: Array<any> | null;
        projectTagIds?: Array<string> | null;
        contractTypeIds?: Array<string> | null;
        projectSettings?: Array<any> | null;
      } | null;
    } | null;
    user?: { __typename?: 'User'; firstName: string; lastName: string } | null;
  }> | null;
};

export type GetCompanyKickOffsQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['ID']['input']>;
  initiatorId?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetCompanyKickOffsQuery = {
  __typename?: 'Query';
  getCompanyKickOffs: Array<{
    __typename?: 'ProjectKickOffs';
    id: string;
    createdAt: string;
    emails?: Array<string> | null;
    title?: string | null;
    status: KickOffStatusEnum;
    data?: {
      __typename?: 'KickOffData';
      projectId?: string | null;
      projectCode?: string | null;
      projectTitle?: string | null;
      clientId?: string | null;
      clientName?: string | null;
      clientCompanyNumber?: string | null;
      clientReps?: Array<any> | null;
      addresses?: Array<any> | null;
      notes?: Array<any> | null;
      newTemplate?: boolean | null;
      projectDetails?: {
        __typename?: 'KickOffProjectDetails';
        managers?: Array<any> | null;
        activities?: Array<any> | null;
        projectTagIds?: Array<string> | null;
        contractTypeIds?: Array<string> | null;
        projectSettings?: Array<any> | null;
      } | null;
    } | null;
    project?: { __typename?: 'Project'; title: string; code: string } | null;
    initiator: { __typename?: 'User'; id: string; firstName: string; lastName: string };
  }>;
};

export type GetCompanyResourcesQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  resourceType?: InputMaybe<CompanyResourceResourceTypeEnum>;
  resourceCategoryId?: InputMaybe<Scalars['ID']['input']>;
  userExists?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetCompanyResourcesQuery = {
  __typename?: 'Query';
  getCompanyResources?: Array<{
    __typename?: 'CompanyResource';
    id: string;
    name: string;
    resourceType: CompanyResourceResourceTypeEnum;
    canInviteSubContractor?: boolean | null;
    resourceMeta?: {
      __typename?: 'ResourceMeta';
      id: string;
      email?: string | null;
      primaryPhone?: string | null;
      bio?: string | null;
      quantity?: string | null;
      unit?: string | null;
      expiryDate?: string | null;
      batchNumber?: string | null;
      currentLocation?: string | null;
      nextServiceDate?: string | null;
      insuranceExpiryDate?: string | null;
      permitExpiryDate?: string | null;
      operatorRequirements?: string | null;
      capacity?: string | null;
      maxReach?: string | null;
      weightDimensions?: string | null;
      fuelType?: FuelTypeEnum | null;
      status?: ResourceMetaStatusTypeEnum | null;
      pointOfContact?: string | null;
      equipmentType?: string | null;
      shortCode?: string | null;
      serialNumber?: string | null;
      makeModel?: string | null;
      isScheduleable?: boolean | null;
      imageUrls?: Array<string> | null;
      resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
      attachments: Array<{
        __typename?: 'Attachment';
        id: string;
        signedBlobId?: string | null;
        previewUrl: string;
        filename: string;
        byteSize: number;
        createdAt?: RawDate | null;
        associationType?: AssociationTypeEnum | null;
        tags?: Array<{ __typename?: 'CompanyTag'; title: string }> | null;
      }>;
    } | null;
    subContractor?: {
      __typename?: 'SubContractor';
      hasFutureSchedules?: boolean | null;
      id: string;
      imageUrl: string;
      isParent: boolean;
      name: string;
    } | null;
    user?: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      primaryPhone?: string | null;
      defaultEmploymentStatus?: EmploymentStatusEnum | null;
    } | null;
  }> | null;
};

export type GetCompanyResourcesPaginatedQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  resourceCategoryId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  resourceType?: InputMaybe<CompanyResourceResourceTypeEnum>;
  userExists?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
}>;

export type GetCompanyResourcesPaginatedQuery = {
  __typename?: 'Query';
  getCompanyResourcesPaginated?: {
    __typename?: 'CompanyResourceConnection';
    totalCount?: number | null;
    nodes?: Array<{
      __typename?: 'CompanyResource';
      id: string;
      name: string;
      resourceType: CompanyResourceResourceTypeEnum;
      uniqueReference: string;
      source: CompanyResourceSourceEnum;
      resourceMeta?: {
        __typename?: 'ResourceMeta';
        id: string;
        email?: string | null;
        primaryPhone?: string | null;
        bio?: string | null;
        pointOfContact?: string | null;
      } | null;
    } | null> | null;
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string | null;
    };
  } | null;
};

export type GetCompanySettingsQueryVariables = Exact<{ [key: string]: never }>;

export type GetCompanySettingsQuery = {
  __typename?: 'Query';
  getCompanySettings: Array<{ __typename?: 'CompanySetting'; id: string; name: string; value: string }>;
};

export type GetCompanyStatsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetCompanyStatsQuery = {
  __typename?: 'Query';
  getCompany?: {
    __typename?: 'Company';
    id: string;
    projectsCount: number;
    reportsCount: number;
    humanResourcesCount: number;
  } | null;
};

export type GetCompanyTagsQueryVariables = Exact<{ [key: string]: never }>;

export type GetCompanyTagsQuery = {
  __typename?: 'Query';
  getCompanyTags: Array<{
    __typename?: 'CompanyTag';
    id: string;
    title: string;
    users?: Array<{ __typename?: 'User'; id: string; firstName: string; lastName: string }> | null;
    equipments?: Array<{ __typename?: 'CompanyEquipment'; id: string; name: string }> | null;
  }>;
};

export type GetCompensationEventNoticesQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
}>;

export type GetCompensationEventNoticesQuery = {
  __typename?: 'Query';
  getCompensationEventNotices: Array<{
    __typename?: 'CompensationEventNotice';
    id: string;
    uuid: string;
    description: string;
    editable: boolean;
    state: CompensationEventNoticeStateEnum;
    imageUrls?: Array<string> | null;
    attachments: Array<{
      __typename?: 'Attachment';
      id: string;
      signedBlobId?: string | null;
      previewUrl: string;
      filename: string;
      byteSize: number;
      createdAt?: RawDate | null;
      associationType?: AssociationTypeEnum | null;
      tags?: Array<{ __typename?: 'CompanyTag'; title: string }> | null;
    }>;
    clientInstruction?: {
      __typename?: 'ClientInstructions';
      id: string;
      instructions: string;
      responseDate: string;
      imageUrls?: Array<string> | null;
      attachments: Array<{
        __typename?: 'Attachment';
        id: string;
        signedBlobId?: string | null;
        previewUrl: string;
        filename: string;
        byteSize: number;
        createdAt?: RawDate | null;
        associationType?: AssociationTypeEnum | null;
        tags?: Array<{ __typename?: 'CompanyTag'; title: string }> | null;
      }>;
    } | null;
    event: { __typename?: 'Event'; id: string; uuid: string; title: string; status: EventStatusEnum };
  }>;
};

export type GetCompensationEventQuotationsQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
}>;

export type GetCompensationEventQuotationsQuery = {
  __typename?: 'Query';
  getCompensationEventQuotations: Array<{
    __typename?: 'CompensationEventQuotation';
    id: string;
    description?: string | null;
    editable: boolean;
    eventId: string;
    programmeImpact: number;
    totalCost?: number | null;
    uuid?: string | null;
    associatedCen?: { __typename?: 'CompensationEventNotice'; uuid: string } | null;
  }>;
};

export type GetConflictingSchedulesQueryVariables = Exact<{
  dateRangeStart?: InputMaybe<Scalars['String']['input']>;
  dateRangeEnd?: InputMaybe<Scalars['String']['input']>;
  resourceIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  projectIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type GetConflictingSchedulesQuery = {
  __typename?: 'Query';
  getConflictingSchedules?: Array<{
    __typename?: 'ConflictedResources';
    id: string;
    title?: string | null;
    date: string;
    startTime: string;
    endTime: string;
    quantity?: number | null;
    source?: string | null;
    resourceId: string;
    resourceName: string;
    resourceType: string;
    address?: {
      __typename?: 'ConflictedScheduleAddress';
      id: string;
      title?: string | null;
      formatted?: string | null;
    } | null;
    project: { __typename?: 'ConflictedScheduleProject'; id: string; code?: string | null; title?: string | null };
    conflictingSchedules?: Array<{
      __typename?: 'ConflictedResources';
      id: string;
      title?: string | null;
      date: string;
      startTime: string;
      endTime: string;
      quantity?: number | null;
      source?: string | null;
      resourceId: string;
      resourceName: string;
      resourceType: string;
      address?: {
        __typename?: 'ConflictedScheduleAddress';
        id: string;
        title?: string | null;
        formatted?: string | null;
      } | null;
      project: { __typename?: 'ConflictedScheduleProject'; id: string; code?: string | null; title?: string | null };
    }> | null;
  }> | null;
};

export type GetContractTypesQueryVariables = Exact<{ [key: string]: never }>;

export type GetContractTypesQuery = {
  __typename?: 'Query';
  getContractTypes: Array<{ __typename?: 'Contract'; id: string; name: string; description?: string | null }>;
};

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never }>;

export type GetCurrentUserQuery = {
  __typename?: 'Query';
  fetchMyData?: {
    __typename?: 'User';
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    imageUrl?: string | null;
    hasCompanies?: boolean | null;
    isOwner?: boolean | null;
    isSuperAdmin?: boolean | null;
    basicOnboardingCompleted?: boolean | null;
    welcomeChecklistCompleted?: boolean | null;
    primaryPhone?: string | null;
    dashboardLayout: string;
    bio?: string | null;
    lastSignInAt?: string | null;
    currentSignInAt?: string | null;
    favoriteTabs: Array<string>;
    sharepointConnectionActive: boolean;
    employers?: Array<{ __typename?: 'Company'; id: string; name: string; imageUrl: string }> | null;
    companies?: Array<{ __typename?: 'Company'; id: string; name: string }> | null;
    defaultCompany?: {
      __typename?: 'Company';
      id: string;
      name: string;
      imageUrl: string;
      primaryPhone?: string | null;
      primaryEmail: string;
      hasProjects?: boolean | null;
      hasClients?: boolean | null;
      hasHumanResources?: boolean | null;
      companyNumber: string;
      tradingName?: string | null;
      vatNumber?: string | null;
      companyType: CompanyTypeEnum;
      address?: {
        __typename?: 'Address';
        id: string;
        street: string;
        city: string;
        state: string;
        zip: string;
        country: string;
        locationType: AddressLocationTypeEnum;
      } | null;
      onboardingSteps: {
        __typename?: 'OnboardingSteps';
        clientCreated: boolean;
        companyInformation: boolean;
        equipmentResourceCreated: boolean;
        humanResourceCreated: boolean;
        planSelection: boolean;
        projectCreated: boolean;
        taskCreated: boolean;
      };
    } | null;
    defaultEmployment?: {
      __typename?: 'Employment';
      id: string;
      status?: EmploymentStatusEnum | null;
      employmentType?: string | null;
      subscription?: {
        __typename?: 'Subscription';
        id: string;
        planType: SubscriptionPlanTypeEnum;
        status: SubscriptionStatusEnum;
        interval: SubscriptionIntervalEnum;
        currentPeriodEnd?: RawDate | null;
        cancelAtPeriodEnd: boolean;
      } | null;
    } | null;
  } | null;
};

export type GetCustomShiftApproversQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;

export type GetCustomShiftApproversQuery = {
  __typename?: 'Query';
  getCustomShiftApprovers: Array<{
    __typename?: 'Employment';
    id: string;
    name?: string | null;
    email?: string | null;
    imageUrl?: string | null;
  }>;
};

export type GetDeliveryItemStatesQueryVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;

export type GetDeliveryItemStatesQuery = {
  __typename?: 'Query';
  getDeliveryItemStates: Array<{
    __typename?: 'DeliveryAndCollectionItemState';
    id: string;
    supplier: string;
    notes?: string | null;
    reportId: string;
    currentState: DeliveryAndCollectionItemStateEnum;
    delivererName: string;
    receiverName: string;
    currentStateSetAt: string;
    uuid: string;
    actor: { __typename?: 'User'; id: string; firstName: string; lastName: string; email: string };
    item: {
      __typename?: 'DeliveryAndCollectionRegisterItem';
      id: string;
      quantity: string;
      companyResource: {
        __typename?: 'CompanyResource';
        id: string;
        name: string;
        resourceType: CompanyResourceResourceTypeEnum;
        resourceMeta?: {
          __typename?: 'ResourceMeta';
          id: string;
          email?: string | null;
          primaryPhone?: string | null;
          bio?: string | null;
          quantity?: string | null;
          unit?: string | null;
          expiryDate?: string | null;
          batchNumber?: string | null;
          currentLocation?: string | null;
          nextServiceDate?: string | null;
          insuranceExpiryDate?: string | null;
          permitExpiryDate?: string | null;
          operatorRequirements?: string | null;
          capacity?: string | null;
          maxReach?: string | null;
          weightDimensions?: string | null;
          fuelType?: FuelTypeEnum | null;
          status?: ResourceMetaStatusTypeEnum | null;
          pointOfContact?: string | null;
          equipmentType?: string | null;
          shortCode?: string | null;
          serialNumber?: string | null;
          makeModel?: string | null;
          isScheduleable?: boolean | null;
          resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
        } | null;
      };
    };
  }>;
};

export type GetDeliveryRegistersQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;

export type GetDeliveryRegistersQuery = {
  __typename?: 'Query';
  getDeliveryRegisters: Array<{
    __typename?: 'DeliveryAndCollectionRegister';
    id: string;
    projectId: string;
    uuid: string;
    createdAt: string;
    requestor: { __typename?: 'User'; id: string; firstName: string; lastName: string; email: string };
    items: Array<{
      __typename?: 'DeliveryAndCollectionRegisterItem';
      id: string;
      quantity: string;
      companyResource: {
        __typename?: 'CompanyResource';
        id: string;
        name: string;
        resourceType: CompanyResourceResourceTypeEnum;
        resourceMeta?: {
          __typename?: 'ResourceMeta';
          id: string;
          email?: string | null;
          primaryPhone?: string | null;
          bio?: string | null;
          quantity?: string | null;
          unit?: string | null;
          expiryDate?: string | null;
          batchNumber?: string | null;
          currentLocation?: string | null;
          nextServiceDate?: string | null;
          insuranceExpiryDate?: string | null;
          permitExpiryDate?: string | null;
          operatorRequirements?: string | null;
          capacity?: string | null;
          maxReach?: string | null;
          weightDimensions?: string | null;
          fuelType?: FuelTypeEnum | null;
          status?: ResourceMetaStatusTypeEnum | null;
          pointOfContact?: string | null;
          equipmentType?: string | null;
          shortCode?: string | null;
          serialNumber?: string | null;
          makeModel?: string | null;
          isScheduleable?: boolean | null;
          resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
        } | null;
      };
      itemStates: Array<{
        __typename?: 'DeliveryAndCollectionItemState';
        id: string;
        supplier: string;
        notes?: string | null;
        reportId: string;
        currentState: DeliveryAndCollectionItemStateEnum;
        delivererName: string;
        receiverName: string;
        currentStateSetAt: string;
        actor: { __typename?: 'User'; id: string; firstName: string; lastName: string; email: string };
      }>;
    }>;
  }>;
};

export type GetDeliveryRegistersForProjectQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  states?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;

export type GetDeliveryRegistersForProjectQuery = {
  __typename?: 'Query';
  getDeliveryRegistersForProject: Array<{
    __typename?: 'DeliveryAndCollectionRegister';
    id: string;
    projectId: string;
    uuid: string;
    createdAt: string;
    requestor: { __typename?: 'User'; id: string; firstName: string; lastName: string; email: string };
    items: Array<{
      __typename?: 'DeliveryAndCollectionRegisterItem';
      id: string;
      quantity: string;
      companyResource: {
        __typename?: 'CompanyResource';
        id: string;
        name: string;
        resourceType: CompanyResourceResourceTypeEnum;
        resourceMeta?: {
          __typename?: 'ResourceMeta';
          id: string;
          email?: string | null;
          primaryPhone?: string | null;
          bio?: string | null;
          quantity?: string | null;
          unit?: string | null;
          expiryDate?: string | null;
          batchNumber?: string | null;
          currentLocation?: string | null;
          nextServiceDate?: string | null;
          insuranceExpiryDate?: string | null;
          permitExpiryDate?: string | null;
          operatorRequirements?: string | null;
          capacity?: string | null;
          maxReach?: string | null;
          weightDimensions?: string | null;
          fuelType?: FuelTypeEnum | null;
          status?: ResourceMetaStatusTypeEnum | null;
          pointOfContact?: string | null;
          equipmentType?: string | null;
          shortCode?: string | null;
          serialNumber?: string | null;
          makeModel?: string | null;
          isScheduleable?: boolean | null;
          resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
        } | null;
      };
      itemStates: Array<{
        __typename?: 'DeliveryAndCollectionItemState';
        id: string;
        currentState: DeliveryAndCollectionItemStateEnum;
        currentStateSetAt: string;
      }>;
    }>;
  }>;
};

export type GetDraftSplitProjectsQueryVariables = Exact<{
  rootProjectId: Scalars['ID']['input'];
}>;

export type GetDraftSplitProjectsQuery = {
  __typename?: 'Query';
  getDraftSplitProjects?: Array<{
    __typename?: 'Project';
    id: string;
    title: string;
    companyId: string;
    issuesCount: number;
    imageUrls?: Array<string> | null;
    endDate?: string | null;
    status: ProjectStatusEnum;
    code: string;
    description: string;
    startDate?: string | null;
    createdAt: string;
    updatedAt: string;
    contractTypeIds?: Array<string> | null;
    tagIds?: Array<string> | null;
    attachments: Array<{
      __typename?: 'Attachment';
      id: string;
      signedBlobId?: string | null;
      previewUrl: string;
      filename: string;
      byteSize: number;
      createdAt?: RawDate | null;
      associationType?: AssociationTypeEnum | null;
      tags?: Array<{ __typename?: 'CompanyTag'; title: string }> | null;
    }>;
    pointOfContacts?: Array<{
      __typename?: 'ProjectUser';
      id: string;
      title: string;
      userType: ProjectUserTypeEnum;
      companyResource?: {
        __typename?: 'CompanyResource';
        id: string;
        name: string;
        resourceType: CompanyResourceResourceTypeEnum;
        resourceMeta?: {
          __typename?: 'ResourceMeta';
          id: string;
          email?: string | null;
          primaryPhone?: string | null;
          bio?: string | null;
          quantity?: string | null;
          unit?: string | null;
          expiryDate?: string | null;
          batchNumber?: string | null;
          currentLocation?: string | null;
          nextServiceDate?: string | null;
          insuranceExpiryDate?: string | null;
          permitExpiryDate?: string | null;
          operatorRequirements?: string | null;
          capacity?: string | null;
          maxReach?: string | null;
          weightDimensions?: string | null;
          fuelType?: FuelTypeEnum | null;
          status?: ResourceMetaStatusTypeEnum | null;
          pointOfContact?: string | null;
          equipmentType?: string | null;
          shortCode?: string | null;
          serialNumber?: string | null;
          makeModel?: string | null;
          isScheduleable?: boolean | null;
          resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
        } | null;
        user?: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          primaryPhone?: string | null;
          defaultEmploymentStatus?: EmploymentStatusEnum | null;
        } | null;
      } | null;
    }> | null;
    managers?: Array<{
      __typename?: 'ProjectUser';
      id: string;
      title: string;
      userType: ProjectUserTypeEnum;
      employment?: {
        __typename?: 'Employment';
        id: string;
        name?: string | null;
        status?: EmploymentStatusEnum | null;
        employee?: {
          __typename?: 'User';
          id: string;
          name?: string | null;
          firstName: string;
          lastName: string;
          email: string;
          primaryPhone?: string | null;
          imageUrl?: string | null;
        } | null;
      } | null;
      user?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName: string;
        lastName: string;
        email: string;
        primaryPhone?: string | null;
        defaultEmploymentStatus?: EmploymentStatusEnum | null;
        imageUrl?: string | null;
      } | null;
      companyResource?: {
        __typename?: 'CompanyResource';
        id: string;
        name: string;
        resourceType: CompanyResourceResourceTypeEnum;
        resourceMeta?: {
          __typename?: 'ResourceMeta';
          id: string;
          email?: string | null;
          primaryPhone?: string | null;
          bio?: string | null;
          quantity?: string | null;
          unit?: string | null;
          expiryDate?: string | null;
          batchNumber?: string | null;
          currentLocation?: string | null;
          nextServiceDate?: string | null;
          insuranceExpiryDate?: string | null;
          permitExpiryDate?: string | null;
          operatorRequirements?: string | null;
          capacity?: string | null;
          maxReach?: string | null;
          weightDimensions?: string | null;
          fuelType?: FuelTypeEnum | null;
          status?: ResourceMetaStatusTypeEnum | null;
          pointOfContact?: string | null;
          equipmentType?: string | null;
          shortCode?: string | null;
          serialNumber?: string | null;
          makeModel?: string | null;
          isScheduleable?: boolean | null;
          resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
        } | null;
        user?: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          primaryPhone?: string | null;
          defaultEmploymentStatus?: EmploymentStatusEnum | null;
          imageUrl?: string | null;
        } | null;
      } | null;
    }> | null;
    client?: { __typename?: 'Client'; id: string; name: string } | null;
    mainAddress?: {
      __typename?: 'Address';
      id: string;
      street: string;
      city: string;
      state: string;
      zip: string;
      country: string;
      locationType: AddressLocationTypeEnum;
    } | null;
    subLocations?: Array<{
      __typename?: 'Address';
      title?: string | null;
      street: string;
      city: string;
      state: string;
      zip: string;
      country: string;
    }> | null;
    projectActivities: Array<{
      __typename?: 'ProjectActivity';
      id: string;
      title: string;
      description?: string | null;
      status: ProjectActivityStatusEnum;
      startTime: string;
      endTime: string;
      timeBasedStatus: ProjectActivityTimeBasedStatusEnum;
      completedAt?: string | null;
      colorCode: string;
      supervisor?: {
        __typename?: 'Employment';
        id: string;
        employee?: { __typename?: 'User'; id: string; firstName: string; lastName: string } | null;
      } | null;
      createdBy: {
        __typename?: 'Employment';
        id: string;
        employee?: { __typename?: 'User'; id: string; firstName: string; lastName: string } | null;
      };
    }>;
    projectSettings: Array<{ __typename?: 'ProjectSetting'; name: string; value: string }>;
  }> | null;
};

export type GetEarlyWarningNoticesQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
}>;

export type GetEarlyWarningNoticesQuery = {
  __typename?: 'Query';
  getEarlyWarningNotices: Array<{
    __typename?: 'EarlyWarningNotice';
    id: string;
    cost?: boolean | null;
    description: string;
    documentUrls?: Array<string> | null;
    imageUrls?: Array<string> | null;
    keyDates?: boolean | null;
    others?: string | null;
    programmeImpact?: boolean | null;
    time?: boolean | null;
  }>;
};

export type GetEmploymentAccessQueryVariables = Exact<{
  employmentId: Scalars['ID']['input'];
}>;

export type GetEmploymentAccessQuery = {
  __typename?: 'Query';
  getEmploymentAccess?: {
    __typename?: 'EmploymentAccess';
    employment: { __typename?: 'Employment'; id: string; fullName?: string | null; imageUrl?: string | null };
    roles: Array<{
      __typename?: 'Role';
      id: string;
      name: string;
      grants: Array<{ __typename?: 'AccessGrantPair'; action: PermissionActionEnum; entity: PermissionEntityEnum }>;
    }>;
    directGrants: Array<{
      __typename?: 'EmploymentGrant';
      id: string;
      action: PermissionActionEnum;
      entity: PermissionEntityEnum;
      projectId?: string | null;
      validTill?: RawDate | null;
      expired: boolean;
      project?: { __typename?: 'Project'; id: string; title: string } | null;
    }>;
    effective: Array<{
      __typename?: 'MyAccessGrant';
      action: PermissionActionEnum;
      entity: PermissionEntityEnum;
      projectIds?: Array<string> | null;
    }>;
  } | null;
};

export type GetEventQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetEventQuery = {
  __typename?: 'Query';
  getEvent: {
    __typename?: 'Event';
    id: string;
    uuid: string;
    title: string;
    category?: EventCategoryEnum | null;
    eventType: EventTypeEnum;
    status: EventStatusEnum;
    description?: string | null;
    ewnCount: number;
    cenCount: number;
    hasActiveCeq: boolean;
    earlyWarningNotices?: Array<{
      __typename?: 'EarlyWarningNotice';
      id: string;
      description: string;
      cost?: boolean | null;
      time?: boolean | null;
      programmeImpact?: boolean | null;
      keyDates?: boolean | null;
      others?: string | null;
      imageUrls?: Array<string> | null;
    }> | null;
    compensationEventNotices?: Array<{
      __typename?: 'CompensationEventNotice';
      id: string;
      description: string;
      editable: boolean;
      state: CompensationEventNoticeStateEnum;
      imageUrls?: Array<string> | null;
    }> | null;
    eventComments?: Array<{
      __typename?: 'EventComment';
      id: string;
      text: string;
      status: EventCommentStatusEnum;
      createdAt?: string | null;
    }> | null;
    project: {
      __typename?: 'Project';
      id: string;
      title: string;
      code: string;
      pointOfContacts?: Array<{
        __typename?: 'ProjectUser';
        id: string;
        title: string;
        companyResource?: {
          __typename?: 'CompanyResource';
          name: string;
          resourceType: CompanyResourceResourceTypeEnum;
          resourceMeta?: {
            __typename?: 'ResourceMeta';
            id: string;
            email?: string | null;
            primaryPhone?: string | null;
            bio?: string | null;
            quantity?: string | null;
            unit?: string | null;
            expiryDate?: string | null;
            batchNumber?: string | null;
            currentLocation?: string | null;
            nextServiceDate?: string | null;
            insuranceExpiryDate?: string | null;
            permitExpiryDate?: string | null;
            operatorRequirements?: string | null;
            capacity?: string | null;
            maxReach?: string | null;
            weightDimensions?: string | null;
            fuelType?: FuelTypeEnum | null;
            status?: ResourceMetaStatusTypeEnum | null;
            pointOfContact?: string | null;
            equipmentType?: string | null;
            shortCode?: string | null;
            serialNumber?: string | null;
            makeModel?: string | null;
            isScheduleable?: boolean | null;
            resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
          } | null;
          user?: {
            __typename?: 'User';
            id: string;
            firstName: string;
            lastName: string;
            email: string;
            primaryPhone?: string | null;
            defaultEmploymentStatus?: EmploymentStatusEnum | null;
          } | null;
        } | null;
      }> | null;
      managers?: Array<{
        __typename?: 'ProjectUser';
        id: string;
        title: string;
        user?: {
          __typename?: 'User';
          id: string;
          name?: string | null;
          firstName: string;
          lastName: string;
          email: string;
          imageUrl?: string | null;
        } | null;
        companyResource?: {
          __typename?: 'CompanyResource';
          name: string;
          resourceType: CompanyResourceResourceTypeEnum;
          resourceMeta?: {
            __typename?: 'ResourceMeta';
            id: string;
            email?: string | null;
            primaryPhone?: string | null;
            bio?: string | null;
            quantity?: string | null;
            unit?: string | null;
            expiryDate?: string | null;
            batchNumber?: string | null;
            currentLocation?: string | null;
            nextServiceDate?: string | null;
            insuranceExpiryDate?: string | null;
            permitExpiryDate?: string | null;
            operatorRequirements?: string | null;
            capacity?: string | null;
            maxReach?: string | null;
            weightDimensions?: string | null;
            fuelType?: FuelTypeEnum | null;
            status?: ResourceMetaStatusTypeEnum | null;
            pointOfContact?: string | null;
            equipmentType?: string | null;
            shortCode?: string | null;
            serialNumber?: string | null;
            makeModel?: string | null;
            isScheduleable?: boolean | null;
            resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
          } | null;
          user?: {
            __typename?: 'User';
            id: string;
            firstName: string;
            lastName: string;
            email: string;
            primaryPhone?: string | null;
            defaultEmploymentStatus?: EmploymentStatusEnum | null;
          } | null;
        } | null;
      }> | null;
      client?: { __typename?: 'Client'; id: string; name: string } | null;
      mainAddress?: {
        __typename?: 'Address';
        id: string;
        street: string;
        city: string;
        state: string;
        zip: string;
        country: string;
        locationType: AddressLocationTypeEnum;
      } | null;
    };
  };
};

export type GetCompanyEventsQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<EventCategoryEnum>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<EventStatusEnum> | EventStatusEnum>;
  order?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetCompanyEventsQuery = {
  __typename?: 'Query';
  getCompanyEvents: Array<{
    __typename?: 'Event';
    id: string;
    title: string;
    uuid: string;
    category?: EventCategoryEnum | null;
    eventType: EventTypeEnum;
    status: EventStatusEnum;
    description?: string | null;
    approved: boolean;
    flag: boolean;
    ewnCount: number;
    cenCount: number;
    hasActiveCeq: boolean;
    projectCurrency?: string | null;
    orderIndex: number;
    occurredAt?: string | null;
    assignee?: {
      __typename?: 'Employment';
      id: string;
      employee?: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        email: string;
        imageUrl?: string | null;
      } | null;
    } | null;
    project: {
      __typename?: 'Project';
      id: string;
      title: string;
      code: string;
      pointOfContacts?: Array<{
        __typename?: 'ProjectUser';
        id: string;
        title: string;
        companyResource?: {
          __typename?: 'CompanyResource';
          id: string;
          name: string;
          resourceType: CompanyResourceResourceTypeEnum;
          resourceMeta?: {
            __typename?: 'ResourceMeta';
            id: string;
            email?: string | null;
            primaryPhone?: string | null;
            bio?: string | null;
            quantity?: string | null;
            unit?: string | null;
            expiryDate?: string | null;
            batchNumber?: string | null;
            currentLocation?: string | null;
            nextServiceDate?: string | null;
            insuranceExpiryDate?: string | null;
            permitExpiryDate?: string | null;
            operatorRequirements?: string | null;
            capacity?: string | null;
            maxReach?: string | null;
            weightDimensions?: string | null;
            fuelType?: FuelTypeEnum | null;
            status?: ResourceMetaStatusTypeEnum | null;
            pointOfContact?: string | null;
            equipmentType?: string | null;
            shortCode?: string | null;
            serialNumber?: string | null;
            makeModel?: string | null;
            isScheduleable?: boolean | null;
            resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
          } | null;
          user?: {
            __typename?: 'User';
            id: string;
            firstName: string;
            lastName: string;
            email: string;
            primaryPhone?: string | null;
            defaultEmploymentStatus?: EmploymentStatusEnum | null;
          } | null;
        } | null;
      }> | null;
      managers?: Array<{
        __typename?: 'ProjectUser';
        id: string;
        title: string;
        user?: {
          __typename?: 'User';
          id: string;
          name?: string | null;
          firstName: string;
          lastName: string;
          email: string;
          imageUrl?: string | null;
        } | null;
        companyResource?: {
          __typename?: 'CompanyResource';
          id: string;
          name: string;
          resourceType: CompanyResourceResourceTypeEnum;
          resourceMeta?: {
            __typename?: 'ResourceMeta';
            id: string;
            email?: string | null;
            primaryPhone?: string | null;
            bio?: string | null;
            quantity?: string | null;
            unit?: string | null;
            expiryDate?: string | null;
            batchNumber?: string | null;
            currentLocation?: string | null;
            nextServiceDate?: string | null;
            insuranceExpiryDate?: string | null;
            permitExpiryDate?: string | null;
            operatorRequirements?: string | null;
            capacity?: string | null;
            maxReach?: string | null;
            weightDimensions?: string | null;
            fuelType?: FuelTypeEnum | null;
            status?: ResourceMetaStatusTypeEnum | null;
            pointOfContact?: string | null;
            equipmentType?: string | null;
            shortCode?: string | null;
            serialNumber?: string | null;
            makeModel?: string | null;
            isScheduleable?: boolean | null;
            resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
          } | null;
          user?: {
            __typename?: 'User';
            id: string;
            firstName: string;
            lastName: string;
            email: string;
            primaryPhone?: string | null;
            defaultEmploymentStatus?: EmploymentStatusEnum | null;
          } | null;
        } | null;
      }> | null;
      client?: { __typename?: 'Client'; id: string; name: string } | null;
      mainAddress?: {
        __typename?: 'Address';
        id: string;
        street: string;
        city: string;
        state: string;
        zip: string;
        country: string;
        locationType: AddressLocationTypeEnum;
      } | null;
    };
    eventSources?: Array<{
      __typename?: 'EventSource';
      source: {
        __typename: 'Issue';
        id: string;
        description: string;
        issueType: IssueTypeEnum;
        categories: Array<{ __typename?: 'IssueCategory'; id: string; name: string }>;
      };
    }> | null;
    eventComments?: Array<{
      __typename?: 'EventComment';
      id: string;
      text: string;
      status: EventCommentStatusEnum;
      createdAt?: string | null;
    }> | null;
  }>;
};

export type GetEventsForProjectsQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
  projectIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetEventsForProjectsQuery = {
  __typename?: 'Query';
  getEventsForProjects: Array<{
    __typename?: 'Event';
    id: string;
    title: string;
    uuid: string;
    category?: EventCategoryEnum | null;
    eventType: EventTypeEnum;
    status: EventStatusEnum;
    description?: string | null;
    approved: boolean;
    ewnCount: number;
    cenCount: number;
    hasActiveCeq: boolean;
    projectCurrency?: string | null;
    orderIndex: number;
    assignee?: {
      __typename?: 'Employment';
      id: string;
      employee?: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        email: string;
        imageUrl?: string | null;
      } | null;
    } | null;
    project: {
      __typename?: 'Project';
      id: string;
      title: string;
      code: string;
      pointOfContacts?: Array<{
        __typename?: 'ProjectUser';
        id: string;
        title: string;
        userType: ProjectUserTypeEnum;
        companyResource?: {
          __typename?: 'CompanyResource';
          id: string;
          name: string;
          resourceType: CompanyResourceResourceTypeEnum;
          resourceMeta?: {
            __typename?: 'ResourceMeta';
            id: string;
            email?: string | null;
            primaryPhone?: string | null;
            bio?: string | null;
            quantity?: string | null;
            unit?: string | null;
            expiryDate?: string | null;
            batchNumber?: string | null;
            currentLocation?: string | null;
            nextServiceDate?: string | null;
            insuranceExpiryDate?: string | null;
            permitExpiryDate?: string | null;
            operatorRequirements?: string | null;
            capacity?: string | null;
            maxReach?: string | null;
            weightDimensions?: string | null;
            fuelType?: FuelTypeEnum | null;
            status?: ResourceMetaStatusTypeEnum | null;
            pointOfContact?: string | null;
            equipmentType?: string | null;
            shortCode?: string | null;
            serialNumber?: string | null;
            makeModel?: string | null;
            isScheduleable?: boolean | null;
            resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
          } | null;
          user?: {
            __typename?: 'User';
            id: string;
            firstName: string;
            lastName: string;
            email: string;
            primaryPhone?: string | null;
            defaultEmploymentStatus?: EmploymentStatusEnum | null;
          } | null;
        } | null;
      }> | null;
      managers?: Array<{
        __typename?: 'ProjectUser';
        id: string;
        title: string;
        userType: ProjectUserTypeEnum;
        employment?: {
          __typename?: 'Employment';
          id: string;
          name?: string | null;
          status?: EmploymentStatusEnum | null;
          employee?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            firstName: string;
            lastName: string;
            email: string;
            primaryPhone?: string | null;
            imageUrl?: string | null;
          } | null;
        } | null;
        user?: {
          __typename?: 'User';
          id: string;
          name?: string | null;
          firstName: string;
          lastName: string;
          email: string;
          primaryPhone?: string | null;
          defaultEmploymentStatus?: EmploymentStatusEnum | null;
          imageUrl?: string | null;
        } | null;
        companyResource?: {
          __typename?: 'CompanyResource';
          id: string;
          name: string;
          resourceType: CompanyResourceResourceTypeEnum;
          resourceMeta?: {
            __typename?: 'ResourceMeta';
            id: string;
            email?: string | null;
            primaryPhone?: string | null;
            bio?: string | null;
            quantity?: string | null;
            unit?: string | null;
            expiryDate?: string | null;
            batchNumber?: string | null;
            currentLocation?: string | null;
            nextServiceDate?: string | null;
            insuranceExpiryDate?: string | null;
            permitExpiryDate?: string | null;
            operatorRequirements?: string | null;
            capacity?: string | null;
            maxReach?: string | null;
            weightDimensions?: string | null;
            fuelType?: FuelTypeEnum | null;
            status?: ResourceMetaStatusTypeEnum | null;
            pointOfContact?: string | null;
            equipmentType?: string | null;
            shortCode?: string | null;
            serialNumber?: string | null;
            makeModel?: string | null;
            isScheduleable?: boolean | null;
            resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
          } | null;
          user?: {
            __typename?: 'User';
            id: string;
            firstName: string;
            lastName: string;
            email: string;
            primaryPhone?: string | null;
            defaultEmploymentStatus?: EmploymentStatusEnum | null;
            imageUrl?: string | null;
          } | null;
        } | null;
      }> | null;
      client?: { __typename?: 'Client'; id: string; name: string } | null;
      mainAddress?: {
        __typename?: 'Address';
        id: string;
        street: string;
        city: string;
        state: string;
        zip: string;
        country: string;
        locationType: AddressLocationTypeEnum;
      } | null;
    };
    eventSources?: Array<{
      __typename?: 'EventSource';
      source: {
        __typename: 'Issue';
        id: string;
        description: string;
        issueType: IssueTypeEnum;
        categories: Array<{ __typename?: 'IssueCategory'; id: string; name: string }>;
      };
    }> | null;
    eventComments?: Array<{
      __typename?: 'EventComment';
      id: string;
      text: string;
      status: EventCommentStatusEnum;
      createdAt?: string | null;
    }> | null;
  }>;
};

export type GetExistingUsersEmailsQueryVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
}>;

export type GetExistingUsersEmailsQuery = { __typename?: 'Query'; getExistingUsersEmails: Array<string> };

export type GetFeedbacksQueryVariables = Exact<{
  resolved?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetFeedbacksQuery = {
  __typename?: 'Query';
  getFeedbacks?: Array<{
    __typename?: 'Feedback';
    id: string;
    name: string;
    email?: string | null;
    text: string;
    feedbackType: string;
    imageUrls?: Array<string> | null;
    resolved: boolean;
    createdAt?: string | null;
  }> | null;
};

export type GetFunnelCardsQueryVariables = Exact<{ [key: string]: never }>;

export type GetFunnelCardsQuery = {
  __typename?: 'Query';
  getFunnelCards: Array<{
    __typename?: 'Project';
    id: string;
    code: string;
    title: string;
    description: string;
    createdAt: string;
    attachments: Array<{
      __typename?: 'Attachment';
      id: string;
      signedBlobId?: string | null;
      previewUrl: string;
      filename: string;
      byteSize: number;
      createdAt?: RawDate | null;
      associationType?: AssociationTypeEnum | null;
      tags?: Array<{ __typename?: 'CompanyTag'; title: string }> | null;
    }>;
    reviewers?: Array<{
      __typename?: 'ProjectUser';
      id: string;
      title: string;
      companyResource?: { __typename?: 'CompanyResource'; id: string } | null;
    }> | null;
  }>;
};

export type GetFutureSchedulesQueryVariables = Exact<{
  rootProjectId: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
}>;

export type GetFutureSchedulesQuery = {
  __typename?: 'Query';
  getFutureSchedules: Array<{
    __typename?: 'Schedule';
    id: string;
    date: string;
    startTime: string;
    endTime: string;
    status: ResourceScheduleStatusEnum;
    companyResource?: {
      __typename?: 'CompanyResource';
      id: string;
      name: string;
      resourceType: CompanyResourceResourceTypeEnum;
      subContractorId?: string | null;
    } | null;
    address?: {
      __typename?: 'Address';
      id: string;
      street: string;
      city: string;
      state: string;
      zip: string;
      country: string;
      title?: string | null;
      locationType: AddressLocationTypeEnum;
    } | null;
    project: { __typename?: 'Project'; id: string; title: string; code: string };
  }>;
};

export type GetGrantRequestsQueryVariables = Exact<{
  status?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetGrantRequestsQuery = {
  __typename?: 'Query';
  getGrantRequests: Array<{
    __typename?: 'GrantRequest';
    id: string;
    action: PermissionActionEnum;
    entity: PermissionEntityEnum;
    notes?: string | null;
    status: string;
    requestFor: string;
    createdAt: RawDate;
    resolvedAt?: RawDate | null;
    project?: { __typename?: 'Project'; id: string; title: string } | null;
    requestorEmployment: { __typename?: 'Employment'; id: string; fullName?: string | null; imageUrl?: string | null };
    actorEmployment?: { __typename?: 'Employment'; id: string; fullName?: string | null } | null;
  }>;
};

export type GetIssueFilterQueryVariables = Exact<{ [key: string]: never }>;

export type GetIssueFilterQuery = {
  __typename?: 'Query';
  getIssueFilter: Array<{ __typename?: 'IssueCategory'; id: string; name: string }>;
};

export type GetKanbanColumnsQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;

export type GetKanbanColumnsQuery = {
  __typename?: 'Query';
  getKanbanColumns: {
    __typename?: 'KanbanColumn';
    id: string;
    name: string;
    value: Array<{ __typename?: 'KanbanColumnItem'; id: string; title: string }>;
  };
};

export type GetKickOffQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetKickOffQuery = {
  __typename?: 'Query';
  getKickOff: {
    __typename?: 'ProjectKickOffs';
    id: string;
    createdAt: string;
    emails?: Array<string> | null;
    title?: string | null;
    status: KickOffStatusEnum;
    data?: {
      __typename?: 'KickOffData';
      projectId?: string | null;
      projectCode?: string | null;
      projectTitle?: string | null;
      clientId?: string | null;
      clientName?: string | null;
      clientCompanyNumber?: string | null;
      clientReps?: Array<any> | null;
      addresses?: Array<any> | null;
      notes?: Array<any> | null;
      newTemplate?: boolean | null;
      projectDetails?: {
        __typename?: 'KickOffProjectDetails';
        managers?: Array<any> | null;
        activities?: Array<any> | null;
        projectTagIds?: Array<string> | null;
        contractTypeIds?: Array<string> | null;
        projectSettings?: Array<any> | null;
      } | null;
    } | null;
    project?: { __typename?: 'Project'; title: string; code: string } | null;
    initiator: { __typename?: 'User'; id: string; firstName: string; lastName: string };
    attachments: Array<{
      __typename?: 'Attachment';
      id: string;
      signedBlobId?: string | null;
      previewUrl: string;
      filename: string;
      byteSize: number;
      createdAt?: RawDate | null;
      associationType?: AssociationTypeEnum | null;
      tags?: Array<{ __typename?: 'CompanyTag'; title: string }> | null;
    }>;
  };
};

export type GetKickOffPreloadDataQueryVariables = Exact<{
  kickOffStatus?: InputMaybe<KickOffStatusEnum>;
  companyId: Scalars['ID']['input'];
}>;

export type GetKickOffPreloadDataQuery = {
  __typename?: 'Query';
  getCompanyKickOffs: Array<{
    __typename?: 'ProjectKickOffs';
    id: string;
    title?: string | null;
    projectId?: string | null;
  }>;
  getClients?: Array<{ __typename?: 'Client'; id: string; name: string }> | null;
  getProjects?: {
    __typename?: 'ProjectConnection';
    edges?: Array<{
      __typename?: 'ProjectEdge';
      node?: { __typename?: 'Project'; id: string; title: string; code: string } | null;
    } | null> | null;
  } | null;
  getManagers?: Array<{ __typename?: 'CompanyResource'; id: string; name: string }> | null;
  getManagerAutocompleteOptions?: Array<{
    __typename?: 'Employment';
    id: string;
    name?: string | null;
    email?: string | null;
  }> | null;
  getCompanyKickOffTemplates?: Array<{ __typename?: 'KickOffTemplate'; id: string; title: string }> | null;
};

export type GetKickOffTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetKickOffTemplateQuery = {
  __typename?: 'Query';
  getKickOffTemplate?: {
    __typename?: 'KickOffTemplate';
    id: string;
    title: string;
    data?: {
      __typename?: 'KickOffData';
      clientId?: string | null;
      clientReps?: Array<any> | null;
      addresses?: Array<any> | null;
      notes?: Array<any> | null;
      projectDetails?: {
        __typename?: 'KickOffProjectDetails';
        managers?: Array<any> | null;
        activities?: Array<any> | null;
        projectTagIds?: Array<string> | null;
        contractTypeIds?: Array<string> | null;
        projectSettings?: Array<any> | null;
      } | null;
    } | null;
  } | null;
};

export type GetKickOffTemplatePreloadDataQueryVariables = Exact<{ [key: string]: never }>;

export type GetKickOffTemplatePreloadDataQuery = {
  __typename?: 'Query';
  getClients?: Array<{ __typename?: 'Client'; id: string; name: string }> | null;
  getManagers?: Array<{ __typename?: 'CompanyResource'; id: string; name: string }> | null;
  getCompanyContractTypes: Array<{
    __typename?: 'CompanyContract';
    id: string;
    contractTypeId?: string | null;
    name: string;
  }>;
  getCompanyTags: Array<{ __typename?: 'CompanyTag'; id: string; title: string }>;
};

export type GetLastCompensationEventQuotationQueryVariables = Exact<{
  eventId: Scalars['ID']['input'];
}>;

export type GetLastCompensationEventQuotationQuery = {
  __typename?: 'Query';
  getLastCompensationEventQuotation?: {
    __typename?: 'CompensationEventQuotation';
    id: string;
    description?: string | null;
    editable: boolean;
    eventId: string;
    programmeImpact: number;
    totalCost?: number | null;
    imageUrls?: Array<string> | null;
    attachments: Array<{
      __typename?: 'Attachment';
      id: string;
      signedBlobId?: string | null;
      previewUrl: string;
      filename: string;
      byteSize: number;
      createdAt?: RawDate | null;
      associationType?: AssociationTypeEnum | null;
      tags?: Array<{ __typename?: 'CompanyTag'; title: string }> | null;
    }>;
  } | null;
};

export type GetManagerAutocompleteOptionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetManagerAutocompleteOptionsQuery = {
  __typename?: 'Query';
  getManagerAutocompleteOptions?: Array<{
    __typename?: 'Employment';
    id: string;
    name?: string | null;
    email?: string | null;
    user?: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      imageUrl?: string | null;
    } | null;
  }> | null;
};

export type GetManagersQueryVariables = Exact<{ [key: string]: never }>;

export type GetManagersQuery = {
  __typename?: 'Query';
  getManagers?: Array<{
    __typename?: 'CompanyResource';
    id: string;
    name: string;
    resourceMeta?: {
      __typename?: 'ResourceMeta';
      id: string;
      email?: string | null;
      primaryPhone?: string | null;
      bio?: string | null;
      quantity?: string | null;
      unit?: string | null;
      expiryDate?: string | null;
      batchNumber?: string | null;
      currentLocation?: string | null;
      nextServiceDate?: string | null;
      insuranceExpiryDate?: string | null;
      permitExpiryDate?: string | null;
      operatorRequirements?: string | null;
      capacity?: string | null;
      maxReach?: string | null;
      weightDimensions?: string | null;
      fuelType?: FuelTypeEnum | null;
      status?: ResourceMetaStatusTypeEnum | null;
      pointOfContact?: string | null;
      equipmentType?: string | null;
      shortCode?: string | null;
      serialNumber?: string | null;
      makeModel?: string | null;
      isScheduleable?: boolean | null;
      resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
    } | null;
    user?: {
      __typename?: 'User';
      id: string;
      firstName: string;
      lastName: string;
      email: string;
      imageUrl?: string | null;
      companyEmployment?: { __typename?: 'Employment'; id: string; status?: EmploymentStatusEnum | null } | null;
    } | null;
  }> | null;
};

export type GetMyGrantRequestsQueryVariables = Exact<{
  status?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetMyGrantRequestsQuery = {
  __typename?: 'Query';
  getMyGrantRequests: Array<{
    __typename?: 'GrantRequest';
    id: string;
    action: PermissionActionEnum;
    entity: PermissionEntityEnum;
    status: string;
    notes?: string | null;
    createdAt: RawDate;
    project?: { __typename?: 'Project'; id: string; title: string } | null;
  }>;
};

export type GetMyNotesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  noteType?: InputMaybe<IssueTypeEnum>;
  source?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetMyNotesQuery = {
  __typename?: 'Query';
  getMyNotes: Array<{
    __typename?: 'Issue';
    id: string;
    description: string;
    issueType: IssueTypeEnum;
    startTime: string;
    endTime: string;
    imageUrls?: Array<string> | null;
    createdAt?: string | null;
    updatedAt?: string | null;
    creator?: {
      __typename?: 'Employment';
      id: string;
      employee?: { __typename?: 'User'; id: string; firstName: string; lastName: string } | null;
    } | null;
  }>;
};

export type GetMyProjectsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  companyId: Scalars['ID']['input'];
}>;

export type GetMyProjectsQuery = {
  __typename?: 'Query';
  getMyProjects?: Array<{
    __typename?: 'Project';
    id: string;
    title: string;
    code: string;
    companyId: string;
    hasSubLocations?: boolean | null;
    createdAt: string;
    updatedAt: string;
    holidays?: string | null;
    managers?: Array<{
      __typename?: 'ProjectUser';
      id: string;
      title: string;
      user?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName: string;
        lastName: string;
        email: string;
        imageUrl?: string | null;
      } | null;
      companyResource?: {
        __typename?: 'CompanyResource';
        name: string;
        resourceType: CompanyResourceResourceTypeEnum;
        resourceMeta?: {
          __typename?: 'ResourceMeta';
          id: string;
          email?: string | null;
          primaryPhone?: string | null;
          bio?: string | null;
          quantity?: string | null;
          unit?: string | null;
          expiryDate?: string | null;
          batchNumber?: string | null;
          currentLocation?: string | null;
          nextServiceDate?: string | null;
          insuranceExpiryDate?: string | null;
          permitExpiryDate?: string | null;
          operatorRequirements?: string | null;
          capacity?: string | null;
          maxReach?: string | null;
          weightDimensions?: string | null;
          fuelType?: FuelTypeEnum | null;
          status?: ResourceMetaStatusTypeEnum | null;
          pointOfContact?: string | null;
          equipmentType?: string | null;
          shortCode?: string | null;
          serialNumber?: string | null;
          makeModel?: string | null;
          isScheduleable?: boolean | null;
          resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
        } | null;
      } | null;
    }> | null;
    mainAddress?: {
      __typename?: 'Address';
      id: string;
      street: string;
      city: string;
      state: string;
      zip: string;
      country: string;
      title?: string | null;
      locationType: AddressLocationTypeEnum;
    } | null;
    addresses?: Array<{
      __typename?: 'Address';
      id: string;
      street: string;
      city: string;
      state: string;
      zip: string;
      country: string;
      title?: string | null;
      locationType: AddressLocationTypeEnum;
    }> | null;
    projectSettings: Array<{ __typename?: 'ProjectSetting'; id: string; name: string; value: string }>;
  }> | null;
};

export type GetMyTasksQueryVariables = Exact<{ [key: string]: never }>;

export type GetMyTasksQuery = {
  __typename?: 'Query';
  getMyTasks: Array<{
    __typename?: 'Task';
    id: string;
    title: string;
    description?: string | null;
    status: TaskStatusEnum;
    priority: TaskPriorityEnum;
    dueDate?: RawDate | null;
    entityType?: string | null;
    entityId?: string | null;
    entityName: string;
    imageUrls?: Array<string> | null;
    createdAt: string;
    updatedAt: string;
    assignee: {
      __typename?: 'Employment';
      id: string;
      employee?: { __typename?: 'User'; id: string; firstName: string; lastName: string; email: string } | null;
    };
    creator: {
      __typename?: 'Employment';
      id: string;
      employee?: { __typename?: 'User'; id: string; firstName: string; lastName: string; email: string } | null;
    };
    attachments: Array<{
      __typename?: 'Attachment';
      id: string;
      signedBlobId?: string | null;
      previewUrl: string;
      filename: string;
      byteSize: number;
      createdAt?: RawDate | null;
      associationType?: AssociationTypeEnum | null;
      tags?: Array<{ __typename?: 'CompanyTag'; title: string }> | null;
    }>;
  }>;
};

export type GetNewUsersRequestsQueryVariables = Exact<{ [key: string]: never }>;

export type GetNewUsersRequestsQuery = {
  __typename?: 'Query';
  getNewUsersRequests?: Array<{
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    primaryPhone?: string | null;
    imageUrl?: string | null;
    status: UserStatusEnum;
    createdAt: string;
  }> | null;
};

export type GetNoteEntityOptionsQueryVariables = Exact<{
  entityType: Scalars['String']['input'];
}>;

export type GetNoteEntityOptionsQuery = { __typename?: 'Query'; getNoteEntityOptions: any };

export type GetNoteFiltersQueryVariables = Exact<{ [key: string]: never }>;

export type GetNoteFiltersQuery = {
  __typename?: 'Query';
  getNoteFilters?: {
    __typename?: 'NoteFilters';
    noteTypes?: Array<string> | null;
    sources?: Array<string> | null;
  } | null;
};

export type GetOptionsForBillableItemsQueryVariables = Exact<{
  itemType: Scalars['String']['input'];
}>;

export type GetOptionsForBillableItemsQuery = {
  __typename?: 'Query';
  getOptionsForBillableItems: Array<{
    __typename?: 'BillableItemOption';
    id: string;
    name: string;
    unit?: string | null;
    uniqueKey: string;
  }>;
};

export type GetOverwatchAutocompleteDataQueryVariables = Exact<{
  includeManagers: Scalars['Boolean']['input'];
  includeResources: Scalars['Boolean']['input'];
  includeProjects: Scalars['Boolean']['input'];
  resourceType?: InputMaybe<CompanyResourceResourceTypeEnum>;
  companyId: Scalars['ID']['input'];
}>;

export type GetOverwatchAutocompleteDataQuery = {
  __typename?: 'Query';
  getManagers?: Array<{ __typename?: 'CompanyResource'; id: string; name: string }> | null;
  getCompanyResources?: Array<{ __typename?: 'CompanyResource'; id: string; name: string }> | null;
  getProjects?: {
    __typename?: 'ProjectConnection';
    edges?: Array<{
      __typename?: 'ProjectEdge';
      node?: { __typename?: 'Project'; id: string; title: string; code: string } | null;
    } | null> | null;
  } | null;
};

export type GetPersonalNotesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  noteType?: InputMaybe<NotesTypeEnum>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;

export type GetPersonalNotesQuery = {
  __typename?: 'Query';
  getPersonalNotes: Array<{
    __typename?: 'Note';
    id: string;
    description: string;
    notesType: NotesTypeEnum;
    reminder?: string | null;
    imageUrls?: Array<string> | null;
    targetId?: string | null;
    targetType?: string | null;
    tags?: Array<{ __typename?: 'CompanyTag'; id: string; title: string }> | null;
    attachments: Array<{
      __typename?: 'Attachment';
      id: string;
      signedBlobId?: string | null;
      previewUrl: string;
      filename: string;
      byteSize: number;
      createdAt?: RawDate | null;
      associationType?: AssociationTypeEnum | null;
      tags?: Array<{ __typename?: 'CompanyTag'; title: string }> | null;
    }>;
  }>;
};

export type GetPlaceholdersForSchedulerQueryVariables = Exact<{
  searchBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetPlaceholdersForSchedulerQuery = {
  __typename?: 'Query';
  getPlaceholdersForScheduler: Array<{
    __typename?: 'SchedulerResource';
    id: string;
    name: string;
    resourceType: string;
    description?: string | null;
  }>;
};

export type GetPreloadTasksDrawerFiltersDataQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;

export type GetPreloadTasksDrawerFiltersDataQuery = {
  __typename?: 'Query';
  getEmployees?: {
    __typename?: 'UserConnection';
    edges?: Array<{
      __typename?: 'UserEdge';
      cursor: string;
      node?: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        companyEmployment?: { __typename?: 'Employment'; id: string } | null;
      } | null;
    } | null> | null;
  } | null;
  getProjects?: {
    __typename?: 'ProjectConnection';
    edges?: Array<{
      __typename?: 'ProjectEdge';
      cursor: string;
      node?: { __typename?: 'Project'; id: string; title: string; code: string } | null;
    } | null> | null;
  } | null;
  getCompanyEvents: Array<{ __typename?: 'Event'; id: string; title: string }>;
  getCompanyReports: {
    __typename?: 'ReportConnection';
    edges?: Array<{
      __typename?: 'ReportEdge';
      cursor: string;
      node?: {
        __typename?: 'Report';
        id: string;
        reportDate: string;
        project: { __typename?: 'Project'; id: string; code: string };
      } | null;
    } | null> | null;
  };
};

export type GetProjectQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;

export type GetProjectQuery = {
  __typename?: 'Query';
  getProject?: {
    __typename?: 'Project';
    id: string;
    title: string;
    companyId: string;
    endDate?: string | null;
    status: ProjectStatusEnum;
    code: string;
    startDate?: string | null;
    createdAt: string;
    updatedAt: string;
    canInviteClient: boolean;
    contractTypeIds?: Array<string> | null;
    tagIds?: Array<string> | null;
    attachments: Array<{
      __typename?: 'Attachment';
      id: string;
      signedBlobId?: string | null;
      previewUrl: string;
      filename: string;
      byteSize: number;
      createdAt?: RawDate | null;
      associationType?: AssociationTypeEnum | null;
      tags?: Array<{ __typename?: 'CompanyTag'; title: string }> | null;
    }>;
    pointOfContacts?: Array<{
      __typename?: 'ProjectUser';
      id: string;
      title: string;
      companyResource?: {
        __typename?: 'CompanyResource';
        id: string;
        name: string;
        resourceType: CompanyResourceResourceTypeEnum;
        resourceMeta?: {
          __typename?: 'ResourceMeta';
          id: string;
          email?: string | null;
          primaryPhone?: string | null;
          bio?: string | null;
          quantity?: string | null;
          unit?: string | null;
          expiryDate?: string | null;
          batchNumber?: string | null;
          currentLocation?: string | null;
          nextServiceDate?: string | null;
          insuranceExpiryDate?: string | null;
          permitExpiryDate?: string | null;
          operatorRequirements?: string | null;
          capacity?: string | null;
          maxReach?: string | null;
          weightDimensions?: string | null;
          fuelType?: FuelTypeEnum | null;
          status?: ResourceMetaStatusTypeEnum | null;
          pointOfContact?: string | null;
          equipmentType?: string | null;
          shortCode?: string | null;
          serialNumber?: string | null;
          makeModel?: string | null;
          isScheduleable?: boolean | null;
          resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
        } | null;
        user?: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          primaryPhone?: string | null;
          defaultEmploymentStatus?: EmploymentStatusEnum | null;
        } | null;
      } | null;
    }> | null;
    managers?: Array<{
      __typename?: 'ProjectUser';
      id: string;
      title: string;
      userType: ProjectUserTypeEnum;
      user?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName: string;
        lastName: string;
        email: string;
        imageUrl?: string | null;
      } | null;
      companyResource?: {
        __typename?: 'CompanyResource';
        id: string;
        name: string;
        resourceType: CompanyResourceResourceTypeEnum;
        resourceMeta?: {
          __typename?: 'ResourceMeta';
          id: string;
          email?: string | null;
          primaryPhone?: string | null;
          bio?: string | null;
          quantity?: string | null;
          unit?: string | null;
          expiryDate?: string | null;
          batchNumber?: string | null;
          currentLocation?: string | null;
          nextServiceDate?: string | null;
          insuranceExpiryDate?: string | null;
          permitExpiryDate?: string | null;
          operatorRequirements?: string | null;
          capacity?: string | null;
          maxReach?: string | null;
          weightDimensions?: string | null;
          fuelType?: FuelTypeEnum | null;
          status?: ResourceMetaStatusTypeEnum | null;
          pointOfContact?: string | null;
          equipmentType?: string | null;
          shortCode?: string | null;
          serialNumber?: string | null;
          makeModel?: string | null;
          isScheduleable?: boolean | null;
          resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
        } | null;
        user?: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          primaryPhone?: string | null;
          defaultEmploymentStatus?: EmploymentStatusEnum | null;
          imageUrl?: string | null;
        } | null;
      } | null;
    }> | null;
    client?: { __typename?: 'Client'; id: string; name: string } | null;
    mainAddress?: {
      __typename?: 'Address';
      id: string;
      title?: string | null;
      street: string;
      city: string;
      state: string;
      zip: string;
      country: string;
      locationType: AddressLocationTypeEnum;
    } | null;
    subLocations?: Array<{
      __typename?: 'Address';
      id: string;
      title?: string | null;
      street: string;
      city: string;
      state: string;
      zip: string;
      country: string;
    }> | null;
    projectSettings: Array<{ __typename?: 'ProjectSetting'; id: string; name: string; value: string }>;
    projectActivities: Array<{
      __typename?: 'ProjectActivity';
      id: string;
      title: string;
      description?: string | null;
      status: ProjectActivityStatusEnum;
      startTime: string;
      endTime: string;
      timeBasedStatus: ProjectActivityTimeBasedStatusEnum;
      completedAt?: string | null;
      colorCode: string;
      supervisor?: {
        __typename?: 'Employment';
        id: string;
        employee?: { __typename?: 'User'; id: string; firstName: string; lastName: string } | null;
      } | null;
      createdBy: {
        __typename?: 'Employment';
        id: string;
        employee?: { __typename?: 'User'; id: string; firstName: string; lastName: string } | null;
      };
    }>;
  } | null;
};

export type GetProjectActivitiesQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;

export type GetProjectActivitiesQuery = {
  __typename?: 'Query';
  getProjectActivities?: Array<{
    __typename?: 'ProjectActivity';
    id: string;
    title: string;
    description?: string | null;
    status: ProjectActivityStatusEnum;
    startTime: string;
    endTime: string;
    timeBasedStatus: ProjectActivityTimeBasedStatusEnum;
    completedAt?: string | null;
    colorCode: string;
    supervisor?: {
      __typename?: 'Employment';
      id: string;
      employee?: { __typename?: 'User'; id: string; firstName: string; lastName: string } | null;
    } | null;
    createdBy: {
      __typename?: 'Employment';
      id: string;
      employee?: { __typename?: 'User'; id: string; firstName: string; lastName: string } | null;
    };
  }> | null;
};

export type GetCompanyAddressesQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;

export type GetCompanyAddressesQuery = {
  __typename?: 'Query';
  getCompanyAddresses: Array<{
    __typename?: 'Address';
    id: string;
    street: string;
    city: string;
    state: string;
    zip: string;
    country: string;
    locationType: AddressLocationTypeEnum;
    title?: string | null;
  }>;
};

export type GetProjectCodeSuggestionQueryVariables = Exact<{
  title: Scalars['String']['input'];
  parentCode?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetProjectCodeSuggestionQuery = { __typename?: 'Query'; getProjectCodeSuggestion?: string | null };

export type GetProjectCodesQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;

export type GetProjectCodesQuery = {
  __typename?: 'Query';
  getProjects?: {
    __typename?: 'ProjectConnection';
    edges?: Array<{ __typename?: 'ProjectEdge'; node?: { __typename?: 'Project'; code: string } | null } | null> | null;
  } | null;
};

export type GetProjectDraftKickOffQueryVariables = Exact<{
  projectId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetProjectDraftKickOffQuery = {
  __typename?: 'Query';
  getProjectDraftKickOff?: {
    __typename?: 'ProjectKickOffs';
    id: string;
    title?: string | null;
    status: KickOffStatusEnum;
    lastEditedAt: string;
    imageUrls?: Array<string> | null;
    data?: {
      __typename?: 'KickOffData';
      projectId?: string | null;
      projectCode?: string | null;
      projectTitle?: string | null;
      clientId?: string | null;
      clientName?: string | null;
      clientCompanyNumber?: string | null;
      clientReps?: Array<any> | null;
      addresses?: Array<any> | null;
      notes?: Array<any> | null;
      newTemplate?: boolean | null;
      projectDetails?: {
        __typename?: 'KickOffProjectDetails';
        managers?: Array<any> | null;
        activities?: Array<any> | null;
        projectTagIds?: Array<string> | null;
        contractTypeIds?: Array<string> | null;
        projectSettings?: Array<any> | null;
      } | null;
    } | null;
    initiator: { __typename?: 'User'; id: string; firstName: string; lastName: string; email: string };
    lastEditedBy: { __typename?: 'User'; id: string; firstName: string; lastName: string };
    attachments: Array<{
      __typename?: 'Attachment';
      id: string;
      signedBlobId?: string | null;
      previewUrl: string;
      filename: string;
      byteSize: number;
      createdAt?: RawDate | null;
      associationType?: AssociationTypeEnum | null;
      tags?: Array<{ __typename?: 'CompanyTag'; title: string }> | null;
    }>;
  } | null;
};

export type GetProjectForEditQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  withDrafts?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetProjectForEditQuery = {
  __typename?: 'Query';
  getProject?: {
    __typename?: 'Project';
    id: string;
    code: string;
    title: string;
    description: string;
    startDate?: string | null;
    endDate?: string | null;
    status: ProjectStatusEnum;
    visible: boolean;
    companyId: string;
    contractTypeIds?: Array<string> | null;
    tagIds?: Array<string> | null;
    attachments: Array<{
      __typename?: 'Attachment';
      id: string;
      signedBlobId?: string | null;
      previewUrl: string;
      filename: string;
      byteSize: number;
      createdAt?: RawDate | null;
      associationType?: AssociationTypeEnum | null;
      tags?: Array<{ __typename?: 'CompanyTag'; title: string }> | null;
    }>;
    pointOfContacts?: Array<{
      __typename?: 'ProjectUser';
      id: string;
      title: string;
      companyResource?: {
        __typename?: 'CompanyResource';
        id: string;
        name: string;
        resourceType: CompanyResourceResourceTypeEnum;
        resourceMeta?: {
          __typename?: 'ResourceMeta';
          id: string;
          email?: string | null;
          primaryPhone?: string | null;
        } | null;
        user?: { __typename?: 'User'; id: string; firstName: string; lastName: string; email: string } | null;
      } | null;
    }> | null;
    managers?: Array<{
      __typename?: 'ProjectUser';
      id: string;
      title: string;
      userType: ProjectUserTypeEnum;
      employment?: {
        __typename?: 'Employment';
        id: string;
        name?: string | null;
        status?: EmploymentStatusEnum | null;
      } | null;
      user?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName: string;
        lastName: string;
        email: string;
        primaryPhone?: string | null;
      } | null;
      companyResource?: {
        __typename?: 'CompanyResource';
        id: string;
        name: string;
        resourceType: CompanyResourceResourceTypeEnum;
        resourceMeta?: {
          __typename?: 'ResourceMeta';
          id: string;
          email?: string | null;
          primaryPhone?: string | null;
        } | null;
        user?: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          primaryPhone?: string | null;
        } | null;
      } | null;
    }> | null;
    client?: { __typename?: 'Client'; id: string; name: string } | null;
    addresses?: Array<{
      __typename?: 'Address';
      id: string;
      title?: string | null;
      street: string;
      city: string;
      state: string;
      zip: string;
      country: string;
      locationType: AddressLocationTypeEnum;
    }> | null;
    projectSettings: Array<{ __typename?: 'ProjectSetting'; id: string; name: string; value: string }>;
    projectActivities: Array<{
      __typename?: 'ProjectActivity';
      id: string;
      title: string;
      description?: string | null;
      status: ProjectActivityStatusEnum;
      startTime: string;
      endTime: string;
      timeBasedStatus: ProjectActivityTimeBasedStatusEnum;
      completedAt?: string | null;
      colorCode: string;
      supervisor?: {
        __typename?: 'Employment';
        id: string;
        employee?: { __typename?: 'User'; id: string; firstName: string; lastName: string } | null;
      } | null;
    }>;
  } | null;
};

export type GetProjectForKickoffQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;

export type GetProjectForKickoffQuery = {
  __typename?: 'Query';
  getProject?: {
    __typename?: 'Project';
    id: string;
    title: string;
    code: string;
    startDate?: string | null;
    pointOfContacts?: Array<{
      __typename?: 'ProjectUser';
      id: string;
      title: string;
      companyResource?: {
        __typename?: 'CompanyResource';
        name: string;
        resourceType: CompanyResourceResourceTypeEnum;
        resourceMeta?: {
          __typename?: 'ResourceMeta';
          id: string;
          email?: string | null;
          primaryPhone?: string | null;
          bio?: string | null;
          quantity?: string | null;
          unit?: string | null;
          expiryDate?: string | null;
          batchNumber?: string | null;
          currentLocation?: string | null;
          nextServiceDate?: string | null;
          insuranceExpiryDate?: string | null;
          permitExpiryDate?: string | null;
          operatorRequirements?: string | null;
          capacity?: string | null;
          maxReach?: string | null;
          weightDimensions?: string | null;
          fuelType?: FuelTypeEnum | null;
          status?: ResourceMetaStatusTypeEnum | null;
          pointOfContact?: string | null;
          equipmentType?: string | null;
          shortCode?: string | null;
          serialNumber?: string | null;
          makeModel?: string | null;
          isScheduleable?: boolean | null;
          resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
        } | null;
        user?: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          primaryPhone?: string | null;
          defaultEmploymentStatus?: EmploymentStatusEnum | null;
        } | null;
      } | null;
    }> | null;
    managers?: Array<{
      __typename?: 'ProjectUser';
      id: string;
      title: string;
      user?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName: string;
        lastName: string;
        email: string;
        imageUrl?: string | null;
      } | null;
      companyResource?: {
        __typename?: 'CompanyResource';
        name: string;
        resourceType: CompanyResourceResourceTypeEnum;
        resourceMeta?: {
          __typename?: 'ResourceMeta';
          id: string;
          email?: string | null;
          primaryPhone?: string | null;
          bio?: string | null;
          quantity?: string | null;
          unit?: string | null;
          expiryDate?: string | null;
          batchNumber?: string | null;
          currentLocation?: string | null;
          nextServiceDate?: string | null;
          insuranceExpiryDate?: string | null;
          permitExpiryDate?: string | null;
          operatorRequirements?: string | null;
          capacity?: string | null;
          maxReach?: string | null;
          weightDimensions?: string | null;
          fuelType?: FuelTypeEnum | null;
          status?: ResourceMetaStatusTypeEnum | null;
          pointOfContact?: string | null;
          equipmentType?: string | null;
          shortCode?: string | null;
          serialNumber?: string | null;
          makeModel?: string | null;
          isScheduleable?: boolean | null;
          resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
        } | null;
        user?: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          primaryPhone?: string | null;
          defaultEmploymentStatus?: EmploymentStatusEnum | null;
        } | null;
      } | null;
    }> | null;
    client?: { __typename?: 'Client'; id: string; name: string } | null;
    mainAddress?: {
      __typename?: 'Address';
      id: string;
      street: string;
      city: string;
      state: string;
      zip: string;
      country: string;
      locationType: AddressLocationTypeEnum;
    } | null;
    projectSettings: Array<{ __typename?: 'ProjectSetting'; id: string; name: string; value: string }>;
  } | null;
};

export type GetProjectForSplittingQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;

export type GetProjectForSplittingQuery = {
  __typename?: 'Query';
  getProject?: {
    __typename?: 'Project';
    id: string;
    title: string;
    status: ProjectStatusEnum;
    code: string;
    companyId: string;
    description: string;
    attachments: Array<{
      __typename?: 'Attachment';
      id: string;
      signedBlobId?: string | null;
      previewUrl: string;
      filename: string;
      byteSize: number;
      createdAt?: RawDate | null;
      associationType?: AssociationTypeEnum | null;
      tags?: Array<{ __typename?: 'CompanyTag'; title: string }> | null;
    }>;
    pointOfContacts?: Array<{
      __typename?: 'ProjectUser';
      id: string;
      title: string;
      userType: ProjectUserTypeEnum;
      companyResource?: {
        __typename?: 'CompanyResource';
        id: string;
        name: string;
        resourceType: CompanyResourceResourceTypeEnum;
        resourceMeta?: {
          __typename?: 'ResourceMeta';
          id: string;
          email?: string | null;
          primaryPhone?: string | null;
          bio?: string | null;
          quantity?: string | null;
          unit?: string | null;
          expiryDate?: string | null;
          batchNumber?: string | null;
          currentLocation?: string | null;
          nextServiceDate?: string | null;
          insuranceExpiryDate?: string | null;
          permitExpiryDate?: string | null;
          operatorRequirements?: string | null;
          capacity?: string | null;
          maxReach?: string | null;
          weightDimensions?: string | null;
          fuelType?: FuelTypeEnum | null;
          status?: ResourceMetaStatusTypeEnum | null;
          pointOfContact?: string | null;
          equipmentType?: string | null;
          shortCode?: string | null;
          serialNumber?: string | null;
          makeModel?: string | null;
          isScheduleable?: boolean | null;
          resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
        } | null;
        user?: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          primaryPhone?: string | null;
          defaultEmploymentStatus?: EmploymentStatusEnum | null;
        } | null;
      } | null;
    }> | null;
    managers?: Array<{
      __typename?: 'ProjectUser';
      id: string;
      title: string;
      userType: ProjectUserTypeEnum;
      employment?: {
        __typename?: 'Employment';
        id: string;
        name?: string | null;
        status?: EmploymentStatusEnum | null;
        employee?: {
          __typename?: 'User';
          id: string;
          name?: string | null;
          firstName: string;
          lastName: string;
          email: string;
          primaryPhone?: string | null;
          imageUrl?: string | null;
        } | null;
      } | null;
      user?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName: string;
        lastName: string;
        email: string;
        primaryPhone?: string | null;
        defaultEmploymentStatus?: EmploymentStatusEnum | null;
        imageUrl?: string | null;
      } | null;
      companyResource?: {
        __typename?: 'CompanyResource';
        id: string;
        name: string;
        resourceType: CompanyResourceResourceTypeEnum;
        resourceMeta?: {
          __typename?: 'ResourceMeta';
          id: string;
          email?: string | null;
          primaryPhone?: string | null;
          bio?: string | null;
          quantity?: string | null;
          unit?: string | null;
          expiryDate?: string | null;
          batchNumber?: string | null;
          currentLocation?: string | null;
          nextServiceDate?: string | null;
          insuranceExpiryDate?: string | null;
          permitExpiryDate?: string | null;
          operatorRequirements?: string | null;
          capacity?: string | null;
          maxReach?: string | null;
          weightDimensions?: string | null;
          fuelType?: FuelTypeEnum | null;
          status?: ResourceMetaStatusTypeEnum | null;
          pointOfContact?: string | null;
          equipmentType?: string | null;
          shortCode?: string | null;
          serialNumber?: string | null;
          makeModel?: string | null;
          isScheduleable?: boolean | null;
          resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
        } | null;
        user?: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          primaryPhone?: string | null;
          defaultEmploymentStatus?: EmploymentStatusEnum | null;
          imageUrl?: string | null;
        } | null;
      } | null;
    }> | null;
    client?: { __typename?: 'Client'; id: string; name: string } | null;
    addresses?: Array<{
      __typename?: 'Address';
      id: string;
      street: string;
      city: string;
      state: string;
      zip: string;
      country: string;
      locationType: AddressLocationTypeEnum;
    }> | null;
    projectSettings: Array<{ __typename?: 'ProjectSetting'; id: string; name: string; value: string }>;
  } | null;
};

export type GetProjectInvitationPrefillDataQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;

export type GetProjectInvitationPrefillDataQuery = {
  __typename?: 'Query';
  getProjectInvitationPrefillData: {
    __typename?: 'ProjectInvitationPrefill';
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    companyName?: string | null;
    companyPhone?: string | null;
  };
};

export type GetProjectIssuesQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;

export type GetProjectIssuesQuery = {
  __typename?: 'Query';
  getProjectIssues: Array<{
    __typename?: 'Issue';
    id: string;
    description: string;
    issueType: IssueTypeEnum;
    createdAt?: string | null;
    categories: Array<{ __typename?: 'IssueCategory'; id: string; name: string }>;
    creator?: {
      __typename?: 'Employment';
      id: string;
      employee?: { __typename?: 'User'; id: string; firstName: string; lastName: string } | null;
    } | null;
  }>;
};

export type GetProjectKickOffsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetProjectKickOffsQuery = {
  __typename?: 'Query';
  getProjectKickOffs: {
    __typename?: 'ProjectKickOffsConnection';
    edges?: Array<{
      __typename?: 'ProjectKickOffsEdge';
      cursor: string;
      node?: {
        __typename?: 'ProjectKickOffs';
        id: string;
        createdAt: string;
        emails?: Array<string> | null;
        title?: string | null;
        project?: { __typename?: 'Project'; title: string; code: string } | null;
        initiator: { __typename?: 'User'; id: string; firstName: string; lastName: string };
      } | null;
    } | null> | null;
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string | null;
    };
  };
};

export type GetProjectLocationsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;

export type GetProjectLocationsQuery = {
  __typename?: 'Query';
  getProject?: {
    __typename?: 'Project';
    id: string;
    title: string;
    companyId: string;
    status: ProjectStatusEnum;
    code: string;
    mainAddress?: {
      __typename?: 'Address';
      id: string;
      street: string;
      city: string;
      state: string;
      zip: string;
      country: string;
    } | null;
    subLocations?: Array<{
      __typename?: 'Address';
      id: string;
      street: string;
      city: string;
      state: string;
      zip: string;
      country: string;
    }> | null;
  } | null;
};

export type GetProjectNotesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetProjectNotesQuery = {
  __typename?: 'Query';
  getProjectNotes: Array<{
    __typename?: 'Note';
    id: string;
    description: string;
    notesType: NotesTypeEnum;
    reminder?: string | null;
    imageUrls?: Array<string> | null;
    targetId?: string | null;
    targetType?: string | null;
    tags?: Array<{ __typename?: 'CompanyTag'; id: string; title: string }> | null;
    attachments: Array<{
      __typename?: 'Attachment';
      id: string;
      signedBlobId?: string | null;
      previewUrl: string;
      filename: string;
      byteSize: number;
      createdAt?: RawDate | null;
      associationType?: AssociationTypeEnum | null;
      tags?: Array<{ __typename?: 'CompanyTag'; title: string }> | null;
    }>;
  }>;
};

export type GetProjectTemplatesQueryVariables = Exact<{ [key: string]: never }>;

export type GetProjectTemplatesQuery = {
  __typename?: 'Query';
  getProjectTemplates: Array<{
    __typename?: 'ProjectTemplate';
    id: string;
    title: string;
    description?: string | null;
    activities?: any | null;
    tags?: Array<{ __typename?: 'CompanyTag'; id: string; title: string }> | null;
    companyResources?: Array<{
      __typename?: 'CompanyResource';
      id: string;
      name: string;
      resourceType: CompanyResourceResourceTypeEnum;
      resourceMeta?: {
        __typename?: 'ResourceMeta';
        id: string;
        email?: string | null;
        primaryPhone?: string | null;
        bio?: string | null;
        quantity?: string | null;
        unit?: string | null;
        expiryDate?: string | null;
        batchNumber?: string | null;
        currentLocation?: string | null;
        nextServiceDate?: string | null;
        insuranceExpiryDate?: string | null;
        permitExpiryDate?: string | null;
        operatorRequirements?: string | null;
        capacity?: string | null;
        maxReach?: string | null;
        weightDimensions?: string | null;
        fuelType?: FuelTypeEnum | null;
        status?: ResourceMetaStatusTypeEnum | null;
        pointOfContact?: string | null;
        equipmentType?: string | null;
        shortCode?: string | null;
        serialNumber?: string | null;
        makeModel?: string | null;
        isScheduleable?: boolean | null;
        resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
      } | null;
      user?: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        email: string;
        primaryPhone?: string | null;
        defaultEmploymentStatus?: EmploymentStatusEnum | null;
        imageUrl?: string | null;
      } | null;
    }> | null;
  }>;
};

export type GetProjectWorkingHoursQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;

export type GetProjectWorkingHoursQuery = {
  __typename?: 'Query';
  getProjectWorkingHours?: { __typename?: 'ProjectWorkingHours'; hours?: any | null } | null;
};

export type GetProjectsQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
  status?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  visible?: InputMaybe<Scalars['Boolean']['input']>;
  peopleIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  hasKickOffs?: InputMaybe<Scalars['Boolean']['input']>;
  hasSubLocations?: InputMaybe<Scalars['Boolean']['input']>;
  hasSubProjects?: InputMaybe<Scalars['Boolean']['input']>;
  hasReportsShared?: InputMaybe<Scalars['Boolean']['input']>;
  hasIssues?: InputMaybe<Scalars['Boolean']['input']>;
  hasOpenEvents?: InputMaybe<Scalars['Boolean']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  isProjectTab?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetProjectsQuery = {
  __typename?: 'Query';
  getProjects?: {
    __typename?: 'ProjectConnection';
    totalCount?: number | null;
    edges?: Array<{
      __typename?: 'ProjectEdge';
      cursor: string;
      node?: {
        __typename?: 'Project';
        id: string;
        title: string;
        description: string;
        companyId: string;
        issuesCount: number;
        imageUrls?: Array<string> | null;
        visible: boolean;
        endDate?: string | null;
        status: ProjectStatusEnum;
        code: string;
        startDate?: string | null;
        createdAt: string;
        updatedAt: string;
        canInviteClient: boolean;
        contractTypeIds?: Array<string> | null;
        tagIds?: Array<string> | null;
        attachments: Array<{
          __typename?: 'Attachment';
          id: string;
          signedBlobId?: string | null;
          previewUrl: string;
          filename: string;
          byteSize: number;
          createdAt?: RawDate | null;
          associationType?: AssociationTypeEnum | null;
          tags?: Array<{ __typename?: 'CompanyTag'; title: string }> | null;
        }>;
        pointOfContacts?: Array<{
          __typename?: 'ProjectUser';
          id: string;
          title: string;
          companyResource?: {
            __typename?: 'CompanyResource';
            id: string;
            name: string;
            resourceType: CompanyResourceResourceTypeEnum;
            resourceMeta?: {
              __typename?: 'ResourceMeta';
              id: string;
              email?: string | null;
              primaryPhone?: string | null;
              bio?: string | null;
              quantity?: string | null;
              unit?: string | null;
              expiryDate?: string | null;
              batchNumber?: string | null;
              currentLocation?: string | null;
              nextServiceDate?: string | null;
              insuranceExpiryDate?: string | null;
              permitExpiryDate?: string | null;
              operatorRequirements?: string | null;
              capacity?: string | null;
              maxReach?: string | null;
              weightDimensions?: string | null;
              fuelType?: FuelTypeEnum | null;
              status?: ResourceMetaStatusTypeEnum | null;
              pointOfContact?: string | null;
              equipmentType?: string | null;
              shortCode?: string | null;
              serialNumber?: string | null;
              makeModel?: string | null;
              isScheduleable?: boolean | null;
              resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
            } | null;
          } | null;
        }> | null;
        managers?: Array<{
          __typename?: 'ProjectUser';
          id: string;
          title: string;
          userType: ProjectUserTypeEnum;
          employment?: {
            __typename?: 'Employment';
            id: string;
            name?: string | null;
            status?: EmploymentStatusEnum | null;
          } | null;
          user?: {
            __typename?: 'User';
            id: string;
            name?: string | null;
            firstName: string;
            lastName: string;
            email: string;
            imageUrl?: string | null;
          } | null;
          companyResource?: {
            __typename?: 'CompanyResource';
            id: string;
            name: string;
            resourceType: CompanyResourceResourceTypeEnum;
            resourceMeta?: {
              __typename?: 'ResourceMeta';
              id: string;
              email?: string | null;
              primaryPhone?: string | null;
              bio?: string | null;
              quantity?: string | null;
              unit?: string | null;
              expiryDate?: string | null;
              batchNumber?: string | null;
              currentLocation?: string | null;
              nextServiceDate?: string | null;
              insuranceExpiryDate?: string | null;
              permitExpiryDate?: string | null;
              operatorRequirements?: string | null;
              capacity?: string | null;
              maxReach?: string | null;
              weightDimensions?: string | null;
              fuelType?: FuelTypeEnum | null;
              status?: ResourceMetaStatusTypeEnum | null;
              pointOfContact?: string | null;
              equipmentType?: string | null;
              shortCode?: string | null;
              serialNumber?: string | null;
              makeModel?: string | null;
              isScheduleable?: boolean | null;
              resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
            } | null;
          } | null;
        }> | null;
        client?: { __typename?: 'Client'; id: string; name: string; primaryEmail?: string | null } | null;
        mainAddress?: {
          __typename?: 'Address';
          id: string;
          title?: string | null;
          street: string;
          city: string;
          state: string;
          zip: string;
          country: string;
          locationType: AddressLocationTypeEnum;
        } | null;
        subLocations?: Array<{
          __typename?: 'Address';
          title?: string | null;
          street: string;
          city: string;
          state: string;
          zip: string;
          country: string;
        }> | null;
        projectActivities: Array<{
          __typename?: 'ProjectActivity';
          id: string;
          title: string;
          description?: string | null;
          status: ProjectActivityStatusEnum;
          startTime: string;
          endTime: string;
          timeBasedStatus: ProjectActivityTimeBasedStatusEnum;
          completedAt?: string | null;
          colorCode: string;
          supervisor?: {
            __typename?: 'Employment';
            id: string;
            employee?: { __typename?: 'User'; id: string; firstName: string; lastName: string } | null;
          } | null;
          createdBy: {
            __typename?: 'Employment';
            id: string;
            employee?: { __typename?: 'User'; id: string; firstName: string; lastName: string } | null;
          };
        }>;
        projectSettings: Array<{ __typename?: 'ProjectSetting'; id: string; name: string; value: string }>;
        kickOffs?: Array<{
          __typename?: 'ProjectKickOffs';
          id: string;
          createdAt: string;
          emails?: Array<string> | null;
          title?: string | null;
          status: KickOffStatusEnum;
          data?: {
            __typename?: 'KickOffData';
            projectId?: string | null;
            projectCode?: string | null;
            projectTitle?: string | null;
            clientId?: string | null;
            clientName?: string | null;
            clientCompanyNumber?: string | null;
            clientReps?: Array<any> | null;
            addresses?: Array<any> | null;
            notes?: Array<any> | null;
            newTemplate?: boolean | null;
            projectDetails?: {
              __typename?: 'KickOffProjectDetails';
              managers?: Array<any> | null;
              activities?: Array<any> | null;
              projectTagIds?: Array<string> | null;
              contractTypeIds?: Array<string> | null;
              projectSettings?: Array<any> | null;
            } | null;
          } | null;
          project?: { __typename?: 'Project'; title: string; code: string } | null;
          initiator: { __typename?: 'User'; id: string; firstName: string; lastName: string };
        }> | null;
      } | null;
    } | null> | null;
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string | null;
    };
  } | null;
};

export type GetProjectsFiltersQueryVariables = Exact<{ [key: string]: never }>;

export type GetProjectsFiltersQuery = {
  __typename?: 'Query';
  getProjectFilters: {
    __typename?: 'ProjectFilters';
    statuses?: Array<string> | null;
    people?: Array<{ __typename?: 'Employment'; id: string; name?: string | null }> | null;
    clients?: Array<{ __typename?: 'Client'; id: string; name: string; companyNumber: string }> | null;
  };
};

export type GetProjectsForFunnelQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
  clientId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetProjectsForFunnelQuery = {
  __typename?: 'Query';
  getProjects?: {
    __typename?: 'ProjectConnection';
    edges?: Array<{
      __typename?: 'ProjectEdge';
      cursor: string;
      node?: {
        __typename?: 'Project';
        id: string;
        title: string;
        code: string;
        attachments: Array<{
          __typename?: 'Attachment';
          id: string;
          signedBlobId?: string | null;
          previewUrl: string;
          filename: string;
          byteSize: number;
          createdAt?: RawDate | null;
          associationType?: AssociationTypeEnum | null;
          tags?: Array<{ __typename?: 'CompanyTag'; title: string }> | null;
        }>;
      } | null;
    } | null> | null;
  } | null;
};

export type GetProjectsForSchedulerQueryVariables = Exact<{
  status?: InputMaybe<Array<ProjectStatusEnum> | ProjectStatusEnum>;
  singleOutProjectId?: InputMaybe<Scalars['ID']['input']>;
  projectIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  tagIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  searchBy?: InputMaybe<Scalars['String']['input']>;
  clientIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
  issueIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  issueSearch?: InputMaybe<Scalars['String']['input']>;
  eventSearch?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetProjectsForSchedulerQuery = {
  __typename?: 'Query';
  getProjectsForScheduling?: Array<{
    __typename?: 'SchedulerProject';
    id: string;
    name: string;
    code: string;
    status: ProjectStatusEnum;
    enableWeekends: boolean;
    shifts?: string | null;
    holidays?: string | null;
    mainAddress?: {
      __typename?: 'Address';
      id: string;
      title?: string | null;
      street: string;
      city: string;
      state: string;
      zip: string;
      country: string;
      locationType: AddressLocationTypeEnum;
    } | null;
    subLocations: Array<{
      __typename?: 'Address';
      id: string;
      title?: string | null;
      street: string;
      city: string;
      state: string;
      zip: string;
      country: string;
      locationType: AddressLocationTypeEnum;
    }>;
  }> | null;
};

export type GetProjectsWithKickOffsQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;

export type GetProjectsWithKickOffsQuery = {
  __typename?: 'Query';
  getProjectsWithKickoffs?: Array<{
    __typename?: 'Project';
    id: string;
    title: string;
    companyId: string;
    endDate?: string | null;
    status: ProjectStatusEnum;
    code: string;
    startDate?: string | null;
    createdAt: string;
    updatedAt: string;
    pointOfContacts?: Array<{
      __typename?: 'ProjectUser';
      id: string;
      title: string;
      companyResource?: {
        __typename?: 'CompanyResource';
        name: string;
        resourceType: CompanyResourceResourceTypeEnum;
        resourceMeta?: {
          __typename?: 'ResourceMeta';
          id: string;
          email?: string | null;
          primaryPhone?: string | null;
          bio?: string | null;
          quantity?: string | null;
          unit?: string | null;
          expiryDate?: string | null;
          batchNumber?: string | null;
          currentLocation?: string | null;
          nextServiceDate?: string | null;
          insuranceExpiryDate?: string | null;
          permitExpiryDate?: string | null;
          operatorRequirements?: string | null;
          capacity?: string | null;
          maxReach?: string | null;
          weightDimensions?: string | null;
          fuelType?: FuelTypeEnum | null;
          status?: ResourceMetaStatusTypeEnum | null;
          pointOfContact?: string | null;
          equipmentType?: string | null;
          shortCode?: string | null;
          serialNumber?: string | null;
          makeModel?: string | null;
          isScheduleable?: boolean | null;
          resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
        } | null;
        user?: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          primaryPhone?: string | null;
          defaultEmploymentStatus?: EmploymentStatusEnum | null;
        } | null;
      } | null;
    }> | null;
    managers?: Array<{
      __typename?: 'ProjectUser';
      id: string;
      title: string;
      user?: {
        __typename?: 'User';
        id: string;
        name?: string | null;
        firstName: string;
        lastName: string;
        email: string;
        imageUrl?: string | null;
      } | null;
      companyResource?: {
        __typename?: 'CompanyResource';
        name: string;
        resourceType: CompanyResourceResourceTypeEnum;
        resourceMeta?: {
          __typename?: 'ResourceMeta';
          id: string;
          email?: string | null;
          primaryPhone?: string | null;
          bio?: string | null;
          quantity?: string | null;
          unit?: string | null;
          expiryDate?: string | null;
          batchNumber?: string | null;
          currentLocation?: string | null;
          nextServiceDate?: string | null;
          insuranceExpiryDate?: string | null;
          permitExpiryDate?: string | null;
          operatorRequirements?: string | null;
          capacity?: string | null;
          maxReach?: string | null;
          weightDimensions?: string | null;
          fuelType?: FuelTypeEnum | null;
          status?: ResourceMetaStatusTypeEnum | null;
          pointOfContact?: string | null;
          equipmentType?: string | null;
          shortCode?: string | null;
          serialNumber?: string | null;
          makeModel?: string | null;
          isScheduleable?: boolean | null;
          resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
        } | null;
        user?: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          primaryPhone?: string | null;
          defaultEmploymentStatus?: EmploymentStatusEnum | null;
        } | null;
      } | null;
    }> | null;
    client?: { __typename?: 'Client'; id: string; name: string } | null;
    mainAddress?: {
      __typename?: 'Address';
      id: string;
      street: string;
      city: string;
      state: string;
      zip: string;
      country: string;
    } | null;
  }> | null;
};

export type GetReportQueryVariables = Exact<{
  reportId?: InputMaybe<Scalars['ID']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  reportDate?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetReportQuery = {
  __typename?: 'Query';
  getReport?: {
    __typename?: 'Report';
    id: string;
    reportDate: string;
    submittedOn?: RawDate | null;
    approvalDate?: RawDate | null;
    approved: boolean;
    createdAt: RawDate;
    updatedAt: RawDate;
    weather?: string | null;
    deliveryAndCollection?: Array<{
      __typename?: 'DeliveryItemsView';
      id: string;
      supplier: string;
      notes?: string | null;
      currentState: DeliveryAndCollectionItemStateEnum;
      delivererName: string;
      receiverName: string;
      imageUrls?: Array<string> | null;
      documentUrls?: Array<string> | null;
      actor: { __typename?: 'User'; id: string; firstName: string; lastName: string; email: string };
      item: {
        __typename?: 'DeliveryAndCollectionRegisterItem';
        id: string;
        quantity: string;
        companyResource: {
          __typename?: 'CompanyResource';
          id: string;
          name: string;
          resourceType: CompanyResourceResourceTypeEnum;
          resourceMeta?: {
            __typename?: 'ResourceMeta';
            id: string;
            email?: string | null;
            primaryPhone?: string | null;
            bio?: string | null;
            quantity?: string | null;
            unit?: string | null;
            expiryDate?: string | null;
            batchNumber?: string | null;
            currentLocation?: string | null;
            nextServiceDate?: string | null;
            insuranceExpiryDate?: string | null;
            permitExpiryDate?: string | null;
            operatorRequirements?: string | null;
            capacity?: string | null;
            maxReach?: string | null;
            weightDimensions?: string | null;
            fuelType?: FuelTypeEnum | null;
            status?: ResourceMetaStatusTypeEnum | null;
            pointOfContact?: string | null;
            equipmentType?: string | null;
            shortCode?: string | null;
            serialNumber?: string | null;
            makeModel?: string | null;
            isScheduleable?: boolean | null;
            resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
          } | null;
        };
      };
    }> | null;
    approvedBy?: {
      __typename?: 'Employment';
      id: string;
      employee?: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        email: string;
        primaryPhone?: string | null;
      } | null;
    } | null;
    issues?: Array<{
      __typename?: 'Issue';
      createdAt?: string | null;
      headline: string;
      description: string;
      id: string;
      issueType: IssueTypeEnum;
      imageUrls?: Array<string> | null;
      documentUrls?: Array<string> | null;
      categories: Array<{ __typename?: 'IssueCategory'; id: string; name: string }>;
    }> | null;
    project: {
      __typename?: 'Project';
      id: string;
      title: string;
      hasSubLocations?: boolean | null;
      archived: boolean;
      code: string;
      client?: { __typename?: 'Client'; id: string; name: string } | null;
      projectSettings: Array<{ __typename?: 'ProjectSetting'; id: string; name: string; value: string }>;
    };
    reporter: {
      __typename?: 'Employment';
      id: string;
      employee?: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        email: string;
        primaryPhone?: string | null;
      } | null;
    };
    peopleRegisters: Array<{
      __typename?: 'Schedule';
      id: string;
      startTime: string;
      endTime: string;
      source?: string | null;
      status: ResourceScheduleStatusEnum;
      title?: string | null;
      address?: {
        __typename?: 'Address';
        city: string;
        country: string;
        id: string;
        locationType: AddressLocationTypeEnum;
        state: string;
        street: string;
        title?: string | null;
        zip: string;
      } | null;
      project: {
        __typename?: 'Project';
        id: string;
        title: string;
        code: string;
        mainAddress?: {
          __typename?: 'Address';
          id: string;
          street: string;
          city: string;
          state: string;
          zip: string;
          country: string;
          locationType: AddressLocationTypeEnum;
        } | null;
        subLocations?: Array<{
          __typename?: 'Address';
          id: string;
          title?: string | null;
          street: string;
          city: string;
          state: string;
          zip: string;
          country: string;
        }> | null;
      };
      companyResource?: {
        __typename?: 'CompanyResource';
        id: string;
        name: string;
        resourceType: CompanyResourceResourceTypeEnum;
        resourceMeta?: {
          __typename?: 'ResourceMeta';
          id: string;
          email?: string | null;
          primaryPhone?: string | null;
          bio?: string | null;
          quantity?: string | null;
          unit?: string | null;
          expiryDate?: string | null;
          batchNumber?: string | null;
          currentLocation?: string | null;
          nextServiceDate?: string | null;
          insuranceExpiryDate?: string | null;
          permitExpiryDate?: string | null;
          operatorRequirements?: string | null;
          capacity?: string | null;
          maxReach?: string | null;
          weightDimensions?: string | null;
          fuelType?: FuelTypeEnum | null;
          status?: ResourceMetaStatusTypeEnum | null;
          pointOfContact?: string | null;
          equipmentType?: string | null;
          shortCode?: string | null;
          serialNumber?: string | null;
          makeModel?: string | null;
          isScheduleable?: boolean | null;
          resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
        } | null;
        user?: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          primaryPhone?: string | null;
          defaultEmploymentStatus?: EmploymentStatusEnum | null;
        } | null;
      } | null;
    }>;
    equipmentRegisters: Array<{
      __typename?: 'Schedule';
      id: string;
      startTime: string;
      endTime: string;
      quantity?: number | null;
      source?: string | null;
      status: ResourceScheduleStatusEnum;
      address?: {
        __typename?: 'Address';
        city: string;
        country: string;
        id: string;
        locationType: AddressLocationTypeEnum;
        state: string;
        street: string;
        title?: string | null;
        zip: string;
      } | null;
      project: {
        __typename?: 'Project';
        id: string;
        title: string;
        code: string;
        mainAddress?: {
          __typename?: 'Address';
          id: string;
          street: string;
          city: string;
          state: string;
          zip: string;
          country: string;
          locationType: AddressLocationTypeEnum;
        } | null;
        subLocations?: Array<{
          __typename?: 'Address';
          id: string;
          title?: string | null;
          street: string;
          city: string;
          state: string;
          zip: string;
          country: string;
        }> | null;
      };
      companyResource?: {
        __typename?: 'CompanyResource';
        id: string;
        name: string;
        resourceType: CompanyResourceResourceTypeEnum;
        resourceMeta?: {
          __typename?: 'ResourceMeta';
          id: string;
          email?: string | null;
          primaryPhone?: string | null;
          bio?: string | null;
          quantity?: string | null;
          unit?: string | null;
          expiryDate?: string | null;
          batchNumber?: string | null;
          currentLocation?: string | null;
          nextServiceDate?: string | null;
          insuranceExpiryDate?: string | null;
          permitExpiryDate?: string | null;
          operatorRequirements?: string | null;
          capacity?: string | null;
          maxReach?: string | null;
          weightDimensions?: string | null;
          fuelType?: FuelTypeEnum | null;
          status?: ResourceMetaStatusTypeEnum | null;
          pointOfContact?: string | null;
          equipmentType?: string | null;
          shortCode?: string | null;
          serialNumber?: string | null;
          makeModel?: string | null;
          isScheduleable?: boolean | null;
          resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
        } | null;
      } | null;
    }>;
    subContractorRegisters: Array<{
      __typename?: 'Schedule';
      id: string;
      date: string;
      startTime: string;
      endTime: string;
      status: ResourceScheduleStatusEnum;
      descriptionOfService?: string | null;
      project: {
        __typename?: 'Project';
        id: string;
        title: string;
        code: string;
        mainAddress?: {
          __typename?: 'Address';
          id: string;
          street: string;
          city: string;
          state: string;
          zip: string;
          country: string;
          locationType: AddressLocationTypeEnum;
        } | null;
        subLocations?: Array<{
          __typename?: 'Address';
          id: string;
          title?: string | null;
          street: string;
          city: string;
          state: string;
          zip: string;
          country: string;
        }> | null;
      };
      companyResource?: {
        __typename?: 'CompanyResource';
        id: string;
        name: string;
        resourceType: CompanyResourceResourceTypeEnum;
        resourceMeta?: {
          __typename?: 'ResourceMeta';
          id: string;
          email?: string | null;
          primaryPhone?: string | null;
          bio?: string | null;
          quantity?: string | null;
          unit?: string | null;
          expiryDate?: string | null;
          batchNumber?: string | null;
          currentLocation?: string | null;
          nextServiceDate?: string | null;
          insuranceExpiryDate?: string | null;
          permitExpiryDate?: string | null;
          operatorRequirements?: string | null;
          capacity?: string | null;
          maxReach?: string | null;
          weightDimensions?: string | null;
          fuelType?: FuelTypeEnum | null;
          status?: ResourceMetaStatusTypeEnum | null;
          pointOfContact?: string | null;
          equipmentType?: string | null;
          shortCode?: string | null;
          serialNumber?: string | null;
          makeModel?: string | null;
          isScheduleable?: boolean | null;
          resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
        } | null;
        subContractor?: {
          __typename?: 'SubContractor';
          hasFutureSchedules?: boolean | null;
          id: string;
          imageUrl: string;
          isParent: boolean;
          name: string;
        } | null;
      } | null;
      address?: {
        __typename?: 'Address';
        id: string;
        street: string;
        city: string;
        state: string;
        zip: string;
        country: string;
        title?: string | null;
      } | null;
    }>;
  } | null;
};

export type GetReportForSelectedDateQueryVariables = Exact<{
  reportDate: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
}>;

export type GetReportForSelectedDateQuery = {
  __typename?: 'Query';
  getReportForSubmission?: {
    __typename?: 'Report';
    id: string;
    approved: boolean;
    createdAt: RawDate;
    reportDate: string;
    stage: string;
    updatedAt: RawDate;
    weather?: string | null;
    projectId: string;
    hasIssues?: boolean | null;
    hasEquipmentRegisters?: boolean | null;
    hasPeopleRegisters?: boolean | null;
  } | null;
};

export type GetReportIssuesQueryVariables = Exact<{
  reportId: Scalars['ID']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetReportIssuesQuery = {
  __typename?: 'Query';
  getReportIssues: Array<{
    __typename?: 'Issue';
    id: string;
    issueType: IssueTypeEnum;
    flagged?: boolean | null;
    startTime: string;
    endTime: string;
    headline: string;
    description: string;
    createdAt?: string | null;
    updatedAt?: string | null;
    imageUrls?: Array<string> | null;
    categories: Array<{ __typename?: 'IssueCategory'; id: string; name: string }>;
  }>;
};

export type GetRepresentativesByClientQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
}>;

export type GetRepresentativesByClientQuery = {
  __typename?: 'Query';
  getRepresentativesByClient?: Array<{
    __typename?: 'CompanyResource';
    id: string;
    name: string;
    resourceType: CompanyResourceResourceTypeEnum;
    resourceMeta?: {
      __typename?: 'ResourceMeta';
      id: string;
      email?: string | null;
      primaryPhone?: string | null;
      bio?: string | null;
      quantity?: string | null;
      unit?: string | null;
      expiryDate?: string | null;
      batchNumber?: string | null;
      currentLocation?: string | null;
      nextServiceDate?: string | null;
      insuranceExpiryDate?: string | null;
      permitExpiryDate?: string | null;
      operatorRequirements?: string | null;
      capacity?: string | null;
      maxReach?: string | null;
      weightDimensions?: string | null;
      fuelType?: FuelTypeEnum | null;
      status?: ResourceMetaStatusTypeEnum | null;
      pointOfContact?: string | null;
      equipmentType?: string | null;
      shortCode?: string | null;
      serialNumber?: string | null;
      makeModel?: string | null;
      isScheduleable?: boolean | null;
      resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
    } | null;
  }> | null;
};

export type GetResourceCategoriesQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;

export type GetResourceCategoriesQuery = {
  __typename?: 'Query';
  getResourceCategories: Array<{ __typename?: 'ResourceCategory'; id?: string | null; name: string }>;
};

export type GetResourcesForSchedulerQueryVariables = Exact<{
  resourceType: Scalars['String']['input'];
  searchBy?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetResourcesForSchedulerQuery = {
  __typename?: 'Query';
  getResourcesForScheduler: {
    __typename?: 'SchedulerResourceConnection';
    totalCount?: number | null;
    nodes?: Array<{
      __typename?: 'SchedulerResource';
      id: string;
      name: string;
      resourceType: string;
      description?: string | null;
    } | null> | null;
    pageInfo: { __typename?: 'PageInfo'; hasNextPage: boolean; endCursor?: string | null };
  };
};

export type GetRolesQueryVariables = Exact<{ [key: string]: never }>;

export type GetRolesQuery = {
  __typename?: 'Query';
  getRoles: Array<{
    __typename?: 'Role';
    id: string;
    name: string;
    description?: string | null;
    membersCount: number;
    grants: Array<{ __typename?: 'AccessGrantPair'; action: PermissionActionEnum; entity: PermissionEntityEnum }>;
    members: Array<{ __typename?: 'Employment'; id: string; fullName?: string | null; imageUrl?: string | null }>;
  }>;
};

export type GetSchedulableCompanyEquipmentsQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
  searchBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetSchedulableCompanyEquipmentsQuery = {
  __typename?: 'Query';
  getSchedulableCompanyEquipments: Array<{
    __typename?: 'CompanyEquipment';
    id: string;
    name: string;
    quantity?: string | null;
    category: string;
    shortCode: string;
    unit: string;
    uuid: string;
    equipmentType: string;
    resourceCategory?: { __typename?: 'ResourceCategory'; name: string } | null;
  }>;
};

export type GetSchedulableEmployeesQueryVariables = Exact<{
  companyId: Scalars['ID']['input'];
  searchBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetSchedulableEmployeesQuery = {
  __typename?: 'Query';
  getSchedulableEmployees?: Array<{
    __typename?: 'User';
    id: string;
    email: string;
    firstName: string;
    lastName: string;
  }> | null;
};

export type GetScheduleForEditQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetScheduleForEditQuery = {
  __typename?: 'Query';
  getScheduleForEdit?: {
    __typename?: 'ScheduleForEdit';
    id: string;
    resourceId?: string | null;
    resourceName?: string | null;
    resourceType: string;
    date: string;
    startTime: string;
    endTime: string;
    addressId?: string | null;
    source?: string | null;
    title?: string | null;
    onHire?: boolean | null;
    descriptionOfService?: string | null;
    customShift?: boolean | null;
  } | null;
};

export type GetScheduledSubContractorsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  date?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetScheduledSubContractorsQuery = {
  __typename?: 'Query';
  getScheduledSubContractors?: Array<{
    __typename?: 'SubContractorSchedule';
    id: string;
    date: string;
    startTime: string;
    endTime: string;
    status: string;
    descriptionOfService: string;
    subContractor: { __typename?: 'SubContractor'; id: string; name: string };
    principalContact: { __typename?: 'User'; id: string; firstName: string; lastName: string; email: string };
    address: {
      __typename?: 'Address';
      id: string;
      street: string;
      city: string;
      state: string;
      zip: string;
      country: string;
      title?: string | null;
    };
  }> | null;
};

export type GetSchedulerFilterOptionsQueryVariables = Exact<{ [key: string]: never }>;

export type GetSchedulerFilterOptionsQuery = {
  __typename?: 'Query';
  getSchedulerFilterOptions: {
    __typename?: 'SchedulerFilterOptions';
    cities: Array<string>;
    zips: Array<string>;
    clients: Array<{ __typename?: 'SchedulerFilterClient'; id: string; name: string }>;
    issues: Array<{ __typename?: 'SchedulerFilterIssue'; id: string; description: string }>;
  };
};

export type GetSchedulesQueryVariables = Exact<{
  date?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['ID']['input']>;
  dateRange?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  resourceType?: InputMaybe<CompanyResourceResourceTypeEnum>;
}>;

export type GetSchedulesQuery = {
  __typename?: 'Query';
  getSchedules?: Array<{
    __typename?: 'Schedule';
    id: string;
    endTime: string;
    startTime: string;
    status: ResourceScheduleStatusEnum;
    date: string;
    title?: string | null;
    source?: string | null;
    collectable?: boolean | null;
    quantity?: number | null;
    descriptionOfService?: string | null;
    onHire?: boolean | null;
    customShift?: boolean | null;
    hasConflicts: boolean;
    project: {
      __typename?: 'Project';
      id: string;
      title: string;
      code: string;
      mainAddress?: {
        __typename?: 'Address';
        id: string;
        street: string;
        city: string;
        state: string;
        zip: string;
        country: string;
        locationType: AddressLocationTypeEnum;
      } | null;
      subLocations?: Array<{
        __typename?: 'Address';
        id: string;
        title?: string | null;
        street: string;
        city: string;
        state: string;
        zip: string;
        country: string;
      }> | null;
    };
    companyResource?: {
      __typename?: 'CompanyResource';
      id: string;
      name: string;
      resourceType: CompanyResourceResourceTypeEnum;
      resourceMeta?: {
        __typename?: 'ResourceMeta';
        id: string;
        email?: string | null;
        primaryPhone?: string | null;
        bio?: string | null;
        quantity?: string | null;
        unit?: string | null;
        expiryDate?: string | null;
        batchNumber?: string | null;
        currentLocation?: string | null;
        nextServiceDate?: string | null;
        insuranceExpiryDate?: string | null;
        permitExpiryDate?: string | null;
        operatorRequirements?: string | null;
        capacity?: string | null;
        maxReach?: string | null;
        weightDimensions?: string | null;
        fuelType?: FuelTypeEnum | null;
        status?: ResourceMetaStatusTypeEnum | null;
        pointOfContact?: string | null;
        equipmentType?: string | null;
        shortCode?: string | null;
        serialNumber?: string | null;
        makeModel?: string | null;
        isScheduleable?: boolean | null;
        resourceCategory?: { __typename?: 'ResourceCategory'; id?: string | null; name: string } | null;
      } | null;
      subContractor?: {
        __typename?: 'SubContractor';
        hasFutureSchedules?: boolean | null;
        id: string;
        imageUrl: string;
        isParent: boolean;
        name: string;
        principalContact?: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          primaryPhone?: string | null;
        } | null;
      } | null;
      user?: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        email: string;
        primaryPhone?: string | null;
        defaultEmploymentStatus?: EmploymentStatusEnum | null;
      } | null;
    } | null;
    address?: {
      __typename?: 'Address';
      id: string;
      street: string;
      city: string;
      state: string;
      zip: string;
      country: string;
      title?: string | null;
      locationType: AddressLocationTypeEnum;
    } | null;
  }> | null;
};

export type GetSchedulesForSchedulerQueryVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  projectId?: InputMaybe<Scalars['ID']['input']>;
}>;

export type GetSchedulesForSchedulerQuery = {
  __typename?: 'Query';
  getSchedulesForScheduler: Array<{
    __typename?: 'SchedulerSchedule';
    id: string;
    projectId: string;
    resourceId: string;
    resourceType: string;
    startDate: string;
    endDate: string;
    name?: string | null;
    source?: string | null;
    title?: string | null;
    onHire?: boolean | null;
    descriptionOfService?: string | null;
    startTime?: string | null;
    endTime?: string | null;
    status?: string | null;
  }>;
};

export type GetSharepointDrivesQueryVariables = Exact<{
  siteId: Scalars['String']['input'];
}>;

export type GetSharepointDrivesQuery = {
  __typename?: 'Query';
  getSharepointDrives: Array<{
    __typename?: 'SharepointDrive';
    id: string;
    name?: string | null;
    driveType?: string | null;
    webUrl?: string | null;
  }>;
};

export type GetSharepointFileMetadataQueryVariables = Exact<{
  driveId: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
}>;

export type GetSharepointFileMetadataQuery = {
  __typename?: 'Query';
  getSharepointFileMetadata?: {
    __typename?: 'SharepointFile';
    id: string;
    name: string;
    size?: number | null;
    lastModified?: string | null;
    mimeType?: string | null;
    isFolder: boolean;
    type: SharepointNodeTypeEnum;
    webUrl?: string | null;
    downloadUrl?: string | null;
  } | null;
};

export type GetSharepointFilesQueryVariables = Exact<{
  driveId: Scalars['String']['input'];
  itemId?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetSharepointFilesQuery = {
  __typename?: 'Query';
  getSharepointFiles: Array<{
    __typename?: 'SharepointFile';
    id: string;
    name: string;
    size?: number | null;
    lastModified?: string | null;
    mimeType?: string | null;
    isFolder: boolean;
    type: SharepointNodeTypeEnum;
    webUrl?: string | null;
    downloadUrl?: string | null;
  }>;
};

export type GetSharepointSitesQueryVariables = Exact<{
  searchQuery?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetSharepointSitesQuery = {
  __typename?: 'Query';
  getSharepointSites: Array<{
    __typename?: 'SharepointSite';
    id: string;
    name?: string | null;
    webUrl?: string | null;
    displayName?: string | null;
  }>;
};

export type GetSubContractorsQueryVariables = Exact<{
  searchBy?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetSubContractorsQuery = {
  __typename?: 'Query';
  getSubContractors: {
    __typename?: 'CompanySubContractorConnection';
    totalCount?: number | null;
    edges?: Array<{
      __typename?: 'CompanySubContractorEdge';
      node?: {
        __typename?: 'CompanySubContractor';
        subContractor: {
          __typename?: 'SubContractor';
          id: string;
          name: string;
          hasFutureSchedules?: boolean | null;
          principalContact?: {
            __typename?: 'User';
            id: string;
            firstName: string;
            lastName: string;
            email: string;
            primaryPhone?: string | null;
          } | null;
        };
      } | null;
    } | null> | null;
    nodes?: Array<{
      __typename?: 'CompanySubContractor';
      subContractor: {
        __typename?: 'SubContractor';
        id: string;
        name: string;
        primaryEmail: string;
        primaryPhone?: string | null;
        principalContact?: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          primaryPhone?: string | null;
        } | null;
      };
    } | null> | null;
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string | null;
    };
  };
};

export type GetTagsForSchedulerQueryVariables = Exact<{ [key: string]: never }>;

export type GetTagsForSchedulerQuery = {
  __typename?: 'Query';
  getCompanyTags: Array<{ __typename?: 'CompanyTag'; id: string; title: string }>;
};

export type GetTaskQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;

export type GetTaskQuery = {
  __typename?: 'Query';
  getTask?: {
    __typename?: 'Task';
    id: string;
    title: string;
    description?: string | null;
    status: TaskStatusEnum;
    priority: TaskPriorityEnum;
    dueDate?: RawDate | null;
    entityType?: string | null;
    entityId?: string | null;
    entityName: string;
    imageUrls?: Array<string> | null;
    createdAt: string;
    updatedAt: string;
    assignee: {
      __typename?: 'Employment';
      id: string;
      employee?: { __typename?: 'User'; id: string; firstName: string; lastName: string; email: string } | null;
    };
    creator: {
      __typename?: 'Employment';
      id: string;
      employee?: { __typename?: 'User'; id: string; firstName: string; lastName: string; email: string } | null;
    };
    attachments: Array<{
      __typename?: 'Attachment';
      id: string;
      signedBlobId?: string | null;
      previewUrl: string;
      filename: string;
      byteSize: number;
      createdAt?: RawDate | null;
      associationType?: AssociationTypeEnum | null;
      tags?: Array<{ __typename?: 'CompanyTag'; title: string }> | null;
    }>;
  } | null;
};

export type GetTaskCommentsQueryVariables = Exact<{
  taskId: Scalars['ID']['input'];
}>;

export type GetTaskCommentsQuery = {
  __typename?: 'Query';
  getTaskComments: Array<{
    __typename?: 'TaskComment';
    id: string;
    content: string;
    isEdited: boolean;
    createdAt: string;
    updatedAt: string;
    employment: {
      __typename?: 'Employment';
      id: string;
      employee?: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        email: string;
        imageUrl?: string | null;
      } | null;
    };
    reactions?: Array<{
      __typename?: 'CommentReaction';
      emoji: string;
      employments: Array<{
        __typename?: 'Employment';
        id: string;
        employee?: { __typename?: 'User'; id: string; firstName: string; lastName: string } | null;
      }>;
    }> | null;
    replies: Array<{
      __typename?: 'TaskComment';
      id: string;
      content: string;
      isEdited: boolean;
      createdAt: string;
      updatedAt: string;
      employment: {
        __typename?: 'Employment';
        id: string;
        employee?: {
          __typename?: 'User';
          id: string;
          firstName: string;
          lastName: string;
          email: string;
          imageUrl?: string | null;
        } | null;
      };
      reactions?: Array<{
        __typename?: 'CommentReaction';
        emoji: string;
        employments: Array<{
          __typename?: 'Employment';
          id: string;
          employee?: { __typename?: 'User'; id: string; firstName: string; lastName: string } | null;
        }>;
      }> | null;
    }>;
  }>;
};

export type GetTasksQueryVariables = Exact<{
  createdById?: InputMaybe<Scalars['ID']['input']>;
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  entity?: InputMaybe<TaskEntity>;
  dueDateFrom?: InputMaybe<Scalars['String']['input']>;
  dueDateTo?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetTasksQuery = {
  __typename?: 'Query';
  getTasks: Array<{
    __typename?: 'Task';
    id: string;
    title: string;
    entityName: string;
    description?: string | null;
    status: TaskStatusEnum;
    priority: TaskPriorityEnum;
    dueDate?: RawDate | null;
    assignee: {
      __typename?: 'Employment';
      id: string;
      employee?: {
        __typename?: 'User';
        id: string;
        firstName: string;
        lastName: string;
        email: string;
        imageUrl?: string | null;
      } | null;
    };
    creator: {
      __typename?: 'Employment';
      id: string;
      employee?: { __typename?: 'User'; id: string; firstName: string; lastName: string; email: string } | null;
    };
  }>;
};

export type GetUnapprovedReportsQueryVariables = Exact<{
  stage?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type GetUnapprovedReportsQuery = {
  __typename?: 'Query';
  getCompanyReports: {
    __typename?: 'ReportConnection';
    totalCount?: number | null;
    edges?: Array<{
      __typename?: 'ReportEdge';
      cursor: string;
      node?: {
        __typename?: 'Report';
        id: string;
        approvalDate?: RawDate | null;
        createdAt: RawDate;
        reportDate: string;
        stage: string;
        updatedAt: RawDate;
        weather?: string | null;
        project: { __typename?: 'Project'; id: string; title: string };
        reporter: {
          __typename?: 'Employment';
          id: string;
          employee?: { __typename?: 'User'; firstName: string; lastName: string; email: string } | null;
        };
        issues?: Array<{
          __typename?: 'Issue';
          id: string;
          description: string;
          issueType: IssueTypeEnum;
          categories: Array<{ __typename?: 'IssueCategory'; id: string; name: string }>;
        }> | null;
      } | null;
    } | null> | null;
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null;
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string | null;
    };
  };
};

export type GetUserNotificationsQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserNotificationsQuery = {
  __typename?: 'Query';
  getUserNotifications?: Array<{
    __typename?: 'Notification';
    id: string;
    read: boolean;
    text: string;
    targetType?: string | null;
    targetId?: string | null;
    priority: NotificationPriorityEnum;
    isMentioned: boolean;
    createdAt?: RawDate | null;
    customShiftDetails?: {
      __typename?: 'CustomShiftNotificationDetails';
      scheduleId: string;
      projectId: string;
      projectName: string;
      date?: string | null;
      startTime: string;
      endTime: string;
      canApprove: boolean;
      existingShifts: Array<{ __typename?: 'ProjectShift'; name: string; startTime: string; endTime: string }>;
    } | null;
  }> | null;
};

export type UserSettingsQueryVariables = Exact<{ [key: string]: never }>;

export type UserSettingsQuery = {
  __typename?: 'Query';
  userSettings?: {
    __typename?: 'UserSetting';
    taskPreferences: string;
    dateTimePreference: string;
    projectOrder: Array<{ __typename?: 'ItemOrder'; i: string; x: number; y: number; h: number; w: number }>;
    widgetLayout: Array<{
      __typename?: 'ItemOrder';
      h: number;
      i: string;
      maxH?: number | null;
      maxW?: number | null;
      minH?: number | null;
      minW?: number | null;
      w: number;
      x: number;
      y: number;
    }>;
  } | null;
};

export type GetIssueCategoriesQueryVariables = Exact<{
  dynamic: Scalars['Boolean']['input'];
}>;

export type GetIssueCategoriesQuery = {
  __typename?: 'Query';
  getIssueCategories: Array<{ __typename?: 'IssueCategory'; id: string; name: string }>;
};

export type MyAccessQueryVariables = Exact<{ [key: string]: never }>;

export type MyAccessQuery = {
  __typename?: 'Query';
  myAccess: Array<{
    __typename?: 'MyAccessGrant';
    action: PermissionActionEnum;
    entity: PermissionEntityEnum;
    projectIds?: Array<string> | null;
  }>;
};

export type VerifyEmailExistsQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;

export type VerifyEmailExistsQuery = { __typename?: 'Query'; verifyEmailExists: any };

export const AddressFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AddressFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Address' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddressFragmentFragment, unknown>;
export const AttachedFileFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachedFile' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Attachment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signedBlobId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'byteSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'associationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AttachedFileFragment, unknown>;
export const CompleteClientFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CompleteClientFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companyResources' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'resourceMeta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompleteClientFragmentFragment, unknown>;
export const CompleteEventFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CompleteEventFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approved' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ewnCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cenCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasActiveCeq' } },
          { kind: 'Field', name: { kind: 'Name', value: 'projectCurrency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderIndex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'occurredAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'employee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'project' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pointOfContacts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'companyResource' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resourceMeta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'resourceCategory' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'managers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'companyResource' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resourceMeta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'resourceCategory' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'client' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mainAddress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationType' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventSources' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'source' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Issue' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'categories' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'issueType' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventComments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompleteEventFragmentFragment, unknown>;
export const CompleteScheduleFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CompleteScheduleFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Schedule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'collectable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionOfService' } },
          { kind: 'Field', name: { kind: 'Name', value: 'onHire' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customShift' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'project' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mainAddress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationType' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companyResource' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'resourceMeta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resourceCategory' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subContractor' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasFutureSchedules' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isParent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'principalContact' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationType' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hasConflicts' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompleteScheduleFragmentFragment, unknown>;
export const RegisterDataFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegisterData' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DeliveryAndCollectionRegister' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'projectId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'companyResource' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resourceMeta' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resourceCategory' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'itemStates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'supplier' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reportId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'actor' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'delivererName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'receiverName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentStateSetAt' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RegisterDataFragment, unknown>;
export const RegisterItemStateFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegisterItemStateFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DeliveryAndCollectionItemState' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supplier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reportId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delivererName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiverName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStateSetAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'item' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'companyResource' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resourceMeta' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resourceCategory' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RegisterItemStateFragmentFragment, unknown>;
export const KickOffDataFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'kickOffDataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'KickOffData' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'projectId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'projectCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'projectTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientCompanyNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientReps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addresses' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTemplate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'projectDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'managers' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activities' } },
                { kind: 'Field', name: { kind: 'Name', value: 'projectTagIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contractTypeIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'projectSettings' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<KickOffDataFragmentFragment, unknown>;
export const ManagerFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'managerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProjectUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'employment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'employee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companyResource' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'resourceMeta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resourceCategory' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ManagerFieldsFragment, unknown>;
export const PocFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'pocFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProjectUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companyResource' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'resourceMeta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resourceCategory' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PocFieldsFragment, unknown>;
export const AcceptClientInvitationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'acceptClientInvitation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firstName' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'lastName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'acceptClientInvitation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'token' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'firstName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'firstName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'lastName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'lastName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'password' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AcceptClientInvitationMutation, AcceptClientInvitationMutationVariables>;
export const AcceptProjectInvitationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'acceptProjectInvitation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'company' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AcceptProjectInvitationCompany' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'user' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AcceptProjectInvitationUser' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'admin' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'AcceptProjectInvitationUser' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'acceptProjectInvitation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'token' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'company' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'company' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'user' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'user' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'admin' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'admin' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AcceptProjectInvitationMutation, AcceptProjectInvitationMutationVariables>;
export const CreateRoleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createRole' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'grants' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'AccessGrantPairInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createRole' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'description' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'grants' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'grants' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateRoleMutation, CreateRoleMutationVariables>;
export const UpdateRoleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateRole' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'grants' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'AccessGrantPairInput' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateRole' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'description' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'grants' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'grants' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'grants' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'entity' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateRoleMutation, UpdateRoleMutationVariables>;
export const DeleteRoleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteRole' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteRole' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteRoleMutation, DeleteRoleMutationVariables>;
export const AssignRoleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'assignRole' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'employmentId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'roleId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignRole' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'employmentId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'employmentId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'roleId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'roleId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssignRoleMutation, AssignRoleMutationVariables>;
export const UnassignRoleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'unassignRole' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'employmentId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'roleId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unassignRole' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'employmentId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'employmentId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'roleId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'roleId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UnassignRoleMutation, UnassignRoleMutationVariables>;
export const SetEmploymentGrantsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'setEmploymentGrants' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'employmentId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'grants' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'EmploymentGrantInput' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setEmploymentGrants' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'employmentId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'employmentId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'grants' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'grants' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'projectId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'validTill' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetEmploymentGrantsMutation, SetEmploymentGrantsMutationVariables>;
export const ResolveGrantRequestDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'resolveGrantRequest' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'approve' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'validTill' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ISO8601DateTime' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'additionalActions' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resolveGrantRequest' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'approve' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'approve' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'validTill' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'validTill' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'additionalActions' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'additionalActions' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResolveGrantRequestMutation, ResolveGrantRequestMutationVariables>;
export const ApproveCustomShiftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'approveCustomShift' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shiftName' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'notificationId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approveCustomShift' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scheduleId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'shiftName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'shiftName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'notificationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'notificationId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ApproveCustomShiftMutation, ApproveCustomShiftMutationVariables>;
export const ApproveEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'approveEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approveEvent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ApproveEventMutation, ApproveEventMutationVariables>;
export const AttachKickOffDocumentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'attachKickOffDocuments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'signedIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachKickOffDocuments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'signedIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'signedIds' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AttachKickOffDocumentsMutation, AttachKickOffDocumentsMutationVariables>;
export const BulkImportCompanyEquipmentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'bulkImportCompanyEquipments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'signedId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bulkImportCompanyEquipments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'signedId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'signedId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BulkImportCompanyEquipmentsMutation, BulkImportCompanyEquipmentsMutationVariables>;
export const BulkImportResourcesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'bulkImportResources' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'importType' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'signedId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bulkImportResources' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'importType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'importType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'signedId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'signedId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BulkImportResourcesMutation, BulkImportResourcesMutationVariables>;
export const BulkImportUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'bulkImportUsers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fileSignedId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bulkImportUsers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fileSignedId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'fileSignedId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BulkImportUsersMutation, BulkImportUsersMutationVariables>;
export const ChangeProjectStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'changeProjectStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'changeProjectStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ChangeProjectStatusMutation, ChangeProjectStatusMutationVariables>;
export const CompleteKickOffDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'completeKickOff' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'kickOffId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emails' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fileUrl' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'signedId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completeKickOff' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'kickOffId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'kickOffId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emails' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emails' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'fileUrl' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'fileUrl' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'signedId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'signedId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompleteKickOffMutation, CompleteKickOffMutationVariables>;
export const CreateAccessRequestDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createAccessRequest' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAccessRequest' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateAccessRequestMutation, CreateAccessRequestMutationVariables>;
export const CreateBillingPortalSessionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createBillingPortalSession' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'createBillingPortalSession' } }],
      },
    },
  ],
} as unknown as DocumentNode<CreateBillingPortalSessionMutation, CreateBillingPortalSessionMutationVariables>;
export const CreateBulkSchedulesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createBulkSchedules' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleData' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ScheduleCreate' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createBulkSchedules' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'schedules' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleData' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateBulkSchedulesMutation, CreateBulkSchedulesMutationVariables>;
export const CreateBulkUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createBulkUsers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'users' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UserCreate' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createBulkUsers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'users' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'users' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateBulkUsersMutation, CreateBulkUsersMutationVariables>;
export const CreateCeqDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createCeq' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cenId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCeq' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cenId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cenId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCeqMutation, CreateCeqMutationVariables>;
export const CreateCeqBillableItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createCeqBillableItem' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ceqId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resourceType' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resourceId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'unit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCeqBillableItem' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ceqId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ceqId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resourceType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resourceType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resourceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resourceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'unit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'unit' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCeqBillableItemMutation, CreateCeqBillableItemMutationVariables>;
export const CreateCeqSubEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createCeqSubEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ceqId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCeqSubEvent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ceqId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ceqId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cost' } },
                { kind: 'Field', name: { kind: 'Name', value: 'programmeImpact' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCeqSubEventMutation, CreateCeqSubEventMutationVariables>;
export const CreateCheckoutSessionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createCheckoutSession' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'interval' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'returnPath' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCheckoutSession' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'interval' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'interval' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'returnPath' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'returnPath' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCheckoutSessionMutation, CreateCheckoutSessionMutationVariables>;
export const CreateClientDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createClient' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'client' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ClientCreate' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createClient' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'client' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'client' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CompleteClientFragment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activeProjectsCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedProjectsCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cancelledProjectsCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'inFunnelCount' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CompleteClientFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Client' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companyResources' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'resourceMeta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateClientMutation, CreateClientMutationVariables>;
export const CreateClientInstructionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createClientInstructions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientInstruction' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ClientInstructionCreate' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createClientInstructions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'clientInstruction' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'clientInstruction' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateClientInstructionsMutation, CreateClientInstructionsMutationVariables>;
export const CreateClientInvitationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createClientInvitation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createClientInvitation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'clientId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateClientInvitationMutation, CreateClientInvitationMutationVariables>;
export const CreateCompanyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createCompany' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ownerId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'primaryPhone' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'primaryEmail' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isParent' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'street' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'city' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'state' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'country' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'zip' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyNumber' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tradingName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'vatNumber' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CompanyTypeEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'logoSignedId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCompany' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ownerId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ownerId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'primaryPhone' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'primaryPhone' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'primaryEmail' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'primaryEmail' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isParent' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isParent' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'street' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'street' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'city' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'city' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'state' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'state' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'country' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'country' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'zip' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'zip' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyNumber' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tradingName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tradingName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'vatNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'vatNumber' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'logoSignedId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'logoSignedId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCompanyMutation, CreateCompanyMutationVariables>;
export const CreateCompanyContractTypeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createCompanyContractType' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contractType' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CompanyContractTypeInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCompanyContractType' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contractType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'contractType' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contractTypeId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCompanyContractTypeMutation, CreateCompanyContractTypeMutationVariables>;
export const CreateCompanyEquipmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createCompanyEquipment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'shortCode' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'unit' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'quantity' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resourceCategoryId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isScheduleable' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'equipmentType' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'EquipmentTypeEnum' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCompanyEquipment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyEquipment' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'name' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'shortCode' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'shortCode' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'unit' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'unit' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'quantity' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'quantity' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'resourceCategoryId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'resourceCategoryId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'isScheduleable' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'isScheduleable' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'equipmentType' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'equipmentType' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCompanyEquipmentMutation, CreateCompanyEquipmentMutationVariables>;
export const CreateCompanyResourceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createCompanyResource' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyResource' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CompanyResourceCreate' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCompanyResource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyResource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyResource' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCompanyResourceMutation, CreateCompanyResourceMutationVariables>;
export const CreateCompanySettingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createCompanySetting' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'settingName' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'settingValue' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCompanySetting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'settingName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'value' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'settingValue' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCompanySettingMutation, CreateCompanySettingMutationVariables>;
export const CreateCompanyTagsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createCompanyTags' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyTags' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CompanyTagCreate' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCompanyTags' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyTags' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyTags' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCompanyTagsMutation, CreateCompanyTagsMutationVariables>;
export const CreateCompensationEventNoticeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createCompensationEventNotice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cen' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CompensationEventNoticeCreate' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCompensationEventNotice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cen' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cen' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateCompensationEventNoticeMutation, CreateCompensationEventNoticeMutationVariables>;
export const CreateCompensationEventQuotationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createCompensationEventQuotation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'quotation' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CompensationEventQuotationCreate' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createCompensationEventQuotation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'quotation' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'quotation' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateCompensationEventQuotationMutation,
  CreateCompensationEventQuotationMutationVariables
>;
export const CreateDeliveryAndCollectionRegisterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createDeliveryAndCollectionRegister' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deliveryAndCollectionRegister' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DeliveryAndCollectionRegisterCreate' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createDeliveryAndCollectionRegister' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'deliveryAndCollectionRegister' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'deliveryAndCollectionRegister' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegisterItemStateFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegisterItemStateFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DeliveryAndCollectionItemState' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supplier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reportId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delivererName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiverName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStateSetAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'item' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'companyResource' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resourceMeta' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resourceCategory' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateDeliveryAndCollectionRegisterMutation,
  CreateDeliveryAndCollectionRegisterMutationVariables
>;
export const CreateDirectUploadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createDirectUpload' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'DirectUploadCreate' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createDirectUpload' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'headers' } },
                { kind: 'Field', name: { kind: 'Name', value: 'blobId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'signedBlobId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateDirectUploadMutation, CreateDirectUploadMutationVariables>;
export const CreateEarlyWarningNoticeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createEarlyWarningNotice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ewn' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'EarlyWarningNoticeCreate' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createEarlyWarningNotice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ewn' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ewn' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateEarlyWarningNoticeMutation, CreateEarlyWarningNoticeMutationVariables>;
export const CreateEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'category' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EventCategoryEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventType' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'EventTypeEnum' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'flag' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventSourcesAttributes' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'EventSourceCreate' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'occurredAt' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createEvent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'event' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'projectId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'category' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'category' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'eventType' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'eventType' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'description' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'flag' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'flag' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'eventSourcesAttributes' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'eventSourcesAttributes' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'occurredAt' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'occurredAt' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CompleteEventFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CompleteEventFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approved' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ewnCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cenCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasActiveCeq' } },
          { kind: 'Field', name: { kind: 'Name', value: 'projectCurrency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderIndex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'occurredAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'employee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'project' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pointOfContacts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'companyResource' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resourceMeta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'resourceCategory' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'managers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'companyResource' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resourceMeta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'resourceCategory' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'client' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mainAddress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationType' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventSources' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'source' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Issue' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'categories' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'issueType' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventComments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateEventMutation, CreateEventMutationVariables>;
export const CreateEventCommentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createEventComment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createEventComment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'text' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'text' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateEventCommentMutation, CreateEventCommentMutationVariables>;
export const CreateFeedbackDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createFeedback' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'feedback' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'FeedbackCreate' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createFeedback' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'feedback' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'feedback' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateFeedbackMutation, CreateFeedbackMutationVariables>;
export const CreateGrantRequestDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createGrantRequest' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'action' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'entity' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'notes' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createGrantRequest' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'action' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'action' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entity' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'entity' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'notes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'notes' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateGrantRequestMutation, CreateGrantRequestMutationVariables>;
export const CreateHumanResourceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createHumanResource' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createHumanResource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateHumanResourceMutation, CreateHumanResourceMutationVariables>;
export const CreateIssueDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createIssue' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'issue' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IssueCreate' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createIssue' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'issue' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'issue' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateIssueMutation, CreateIssueMutationVariables>;
export const CreateKanbanColumnsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createKanbanColumns' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'columnId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createKanbanColumns' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'title' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'columnId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'columnId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateKanbanColumnsMutation, CreateKanbanColumnsMutationVariables>;
export const CreateKickOffDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createKickOff' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'JSON' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'templateId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createKickOff' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'kickOff' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'data' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'templateId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'templateId' } },
                    },
                  ],
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateKickOffMutation, CreateKickOffMutationVariables>;
export const CreateMeetingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createMeeting' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'meetingData' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateMeetingInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createMeeting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'meetingData' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'meetingData' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateMeetingMutation, CreateMeetingMutationVariables>;
export const CreateMeetingMinutesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createMeetingMinutes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'meetingId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'noteSections' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'JSON' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createMeetingMinutes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'meetingId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'meetingId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'noteSections' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'noteSections' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateMeetingMinutesMutation, CreateMeetingMinutesMutationVariables>;
export const CreateNotesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createNotes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'noteData' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NotesCreate' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createNotes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'noteData' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'noteData' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notesType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reminder' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrls' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AttachedFile' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachedFile' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Attachment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signedBlobId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'byteSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'associationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateNotesMutation, CreateNotesMutationVariables>;
export const CreateProjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createProject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientReps' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ClientRepInput' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'addresses' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'AddressInput' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sourceType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sourceId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectUsers' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ManagerCreate' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tagIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contractTypeIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'activities' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ActivityInput' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'settings' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProjectSettingsCreate' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'visible' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createProject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'project' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'code' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'description' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'startDate' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'endDate' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'clientReps' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'clientReps' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'clientId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'companyId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'addresses' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'addresses' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sourceType' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'sourceType' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sourceId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'sourceId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'projectUsers' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'projectUsers' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'tagIds' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'tagIds' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'contractTypeIds' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'contractTypeIds' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'activities' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'activities' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'settings' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'settings' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'visible' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'visible' } },
                    },
                  ],
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateProjectMutation, CreateProjectMutationVariables>;
export const CreateProjectActivityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createProjectActivity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectActivity' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProjectActivityCreate' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createProjectActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectActivity' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectActivity' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateProjectActivityMutation, CreateProjectActivityMutationVariables>;
export const CreateProjectTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createProjectTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectTemplate' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProjectTemplateCreate' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createProjectTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectTemplate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectTemplate' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateProjectTemplateMutation, CreateProjectTemplateMutationVariables>;
export const CreateReportIssueDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createReportIssue' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportIssue' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IssueCreate' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createReportIssue' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reportIssue' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportIssue' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'issueType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categories' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrls' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateReportIssueMutation, CreateReportIssueMutationVariables>;
export const CreateRepresentativeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createRepresentative' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'primaryPhone' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createRepresentative' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'representative' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'name' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'email' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'primaryPhone' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'primaryPhone' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'clientId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
                    },
                  ],
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateRepresentativeMutation, CreateRepresentativeMutationVariables>;
export const CreateResourceCategoryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createResourceCategory' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createResourceCategory' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resourceCategory' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'name' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'companyId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
                    },
                  ],
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateResourceCategoryMutation, CreateResourceCategoryMutationVariables>;
export const CreateResourceScheduleV2Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createResourceScheduleV2' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateResourceScheduleV2Input' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createResourceScheduleV2' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hasConflicts' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'schedules' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'projectId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resourceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'onHire' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'descriptionOfService' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateResourceScheduleV2Mutation, CreateResourceScheduleV2MutationVariables>;
export const ScheduleGuestUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'scheduleGuestUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleInfo' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'GuestUserScheduleCreate' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createGuestSchedule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resourceSchedule' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleInfo' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ScheduleGuestUserMutation, ScheduleGuestUserMutationVariables>;
export const CreateSingleScheduleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createSingleSchedule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleInfo' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ResourceScheduleCreate' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createSingleSchedule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resourceSchedule' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleInfo' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'scheduleId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasConflicts' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateSingleScheduleMutation, CreateSingleScheduleMutationVariables>;
export const CreateSubContractorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createSubContractor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subContractor' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SubContractorCreate' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createSubContractor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subContractor' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subContractor' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateSubContractorMutation, CreateSubContractorMutationVariables>;
export const CreateSubContractorInvitationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createSubContractorInvitation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyResourceId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createSubContractorInvitation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyResourceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyResourceId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateSubContractorInvitationMutation, CreateSubContractorInvitationMutationVariables>;
export const CreateSubContractorSchedulesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createSubContractorSchedules' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleData' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SubContractorScheduleCreate' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createSubContractorSchedules' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subContractorSchedule' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleData' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateSubContractorSchedulesMutation, CreateSubContractorSchedulesMutationVariables>;
export const CreateTaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createTask' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'task' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'TaskCreate' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'task' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'task' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateTaskMutation, CreateTaskMutationVariables>;
export const CreateTaskCommentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createTaskComment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'comment' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'TaskCommentInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createTaskComment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'comment' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'comment' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateTaskCommentMutation, CreateTaskCommentMutationVariables>;
export const CreateUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firstName' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'lastName' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'primaryPhone' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'bio' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyResourceId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'user' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'email' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'firstName' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'firstName' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'lastName' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'lastName' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'primaryPhone' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'primaryPhone' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'bio' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'bio' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'companyResourceId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'companyResourceId' } },
                    },
                  ],
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>;
export const CreateUserMergeRequestDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createUserMergeRequest' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sourceEmail' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createUserMergeRequest' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sourceEmail' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sourceEmail' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateUserMergeRequestMutation, CreateUserMergeRequestMutationVariables>;
export const CreateUserPasswordResetDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createUserPasswordReset' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'origin' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createUserPasswordReset' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'origin' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'origin' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateUserPasswordResetMutation, CreateUserPasswordResetMutationVariables>;
export const DestroyAttachmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'destroyAttachment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'destroyAttachment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DestroyAttachmentMutation, DestroyAttachmentMutationVariables>;
export const DestroyCompanyContractTypeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'destroyCompanyContractType' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'destroyCompanyContractType' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DestroyCompanyContractTypeMutation, DestroyCompanyContractTypeMutationVariables>;
export const DestroyDeliveryAndCollectionItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'destroyDeliveryAndCollectionItem' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'destroyDeliveryAndCollectionItem' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DestroyDeliveryAndCollectionItemMutation,
  DestroyDeliveryAndCollectionItemMutationVariables
>;
export const DestroyKickOffTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'destroyKickOffTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'destroyKickOffTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DestroyKickOffTemplateMutation, DestroyKickOffTemplateMutationVariables>;
export const DestroyNotesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'destroyNotes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'destroyNotes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DestroyNotesMutation, DestroyNotesMutationVariables>;
export const DestroyProjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'destroyProject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'destroyProject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DestroyProjectMutation, DestroyProjectMutationVariables>;
export const DestroyProjectActivityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'destroyProjectActivity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'destroyProjectActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DestroyProjectActivityMutation, DestroyProjectActivityMutationVariables>;
export const RemoveIssueDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'removeIssue' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'issueId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'destroyReportIssue' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'issueId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveIssueMutation, RemoveIssueMutationVariables>;
export const DestroySubContractorDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'destroySubContractor' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ignoreSchedules' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'updatedSubContractorId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'destroySubContractor' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ignoreSchedules' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ignoreSchedules' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'updatedSubContractorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'updatedSubContractorId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DestroySubContractorMutation, DestroySubContractorMutationVariables>;
export const DestroyTaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'destroyTask' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'destroyTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DestroyTaskMutation, DestroyTaskMutationVariables>;
export const DispatchAttachmentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'dispatchAttachments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'documentIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dispatchAttachments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'documentIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'documentIds' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DispatchAttachmentsMutation, DispatchAttachmentsMutationVariables>;
export const DisputeCompensationEventNoticeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'disputeCompensationEventNotice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disputeCompensationEventNotice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DisputeCompensationEventNoticeMutation, DisputeCompensationEventNoticeMutationVariables>;
export const DropEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'dropEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateEvent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'event' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status' },
                      value: { kind: 'EnumValue', value: 'discontinued' },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DropEventMutation, DropEventMutationVariables>;
export const DropResourceScheduleV2Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'dropResourceScheduleV2' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dropResourceScheduleV2' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ids' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ids' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'droppedIds' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DropResourceScheduleV2Mutation, DropResourceScheduleV2MutationVariables>;
export const ExchangeRefreshTokenForJwtDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'exchangeRefreshTokenForJwt' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'exchangeRefreshTokenForJwt' } }],
      },
    },
  ],
} as unknown as DocumentNode<ExchangeRefreshTokenForJwtMutation, ExchangeRefreshTokenForJwtMutationVariables>;
export const ExportUserDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'exportUserData' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'exportUserData' } }],
      },
    },
  ],
} as unknown as DocumentNode<ExportUserDataMutation, ExportUserDataMutationVariables>;
export const IssueCompensationEventNoticeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'issueCompensationEventNotice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issueCompensationEventNotice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IssueCompensationEventNoticeMutation, IssueCompensationEventNoticeMutationVariables>;
export const IssueCompensationEventQuotationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'issueCompensationEventQuotation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issueCompensationEventQuotation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IssueCompensationEventQuotationMutation, IssueCompensationEventQuotationMutationVariables>;
export const SignInDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'signIn' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rememberMe' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signIn' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'password' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'rememberMe' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'rememberMe' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SignInMutation, SignInMutationVariables>;
export const SignOutDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'signOut' },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'signOut' } }] },
    },
  ],
} as unknown as DocumentNode<SignOutMutation, SignOutMutationVariables>;
export const ManageProjectLocationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'manageProjectLocations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'addresses' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'AddressUpdate' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'manageProjectLocations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'addresses' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'addresses' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ManageProjectLocationsMutation, ManageProjectLocationsMutationVariables>;
export const MarkAsCollectedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'markAsCollected' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'delivererName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'receiverName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'notes' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'signedIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'markAsCollected' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'delivererName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'delivererName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'receiverName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'receiverName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'notes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'notes' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'signedIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'signedIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegisterItemStateFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegisterItemStateFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DeliveryAndCollectionItemState' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supplier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reportId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delivererName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiverName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStateSetAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'item' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'companyResource' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resourceMeta' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resourceCategory' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MarkAsCollectedMutation, MarkAsCollectedMutationVariables>;
export const MarkAsDeployedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'markAsDeployed' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportDate' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startTime' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endTime' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'markAsDeployed' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reportDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startTime' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startTime' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endTime' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'endTime' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MarkAsDeployedMutation, MarkAsDeployedMutationVariables>;
export const MarkAsReadyForCollectionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'markAsReadyForCollection' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyResourceId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'markAsReadyForCollection' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyResourceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyResourceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reportId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scheduleId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegisterItemStateFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegisterItemStateFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DeliveryAndCollectionItemState' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supplier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reportId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delivererName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiverName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStateSetAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'item' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'companyResource' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resourceMeta' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resourceCategory' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MarkAsReadyForCollectionMutation, MarkAsReadyForCollectionMutationVariables>;
export const MarkNotificationsAsReadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'markNotificationsAsRead' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'markNotificationsAsRead' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MarkNotificationsAsReadMutation, MarkNotificationsAsReadMutationVariables>;
export const ReactOnTaskCommentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'reactOnTaskComment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reaction' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'TaskCommentReactionInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'reactOnTaskComment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reaction' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reaction' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReactOnTaskCommentMutation, ReactOnTaskCommentMutationVariables>;
export const RejectCustomShiftDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'rejectCustomShift' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startTime' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endTime' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'notificationId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rejectCustomShift' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scheduleId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startTime' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startTime' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endTime' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'endTime' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'notificationId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'notificationId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RejectCustomShiftMutation, RejectCustomShiftMutationVariables>;
export const RemoveProfilePictureDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'removeProfilePicture' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeProfilePicture' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveProfilePictureMutation, RemoveProfilePictureMutationVariables>;
export const RemoveUsersFromProjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'removeUsersFromProject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeUsersFromProject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userIds' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveUsersFromProjectMutation, RemoveUsersFromProjectMutationVariables>;
export const ResetUserPasswordDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'resetUserPassword' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resetUserPassword' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'token' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'password' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>;
export const ResizeResourceScheduleV2Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'resizeResourceScheduleV2' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ResizeResourceScheduleV2Input' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resizeResourceScheduleV2' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hasConflicts' } },
                { kind: 'Field', name: { kind: 'Name', value: 'droppedScheduleIds' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'schedules' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'projectId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resourceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'onHire' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'descriptionOfService' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResizeResourceScheduleV2Mutation, ResizeResourceScheduleV2MutationVariables>;
export const RevertReportApprovalDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'revertReportApproval' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revertReportApproval' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reportId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RevertReportApprovalMutation, RevertReportApprovalMutationVariables>;
export const SelectFreePlanDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'selectFreePlan' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'selectFreePlan' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'planType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'interval' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SelectFreePlanMutation, SelectFreePlanMutationVariables>;
export const SetDocumentAssociationTypeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'setDocumentAssociationType' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'attachableType' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'attachableId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'associationType' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AssociationTypeEnum' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setDocumentAssociationType' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attachableType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'attachableType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'attachableId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'attachableId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'associationType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'associationType' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SetDocumentAssociationTypeMutation, SetDocumentAssociationTypeMutationVariables>;
export const ShareKickOffTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'shareKickOffTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emails' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shareKickOffTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emails' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emails' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShareKickOffTemplateMutation, ShareKickOffTemplateMutationVariables>;
export const ShareReportsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'shareReports' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'emails' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shareProjectReports' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emails' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'emails' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ShareReportsMutation, ShareReportsMutationVariables>;
export const SignUpDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'signUp' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firstName' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'lastName' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'confirmPassword' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'signUp' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'firstName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'firstName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'lastName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'lastName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'password' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'password' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'confirmPassword' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'confirmPassword' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SignUpMutation, SignUpMutationVariables>;
export const SplitProjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'splitProject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rootId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'splits' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProjectSplit' } } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'finalize' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subContractorProjectMappings' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'SubContractorProjectMappingInput' } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'splitProject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'rootId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'rootId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'splits' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'splits' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'finalize' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'finalize' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subContractorProjectMappings' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subContractorProjectMappings' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SplitProjectMutation, SplitProjectMutationVariables>;
export const SubmitReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'submitReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submitReport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reportId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubmitReportMutation, SubmitReportMutationVariables>;
export const TagAttachmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'tagAttachment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyTagIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tagAttachment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyTagIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyTagIds' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TagAttachmentMutation, TagAttachmentMutationVariables>;
export const UpdateAccessRequestDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateAccessRequest' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'accessRequest' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AccessRequestUpdate' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAccessRequest' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'accessRequest' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'accessRequest' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateAccessRequestMutation, UpdateAccessRequestMutationVariables>;
export const UpdateCeqBillableItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateCeqBillableItem' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resourceId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'role' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCeqBillableItem' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resourceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resourceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'rate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'rate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'role' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'role' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCeqBillableItemMutation, UpdateCeqBillableItemMutationVariables>;
export const UpdateCeqSubEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateCeqSubEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'programmeImpact' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCeqSubEvent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'programmeImpact' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'programmeImpact' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCeqSubEventMutation, UpdateCeqSubEventMutationVariables>;
export const UpdateClientDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateClient' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'phone' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyNumber' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tradingName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'vatNumber' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CompanyTypeEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'street' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'city' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'state' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'country' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'zip' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'client' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ClientUpdate' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateClient' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'phone' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'phone' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyNumber' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tradingName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tradingName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'vatNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'vatNumber' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'street' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'street' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'city' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'city' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'state' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'state' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'country' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'country' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'zip' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'zip' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'client' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'client' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateClientMutation, UpdateClientMutationVariables>;
export const UpdateCompanyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateCompany' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'primaryPhone' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'primaryEmail' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'street' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'city' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'state' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'country' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'zip' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyNumber' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tradingName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'vatNumber' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CompanyTypeEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'logoSignedId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCompany' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'primaryPhone' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'primaryPhone' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'primaryEmail' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'primaryEmail' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'street' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'street' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'city' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'city' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'state' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'state' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'country' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'country' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'zip' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'zip' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyNumber' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tradingName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tradingName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'vatNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'vatNumber' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'logoSignedId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'logoSignedId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCompanyMutation, UpdateCompanyMutationVariables>;
export const UpdateCompanyEventColumnDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateCompanyEventColumn' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'label' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCompanyEventColumn' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'label' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'label' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCompanyEventColumnMutation, UpdateCompanyEventColumnMutationVariables>;
export const UpdateCompanyResourceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateCompanyResource' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyResource' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CompanyResourceUpdate' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCompanyResource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyResource' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyResource' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCompanyResourceMutation, UpdateCompanyResourceMutationVariables>;
export const UpdateCompensationEventNoticeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateCompensationEventNotice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'cen' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CompensationEventNoticeUpdate' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateCompensationEventNotice' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'cen' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'cen' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateCompensationEventNoticeMutation, UpdateCompensationEventNoticeMutationVariables>;
export const UpdateConflictedSchedulesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateConflictedSchedules' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resourceSchedules' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'ResourceScheduleUpdate' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateConflictedSchedules' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resourceSchedules' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resourceSchedules' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateConflictedSchedulesMutation, UpdateConflictedSchedulesMutationVariables>;
export const UpdateDefaultCompanyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateDefaultCompany' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDefaultCompany' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateDefaultCompanyMutation, UpdateDefaultCompanyMutationVariables>;
export const UpdateDeliveryAndCollectionItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateDeliveryAndCollectionItem' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'stateId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'quantity' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'supplier' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'delivererName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'receiverName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'notes' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateDeliveryAndCollectionItem' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'stateId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'stateId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'quantity' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'quantity' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'supplier' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'supplier' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'delivererName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'delivererName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'receiverName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'receiverName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'notes' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'notes' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegisterItemStateFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegisterItemStateFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DeliveryAndCollectionItemState' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supplier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reportId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delivererName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiverName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStateSetAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'item' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'companyResource' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resourceMeta' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resourceCategory' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateDeliveryAndCollectionItemMutation, UpdateDeliveryAndCollectionItemMutationVariables>;
export const UpdateEmployeeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateEmployee' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'user' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'EmployeeUpdate' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateEmployee' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'user' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'user' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;
export const UpdateEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'category' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EventCategoryEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EventStatusEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EventTypeEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'flag' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'occurredAt' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'assigneeUserId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateEvent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'event' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'category' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'category' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'status' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'eventType' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'eventType' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'description' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'flag' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'flag' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'occurredAt' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'occurredAt' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'assigneeUserId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'assigneeUserId' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CompleteEventFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CompleteEventFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approved' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ewnCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cenCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasActiveCeq' } },
          { kind: 'Field', name: { kind: 'Name', value: 'projectCurrency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderIndex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'occurredAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'employee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'project' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pointOfContacts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'companyResource' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resourceMeta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'resourceCategory' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'managers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'companyResource' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resourceMeta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'resourceCategory' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'client' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mainAddress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationType' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventSources' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'source' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Issue' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'categories' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'issueType' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventComments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateEventMutation, UpdateEventMutationVariables>;
export const UpdateEventPositionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateEventPosition' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'EventStatusEnum' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'prevId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'nextId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateEventPosition' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'prevId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'prevId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'nextId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'nextId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateEventPositionMutation, UpdateEventPositionMutationVariables>;
export const UpdateFeedbackDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateFeedback' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'feedback' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'FeedbackUpdate' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateFeedback' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'feedback' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'feedback' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateFeedbackMutation, UpdateFeedbackMutationVariables>;
export const UpdateGanttScheduleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateGanttSchedule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'updatedResourceId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'source' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startTime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endTime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'descriptionOfService' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateGanttSchedule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scheduleIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'updatedResourceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'updatedResourceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'title' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'source' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'source' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startTime' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startTime' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endTime' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'endTime' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'descriptionOfService' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'descriptionOfService' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateGanttScheduleMutation, UpdateGanttScheduleMutationVariables>;
export const UpdateReportIssueDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateReportIssue' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportIssue' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IssueUpdate' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateReportIssue' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reportIssue' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportIssue' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'issueType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categories' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrls' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateReportIssueMutation, UpdateReportIssueMutationVariables>;
export const UpdateKanbanColumnsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateKanbanColumns' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'columnId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateKanbanColumns' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'title' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'columnId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'columnId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateKanbanColumnsMutation, UpdateKanbanColumnsMutationVariables>;
export const UpdateKickOffActionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateKickOffActions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'kickOffId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'kickOffActions' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'JSON' } } },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateKickOffActions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'kickOffId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'kickOffId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'kickOffActions' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'kickOffActions' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateKickOffActionsMutation, UpdateKickOffActionsMutationVariables>;
export const UpdateKickOffBasicsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateKickOffBasics' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'JSON' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateKickOffBasics' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'title' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateKickOffBasicsMutation, UpdateKickOffBasicsMutationVariables>;
export const UpdateKickOffProjectDetailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateKickOffProjectDetails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'kickOffId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'managers' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'JSON' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'activities' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'JSON' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectSettings' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'JSON' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'contractTypeIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectTagIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateKickOffProjectDetails' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'kickOffId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'kickOffId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'managers' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'managers' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'activities' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'activities' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectSettings' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectSettings' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'contractTypeIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'contractTypeIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectTagIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectTagIds' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateKickOffProjectDetailsMutation, UpdateKickOffProjectDetailsMutationVariables>;
export const UpdateKickOffTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateKickOffTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'JSON' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateKickOffTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'title' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateKickOffTemplateMutation, UpdateKickOffTemplateMutationVariables>;
export const UpdateNotesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateNotes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'noteData' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'NotesUpdate' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateNotes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'noteData' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'noteData' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notesType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reminder' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrls' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AttachedFile' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachedFile' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Attachment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signedBlobId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'byteSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'associationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateNotesMutation, UpdateNotesMutationVariables>;
export const UpdateOnboardingStepDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateOnboardingStep' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'step' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'OnboardingStepsEnum' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateOnboardingStep' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'step' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'step' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'companyInformation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'planSelection' } },
                { kind: 'Field', name: { kind: 'Name', value: 'humanResourceCreated' } },
                { kind: 'Field', name: { kind: 'Name', value: 'equipmentResourceCreated' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clientCreated' } },
                { kind: 'Field', name: { kind: 'Name', value: 'projectCreated' } },
                { kind: 'Field', name: { kind: 'Name', value: 'taskCreated' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateOnboardingStepMutation, UpdateOnboardingStepMutationVariables>;
export const UpdateProjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateProject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectUsers' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ManagerUpdate' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'representativeId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'addressId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectSettings' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProjectSettingsUpdate' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'visible' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateProject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'project' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'title' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'description' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'description' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'code' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'clientId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'projectUsers' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'projectUsers' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'representativeId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'representativeId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'addressId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'addressId' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'projectSettings' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'projectSettings' } },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'visible' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'visible' } },
                    },
                  ],
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateProjectMutation, UpdateProjectMutationVariables>;
export const UpdateProjectActivityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateProjectActivity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectActivity' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProjectActivityUpdate' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateProjectActivity' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectActivity' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectActivity' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateProjectActivityMutation, UpdateProjectActivityMutationVariables>;
export const UpdateProjectOrderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateProjectOrder' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'newOrder' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUserSetting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'StringValue', value: 'project_order', block: false },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'value' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'newOrder' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateProjectOrderMutation, UpdateProjectOrderMutationVariables>;
export const UpdateProjectReviewerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateProjectReviewer' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyResourceId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateProjectReviewer' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'title' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyResourceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyResourceId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateProjectReviewerMutation, UpdateProjectReviewerMutationVariables>;
export const UpdateReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'approved' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateReport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reportId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'approved' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'approved' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'approvalDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'approved' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reportDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'project' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reporter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'employee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categories' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'issueType' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'weather' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateReportMutation, UpdateReportMutationVariables>;
export const UpdateResourceScheduleV2Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateResourceScheduleV2' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateResourceScheduleV2Input' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateResourceScheduleV2' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hasConflicts' } },
                { kind: 'Field', name: { kind: 'Name', value: 'droppedScheduleIds' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'schedules' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'projectId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resourceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'onHire' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'descriptionOfService' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateResourceScheduleV2Mutation, UpdateResourceScheduleV2MutationVariables>;
export const UpdateScheduleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateSchedule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'schedule' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ScheduleUpdate' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSchedule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'schedule' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'schedule' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CompleteScheduleFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CompleteScheduleFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Schedule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'collectable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionOfService' } },
          { kind: 'Field', name: { kind: 'Name', value: 'onHire' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customShift' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'project' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mainAddress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationType' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companyResource' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'resourceMeta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resourceCategory' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subContractor' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasFutureSchedules' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isParent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'principalContact' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationType' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hasConflicts' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateScheduleMutation, UpdateScheduleMutationVariables>;
export const UpdateSubContractorScheduleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateSubContractorSchedule' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'subContractorSchedule' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SubContractorScheduleUpdate' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSubContractorSchedule' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subContractorSchedule' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'subContractorSchedule' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateSubContractorScheduleMutation, UpdateSubContractorScheduleMutationVariables>;
export const UpdateSubEventBillableItemDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateSubEventBillableItem' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'multiplier' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'quantity' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSubEventBillableItem' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'multiplier' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'multiplier' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'quantity' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'quantity' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateSubEventBillableItemMutation, UpdateSubEventBillableItemMutationVariables>;
export const UpdateTaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateTask' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'task' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'TaskUpdate' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'task' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'task' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dueDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'employee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'creator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'employee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AttachedFile' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachedFile' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Attachment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signedBlobId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'byteSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'associationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateTaskMutation, UpdateTaskMutationVariables>;
export const UpdateTaskCommentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateTaskComment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isEdited' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateTaskComment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'content' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'content' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isEdited' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isEdited' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateTaskCommentMutation, UpdateTaskCommentMutationVariables>;
export const UpdateUserProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateUserProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'user' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'UserUpdate' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUserProfile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'user' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'user' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const UpdateUserSettingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateUserSetting' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'value' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUserSetting' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'value' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'value' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserSettingMutation, UpdateUserSettingMutationVariables>;
export const UploadBillableItemFilesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'uploadBillableItemFiles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'itemId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'signedIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uploadBillableItemFiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'itemId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'itemId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'signedIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'signedIds' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UploadBillableItemFilesMutation, UploadBillableItemFilesMutationVariables>;
export const UploadCeqFilesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'uploadCeqFiles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'signedIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uploadCeqFiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'signedIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'signedIds' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UploadCeqFilesMutation, UploadCeqFilesMutationVariables>;
export const UploadFunnelProjectFilesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'uploadFunnelProjectFiles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'signedIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'uploadFunnelProjectFiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'signedIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'signedIds' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UploadFunnelProjectFilesMutation, UploadFunnelProjectFilesMutationVariables>;
export const VerifyCheckoutSessionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'verifyCheckoutSession' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verifyCheckoutSession' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sessionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sessionId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'planType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'interval' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentPeriodEnd' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cancelAtPeriodEnd' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VerifyCheckoutSessionMutation, VerifyCheckoutSessionMutationVariables>;
export const AccessProjectsPickerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'accessProjectsPicker' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getProjects' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccessProjectsPickerQuery, AccessProjectsPickerQueryVariables>;
export const AccessRegistryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'accessRegistry' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accessRegistry' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                { kind: 'Field', name: { kind: 'Name', value: 'projectScoped' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ownable' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'actions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'color' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AccessRegistryQuery, AccessRegistryQueryVariables>;
export const CheckScheduleConflictsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'checkScheduleConflicts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'updatedResourceId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startTime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endTime' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'checkScheduleConflicts' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'scheduleIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'scheduleIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'updatedResourceId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'updatedResourceId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startTime' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startTime' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endTime' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'endTime' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CheckScheduleConflictsQuery, CheckScheduleConflictsQueryVariables>;
export const CompanyEmploymentsListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CompanyEmploymentsList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeSelf' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeOwner' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companyEmployments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeSelf' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'includeSelf' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'includeOwner' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'includeOwner' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CompanyEmploymentsListQuery, CompanyEmploymentsListQueryVariables>;
export const GetAccessAuditEventsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAccessAuditEvents' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAccessAuditEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'offset' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'offset' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'event' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subjectType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subjectId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'payload' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'actorEmployment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAccessAuditEventsQuery, GetAccessAuditEventsQueryVariables>;
export const GetAccessRequestsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAccessRequests' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAccessRequests' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAccessRequestsQuery, GetAccessRequestsQueryVariables>;
export const GetActivitiesForProjectsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getActivitiesForProjects' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getActivitiesForProjects' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeBasedStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colorCode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'supervisor' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'employee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'createdBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'employee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'project' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetActivitiesForProjectsQuery, GetActivitiesForProjectsQueryVariables>;
export const GetAllEmployeesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAllEmployees' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getEmployees' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cursor' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastSignInAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currentSignInAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'loginEnabled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'hasFutureSchedules' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'companyEmployment' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'loginEnabled' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllEmployeesQuery, GetAllEmployeesQueryVariables>;
export const GetAllReportsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAllReports' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'stage' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'issueType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'categoryIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'issueDescription' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCompanyReports' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'stage' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'stage' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'issueType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'issueType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'categoryIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'categoryIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'issueDescription' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'issueDescription' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cursor' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'approvalDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'approved' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'reportDate' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'project' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'reporter' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'employee' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'issues' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'categories' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'issueType' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'weather' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAllReportsQuery, GetAllReportsQueryVariables>;
export const GetAttachmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAttachment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAttachment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AttachedFile' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachedFile' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Attachment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signedBlobId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'byteSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'associationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAttachmentQuery, GetAttachmentQueryVariables>;
export const GetCeqBillableItemsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCeqBillableItems' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ceqId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resourceType' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCeqBillableItems' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ceqId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ceqId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resourceType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resourceType' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'role' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'itemCategory' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrls' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AttachedFile' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subEventBillableItems' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cost' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'multiplier' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ceqSubEventId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachedFile' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Attachment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signedBlobId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'byteSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'associationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCeqBillableItemsQuery, GetCeqBillableItemsQueryVariables>;
export const GetCeqSubEventsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCeqSubEvents' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ceqId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCeqSubEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ceqId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ceqId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cost' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCeqSubEventsQuery, GetCeqSubEventsQueryVariables>;
export const GetCeqSubEventsSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCeqSubEventsSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'ceqId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCeqSubEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'ceqId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'ceqId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cost' } },
                { kind: 'Field', name: { kind: 'Name', value: 'programmeImpact' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCeqSubEventsSummaryQuery, GetCeqSubEventsSummaryQueryVariables>;
export const GetClientResourcesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getClientResources' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getClient' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'clientId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'companyResources' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resourceMeta' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClientResourcesQuery, GetClientResourcesQueryVariables>;
export const GetClientsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getClients' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectStatus' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProjectStatusEnum' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyName' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'visible' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getClients' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectStatus' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectStatus' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'visible' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'visible' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AddressFragment' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'activeProjectsCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedProjectsCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cancelledProjectsCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'inFunnelCount' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AddressFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Address' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'street' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClientsQuery, GetClientsQueryVariables>;
export const GetClientsBasicDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getClientsBasic' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getClients' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClientsBasicQuery, GetClientsBasicQueryVariables>;
export const GetClientsFiltersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getClientsFilters' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getClientsFilters' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'projectStatuses' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyNames' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetClientsFiltersQuery, GetClientsFiltersQueryVariables>;
export const GetCompaniesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCompanies' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCompanies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyNumber' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'owner' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCompaniesQuery, GetCompaniesQueryVariables>;
export const GetCompaniesHouseInfoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCompaniesHouseInfo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyNumber' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCompaniesHouseInfo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyNumber' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyNumber' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'number' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCompaniesHouseInfoQuery, GetCompaniesHouseInfoQueryVariables>;
export const GetProjectAddressesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getProjectAddresses' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getProjectAddresses' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProjectAddressesQuery, GetProjectAddressesQueryVariables>;
export const GetCompanyContractTypesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCompanyContractTypes' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCompanyContractTypes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contractTypeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCompanyContractTypesQuery, GetCompanyContractTypesQueryVariables>;
export const GetCompanyDocumentsHierarchyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCompanyDocumentsHierarchy' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CompanyDocumentsHierarchyInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCompanyDocumentsHierarchy' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'childrenCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCompanyDocumentsHierarchyQuery, GetCompanyDocumentsHierarchyQueryVariables>;
export const GetCompanyEmployeesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCompanyEmployees' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getEmployees' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cursor' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCompanyEmployeesQuery, GetCompanyEmployeesQueryVariables>;
export const GetCompanyEventColumnsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCompanyEventColumns' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCompanyEventColumns' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCompanyEventColumnsQuery, GetCompanyEventColumnsQueryVariables>;
export const GetCompanyNotesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCompanyNotes' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCompanyIssues' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'category' },
                value: { kind: 'StringValue', value: 'notes', block: false },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'issueType' },
                value: { kind: 'StringValue', value: '', block: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCompanyNotesQuery, GetCompanyNotesQueryVariables>;
export const GetCompanyKickOffTemplatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCompanyKickOffTemplates' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCompanyKickOffTemplates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'clientReps' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addresses' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'projectDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'managers' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'activities' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'projectTagIds' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'contractTypeIds' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'projectSettings' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCompanyKickOffTemplatesQuery, GetCompanyKickOffTemplatesQueryVariables>;
export const GetCompanyKickOffsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCompanyKickOffs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'initiatorId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCompanyKickOffs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'initiatorId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'initiatorId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'emails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'kickOffDataFragment' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'project' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'initiator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'kickOffDataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'KickOffData' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'projectId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'projectCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'projectTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientCompanyNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientReps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addresses' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTemplate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'projectDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'managers' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activities' } },
                { kind: 'Field', name: { kind: 'Name', value: 'projectTagIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contractTypeIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'projectSettings' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCompanyKickOffsQuery, GetCompanyKickOffsQueryVariables>;
export const GetCompanyResourcesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCompanyResources' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resourceType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CompanyResourceResourceTypeEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resourceCategoryId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userExists' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCompanyResources' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resourceType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resourceType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resourceCategoryId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resourceCategoryId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userExists' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userExists' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canInviteSubContractor' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'resourceMeta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resourceCategory' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrls' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attachments' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AttachedFile' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subContractor' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasFutureSchedules' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isParent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachedFile' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Attachment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signedBlobId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'byteSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'associationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCompanyResourcesQuery, GetCompanyResourcesQueryVariables>;
export const GetCompanyResourcesPaginatedDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCompanyResourcesPaginated' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resourceCategoryId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resourceType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CompanyResourceResourceTypeEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userExists' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCompanyResourcesPaginated' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resourceCategoryId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resourceCategoryId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resourceType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resourceType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userExists' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userExists' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'before' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'last' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uniqueReference' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resourceMeta' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCompanyResourcesPaginatedQuery, GetCompanyResourcesPaginatedQueryVariables>;
export const GetCompanySettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCompanySettings' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCompanySettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCompanySettingsQuery, GetCompanySettingsQueryVariables>;
export const GetCompanyStatsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCompanyStats' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCompany' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'projectsCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reportsCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'humanResourcesCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCompanyStatsQuery, GetCompanyStatsQueryVariables>;
export const GetCompanyTagsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCompanyTags' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCompanyTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'users' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'equipments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCompanyTagsQuery, GetCompanyTagsQueryVariables>;
export const GetCompensationEventNoticesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCompensationEventNotices' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCompensationEventNotices' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'editable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrls' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AttachedFile' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clientInstruction' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'instructions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'responseDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrls' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attachments' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AttachedFile' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'event' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachedFile' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Attachment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signedBlobId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'byteSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'associationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCompensationEventNoticesQuery, GetCompensationEventNoticesQueryVariables>;
export const GetCompensationEventQuotationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCompensationEventQuotations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCompensationEventQuotations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'editable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'programmeImpact' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCost' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'associatedCen' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'uuid' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCompensationEventQuotationsQuery, GetCompensationEventQuotationsQueryVariables>;
export const GetConflictingSchedulesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getConflictingSchedules' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dateRangeStart' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dateRangeEnd' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resourceIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getConflictingSchedules' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dateRangeStart' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dateRangeStart' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dateRangeEnd' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dateRangeEnd' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resourceIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resourceIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'formatted' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'project' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'conflictingSchedules' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resourceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resourceName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'formatted' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'project' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetConflictingSchedulesQuery, GetConflictingSchedulesQueryVariables>;
export const GetContractTypesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getContractTypes' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getContractTypes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetContractTypesQuery, GetContractTypesQueryVariables>;
export const GetCurrentUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCurrentUser' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchMyData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'employers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'companies' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'defaultCompany' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryEmail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasProjects' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasClients' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasHumanResources' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tradingName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'vatNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'locationType' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onboardingSteps' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'clientCreated' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'companyInformation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'equipmentResourceCreated' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'humanResourceCreated' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'planSelection' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'projectCreated' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'taskCreated' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasCompanies' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isOwner' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSuperAdmin' } },
                { kind: 'Field', name: { kind: 'Name', value: 'basicOnboardingCompleted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'welcomeChecklistCompleted' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dashboardLayout' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastSignInAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentSignInAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'favoriteTabs' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sharepointConnectionActive' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'defaultEmployment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'employmentType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subscription' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'planType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'interval' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currentPeriodEnd' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'cancelAtPeriodEnd' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const GetCustomShiftApproversDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCustomShiftApprovers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCustomShiftApprovers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCustomShiftApproversQuery, GetCustomShiftApproversQueryVariables>;
export const GetDeliveryItemStatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getDeliveryItemStates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getDeliveryItemStates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reportId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegisterItemStateFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegisterItemStateFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DeliveryAndCollectionItemState' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supplier' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reportId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'delivererName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiverName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'currentStateSetAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'actor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'item' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'companyResource' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resourceMeta' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resourceCategory' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDeliveryItemStatesQuery, GetDeliveryItemStatesQueryVariables>;
export const GetDeliveryRegistersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getDeliveryRegisters' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getDeliveryRegisters' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegisterData' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegisterData' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DeliveryAndCollectionRegister' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'projectId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestor' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'companyResource' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resourceMeta' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resourceCategory' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'itemStates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'supplier' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reportId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'actor' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'delivererName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'receiverName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentStateSetAt' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDeliveryRegistersQuery, GetDeliveryRegistersQueryVariables>;
export const GetDeliveryRegistersForProjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getDeliveryRegistersForProject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'states' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getDeliveryRegistersForProject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'states' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'states' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'projectId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requestor' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'items' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'companyResource' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resourceMeta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'resourceCategory' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'itemStates' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currentState' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currentStateSetAt' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDeliveryRegistersForProjectQuery, GetDeliveryRegistersForProjectQueryVariables>;
export const GetDraftSplitProjectsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getDraftSplitProjects' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rootProjectId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getDraftSplitProjects' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'rootProjectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'rootProjectId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'issuesCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrls' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AttachedFile' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pointOfContacts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'pocFields' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'managers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'managerFields' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'client' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mainAddress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationType' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'projectActivities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timeBasedStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'colorCode' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'supervisor' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'employee' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'employee' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'projectSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'contractTypeIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tagIds' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachedFile' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Attachment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signedBlobId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'byteSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'associationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'pocFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProjectUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companyResource' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'resourceMeta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resourceCategory' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'managerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProjectUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'employment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'employee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companyResource' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'resourceMeta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resourceCategory' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetDraftSplitProjectsQuery, GetDraftSplitProjectsQueryVariables>;
export const GetEarlyWarningNoticesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getEarlyWarningNotices' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getEarlyWarningNotices' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cost' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentUrls' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrls' } },
                { kind: 'Field', name: { kind: 'Name', value: 'keyDates' } },
                { kind: 'Field', name: { kind: 'Name', value: 'others' } },
                { kind: 'Field', name: { kind: 'Name', value: 'programmeImpact' } },
                { kind: 'Field', name: { kind: 'Name', value: 'time' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetEarlyWarningNoticesQuery, GetEarlyWarningNoticesQueryVariables>;
export const GetEmploymentAccessDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getEmploymentAccess' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'employmentId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getEmploymentAccess' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'employmentId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'employmentId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'employment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'roles' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'grants' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'entity' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'directGrants' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'entity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'projectId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'validTill' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expired' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'project' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'effective' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'entity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'projectIds' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetEmploymentAccessQuery, GetEmploymentAccessQueryVariables>;
export const GetEventDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getEvent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getEvent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ewnCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cenCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasActiveCeq' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'earlyWarningNotices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cost' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'time' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'programmeImpact' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'keyDates' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'others' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrls' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'compensationEventNotices' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'editable' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrls' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eventComments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'project' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pointOfContacts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'companyResource' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'resourceMeta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'resourceCategory' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'user' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'managers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'companyResource' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'resourceMeta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'resourceCategory' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'user' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'client' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mainAddress' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'locationType' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetEventQuery, GetEventQueryVariables>;
export const GetCompanyEventsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCompanyEvents' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'category' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EventCategoryEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'EventStatusEnum' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'date' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'timeZone' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCompanyEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'category' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'category' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'date' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'date' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'timeZone' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'timeZone' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CompleteEventFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CompleteEventFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'category' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'approved' } },
          { kind: 'Field', name: { kind: 'Name', value: 'flag' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ewnCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cenCount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasActiveCeq' } },
          { kind: 'Field', name: { kind: 'Name', value: 'projectCurrency' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderIndex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'occurredAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignee' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'employee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'project' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pointOfContacts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'companyResource' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resourceMeta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'resourceCategory' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'managers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'companyResource' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resourceMeta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'resourceCategory' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'client' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mainAddress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationType' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventSources' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'source' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Issue' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'categories' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'issueType' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventComments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCompanyEventsQuery, GetCompanyEventsQueryVariables>;
export const GetEventsForProjectsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getEventsForProjects' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'category' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getEventsForProjects' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'category' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'category' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'order' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'order' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'approved' } },
                { kind: 'Field', name: { kind: 'Name', value: 'ewnCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cenCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasActiveCeq' } },
                { kind: 'Field', name: { kind: 'Name', value: 'projectCurrency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'orderIndex' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'employee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'project' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pointOfContacts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'pocFields' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'managers' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'managerFields' } }],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'client' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mainAddress' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'locationType' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eventSources' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'source' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Issue' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'categories' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'issueType' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eventComments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'pocFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProjectUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companyResource' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'resourceMeta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resourceCategory' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'managerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProjectUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'employment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'employee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companyResource' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'resourceMeta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resourceCategory' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetEventsForProjectsQuery, GetEventsForProjectsQueryVariables>;
export const GetExistingUsersEmailsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getExistingUsersEmails' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'firstName' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'lastName' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getExistingUsersEmails' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'firstName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'firstName' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'lastName' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'lastName' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetExistingUsersEmailsQuery, GetExistingUsersEmailsQueryVariables>;
export const GetFeedbacksDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getFeedbacks' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resolved' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getFeedbacks' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resolved' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resolved' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'feedbackType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrls' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resolved' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetFeedbacksQuery, GetFeedbacksQueryVariables>;
export const GetFunnelCardsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getFunnelCards' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getFunnelCards' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AttachedFile' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reviewers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'companyResource' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachedFile' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Attachment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signedBlobId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'byteSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'associationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetFunnelCardsQuery, GetFunnelCardsQueryVariables>;
export const GetFutureSchedulesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getFutureSchedules' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'rootProjectId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getFutureSchedules' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'rootProjectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'rootProjectId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'companyResource' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subContractorId' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationType' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'project' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetFutureSchedulesQuery, GetFutureSchedulesQueryVariables>;
export const GetGrantRequestsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getGrantRequests' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getGrantRequests' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestFor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resolvedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'project' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'requestorEmployment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'actorEmployment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetGrantRequestsQuery, GetGrantRequestsQueryVariables>;
export const GetIssueFilterDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getIssueFilter' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getIssueFilter' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetIssueFilterQuery, GetIssueFilterQueryVariables>;
export const GetKanbanColumnsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getKanbanColumns' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getKanbanColumns' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'name' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'value' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetKanbanColumnsQuery, GetKanbanColumnsQueryVariables>;
export const GetKickOffDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getKickOff' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getKickOff' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'emails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'kickOffDataFragment' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'project' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'initiator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AttachedFile' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'kickOffDataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'KickOffData' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'projectId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'projectCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'projectTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientCompanyNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientReps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addresses' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTemplate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'projectDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'managers' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activities' } },
                { kind: 'Field', name: { kind: 'Name', value: 'projectTagIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contractTypeIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'projectSettings' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachedFile' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Attachment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signedBlobId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'byteSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'associationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetKickOffQuery, GetKickOffQueryVariables>;
export const GetKickOffPreloadDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getKickOffPreloadData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'kickOffStatus' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'KickOffStatusEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCompanyKickOffs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'kickOffStatus' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'projectId' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getClients' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getProjects' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getManagers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getManagerAutocompleteOptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCompanyKickOffTemplates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetKickOffPreloadDataQuery, GetKickOffPreloadDataQueryVariables>;
export const GetKickOffTemplateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getKickOffTemplate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getKickOffTemplate' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'clientReps' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addresses' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'projectDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'managers' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'activities' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'projectTagIds' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'contractTypeIds' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'projectSettings' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetKickOffTemplateQuery, GetKickOffTemplateQueryVariables>;
export const GetKickOffTemplatePreloadDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getKickOffTemplatePreloadData' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getClients' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getManagers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCompanyContractTypes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contractTypeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCompanyTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetKickOffTemplatePreloadDataQuery, GetKickOffTemplatePreloadDataQueryVariables>;
export const GetLastCompensationEventQuotationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getLastCompensationEventQuotation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getLastCompensationEventQuotation' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'editable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'eventId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'programmeImpact' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCost' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrls' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AttachedFile' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachedFile' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Attachment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signedBlobId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'byteSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'associationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetLastCompensationEventQuotationQuery, GetLastCompensationEventQuotationQueryVariables>;
export const GetManagerAutocompleteOptionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getManagerAutocompleteOptions' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getManagerAutocompleteOptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetManagerAutocompleteOptionsQuery, GetManagerAutocompleteOptionsQueryVariables>;
export const GetManagersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getManagers' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getManagers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'resourceMeta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resourceCategory' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'companyEmployment' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetManagersQuery, GetManagersQueryVariables>;
export const GetMyGrantRequestsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getMyGrantRequests' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getMyGrantRequests' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'project' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMyGrantRequestsQuery, GetMyGrantRequestsQueryVariables>;
export const GetMyNotesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getMyNotes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'noteType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'IssueTypeEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'source' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getMyNotes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'noteType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'noteType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'source' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'source' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'issueType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrls' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'creator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'employee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMyNotesQuery, GetMyNotesQueryVariables>;
export const GetMyProjectsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getMyProjects' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getMyProjects' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'managers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'companyResource' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resourceMeta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'resourceCategory' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'hasSubLocations' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mainAddress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationType' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addresses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationType' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'projectSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'holidays' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMyProjectsQuery, GetMyProjectsQueryVariables>;
export const GetMyTasksDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getMyTasks' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getMyTasks' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dueDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'employee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'creator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'employee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrls' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AttachedFile' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachedFile' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Attachment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signedBlobId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'byteSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'associationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetMyTasksQuery, GetMyTasksQueryVariables>;
export const GetNewUsersRequestsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getNewUsersRequests' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getNewUsersRequests' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetNewUsersRequestsQuery, GetNewUsersRequestsQueryVariables>;
export const GetNoteEntityOptionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getNoteEntityOptions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getNoteEntityOptions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entityType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'entityType' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetNoteEntityOptionsQuery, GetNoteEntityOptionsQueryVariables>;
export const GetNoteFiltersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getNoteFilters' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getNoteFilters' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'noteTypes' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sources' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetNoteFiltersQuery, GetNoteFiltersQueryVariables>;
export const GetOptionsForBillableItemsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getOptionsForBillableItems' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'itemType' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getOptionsForBillableItems' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'itemType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'itemType' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uniqueKey' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOptionsForBillableItemsQuery, GetOptionsForBillableItemsQueryVariables>;
export const GetOverwatchAutocompleteDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getOverwatchAutocompleteData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeManagers' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeResources' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeProjects' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resourceType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CompanyResourceResourceTypeEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getManagers' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: { kind: 'Variable', name: { kind: 'Name', value: 'includeManagers' } },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCompanyResources' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resourceType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resourceType' } },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: { kind: 'Variable', name: { kind: 'Name', value: 'includeResources' } },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getProjects' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
              },
            ],
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  {
                    kind: 'Argument',
                    name: { kind: 'Name', value: 'if' },
                    value: { kind: 'Variable', name: { kind: 'Name', value: 'includeProjects' } },
                  },
                ],
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetOverwatchAutocompleteDataQuery, GetOverwatchAutocompleteDataQueryVariables>;
export const GetPersonalNotesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPersonalNotes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'noteType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'NotesTypeEnum' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tagIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getPersonalNotes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'noteType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'noteType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tagIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tagIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notesType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reminder' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrls' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AttachedFile' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachedFile' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Attachment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signedBlobId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'byteSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'associationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPersonalNotesQuery, GetPersonalNotesQueryVariables>;
export const GetPlaceholdersForSchedulerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPlaceholdersForScheduler' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getPlaceholdersForScheduler' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchBy' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPlaceholdersForSchedulerQuery, GetPlaceholdersForSchedulerQueryVariables>;
export const GetPreloadTasksDrawerFiltersDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPreloadTasksDrawerFiltersData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getEmployees' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cursor' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'companyEmployment' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getProjects' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cursor' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCompanyEvents' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCompanyReports' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cursor' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'reportDate' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'project' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPreloadTasksDrawerFiltersDataQuery, GetPreloadTasksDrawerFiltersDataQueryVariables>;
export const GetProjectDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getProject' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getProject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AttachedFile' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'companyId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pointOfContacts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'companyResource' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resourceMeta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'resourceCategory' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'canInviteClient' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'managers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'companyResource' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resourceMeta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'resourceCategory' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'client' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mainAddress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationType' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'projectSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'projectActivities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timeBasedStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'colorCode' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'supervisor' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'employee' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'createdBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'employee' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'contractTypeIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tagIds' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachedFile' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Attachment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signedBlobId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'byteSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'associationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProjectQuery, GetProjectQueryVariables>;
export const GetProjectActivitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getProjectActivities' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getProjectActivities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timeBasedStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'colorCode' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'supervisor' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'employee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'createdBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'employee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProjectActivitiesQuery, GetProjectActivitiesQueryVariables>;
export const GetCompanyAddressesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCompanyAddresses' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCompanyAddresses' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCompanyAddressesQuery, GetCompanyAddressesQueryVariables>;
export const GetProjectCodeSuggestionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getProjectCodeSuggestion' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'parentCode' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getProjectCodeSuggestion' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'title' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'title' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'parentCode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'parentCode' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProjectCodeSuggestionQuery, GetProjectCodeSuggestionQueryVariables>;
export const GetProjectCodesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getProjectCodes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getProjects' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'code' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProjectCodesQuery, GetProjectCodesQueryVariables>;
export const GetProjectDraftKickOffDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getProjectDraftKickOff' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getProjectDraftKickOff' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'data' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'kickOffDataFragment' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'initiator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastEditedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'lastEditedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrls' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AttachedFile' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'kickOffDataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'KickOffData' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'projectId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'projectCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'projectTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientCompanyNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientReps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addresses' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTemplate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'projectDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'managers' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activities' } },
                { kind: 'Field', name: { kind: 'Name', value: 'projectTagIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contractTypeIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'projectSettings' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachedFile' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Attachment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signedBlobId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'byteSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'associationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProjectDraftKickOffQuery, GetProjectDraftKickOffQueryVariables>;
export const GetProjectForEditDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getProjectForEdit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'withDrafts' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getProject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'withDrafts' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'withDrafts' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'visible' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contractTypeIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tagIds' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AttachedFile' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pointOfContacts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'companyResource' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resourceMeta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'managers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'employment' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'companyResource' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resourceMeta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'client' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addresses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationType' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'projectSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'projectActivities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timeBasedStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'colorCode' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'supervisor' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'employee' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachedFile' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Attachment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signedBlobId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'byteSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'associationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProjectForEditQuery, GetProjectForEditQueryVariables>;
export const GetProjectForKickoffDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getProjectForKickoff' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getProject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pointOfContacts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'companyResource' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resourceMeta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'resourceCategory' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'managers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'companyResource' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resourceMeta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'resourceCategory' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'client' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mainAddress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationType' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'projectSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProjectForKickoffQuery, GetProjectForKickoffQueryVariables>;
export const GetProjectForSplittingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getProjectForSplitting' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getProject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AttachedFile' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pointOfContacts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'pocFields' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'managers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'managerFields' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'client' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'addresses' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationType' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'projectSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachedFile' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Attachment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signedBlobId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'byteSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'associationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'pocFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProjectUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companyResource' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'resourceMeta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resourceCategory' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'managerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ProjectUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'employment' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'employee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'user' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companyResource' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'resourceMeta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resourceCategory' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProjectForSplittingQuery, GetProjectForSplittingQueryVariables>;
export const GetProjectInvitationPrefillDataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getProjectInvitationPrefillData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getProjectInvitationPrefillData' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'token' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'token' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyPhone' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProjectInvitationPrefillDataQuery, GetProjectInvitationPrefillDataQueryVariables>;
export const GetProjectIssuesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getProjectIssues' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getProjectIssues' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categories' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'issueType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'creator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'employee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProjectIssuesQuery, GetProjectIssuesQueryVariables>;
export const GetProjectKickOffsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getProjectKickOffs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getProjectKickOffs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cursor' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'emails' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'project' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'initiator' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProjectKickOffsQuery, GetProjectKickOffsQueryVariables>;
export const GetProjectLocationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getProjectLocations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getProject' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mainAddress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProjectLocationsQuery, GetProjectLocationsQueryVariables>;
export const GetProjectNotesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getProjectNotes' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getProjectNotes' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notesType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reminder' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrls' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AttachedFile' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachedFile' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Attachment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signedBlobId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'byteSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'associationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProjectNotesQuery, GetProjectNotesQueryVariables>;
export const GetProjectTemplatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getProjectTemplates' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getProjectTemplates' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'tags' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'companyResources' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resourceMeta' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resourceCategory' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'activities' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProjectTemplatesQuery, GetProjectTemplatesQueryVariables>;
export const GetProjectWorkingHoursDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getProjectWorkingHours' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getProjectWorkingHours' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'hours' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProjectWorkingHoursQuery, GetProjectWorkingHoursQueryVariables>;
export const GetProjectsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getProjects' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'visible' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'peopleIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'hasKickOffs' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'hasSubLocations' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'hasSubProjects' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'hasReportsShared' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'hasIssues' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'hasOpenEvents' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchText' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'isProjectTab' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getProjects' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'clientId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'visible' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'visible' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'peopleIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'peopleIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'hasKickOffs' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'hasKickOffs' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'hasSubLocations' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'hasSubLocations' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'hasSubProjects' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'hasSubProjects' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'hasReportsShared' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'hasReportsShared' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'hasIssues' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'hasIssues' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'hasOpenEvents' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'hasOpenEvents' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchText' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchText' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'isProjectTab' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'isProjectTab' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cursor' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'companyId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'issuesCount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrls' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'visible' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'attachments' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AttachedFile' } }],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'pointOfContacts' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'companyResource' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'resourceMeta' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'resourceCategory' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canInviteClient' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'managers' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'userType' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'employment' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'user' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'companyResource' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'resourceMeta' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'resourceCategory' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                  ],
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'client' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryEmail' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mainAddress' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'locationType' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'subLocations' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'projectActivities' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'timeBasedStatus' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'colorCode' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'supervisor' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'employee' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'createdBy' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'employee' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'projectSettings' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'contractTypeIds' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'tagIds' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'kickOffs' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'emails' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'data' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: { kind: 'Name', value: 'kickOffDataFragment' },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'project' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'initiator' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachedFile' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Attachment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signedBlobId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'byteSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'associationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'kickOffDataFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'KickOffData' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'projectId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'projectCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'projectTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientCompanyNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'clientReps' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addresses' } },
          { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'newTemplate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'projectDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'managers' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activities' } },
                { kind: 'Field', name: { kind: 'Name', value: 'projectTagIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contractTypeIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'projectSettings' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProjectsQuery, GetProjectsQueryVariables>;
export const GetProjectsFiltersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getProjectsFilters' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getProjectFilters' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'people' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'statuses' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clients' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'companyNumber' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProjectsFiltersQuery, GetProjectsFiltersQueryVariables>;
export const GetProjectsForFunnelDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getProjectsForFunnel' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getProjects' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'clientId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'visible' },
                value: { kind: 'BooleanValue', value: false },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cursor' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'attachments' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AttachedFile' } }],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachedFile' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Attachment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signedBlobId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'byteSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'associationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProjectsForFunnelQuery, GetProjectsForFunnelQueryVariables>;
export const GetProjectsForSchedulerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getProjectsForScheduler' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProjectStatusEnum' } },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'singleOutProjectId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'tagIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'city' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'zip' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'issueIds' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'issueSearch' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventSearch' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getProjectsForScheduling' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'singleOutProjectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'singleOutProjectId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'tagIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'tagIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'clientIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'clientIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'city' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'city' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'zip' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'zip' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'issueIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'issueIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'issueSearch' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'issueSearch' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'eventSearch' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'eventSearch' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enableWeekends' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shifts' } },
                { kind: 'Field', name: { kind: 'Name', value: 'holidays' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mainAddress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationType' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationType' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProjectsForSchedulerQuery, GetProjectsForSchedulerQueryVariables>;
export const GetProjectsWithKickOffsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getProjectsWithKickOffs' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getProjectsWithKickoffs' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pointOfContacts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'companyResource' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resourceMeta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'resourceCategory' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'managers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'companyResource' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resourceMeta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'resourceCategory' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'client' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mainAddress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetProjectsWithKickOffsQuery, GetProjectsWithKickOffsQueryVariables>;
export const GetReportDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getReport' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getReport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reportId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reportDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportDate' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reportDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'submittedOn' } },
                { kind: 'Field', name: { kind: 'Name', value: 'approvalDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'approved' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'weather' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'deliveryAndCollection' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'supplier' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'notes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'delivererName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'receiverName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'documentUrls' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'actor' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'item' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'companyResource' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'resourceMeta' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'resourceCategory' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'approvedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'employee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'categories' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'issueType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrls' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'documentUrls' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'project' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasSubLocations' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'archived' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'client' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'projectSettings' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reporter' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'employee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'peopleRegisters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'locationType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'project' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mainAddress' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'locationType' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'subLocations' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'companyResource' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resourceMeta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'resourceCategory' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'user' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'equipmentRegisters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'locationType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'project' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mainAddress' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'locationType' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'subLocations' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'companyResource' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resourceMeta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'resourceCategory' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subContractorRegisters' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'descriptionOfService' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'project' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mainAddress' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'locationType' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'subLocations' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'companyResource' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'resourceMeta' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'resourceCategory' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'subContractor' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'hasFutureSchedules' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isParent' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetReportQuery, GetReportQueryVariables>;
export const GetReportForSelectedDateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getReportForSelectedDate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportDate' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getReportForSubmission' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reportDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'approved' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reportDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'weather' } },
                { kind: 'Field', name: { kind: 'Name', value: 'projectId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasIssues' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasEquipmentRegisters' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasPeopleRegisters' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetReportForSelectedDateQuery, GetReportForSelectedDateQueryVariables>;
export const GetReportIssuesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getReportIssues' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'category' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getReportIssues' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reportId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'category' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'category' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'issueType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'flagged' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'categories' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'headline' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrls' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetReportIssuesQuery, GetReportIssuesQueryVariables>;
export const GetRepresentativesByClientDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getRepresentativesByClient' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getRepresentativesByClient' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'clientId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'clientId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'resourceMeta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resourceCategory' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetRepresentativesByClientQuery, GetRepresentativesByClientQueryVariables>;
export const GetResourceCategoriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getResourceCategories' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getResourceCategories' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetResourceCategoriesQuery, GetResourceCategoriesQueryVariables>;
export const GetResourcesForSchedulerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getResourcesForScheduler' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resourceType' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getResourcesForScheduler' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resourceType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resourceType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'first' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'after' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetResourcesForSchedulerQuery, GetResourcesForSchedulerQueryVariables>;
export const GetRolesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getRoles' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getRoles' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'membersCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'grants' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'entity' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'members' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fullName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetRolesQuery, GetRolesQueryVariables>;
export const GetSchedulableCompanyEquipmentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getSchedulableCompanyEquipments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSchedulableCompanyEquipments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchBy' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uuid' } },
                { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'resourceCategory' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'name' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSchedulableCompanyEquipmentsQuery, GetSchedulableCompanyEquipmentsQueryVariables>;
export const GetSchedulableEmployeesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getSchedulableEmployees' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSchedulableEmployees' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchBy' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSchedulableEmployeesQuery, GetSchedulableEmployeesQueryVariables>;
export const GetScheduleForEditDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getScheduleForEdit' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getScheduleForEdit' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onHire' } },
                { kind: 'Field', name: { kind: 'Name', value: 'descriptionOfService' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customShift' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetScheduleForEditQuery, GetScheduleForEditQueryVariables>;
export const GetScheduledSubContractorsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getScheduledSubContractors' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'date' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getScheduledSubContractors' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'date' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'date' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'descriptionOfService' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subContractor' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'principalContact' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetScheduledSubContractorsQuery, GetScheduledSubContractorsQueryVariables>;
export const GetSchedulerFilterOptionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getSchedulerFilterOptions' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSchedulerFilterOptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'clients' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'cities' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zips' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issues' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSchedulerFilterOptionsQuery, GetSchedulerFilterOptionsQueryVariables>;
export const GetSchedulesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getSchedules' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'date' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'resourceType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'CompanyResourceResourceTypeEnum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSchedules' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'date' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'date' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dateRange' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dateRange' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'companyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'companyId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'resourceType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'resourceType' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CompleteScheduleFragment' } }],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CompleteScheduleFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Schedule' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'date' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'source' } },
          { kind: 'Field', name: { kind: 'Name', value: 'collectable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'descriptionOfService' } },
          { kind: 'Field', name: { kind: 'Name', value: 'onHire' } },
          { kind: 'Field', name: { kind: 'Name', value: 'customShift' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'project' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mainAddress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'locationType' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subLocations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'companyResource' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'resourceMeta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bio' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'unit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'batchNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currentLocation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nextServiceDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'insuranceExpiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'permitExpiryDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'operatorRequirements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'capacity' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxReach' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'weightDimensions' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fuelType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pointOfContact' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'equipmentType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'shortCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'serialNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'makeModel' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isScheduleable' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'resourceCategory' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subContractor' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hasFutureSchedules' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isParent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'principalContact' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'defaultEmploymentStatus' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationType' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'hasConflicts' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSchedulesQuery, GetSchedulesQueryVariables>;
export const GetSchedulesForSchedulerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getSchedulesForScheduler' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSchedulesForScheduler' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endDate' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'projectId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'projectId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'projectId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resourceType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'onHire' } },
                { kind: 'Field', name: { kind: 'Name', value: 'descriptionOfService' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSchedulesForSchedulerQuery, GetSchedulesForSchedulerQueryVariables>;
export const GetSharepointDrivesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getSharepointDrives' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'siteId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSharepointDrives' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'siteId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'siteId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'driveType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'webUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSharepointDrivesQuery, GetSharepointDrivesQueryVariables>;
export const GetSharepointFileMetadataDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getSharepointFileMetadata' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'driveId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'itemId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSharepointFileMetadata' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'driveId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'driveId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'itemId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'itemId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastModified' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isFolder' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'webUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSharepointFileMetadataQuery, GetSharepointFileMetadataQueryVariables>;
export const GetSharepointFilesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getSharepointFiles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'driveId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'itemId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSharepointFiles' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'driveId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'driveId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'itemId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'itemId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastModified' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mimeType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isFolder' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'webUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'downloadUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSharepointFilesQuery, GetSharepointFilesQueryVariables>;
export const GetSharepointSitesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getSharepointSites' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchQuery' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSharepointSites' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchQuery' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchQuery' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'webUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSharepointSitesQuery, GetSharepointSitesQueryVariables>;
export const GetSubContractorsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getSubContractors' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchBy' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getSubContractors' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchBy' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'subContractor' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'hasFutureSchedules' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'principalContact' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'subContractor' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'primaryEmail' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'principalContact' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetSubContractorsQuery, GetSubContractorsQueryVariables>;
export const GetTagsForSchedulerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getTagsForScheduler' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCompanyTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTagsForSchedulerQuery, GetTagsForSchedulerQueryVariables>;
export const GetTaskDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getTask' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getTask' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dueDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'employee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'creator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'employee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'imageUrls' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'attachments' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AttachedFile' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AttachedFile' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Attachment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'signedBlobId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'previewUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'filename' } },
          { kind: 'Field', name: { kind: 'Name', value: 'byteSize' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'associationType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'title' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTaskQuery, GetTaskQueryVariables>;
export const GetTaskCommentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getTaskComments' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'taskId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getTaskComments' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'taskId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'taskId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEdited' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'employment' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'employee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'reactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'emoji' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'employments' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'employee' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'replies' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isEdited' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'employment' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'employee' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'reactions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'emoji' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'employments' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'employee' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTaskCommentsQuery, GetTaskCommentsQueryVariables>;
export const GetTasksDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getTasks' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'createdById' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'assigneeId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'priority' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchText' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'entity' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'TaskEntity' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dueDateFrom' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dueDateTo' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getTasks' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'createdById' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'createdById' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'assigneeId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'assigneeId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'priority' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'priority' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'searchText' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'searchText' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'entity' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'entity' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dueDateFrom' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dueDateFrom' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dueDateTo' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dueDateTo' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dueDate' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'assignee' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'employee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageUrl' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'creator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'employee' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetTasksQuery, GetTasksQueryVariables>;
export const GetUnapprovedReportsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUnapprovedReports' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'stage' } },
          type: {
            kind: 'ListType',
            type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'approved' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getCompanyReports' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'stage' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'stage' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalCount' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'edges' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cursor' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'node' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'approvalDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'reportDate' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'weather' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'project' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'reporter' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'employee' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'issues' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'categories' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'issueType' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'pageInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'endCursor' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUnapprovedReportsQuery, GetUnapprovedReportsQueryVariables>;
export const GetUserNotificationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getUserNotifications' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUserNotifications' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'read' } },
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isMentioned' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customShiftDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'scheduleId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'projectId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'projectName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canApprove' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'existingShifts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'startTime' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'endTime' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserNotificationsQuery, GetUserNotificationsQueryVariables>;
export const UserSettingsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'userSettings' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userSettings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'taskPreferences' } },
                { kind: 'Field', name: { kind: 'Name', value: 'dateTimePreference' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'projectOrder' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'i' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'h' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'w' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'widgetLayout' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'h' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'i' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxH' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxW' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'minH' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'minW' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'w' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'y' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UserSettingsQuery, UserSettingsQueryVariables>;
export const GetIssueCategoriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getIssueCategories' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'dynamic' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getIssueCategories' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'dynamic' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'dynamic' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetIssueCategoriesQuery, GetIssueCategoriesQueryVariables>;
export const MyAccessDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'myAccess' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myAccess' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'action' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entity' } },
                { kind: 'Field', name: { kind: 'Name', value: 'projectIds' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MyAccessQuery, MyAccessQueryVariables>;
export const VerifyEmailExistsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'verifyEmailExists' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verifyEmailExists' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VerifyEmailExistsQuery, VerifyEmailExistsQueryVariables>;
